import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
    en: {
        navbar: {
            home: 'Home',
            aboutUs: 'About Us',
            rooms: 'Rooms',
            ayurveda: 'Ayurveda',
            yoga: 'Yoga',
            food: 'Food',
            events: 'Events',
            blogs: 'Blogs',
            tours: 'Tours',
            contactUs: 'Contact Us',
            bookOnline: 'Book Online',
            locationMaggona: 'Maggona Sri Lanka',
            selectResort: 'Select Resort',
            language: 'Language',
            mainTitle: 'Mahi Beach Ayurveda Resort',
            resortBeach: 'Mahi Beach Ayurveda Resort'
        },
        footer: {
            description: 'Mahi Beach Ayurveda Resort is committed to providing exceptional hospitality and experiences, ensuring every guest feels valued and rejuvenated.',
            linksTitle: 'Links',
            contactTitle: 'Contact Us',
            viewLocation: 'View Location',
            navHome: 'Home',
            navAbout: 'About',
            navContact: 'Contact',
            navRooms: 'Rooms',
            navAyurveda: 'Ayurveda',
            copyright: '© Copyright {{year}} Mahi Beach Ayurveda Resort.',
            developedBy: 'Developed By',
            developerName: 'Redev Solution +94 764 608 225'
        },
        blogs: {
            heroTitle: 'Mahi Beach Ayurveda Resort Blogs',
            heroSubtitle1: 'Stories from the shore, Ayurveda rituals at',
            heroSubtitle2: 'Mahi Beach Ayurveda Resort',
            heroSubtitle3: '. Dive into tips, history, and behind-the-scenes notes.',
            heroAlt: 'Resort beachfront walkway at sunset',
            sectionTitle: 'Mahi Beach Ayurveda Resort Blogs',
            sectionDescription: 'Guides, stories, and notes from our coastline retreat—spanning Ayurveda rituals, gemstone lore, and travel tips around Bentota.',
            ayurvedaTitle: 'The Heart of Authentic Ayurveda',
            ayurvedaExcerpt: 'Experience time-honored healing traditions rooted in Sri Lanka\'s ancient wisdom.',
            ayurvedaDescription: 'At Mahi Beach Ayurveda Resort, Ayurveda is more than a treatment — it is a way of life. Our therapies are based on centuries-old knowledge, personalized to your body type, and guided by experienced Ayurvedic physicians for deep, lasting balance.',
            ayurvedaAlt: 'Ayurvedic treatment setup with herbal oils and natural elements',
            healingTitle: 'Personalized Healing Journeys',
            healingExcerpt: 'Why every guest\'s program is uniquely designed.',
            healingDescription: 'From initial consultations to daily treatments, your healing journey is carefully tailored. Herbal therapies, therapeutic massages, yoga, and meditation work together to restore harmony between body, mind, and spirit.',
            healingAlt: 'Ayurvedic doctor consulting a guest in a calm setting',
            natureTitle: 'Healing by the Ocean',
            natureExcerpt: 'How the sea breeze and tropical surroundings enhance your journey.',
            natureDescription: 'Nestled along Sri Lanka\'s tranquil coastline, Mahi Beach offers a naturally healing environment. The sound of waves, fresh ocean air, and lush greenery amplify the effects of Ayurveda, creating deep relaxation and renewal.',
            natureAlt: 'Beachfront view of the resort with palm trees and ocean',
            foodTitle: 'Ayurvedic Cuisine for Inner Balance',
            foodExcerpt: 'Nourishing meals crafted to support your treatment.',
            foodDescription: 'Our Ayurvedic cuisine is freshly prepared using seasonal, locally sourced ingredients. Each meal is aligned with your dosha, supporting digestion, detoxification, and overall vitality while remaining flavorful and satisfying.',
            foodAlt: 'Traditional Ayurvedic meal served in natural bowls',
            yogaTitle: 'Yoga, Meditation & Inner Stillness',
            yogaExcerpt: 'Gentle practices that calm the mind and strengthen the body.',
            yogaDescription: 'Daily yoga and meditation sessions complement your treatments, improving flexibility, breathing, and mental clarity. These mindful practices help you reconnect with yourself and carry a sense of peace beyond your stay.',
            yogaAlt: 'Guests practicing yoga facing the ocean at sunrise',
            lifestyleTitle: 'Bringing Ayurveda Home',
            lifestyleExcerpt: 'Simple lifestyle practices to continue your journey.',
            lifestyleDescription: 'Before you depart, our experts guide you on maintaining balance through daily routines, diet, and self-care rituals. Take home more than memories — take home a sustainable path to healthier living.',
            lifestyleAlt: 'Guest relaxing with herbal tea in a serene resort setting',
            readMore: 'Read more'
        },
        events: {
            heroEyebrow: 'Experiences & Activities',
            heroTitle: 'Our Events',
            heroSubtitle: 'Curated experiences that blend Sri Lankan tradition with coastal luxury',
            heroAlt: 'Events at Mahi Beach',
            availableDaily: 'Available Daily',
            bookNow: 'Book Now',
            highlightsTitle: 'Highlights',
            detailAlt: '{{title}} detail',
            ctaTitle: 'Ready to Create Memories?',
            ctaDescription: 'Contact our team to customize your perfect event experience at Mahi Beach Ayurveda Resort',
            ctaContact: 'Contact Us',
            ctaViewRooms: 'View Rooms',
            buddhistMonkMeditationTitle: 'Meditation by Buddhist Monks',
            buddhistMonkMeditationSubtitle: 'Traditional mindfulness practices',
            buddhistMonkMeditationDescription: 'Experience authentic Buddhist meditation led by experienced monks in our peaceful resort setting. These ancient practices promote inner peace, mindfulness, and spiritual wellness through guided sessions combining traditional chanting, breathing techniques, and silent meditation.',
            buddhistMonkMeditationHighlight1: 'Traditional Buddhist meditation sessions',
            buddhistMonkMeditationHighlight2: 'Experienced monk-led guidance',
            buddhistMonkMeditationHighlight3: 'Peaceful indoor resort setting',
            buddhistMonkMeditationHighlight4: 'Mindfulness and breathing techniques',
            buddhistMonkMeditationHighlight5: 'Spiritual wellness practices',
            cookeryTitle: 'Cookery Programs',
            cookerySubtitle: 'Taste of Sri Lanka',
            cookeryDescription: 'Immerse yourself in the vibrant flavors of Sri Lankan cuisine. Our expert chefs guide you through hands-on cooking sessions, teaching you traditional recipes passed down through generations. Learn to prepare aromatic curries, hoppers, coconut sambol, and more using fresh local ingredients.',
            cookeryHighlight1: 'Traditional Sri Lankan recipes',
            cookeryHighlight2: 'Hands-on cooking experience',
            cookeryHighlight3: 'Fresh local ingredients',
            cookeryHighlight4: 'Take recipes home',
            cookeryHighlight5: 'Spice garden tour included',
            meditationTitle: 'Meditation Programs',
            meditationSubtitle: 'Inner Peace & Mindfulness',
            meditationDescription: 'Find tranquility in our guided meditation sessions set against the serene backdrop of the Indian Ocean. Our experienced instructors lead you through ancient mindfulness techniques, breathing exercises, and yoga practices designed to calm the mind and rejuvenate the spirit.',
            meditationHighlight1: 'Sunrise & sunset sessions',
            meditationHighlight2: 'Beachfront meditation',
            meditationHighlight3: 'Guided by experts',
            meditationHighlight4: 'Breathing techniques',
            meditationHighlight5: 'Yoga & mindfulness practices',
            nightBeachPartiesTitle: 'Grill Night',
            nightBeachPartiesSubtitle: 'Beachside Culinary Experience',
            nightBeachPartiesDescription: 'Indulge in an unforgettable beachside grill night under the stars. Savor freshly grilled seafood, premium meats, and vibrant vegetables while enjoying the soothing sound of ocean waves. Our expert chefs prepare every dish to perfection, creating a memorable dining experience in a magical coastal setting.',
            nightBeachPartiesHighlight1: 'Freshly grilled seafood and meats',
            nightBeachPartiesHighlight2: 'Live grilling demonstration by chefs',
            nightBeachPartiesHighlight3: 'Oceanfront dining atmosphere',
            nightBeachPartiesHighlight4: 'Premium BBQ buffet selection',
            nightBeachPartiesHighlight5: 'Beachside ambiance with bonfire',
            bbqTitle: 'BBQ Events',
            bbqSubtitle: 'Beachside Celebrations',
            bbqDescription: 'Experience unforgettable evenings with our beachside BBQ events. Savor freshly grilled seafood, premium meats, and vegetarian delights while the waves whisper nearby. Live music, fire dancers, and the starlit sky create the perfect ambiance for celebration and connection.',
            bbqHighlight1: 'Fresh grilled seafood',
            bbqHighlight2: 'Oceanfront dining',
            bbqHighlight3: 'Live entertainment',
            bbqHighlight4: 'Bonfire experience',
            bbqHighlight5: 'Customizable menus',
            boatTitle: 'Boat Rides',
            boatSubtitle: 'Coastal Adventures',
            boatDescription: 'Embark on enchanting boat journeys along the coastal waters and explore the beauty of the Indian Ocean. Glide through scenic routes, spot exotic marine life and seabirds, or enjoy romantic sunset cruises. Our boat rides offer a unique perspective of Sri Lanka\'s natural coastal beauty and diverse marine ecosystems.',
            boatHighlight1: 'Coastal cruises',
            boatHighlight2: 'Marine wildlife spotting',
            boatHighlight3: 'Wildlife spotting',
            boatHighlight4: 'Sunset boat tours',
            boatHighlight5: 'Private charter available',
            ayurvedaLecturesTitle: 'Ayurveda Doctors\' Lectures',
            ayurvedaLecturesSubtitle: 'Ancient Wisdom & Modern Practices',
            ayurvedaLecturesDescription: 'Discover the profound principles of Ayurveda through expert-led lectures by certified Ayurvedic doctors and practitioners. Learn about dosha balancing, herbal remedies, holistic healing practices, and how ancient wisdom applies to modern times. Our interactive sessions demystify Ayurvedic philosophy and its application to daily life.',
            ayurvedaLecturesHighlight1: 'Certified Ayurveda doctors',
            ayurvedaLecturesHighlight2: 'Personalized dosha analysis',
            ayurvedaLecturesHighlight3: 'Herbal remedy education',
            ayurvedaLecturesHighlight4: 'Q&A sessions included',
            ayurvedaLecturesHighlight5: 'Take-home guide',
            traditionalClothsTitle: 'Traditional Cloths Wearing Events',
            traditionalClothsSubtitle: 'Cultural Heritage Experience',
            traditionalClothsDescription: 'Immerse yourself in Sri Lankan cultural heritage by learning to wear and appreciate traditional attire. Our expert stylists guide you through dressing in authentic Kandyan sarees and traditional garments, explaining the cultural significance of each piece. Perfect for special occasions, cultural appreciation, or creating memorable photos.',
            traditionalClothsHighlight1: 'Expert styling guidance',
            traditionalClothsHighlight2: 'Authentic traditional sarees',
            traditionalClothsHighlight3: 'Cultural significance explained',
            traditionalClothsHighlight4: 'Professional photography included',
            traditionalClothsHighlight5: 'Fashion fusion workshops',
            shanthiKarmaTitle: 'Cultural Dance',
            shanthiKarmaSubtitle: 'Traditional Sri Lankan Performances',
            shanthiKarmaDescription: 'Immerse yourself in the vibrant world of Sri Lankan cultural dance. Experience mesmerizing traditional performances featuring colorful costumes, rhythmic drumming, and ancient storytelling through movement. Our talented dancers showcase centuries-old folk dances, Kandyan dance, and cultural rituals that bring Sri Lankan heritage to life.',
            shanthiKarmaHighlight1: 'Authentic Sri Lankan traditional dances',
            shanthiKarmaHighlight2: 'Colorful traditional costumes and makeup',
            shanthiKarmaHighlight3: 'Live drum accompaniment',
            shanthiKarmaHighlight4: 'Cultural storytelling through movement',
            shanthiKarmaHighlight5: 'Kandyan and folk dance performances',
            musicTherapyTitle: 'Music Therapy',
            musicTherapySubtitle: 'Healing Through Sound',
            musicTherapyDescription: 'Discover the therapeutic power of music at our specialized sessions combining ancient Sri Lankan instruments with modern healing techniques. Our certified music therapists use sound vibrations, rhythmic patterns, and melodic harmonies to reduce stress, enhance emotional wellbeing, and promote deep relaxation.',
            musicTherapyHighlight1: 'Traditional Sri Lankan instruments',
            musicTherapyHighlight2: 'Certified music therapists',
            musicTherapyHighlight3: 'Sound healing vibrations',
            musicTherapyHighlight4: 'Stress reduction techniques',
            musicTherapyHighlight5: 'Group and private sessions',
            taiChiTitle: 'Tai Chi',
            taiChiSubtitle: 'Gentle Movement & Balance',
            taiChiDescription: 'Experience the ancient Chinese martial art of Tai Chi, practiced in our serene beachfront setting. This gentle, flowing exercise combines slow, deliberate movements with deep breathing and meditation to improve balance, flexibility, and inner calm. Perfect for all ages and fitness levels.',
            taiChiHighlight1: 'Beachfront morning sessions',
            taiChiHighlight2: 'Experienced Tai Chi instructors',
            taiChiHighlight3: 'Improves balance and flexibility',
            taiChiHighlight4: 'Suitable for all fitness levels',
            taiChiHighlight5: 'Meditation and breathing techniques',
        },
        food: {
            heroTitle: 'Ayurvedic Dining & Coastal Cuisine',
            heroSubtitle: 'Authentic Sri Lankan Flavors & Fresh Coastal Cuisine',
            heroAlt: 'Culinary Experience at Mahi Beach Ayurveda Resort',
            wellnessEyebrow: 'Through Food',
            wellnessTitle: 'The Importance of',
            ayurvedicFood: 'Ayurvedic Food',
            wellnessIntro1: 'In Ayurveda, food is considered the greatest medicine. What you eat directly influences your doshas (Vata, Pitta, Kapha), digestion (agni), and overall balance of body, mind, and spirit.',
            wellnessIntro2: 'Ayurvedic nutrition emphasizes fresh, seasonal, whole foods prepared with care and mindful eating. It promotes six tastes (sweet, sour, salty, pungent, bitter, astringent) in every meal to nourish all senses and maintain harmony.',
            wellnessIntro3: 'Proper Ayurvedic food supports strong digestion, helps remove toxins (ama), boosts immunity, improves energy, reduces stress, and prevents many chronic conditions. At Mahi Beach, every dish is crafted to align with your unique constitution for deep healing and vitality.',
            foodImage1Alt: 'Traditional Ayurvedic meal with six tastes',
            foodImage2Alt: 'Ayurvedic herbs and spices for balanced nutrition',
            culinaryPhilosophyEyebrow: 'Our Culinary Philosophy',
            culinaryPhilosophyTitle: 'Ayurvedic',
            nutritionHighlight: 'Nutrition',
            culinaryPhilosophyResort: 'at Mahi Beach Ayurveda Resort',
            nutritionTopImageAlt: 'Ayurvedic Cuisine at Mahi Beach Ayurveda Resort',
            freshNourishingLabel: 'Fresh & Nourishing',
            healingIngredientsAlt: 'Healthy Ayurvedic Ingredients and Spices',
            healingIngredientsLabel: 'Healing Ingredients',
            philosophyText1: 'The food, which encompasses the six main tastes (sweet, sour, salty, bitter, pungent, and astringent) along with many subtle variations, has been described in classical Ayurvedic texts—some dating back over 5,000 years—together with each food\'s essential properties: Guna (inherent quality), Virya (potency/heating or cooling effect), Vipaka (post-digestive impact), and Prabhava (unique special action).',
            philosophyText2: 'As a result, Ayurvedic nutrition plays a central role at Mahi Beach Ayurveda Resort. This does not mean a rigid, monotonous regimen of bland, tasteless, or overly bitter vegetarian meals dictated solely by physicians. On the contrary, our Ayurveda kitchen stands out as one of our greatest strengths: the dishes prepared by our skilled cooks will surprise and delight you every single day of your stay!',
            philosophyText3: 'At breakfast, enjoy a generous buffet featuring fresh tropical fruits, freshly squeezed juices, nourishing herbal soups, home-baked breads and light cookies, plus a variety of authentic Sri Lankan breakfast options. For lunch, savor a colorful and flavorful buffet with mild fish curries, vegetable preparations, and herbal-infused dishes. In the evening, we serve a set vegetarian menu with a fresh fish option available. On Saturdays, we celebrate "Sri Lankan Night" with an expanded buffet—our chefs prepare traditional local specialties right in front of you, creating a lively and authentic experience.',
            philosophyText4: 'In Ayurveda, foods and beverages are classified in many ways—according to taste and properties, the body\'s digestive capacity (agni), suitability for specific health conditions, seasonal appropriateness, and more. At Mahi Beach, we carefully consider all these factors simultaneously, making a conscious effort to include all six tastes in balanced combinations tailored to each guest\'s individual constitution.',
            philosophyText5: 'Our meals feature fresh vegetables, tropical fruits, and responsibly sourced fish. We do not serve red meat or alcohol.',
            philosophyText6: 'During meal times, an Ayurvedic doctor or qualified dietician is always available to guide you. They will advise on the most suitable vegetables, herbs, and spices for your current treatment phase and help you select or avoid dishes accordingly. Your personalized herbal elixir and any specific instructions from the health centre team will be placed on your individual table.',
            philosophyText7: 'This level of personalized care and attention to diet is a hallmark of the Mahi Beach Ayurveda Resort experience.',
            philosophyText8: 'Food is regarded as Prana—the vital life-sustaining energy—for every human being. That is why we encourage you to approach each meal with full awareness: savoring the aromas, experiencing the tastes, feeling the gentle warmth, and enjoying the mouth-watering sensations mindfully.',
            diningExperienceEyebrow: 'Dining Experience',
            restaurantTitlePrefix: 'Our',
            ayurvedicHighlight: 'Ayurvedic',
            restaurantTitleSuffix: 'Restaurant',
            restaurantDetail1: 'Our Ayurvedic restaurant at Mahi Beach Ayurveda Resort offers a unique dining experience that harmonizes traditional Ayurvedic principles with authentic Sri Lankan coastal cuisine. We prioritize fresh, locally sourced ingredients to create meals that not only delight the palate but also promote holistic well-being.',
            restaurantDetail2: 'The menu is thoughtfully crafted to balance the six tastes (sweet, sour, salty, bitter, pungent, and astringent) in every dish, ensuring a nourishing and satisfying experience. Each meal is prepared with care, incorporating Ayurvedic herbs and spices known for their healing properties.',
            restaurantDetail3: 'Guests can enjoy a variety of dishes tailored to their individual doshas (body constitutions), with options for vegetarian, vegan, and pescatarian diets. Our chefs work closely with Ayurvedic practitioners to ensure that each meal supports the guests\' health and goals.',
            restaurantDetail4: 'The restaurant\'s ambiance reflects the serene coastal environment, providing a tranquil setting for mindful eating. Whether you\'re indulging in a hearty breakfast buffet or savoring a gourmet dinner, every meal at our Ayurvedic restaurant is an opportunity to nourish both body and soul.',
            restaurantDetail5: 'Join us at Mahi Beach Ayurveda Resort\'s Ayurvedic restaurant for a culinary journey that celebrates the rich flavors of Sri Lanka while embracing the timeless wisdom of Ayurveda.',
            restaurantImageAlt: 'Dining at Mahi Beach Ayurveda Resort',
            premiumDiningLabel: 'Premium Dining',
            premiumDiningDescription: 'Experience authentic Ayurvedic cuisine in a serene beachfront setting'
        },
        yoga: {
            heroTitle: 'Yoga at Resort',
            heroSubtitle: 'Find Balance, Strength & Inner Peace in Maggona',
            heroAlt: 'Yoga at Mahi Beach Ayurveda Resort',
            importanceEyebrow: '& Balance',
            importanceTitle: 'Importance of Yoga & Meditation',
            importanceImageAlt: 'Importance of Yoga and Meditation',
            importanceText1: 'Yoga and meditation are ancient practices that offer numerous physical, mental, and emotional benefits. They promote flexibility, strength, and balance while reducing stress and anxiety.',
            importanceText2: 'Regular practice can enhance concentration, improve sleep quality, and boost overall well-being. Yoga also encourages mindfulness, helping individuals connect with their inner selves and find peace amidst the chaos of daily life.',
            importanceText3: 'At Mahi Beach Ayurveda Resort, we provide serene environments perfect for practicing yoga and meditation, allowing guests to rejuvenate their mind, body, and spirit.',
            practiceEyebrow: 'Our Practice',
            practiceTitle: 'Yoga Practice & Experience',
            practiceImageAlt: 'Yoga Practice at Resort',
            practiceText1: 'At Mahi Beach Ayurveda Resort, yoga is practiced primarily as traditional Hatha Yoga, combined with Pranayama (breathing techniques). This holistic approach is designed to awaken inner awareness and gently stimulate the Kundalini (often referred to as the third eye). Special emphasis is placed on spinal alignment and flexibility, as a supple spine is believed to slow the aging process—“You are only as old as your spine.”',
            practiceText2: 'Yoga sessions are conducted four times per week and are suitable for both beginners and experienced practitioners. From time to time, special sessions such as Ashtanga Yoga are also introduced, allowing guests to experience a variety of postures and routines. Our Ayurvedic physicians encourage regular participation to support and enhance the overall treatment program.',
            practiceText3: 'All yoga sessions are held in our dedicated Yoga Shala, a calm and serene space designed to support focus, balance, and mindful movement. Each session typically begins with Sun Salutations, followed by Pranayama and a sequence of carefully selected asanas aimed at improving flexibility, circulation, and overall well-being.',
            practiceText4: 'Our experienced yoga teachers adapt each session according to the individual needs, abilities, and health conditions of the guests, ensuring a safe, supportive, and deeply beneficial yoga experience for everyone.',
            spiritualEyebrow: 'Spiritual Journey',
            spiritualTitle: 'Meditation & Spiritual Activities',
            spiritualSubtitle: 'Deepen your spiritual practice with our sacred ceremonies and guided meditation sessions',
            meditationImageAlt: 'Meditation and Spiritual Practice at the Resort',
            meditationTitle: 'Meditation Sessions',
            meditationDesc: 'Guests are invited to participate in guided meditation sessions held three times per week, inspired by Buddhist traditions. These sessions are designed to calm the mind, deepen awareness, and support emotional and spiritual healing. The meditation takes place at a peaceful island temple, which guests reach by boat—adding a serene and meaningful journey that enhances the overall meditative experience.'
        },


        ayurveda: {
            accordionTitle1: 'Understanding Panchakarma Ayurveda',
            accordionDesc1: 'Ayurveda ("science of life") is among the world\'s oldest holistic healing systems, developed over 5,000 years ago. Panchakarma rests on the idea that health depends on harmony between mind, body, spirit, and environment. Its primary aim is to build resilience and prevent illness, while therapies can be tailored to specific concerns.',
            accordionTitle2: 'Panchakarma and Vital Energy',
            accordionDesc2: 'Ayurveda teaches that everything in the universe is interconnected. When mind, body, and spirit are aligned, wellbeing follows; when balance is disturbed, illness can arise. Factors like heredity, injury, seasons, age, and emotions can upset this harmony.\n\nAyurveda describes five elements—space, air, fire, water, and earth—which combine in the body as three energies called doshas: Vata (space/air), Pitta (fire/water), and Kapha (water/earth). These govern bodily functions.\n\nEach person inherits a unique blend of the three doshas, usually with one dominant. The balance among them is believed to shape health tendencies and vulnerabilities.',
            accordionTitle3: 'Vata Dosha',
            accordionDesc3: 'Vata is considered the most influential dosha, guiding basic functions such as cellular movement, breathing, circulation, heart rhythm, and elimination. It can be disrupted by irregular meals, fear, grief, and late nights.\n\nIf Vata is dominant, you may be quick-thinking, creative, and energetic, with changing moods. Physically you may be lean, tend to lose weight easily, and feel cold. When imbalanced, Vata can lead to anxiety, restlessness, forgetfulness, or conditions like asthma and joint issues.\n\nAyurveda balances excess Vata with grounding practices: meditation, massage, steady routines, and warm, gentle foods.',
            accordionTitle4: 'Pitta Dosha',
            accordionDesc4: 'Pitta governs digestion, metabolism, and appetite-related hormones. It can be aggravated by spicy or sour foods, too much heat or sun, and skipped meals.\n\nIf Pitta is dominant, you may be driven, confident, and a natural leader, often with a warm body temperature and athletic build. Imbalance can show up as irritability, impatience, or inflammation.\n\nTo soothe Pitta (fire/water), Ayurveda recommends cooling, light foods and calming practices like gentle yoga and moderation.',
            accordionTitle5: 'Kapha Dosha',
            accordionDesc5: 'Kapha supports structure, strength, stability, and immunity. It can be disturbed by excessive sweets, salty foods, heavy meals, and too much sleep.\n\nKapha-dominant people are often steady, calm, and patient, with a sturdier build. When out of balance, Kapha may lead to fatigue, sluggishness, weight gain, or congestion.\n\nBalancing Kapha (earth/water) involves lighter meals, more fruits and vegetables, and movement that energizes the body.',
            close: 'Close',
            next: 'Next',
            previous: 'Previous',
            treatmentsTitle: 'Signature Panchakarma Therapies',
            treatmentsSubtitle: 'Time-honored rituals that restore balance, soften tension, and renew body and mind.',
            bookTreatment: 'Reserve This Treatment',
            benefitsTitle: 'Why Panchakarma Matters',
            shirodhara: 'Shirodhara',
            shirodharaDesc: 'Warm herbal oil is streamed over the forehead to soothe the nervous system.',
            shirodhara1: 'Eases stress and anxious thoughts',
            shirodhara2: 'Encourages deeper, more restful sleep',
            shirodhara3: 'Sharpens calm focus',
            steamBath: 'Steam Bath',
            steamBathDesc: 'Herbal steam opens pores, supports detox, and relaxes tight muscles.',
            steamBath1: 'Supports detox through gentle sweating',
            steamBath2: 'Boosts circulation',
            steamBath3: 'Soothes muscular tightness',
            flowerBath: 'Flower Bath',
            flowerBathDesc: 'A fragrant floral soak designed to relax and reset.',
            flowerBath1: 'Settles the nervous system',
            flowerBath2: 'Softens and hydrates skin',
            flowerBath3: 'Lifts mood',
            headMassage: 'Head Massage',
            headMassageDesc: 'Focused scalp massage to melt built-up tension.',
            headMassage1: 'Relieves head pressure',
            headMassage2: 'Nourishes scalp and roots',
            headMassage3: 'Invites deep relaxation',
            faceMassage: 'Face Massage',
            faceMassageDesc: 'Gentle facial massage that revives glow and eases stress.',
            faceMassage1: 'Brightens complexion',
            faceMassage2: 'Releases facial tightness',
            faceMassage3: 'Supports lymph flow',
            neckMassage: 'Neck Massage',
            neckMassageDesc: 'Targeted work to ease neck stiffness.',
            neckMassage1: 'Reduces neck discomfort',
            neckMassage2: 'Improves range of motion',
            neckMassage3: 'Calms stress',
            shoulderMassage: 'Shoulder Massage',
            shoulderMassageDesc: 'Therapeutic massage to loosen tight shoulders.',
            shoulderMassage1: 'Eases shoulder ache',
            shoulderMassage2: 'Supports better posture',
            shoulderMassage3: 'Releases muscle knots',
            bodyMassage: 'Body Massage',
            bodyMassageDesc: 'A full-body ritual to unwind and restore.',
            bodyMassage1: 'Improves circulation',
            bodyMassage2: 'Eases muscle soreness',
            bodyMassage3: 'Promotes overall relaxation',
            backMassage: 'Back Massage',
            backMassageDesc: 'Therapeutic back work to release tension.',
            backMassage1: 'Soothes back pain',
            backMassage2: 'Supports spinal comfort',
            backMassage3: 'Reduces stress',
            footMassage: 'Foot Massage',
            footMassageDesc: 'A grounding foot massage that relaxes the whole body.',
            footMassage1: 'Stimulates circulation',
            footMassage2: 'Relieves tired feet',
            footMassage3: 'Encourages calm',
            purgative: 'Purgative',
            purgativeDesc: 'A cleansing therapy aimed at clearing excess Pitta and digestive toxins.',
            purgative1: 'Purifies the intestines',
            purgative2: 'Balances Pitta',
            purgative3: 'Supports digestive function',
            nasalClearing: 'Nasal Cleansing',
            nasalClearingDesc: 'Herbal nasal therapy to clear passages and support breathing.',
            nasalClearing1: 'Relieves congestion',
            nasalClearing2: 'Improves airflow',
            nasalClearing3: 'Eases sinus pressure',
            powderMassage: 'Powder Massage',
            powderMassageDesc: 'Herbal powder exfoliation to refresh and enliven the skin.',
            powderMassage1: 'Removes dull, dead skin',
            powderMassage2: 'Refines skin texture',
            powderMassage3: 'Boosts circulation',
            intensiveMassageDesc: 'Deep therapeutic work for chronic tightness and stubborn knots.',
            intensiveMassage1: 'Releases deep muscle tension',
            intensiveMassage2: 'Increases blood flow',
            intensiveMassage3: 'Reduces lingering soreness',
            thermoMassage: 'Thermo Massage',
            thermoMassageDesc: 'Heated herbal oils to relax tissues and support healing.',
            thermoMassage1: 'Soothes sore muscles',
            thermoMassage2: 'Invites deep relaxation',
            thermoMassage3: 'Encourages balanced energy',
            synchronMassage: 'Synchron Massage',
            synchronMassageDesc: 'Two-therapist synchronized massage for total-body harmony.',
            synchronMassage1: 'Creates full-body balance',
            synchronMassage2: 'Supports steady energy flow',
            synchronMassage3: 'Amplifies relaxation',
            specialMassage: 'Special Massage',
            specialMassageDesc: 'A tailored massage designed around your personal wellness needs.',
            specialMassage1: 'Customized to you',
            specialMassage2: 'Targets specific concerns',
            specialMassage3: 'Supports a focused healing plan',
            benefit1Title: 'Detox Support:',
            benefit1Desc: 'Panchakarma helps clear accumulated toxins and refresh vitality.',
            benefit2Title: 'Digestive Ease:',
            benefit2Desc: 'Therapies encourage smoother digestion and improved nutrient uptake.',
            benefit3Title: 'Stress Reset:',
            benefit3Desc: 'Calming treatments quiet the mind and reduce anxiety.',
            benefit4Title: 'Immune Resilience:',
            benefit4Desc: 'Regular sessions strengthen defenses and overall resilience.',
            benefit5Title: 'Renewal:',
            benefit5Desc: 'Supports cellular rejuvenation for healthier skin and a youthful glow.',
            benefit6Title: 'Dosha Balance:',
            benefit6Desc: 'Restores harmony across Vata, Pitta, and Kapha for lasting wellbeing.',
            akkupancharTitle: 'Acupuncture Therapy',
            akkupancharDesc1: 'is an ancient therapeutic practice that involves the use of fine needles applied to specific points on the body. This therapeutic treatment is designed to stimulate vital energy channels and promote healing.',
            akkupancharBenefit: 'Key Benefits:',
            akkupancharDesc2: 'This specialized therapy helps in relieving chronic pain, improving joint flexibility, enhancing blood circulation, and restoring the body\'s natural energy flow. It is particularly effective for those seeking deep therapeutic healing and rejuvenation.',
            akkupancharApplication: 'Therapeutic Application:',
            akkupancharDesc3: 'Acupuncture works by targeting specific marma points (vital junctions) throughout the body, using carefully selected techniques to balance the doshas and promote optimal health.',
            akkupancharTransform: 'Experience Transformation:',
            akkupancharDesc4: 'At Mahi Beach Ayurveda Resort, our experienced practitioners customize each Acupuncture session to address your unique health needs, ensuring a profound and lasting healing experience.',
            experienceAkkupanchar: 'Experience Acupuncture Today',
            doctorsEyebrow: 'OUR EXPERT TEAM',
            doctorsSectionTitle: 'Our Doctors',
            drSandyaName: 'Dr. M. Sandya Mendis',
            drSandyaProfession: 'Ayurveda Medical Doctor',
            drSandyaSpecialization: 'Clinical Ayurveda, Personalized Treatment Planning, Hospitality Ayurveda Care',
            drSandyaProfileTitle: 'Professional Profile',
            drSandyaProfile: 'Compassionate and dedicated Ayurveda professional with over 25 years of experience providing personalized care and wellness solutions. Specialized in blending traditional Ayurvedic principles with modern therapeutic practices to deliver holistic healing experiences for guests at luxury wellness resorts.',
            drSandyaWorkExpTitle: 'Work Experience',
            drSandyaWorkExp1: 'Chief Doctor & Programme Development Lead - Mahi Beach Ayurveda Resort (2023 – Present)',
            drSandyaWorkExp2: 'Senior Ayurveda Doctor - Sun Aqua Resort and Spa, Maggona (2008 – 2023)',
            drSandyaWorkExp3: 'Ayurveda Consultant - Amba Ayurveda Specialty Clinic (2006 – 2008)',
            drSandyaWorkExp4: 'Ayurveda Doctor & Panchakarma Specialist - Paradise Road The Villa Bentota (2002 – 2006)',
            drSandyaWorkExp5: 'Ayurveda Medical Officer - Hotel Blue Water (1996 – 2002)',
            drSandyaEducationTitle: 'Education & Professional Qualifications',
            drSandyaEdu1: 'Diploma in Ayurveda - Government Ayurveda College, Borella (1989 – 1993)',
            drSandyaEdu2: 'Reiki 2nd Degree - Reiki Dasa Centre Negombo Sri Lanka (2015 – 2016)',
            drPandukaName: 'Dr. Panduka Ranaweera',
            drPandukaProfession: 'Ayurvedic Physician',
            drPandukaQualification: 'B.A.M.S. (Bachelor of Ayurvedic Medicine and Surgery)',
            drPandukaProfileTitle: 'Professional Profile',
            drPandukaProfile: 'Dr. Panduka Ranaweera is a qualified and experienced Ayurvedic physician, holding a Bachelor of Ayurvedic Medicine and Surgery (B.A.M.S.) from the University of Colombo. His academic training is firmly based on classical Ayurvedic principles and comprehensive clinical education, supporting a structured, ethical, and evidence-informed approach to traditional medicine.',
            drPandukaExpertiseTitle: 'Professional Expertise',
            drPandukaExpertise: 'In addition to clinical practice, Dr. Ranaweera conducts professional Ayurveda lectures for guests and wellness programs, offering clear insights into Ayurvedic philosophy, disease prevention, lifestyle management, and the practical application of traditional therapies. These sessions enhance guest understanding and engagement, contributing to sustainable health outcomes.',
            drPandukaSpecialtyTitle: 'Integrative Therapies',
            drPandukaSpecialty: 'His therapeutic expertise also extends to Acupuncture and Music Therapy, which he integrates selectively to support pain management, stress reduction, neurological balance, and emotional wellbeing. By combining Ayurveda with these complementary modalities, Dr. Ranaweera delivers a truly integrative healing experience.',
            drPandukaRoleTitle: 'Commitment to Excellence',
            drPandukaRole: 'In his role at the hotel, Dr. Ranaweera upholds high clinical standards while providing personalized treatment plans and holistic wellness guidance. His professional, calm, and compassionate approach ensures that each guest receives safe, authentic, and results-oriented care aimed at long-term balance, vitality, and overall wellbeing.',
            gallery1: 'Shirodhara Therapy',
            gallery2: 'Steam Bath',
            gallery3: 'Flower Bath',
            gallery4: 'Head Massage',
            gallery5: 'Body Massage',
            gallery6: 'Neck Massage',
            gallery7: 'Face Massage',
            gallery8: 'Shoulder Massage',
            heroTitle: 'Panchakarma Ayurveda',
            heroSubtitle: 'Rejuvenate Body, Mind & Spirit in Maggona',
            heroTagline: 'Experience authentic Sri Lankan Ayurveda healing by the ocean',
            sectionEyebrow: 'PANCHAKARMA AYURVEDA AT MAHI BEACH AYURVEDA RESORT',
            sectionDescription: 'Explore the ancient Panchakarma tradition at Mahi Beach Ayurveda Resort in Maggona, Sri Lanka. Our Ayurveda team designs personalized care to cleanse, restore, and harmonize body, mind, and spirit.',
            treatmentProgramme: {
                title: 'Ayurveda Treatment Programme',
                subtitle: 'Your Journey to Balance, Detox & Deep Renewal',
                intro: 'Settle into authentic Ayurvedic care in a quiet coastal retreat that restores the body, calms the mind, and recharges your energy. From the moment you arrive, we handle the details so you can focus fully on wellbeing.',
                welcomeTitle: 'Welcome & Gentle Start',
                contact: {
                    heroTitle: 'Contact Us',
                    heroSubtitle: 'Mahi Beach Ayurveda Resort',
                    heroAlt: 'Contact Us',
                    sectionTitle: 'Feel Free To Contact Us',
                    sectionSubtitle: 'We’re Here to Help You Relax & Rejuvenate',
                    sectionDescription: 'Contact Mahi Beach Ayurveda Resort for inquiries about your Ayurvedic stay, packages, bookings, or any questions during your time with us in beautiful Maggona, Mororgalla.',
                    callUs: 'Call Us',
                    emailTitle: 'Email',
                    ourLocation: 'Our Location',
                    locationAddress: 'No.112 rendagewatta Galle Rd, Maggona',
                    socialNetwork: 'Social Network',
                    ariaFacebook: 'Facebook',
                    ariaInstagram: 'Instagram',
                    ariaWhatsApp: 'WhatsApp',
                    ariaTikTok: 'TikTok',
                    getInTouch: 'Get In Touch',
                    getInTouchDescription: 'We’d love to hear from you — our team is ready to assist with your journey, answer questions, and help you plan a rejuvenating stay.',
                    nameLabel: 'Name',
                    emailLabel: 'Email',
                    contactNumberLabel: 'Contact Number',
                    messageLabel: 'Message',
                    sending: 'Sending...',
                    sendMessage: 'Send Message',
                    successMessage: "Your message has been sent successfully! We'll get back to you soon.",
                    errorMessage: 'An error occurred while sending your message. Please try again.',
                    findUsOnMap: 'Find Us on the Map',
                    whatsappSubject: 'Mahi Beach Ayurveda Resort Contact',
                    whatsappName: 'Name',
                    whatsappEmail: 'Email',
                    whatsappContactNumber: 'Contact Number',
                    whatsappMessage: 'Message'
                },
                contact2: {
                    heroTitle: 'Contact Us',
                    heroSubtitle: 'Mahi Beach Ayurveda Resort',
                    heroAlt: 'Contact Us',
                    sectionTitle: 'Feel Free To Contact Us',
                    sectionSubtitle: 'We’re Here to Help You Relax & Rejuvenate',
                    sectionDescription: 'Contact Mahi Beach Ayurveda Resort for inquiries about your Ayurvedic stay, packages, bookings, or any questions during your time with us in beautiful Maggona, Mororgalla.',
                    callUs: 'Call Us',
                    emailTitle: 'Email',
                    ourLocation: 'Our Location',
                    locationAddress: 'No.112 rendagewatta Galle Rd, Maggona',
                    socialNetwork: 'Social Network',
                    ariaFacebook: 'Facebook',
                    ariaInstagram: 'Instagram',
                    ariaWhatsApp: 'WhatsApp',
                    ariaTikTok: 'TikTok',
                    getInTouch: 'Get In Touch',
                    getInTouchDescription: 'We’d love to hear from you — our team is ready to assist with your journey, answer questions, and help you plan a rejuvenating stay.',
                    nameLabel: 'Name',
                    emailLabel: 'Email',
                    contactNumberLabel: 'Contact Number',
                    messageLabel: 'Message',
                    sending: 'Sending...',
                    sendMessage: 'Send Message',
                    successMessage: "Your message has been sent successfully! We'll get back to you soon.",
                    errorMessage: 'An error occurred while sending your message. Please try again.',
                    findUsOnMap: 'Find Us on the Map',
                    whatsappSubject: 'Mahi Beach Ayurveda Resort Contact',
                    whatsappName: 'Name',
                    whatsappEmail: 'Email',
                    whatsappContactNumber: 'Contact Number',
                    whatsappMessage: 'Message'
                },

            },
        },
        tours: {
            heroTitle: 'Tours & Excursions',
            heroSubtitle: 'Discover Sri Lanka\'s Beauty from Maggona',
            kandeAlt: 'Kande Vihara Temple - Maggona',
            kandeTitle: 'Kande Vihara Temple Visit',
            kandeBuddhaAlt: 'Giant Buddha Statue at Kande Vihara Temple',
            bentotaTitle: 'Coastal Boat Safari',
            bentotaAlt: 'Coastal Boat Safari - Marine Life and Scenic Views',
            galleTitle: 'Galle Old City Tour',
            galleAlt: 'Galle Old City Tour',
            sigiriyaTitle: 'Sigiriya Rock Fortress Tour',
            sigiriyaAlt: 'Sigiriya Rock Fortress Tour',
            kandyTitle: 'Kandy Cultural Tour',
            kandyAlt: 'Kandy Cultural Tour',
            bookTour: 'Book This Tour',
            viewDetails: 'View Details',
            introPara1: 'Sri Lanka is a land of timeless beauty, where golden beaches, lush green landscapes, ancient temples, and vibrant culture come together in perfect harmony.',
            introPara2: 'From the tranquil southwest coast to historic cities, sacred sites, wildlife sanctuaries, and misty hill country, every journey offers a unique and unforgettable experience.',
            introPara3: 'Starting from Mahi Beach Ayurveda Resort in Maggona, our carefully curated tours and excursions are designed to enrich your stay while perfectly balancing exploration, relaxation, .',
            kandeDetail1: 'Kande Vihara Temple (Kande Viharaya) – one of the most iconic Buddhist temples near Maggona.',
            kandeDetail2: 'Founded in 1734, this serene \'Mountain Temple\' sits atop a hill offering peaceful views over the coastline.',
            kandeDetail3: 'Highlights include the massive 48-meter (160 ft) seated Buddha statue (one of Sri Lanka\'s tallest), intricate Kandyan-era frescoes, ancient relic chamber, beautiful moonstone entrance, and a sacred Bodhi tree over 300 years old.',
            kandeDetail4: 'A perfect half-day spiritual & cultural experience – ideal for morning visits to avoid heat.',
            bentotaDetail1: 'Enjoy a peaceful and scenic boat safari along the coastal waters, one of the most popular nature excursions near Maggona.',
            bentotaDetail2: 'Glide through serene waters and scenic coastlines while spotting local marine wildlife and seabirds.',
            bentotaDetail3: 'Common sightings include various bird species (kingfishers, herons, eagles), dolphins, sea turtles, and tropical fish.',
            bentotaDetail4: 'Your experienced boatman/guide will point out interesting marine life, traditional fishing methods, and coastal village life.',
            bentotaDetail5: 'Perfect for nature lovers and photographers – calm, relaxing, and complementary to your Ayurvedic stay.',
            galleDetail1: 'Explore the historic Galle Fort, a UNESCO World Heritage Site and one of Sri Lanka\'s most well-preserved colonial-era forts.',
            galleDetail2: 'Wander through cobblestone streets lined with Dutch colonial buildings, boutique shops, cafes, and art galleries.',
            galleDetail3: 'Visit key landmarks such as the Galle Lighthouse, Dutch Reformed Church, National Maritime Museum, and the ramparts offering stunning ocean views.',
            galleDetail4: 'Learn about the fort\'s rich history, architecture, and cultural significance from your knowledgeable guide.',
            galleDetail5: 'Ideal for history buffs, culture enthusiasts, and those looking to experience Sri Lanka\'s colonial past.',
            sigiriyaDetail1: 'Discover the ancient rock fortress of Sigiriya, one of Sri Lanka\'s most iconic landmarks and a UNESCO World Heritage Site.',
            sigiriyaDetail2: 'Climb the impressive rock to explore the ruins of King Kasyapa\'s palace, adorned with frescoes, water gardens, and the famous Mirror Wall.',
            sigiriyaDetail3: 'Enjoy panoramic views of the surrounding jungle and countryside from the summit.',
            sigiriyaDetail4: 'Learn about the fascinating history, architecture, and legends associated with Sigiriya from your expert guide.',
            sigiriyaDetail5: 'Perfect for history enthusiasts, adventure seekers, and those interested in Sri Lanka\'s rich cultural heritage.',
            kandyDetail1: 'Experience the vibrant culture of Kandy, Sri Lanka\'s last royal capital and a UNESCO World Heritage Site.',
            kandyDetail2: 'Visit the Temple of the Sacred Tooth Relic (Sri Dalada Maligawa), one of the most important Buddhist sites in the world.',
            kandyDetail3: 'Explore the Royal Botanical Gardens in Peradeniya, home to a vast collection of tropical plants and orchids.',
            kandyDetail4: 'Enjoy a traditional Kandyan dance performance, showcasing Sri Lanka\'s rich artistic heritage.',
            kandyDetail5: 'Ideal for culture enthusiasts, history buffs, and those looking to immerse themselves in Sri Lanka\'s traditions.',
            ellaTitle: 'Ella Hill Country Adventure',
            ellaAlt: 'Ella Hill Country Tour - Nine Arch Bridge and Tea Plantations',
            ellaDetail1: 'Journey to Ella, one of Sri Lanka\'s most picturesque hill country destinations, renowned for its stunning mountain vistas and cool climate.',
            ellaDetail2: 'Visit the iconic Nine Arch Bridge, a colonial-era railway marvel set amid lush greenery, perfect for photography and watching trains pass through.',
            ellaDetail3: 'Explore verdant tea plantations, learn about Ceylon tea production, and enjoy panoramic views from Little Adam\'s Peak or Ella Rock.',
            ellaDetail4: 'Discover cascading waterfalls including Ravana Falls, hike through scenic trails, and experience the charming village atmosphere.',
            ellaDetail5: 'Perfect for nature lovers, adventure seekers, and those wanting to escape to Sri Lanka\'s breathtaking highlands.'
        },
        contact: {
            heroTitle: 'Contact Us',
            heroSubtitle: 'Mahi Beach Ayurveda Resort',
            heroAlt: 'Contact Us',
            sectionTitle: 'Feel Free To Contact Us',
            sectionSubtitle: 'We’re Here to Help You Relax & Rejuvenate',
            sectionDescription: 'Contact Mahi Beach Ayurveda Resort for inquiries about your Ayurvedic stay, packages, bookings, or any questions during your time with us in beautiful Maggona, Moragalla.',
            callUs: 'Call Us',
            emailTitle: 'Email',
            ourLocation: 'Our Location',
            locationAddress: 'No.112 rendagewatta Galle Rd, Maggona',
            socialNetwork: 'Social Network',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Get In Touch',
            getInTouchDescription: 'We’d love to hear from you — our team is ready to assist with your journey, answer questions, and help you plan a rejuvenating stay.',
            nameLabel: 'Name',
            emailLabel: 'Email',
            contactNumberLabel: 'Contact Number',
            messageLabel: 'Message',
            sending: 'Sending...',
            sendMessage: 'Send Message',
            successMessage: "Your message has been sent successfully! We'll get back to you soon.",
            errorMessage: 'An error occurred while sending your message. Please try again.',
            findUsOnMap: 'Find Us on the Map',
            whatsappSubject: 'Mahi Beach Ayurveda Resort Contact',
            whatsappName: 'Name',
            whatsappEmail: 'Email',
            whatsappContactNumber: 'Contact Number',
            whatsappMessage: 'Message'
        },
        about: {
            heroTitle: 'About Us',
            heroSubtitle: 'Mahi Beach Ayurveda Resort',
            heroBeachResort: 'Beach Resort',
            heroTagline1: 'Ancient wisdom meets modern at Mahi Beach Ayurveda Resort',
            heroTagline2: 'Personalized Ayurvedic treatments, ocean views and genuine Sri Lankan hospitality',
            heroDescription: 'Experience authentic Ayurvedic wellness in our signature Deluxe Room, where ocean serenity meets timeless healing.',
            bookDeluxeRoom: 'Book Your Deluxe Room',
            bookDeluxeRoomShort: 'Book Deluxe Room',
            slide1: 'Deluxe Serenity',
            slide2: 'Ayurvedic Harmony',
            slide3: 'Beachfront Luxury',
            slide4: 'Natural Elegance',
            slide5: 'Healing Escape',
            historyLabel: 'Our Journey',
            historyTitle: 'Mahi Beach Ayurveda Resort',
            historyDesc1: 'Established in 2025, Mahi Beach Ayurveda Resort was born from a vision to create a sanctuary where ancient Ayurvedic wisdom meets the tranquil beauty of Sri Lanka\'s southern coast. Located in the serene coastal town of Maggona, our resort brings together traditional healing practices with modern luxury and comfort.',
            historyDesc2: 'Our founders, inspired by generations of traditional Ayurvedic practitioners, sought to preserve these time-honored healing arts while providing world-class facilities and genuine Sri Lankan hospitality. From our opening, we have remained committed to authentic Ayurvedic experiences, offering personalized treatments and care that honor the ancient traditions of holistic wellness.',
            historyDesc3: 'At Mahi Beach Ayurveda Resort, we welcome guests from around the world to experience the transformative power of authentic Ayurveda. Each visitor becomes part of our story, finding balance, healing, and rejuvenation in our peaceful beachfront haven.',
            statYear: '2025',
            statYearLabel: 'Established',
            statGuest: 'World-Class',
            statGuestLabel: 'Ayurveda Experience',
            experienceLegacy: 'Experience Our Vision',
            established: 'Established',
            since2010: 'Since 2025',
            chairmanLabel: 'Chairman\'s Vision',
            chairmanTitle: 'Rooted in Tradition, Inspired by Wellness',
            chairmanDesc1: 'Welcome to Mahi Beach Ayurveda Resort. Our vision since 2025 has been to create a sanctuary where ancient Ayurvedic wisdom meets modern comfort, all wrapped in the genuine warmth of Sri Lankan hospitality.',
            chairmanDesc2: 'Every aspect of our resort—from personalized treatments and nourishing cuisine to the peaceful ambiance of our spaces—is thoughtfully crafted to support your path to wellness, balance, and inner peace. It is our privilege to accompany you on this transformative journey.',
            chairmanDesc3: 'I personally welcome you to discover the harmony, authenticity, and tranquility that are the foundation of Mahi Beach.',
            chairmanSignature: '— Mr. Mahinda',
            chairmanBadge: 'Chairman',
            chairmanName: 'Mr. Mahinda',
            chairmanImageAlt: 'Chairman Mr. Mahinda',
            staffLabel: 'Our Team',
            staffTitle: 'Meet Our Dedicated Staff',
            staffDesc1: 'At Mahi Beach Ayurveda Resort, our team is the heart of everything we do. Our staff members are carefully selected and trained professionals who share a deep passion for Ayurvedic and authentic hospitality.',
            staffDesc2: 'From our experienced Ayurvedic practitioners and skilled massage therapists to our dedicated hospitality team, each member brings years of expertise and genuine care to every guest interaction. We believe that true comes not just from treatments, but from the warmth and attention of people who genuinely care about your journey.',
            staffDesc3: 'Our staff undergoes continuous training in the latest Ayurvedic practices while maintaining the highest standards of professionalism and cultural sensitivity. We take pride in creating meaningful connections with our guests, ensuring that every visit becomes a memorable and transformative experience.',
            statStaff: '15+',
            statStaffLabel: 'Skilled Professionals',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Guest Satisfaction',
            staffImageAlt: 'Our dedicated staff team at Mahi Beach Ayurveda Resort',
            commitmentBadge: 'Our Commitment',
            excellenceCare: 'Excellence & Care',
            ctaLabel: 'Get in Touch',
            ctaHeading: 'Ready to Begin Your Journey?',
            ctaDesc: 'Connect with our team to book your personalized Ayurvedic retreat. Whether you have questions about our therapies, accommodations, or special packages, we\'re here to help create your perfect escape.',
            ctaButtonContact: 'Contact Us Now',
            ctaButtonRooms: 'Explore Rooms',
            contactUs: 'Contact Us',
            quickInfoCall: 'Call Us',
            quickInfoEmail: 'Email Us',
            quickInfoLocation: 'Location',
            locationCity: 'Maggona Sri Lanka'
        },
        rooms: {
            heroTitle: 'Your Sanctuary Awaits',
            heroSubtitle: 'Handcrafted spaces designed for healing, restoration, and profound peace.',
            heroAlt: 'Mahi Beach Ayurveda Resort Rooms',
            exploreRooms: 'Explore Our Rooms',
            filterAll: 'All',
            filterLuxurySuite: 'Sea View Luxury Suite',
            filterDeluxeRooms: 'Deluxe Rooms',
            filterDeluxeSeaView: 'Deluxe Room with Sea View',
            noRoomsFound: 'No rooms found in this category.',
            allRoomsInclude: 'All Rooms Include',
            essentialComforts: 'Essential comforts for your journey',
            roomSize: 'Room Size',
            guests: 'Guests',
            amenities: 'Amenities',
            roomAmenities: 'Room Amenities',
            specialFeatures: 'Special Features',
            bookNow: 'Book Now',
            viewDetails: 'View Details',
            viewFullDetails: 'View Full Details',
            highSpeedWifi: 'High-Speed WiFi',
            herbalTea: 'Herbal Tea Selection',
            climateControl: 'Climate Control',
            rainShower: 'Rain Shower',
            organicToiletries: 'Organic Toiletries',
            dailyHousekeeping: 'Daily Housekeeping',
            concierge: '24/7 Concierge',
            yogaMat: 'Yoga Mat & Props',
            beginHealing: 'Begin Your Healing Journey',
            beginHealingDesc: 'Experience authentic Ayurvedic in surroundings designed to nurture your body, calm your mind, and restore your spirit.',
            reserveRoom: 'Reserve Your Room',
            speakAdvisor: 'Speak to Advisor',
            exploreOurRooms: 'Explore Our Rooms',
            viewRoom: 'View Room',
            luxurySuiteName: 'Sea View Luxury Suite',
            luxurySuiteCategory: 'Sea View Luxury Suite',
            luxurySuiteDesc: 'Experience ultimate serenity in our spacious Luxury Suite, designed with traditional Ayurvedic principles and breathtaking Sea views.',
            deluxeRoomName: 'Deluxe Room',
            deluxeRoomCategory: 'Deluxe Rooms',
            deluxeRoomDesc: 'Harmoniously balanced room featuring natural wood elements and cooling water features for perfect tranquility.',
            seaViewDeluxeName: 'Sea View Deluxe',
            seaViewDeluxeCategory: 'Deluxe Room with Sea View',
            seaViewDeluxeDesc: 'Wake up to calming sea breezes and panoramic ocean views in this elegantly designed deluxe room.',
            kingSizeBed: 'King-Size Bed',
            herbalTeaCoffee: 'Herbal Tea & Coffee',
            individuallyControlledAC: 'Individually Controlled AC',
            premiumOrganicToiletries: 'Premium Organic Toiletries',
            dailyFreshFlowers: 'Daily Fresh Flowers',
            beachView: 'Beach View',
            signatureAccommodation: 'Signature Accommodation',
            inRoomComfort: 'In-Room Comfort',
            deluxeRoomAmenities: 'Deluxe Room Amenities',
            momentsInDeluxeRoom: 'Moments in the Deluxe Room',
            experienceAyurvedicLiving: 'Experience authentic Ayurvedic living in our signature Deluxe Room',
            reserveYourStay: 'Reserve Your Stay',
            deluxeRoom: {
                resortName: 'Mahi Beach Ayurveda Resort',
                heroTitle: 'Deluxe Room with a Balcony and Sea View',
                heroSubtitle: 'Unwind in a calming coastal retreat inspired by the golden beaches of Bentota, pairing modern amenities with gentle sea breezes.',
                bookThisRoom: 'Book this room',
                callReservations: 'Call reservations',
                signatureFeatures: 'Signature Features',
                deluxeRoomName: 'Deluxe Room',
                discoverTheSpace: 'Discover the Space',
                whatsIncluded: "What's Included",
                deluxeComfortCare: 'Deluxe Comfort & Care',
                inclusions: 'Inclusions',
                coreAmenities: 'Core Amenities',
                amenityHighSpeedWifi: 'High-speed Wi-Fi',
                amenityHerbalTeaCoffee: 'Herbal tea & coffee',
                amenityIndividuallyControlledAC: 'Individually controlled A/C',
                amenityRainShower: 'Rain shower',
                amenityOrganicToiletries: 'Organic toiletries',
                amenityDailyFreshFlowers: 'Daily fresh flowers',
                beginYourHealingStay: 'Begin Your Healing Stay',
                experienceAyurvedicSerenity: 'Experience authentic Ayurvedic serenity in our signature Deluxe Room',
                checkAvailabilityBook: 'Check Availability & Book',
                speakWithReservations: 'Speak with Reservations',
                reserveThisRoom: 'Reserve This Room',
                navAll: 'All',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe with Sea View',
                navSuite: 'Suite',
                sectionTitle: 'A soothing coastal hideaway',
                sectionDesc: 'The Deluxe Room is crafted for slow mornings and unhurried sunsets. Soft neutral tones, generous glazing, and thoughtful lighting invite the sea view in, while the balcony offers your own perch above the shoreline.',
                highlight1Title: 'Panoramic Beach Views',
                highlight1Desc: 'Wake up to azure waters and golden sunrises from your private balcony.',
                highlight2Title: 'Elegant Coastal Interiors',
                highlight2Desc: 'Soft neutral palettes, warm timber accents, and generous natural light.',
                highlight3Title: 'Serene Sleep Experience',
                highlight3Desc: 'Plush king bed with premium linens curated for restorative rest.',
                atAGlance: 'At a glance',
                statSize: 'Size',
                statSizeValue: '41 sqm',
                statView: 'View',
                statViewValue: 'Indian Ocean',
                statGuests: 'Guests',
                statGuestsValue: '2 Adults',
                statBed: 'Bed',
                statBedValue: 'King or Twin',
                reserve: 'Reserve',
                galleryAlt: 'Deluxe room gallery',
                inclusionsTitle: 'Included with your stay',
                inclusionsSubtitle: 'Thoughtful touches, all-day comfort',
                enhancedCleanliness: 'Enhanced cleanliness and safety standards',
                inclusion1: 'Complimentary breakfast,Lunch,Dinner at Breeze Restaurant',
                inclusion2: 'High-speed Wi-Fi and in-room workspace',
                inclusion3: '24-hour room service and concierge',
                inclusion4: 'Daily housekeeping with evening turndown',
                inclusion5: 'Access to infinity pool and Ayurveda spa facilities',
                inclusion6: 'Complimentary parking and shuttle service to nearby attractions',
                amenityGroup1Title: 'Room Features',
                amenityGroup1Item1: '41 sqm of space',
                amenityGroup1Item2: 'Private balcony with seating',
                amenityGroup1Item3: 'Air conditioning with climate control',
                amenityGroup1Item4: 'In-room safe',
                amenityGroup2Title: 'Bath Experience',
                amenityGroup2Item1: 'Rain shower with hot and cold water',
                amenityGroup2Item2: 'Premium bath amenities',
                amenityGroup2Item3: 'Hair dryer',
                amenityGroup2Item4: 'Soft bathrobes and slippers',
                amenityGroup3Title: 'In-Room Comforts',
                amenityGroup3Item1: '55" smart TV with cable',
                amenityGroup3Item2: 'Coffee and tea station',
                amenityGroup3Item3: 'Direct-dial telephone',
                amenityGroup4Title: 'Connectivity',
                amenityGroup4Item1: 'Complimentary Wi-Fi',
                amenityGroup4Item2: 'Work desk',
                amenityGroup4Item3: '24/7 front desk support',
                essentialsTitle: 'In-room essentials',
                essentialsHeading: 'Everything you need to feel at home',
                essentialsDesc: 'From seamless connectivity to carefully chosen refreshments, the Deluxe Room blends leisure and practicality so you can focus on the moments that matter.',
                essential1: 'Complimentary Wi-Fi',
                essential2: 'Coffee and tea station',
                essential3: '24/7 room service',
                essential4: 'Rain shower',
                oceanTitle: 'By the ocean',
                oceanSubtitle: 'Slow down, breathe in the sea air',
                oceanAlt: 'Deluxe room seating',
                ctaTitle: 'Ready to stay?',
                ctaHeading: 'Reserve the Deluxe Room today',
                ctaDesc: 'Speak with our reservations team for the best available rates and special offers.',
                checkAvailability: 'Check availability'
            }
        },
        home: {
            // Hero Section
            heroTitle: 'Mahi Beach Ayurveda Resort',
            heroSubtitle1: 'Ayurveda by the ocean',
            heroSubtitle2: 'Find balance, breathe easy, and renew your energy in Maggona.',
            exploreResort: 'Explore resort',
            bookNow: 'Book now',

            // Sections
            sections: {
                recommendations: {
                    title: 'Our Signature Experiences',
                    subtitle: 'Discover what makes your Ayurvedic journey transformative'
                }
            },

            // Recommendations Section
            recommendations: {
                panchakarma: {
                    label: 'ANCIENT HEALING',
                    name: 'Panchakarma Ayurveda'
                },
                yoga: {
                    label: 'MIND & BODY',
                    name: 'Yoga & Meditation'
                },
                cuisine: {
                    label: 'WELLNESS DINING',
                    name: 'Ayurvedic Cuisine'
                },
                wellness: {
                    label: 'TOTAL WELLNESS',
                    name: 'Wellness Packages'
                },
                spa: {
                    label: 'RELAXATION',
                    name: 'Spa Therapies'
                }
            },

            // Welcome Section
            welcomeLabel: 'Welcome',
            welcomeTitle: 'Mahi Beach Ayurveda Resort',
            welcomeDesc1: 'Nestled along the pristine shores of Maggona, Mahi Beach Ayurveda Resort offers a harmonious blend of ancient healing traditions and modern coastal luxury. Our sanctuary invites you to embark on a transformative transformative journey, where the rhythmic sounds of the Indian Ocean meet the timeless wisdom of Ayurveda.',
            welcomeDesc2: 'Experience personalized Ayurvedic treatments, savor nourishing cuisine crafted to balance your dosha, and unwind in elegantly appointed rooms with breathtaking ocean views. Whether you seek rejuvenation, relaxation, or spiritual renewal, our dedicated team of Ayurvedic practitioners and experts are here to guide you every step of the way.',
            learnMore: 'Learn More',
            contactUs: 'Contact Us',
            welcomeImageAlt: 'Mahi Beach Ayurveda Resort',
            welcomeImageCaption: 'Ayurveda & Beach Retreat',
            welcomeImageLocation: 'Maggona Sri Lanka',

            // Highlight Section
            highlightTitle: 'A seaside Ayurveda sanctuary',
            highlightDesc: 'Discover holistic healing on Sri Lanka\'s southwest coast. From tailored treatments to quiet balconies and mindful cuisine, every detail is crafted to restore your rhythm.',

            // Services
            service1Title: 'Holistic Ayurveda Therapies',
            service1Desc: 'Personalized consultations, authentic herbal oils, and daily treatments guided by experienced Ayurveda doctors.',
            service2Title: 'Beachfront Rooms & Suites',
            service2Desc: 'Wake up to ocean breeze, private balconies, and calming interiors designed for deep rest.',
            service3Title: 'Cuisine',
            service3Desc: 'Fresh Sri Lankan produce, plant-forward menus, and tailored meal plans that complement your dosha.',
            service4Title: 'Yoga & Mindfulness',
            service4Desc: 'Sunrise yoga, sunset meditation, and breathwork sessions set against the rhythm of the waves.',
            service5Title: 'Coastal Excursions',
            service5Desc: 'Coastal boat rides, turtle hatchery visits, spice garden walks, and village cycling tours.',

            // Rooms
            roomsTitle: 'Our Rooms',
            roomsDesc: 'Choose the sanctuary that matches your pace, from breezy suites to cozy deluxe hideaways, each layered with soft linens, warm wood, and sunrise-ready balconies.',
            roomBadge: 'Oceanfront Escape',
            bookableNow: 'Bookable now',
            seaBreezeReady: 'Sea breeze ready',
            viewRoom: 'View Room',
            room1Title: 'Sea View Suite Rooms',
            room1Desc: 'Spacious suites with lounge seating, generous balconies, and calming palettes for slow mornings.',
            room2Title: 'Deluxe Rooms',
            room2Desc: 'Cozy retreats with plush beds, garden views, and warm wooden accents for everyday ease.',
            room3Title: 'Deluxe Sea View',
            room3Desc: 'Wake to the ocean horizon, soft linens, and a private balcony made for golden sunsets.',

            // Achievements
            achievementsTitle: 'Trusted by the sea',
            achievement1Title: 'Happy Guests',
            achievement1Count: '1,000+',
            achievement2Title: 'Ayurveda Treatments',
            achievement2Count: '20+',
            achievement3Title: 'Years of Care',
            achievement3Count: '15+',
            achievement4Title: 'Traveler Accolades',
            achievement4Count: '1,000+',

            // Experiences
            experiencesTitle: 'Explore Mahi Beach Ayurveda Resort',
            experiencesDesc: 'From Ayurveda journeys to curated excursions, choose the experiences that make your stay memorable.',
            planYourStay: 'Plan your stay',
            experience1Title: 'Rooms & Suites',
            experience1Desc: 'Airy spaces with balconies, ocean or garden views, and thoughtful comforts for unhurried stays.',
            experience2Title: 'Ayurveda Spa',
            experience2Desc: 'Authentic therapies, steam baths, and restorative massages delivered with time-honored rituals.',
            experience3Title: 'Dining Experience',
            experience3Desc: 'Nutritious Sri Lankan and international cuisine served in our restaurant, thoughtfully prepared to nourish both body and mind.',
            experience4Title: 'Experiences & Tours',
            experience4Desc: 'Coastal tours, temple visits, water sports, and curated cultural excursions around Bentota.',

            // Gallery
            galleryTitle: 'Moments at Mahi Beach Ayurveda Resort',
            galleryDesc: 'A glimpse into our coastal sanctuary—sunrises, serene treatments, nourishing plates, and quiet corners made for you.',
            gallery1Alt: 'Sunlit palm-lined beach at Mahi Beach',
            gallery2Alt: 'Ayurveda oil treatment in progress',
            gallery3Alt: 'Resort pool with loungers',
            gallery4Alt: 'Herbal ingredients prepared for spa',
            gallery5Alt: 'Couple enjoying sunset by the sea',
            gallery6Alt: 'Yoga deck facing the ocean',
            gallery7Alt: 'Tropical garden pathway',
            gallery8Alt: 'Healthy breakfast spread',
            gallery9Alt: 'Serene coastal view',
            gallery10Alt: 'Warmly lit resort exterior at dusk',
            gallery11Alt: 'Ayurveda herbs and oils display',
            gallery12Alt: 'Cozy seating by the garden',

            // Resort Images
            resort1Alt: 'Open-air lounge with greenery',
            resort2Alt: 'Comfortable room interior',
            resort3Alt: 'Spa treatment space',
            resort4Alt: 'Dining area with natural light',
            resort5Alt: 'Relaxing pool view',

            // Sunset Section
            sunsetLabel: 'Nature\'s Daily Masterpiece',
            sunsetTitle: 'Evening Sunset',
            sunsetDesc1: 'As day gracefully surrenders to dusk, witness the sky transform into a canvas of amber, crimson, and gold. The gentle Indian Ocean mirrors this celestial spectacle, creating a mesmerizing symphony of light and water.',
            sunsetDesc2: 'Every evening at Mahi Beach offers front-row seats to one of nature\'s most breathtaking performances. Find your perfect vantage point—whether from your private balcony, the beachfront lounge, or our sunset meditation deck—and let the serene beauty wash over you.',
            sunsetFeature1: 'Unobstructed ocean views from every corner',
            sunsetFeature2: 'Sunset calm meditation',
            sunsetFeature3: 'Complimentary herbal tea served daily',
            sunsetFeature4: 'Picture-perfect moments every evening',
            sunsetImageAlt: 'Evening sunset at Mahi Beach Ayurveda Resort',
            bestTime: 'Best Time',
            sunsetTime: '6:00 PM - 6:45 PM',

            // Pool Section
            poolLabel: 'Aquatic Serenity',
            poolTitle: 'Pool Area',
            poolDesc1: 'Immerse yourself in tranquility at our pristine infinity pool, where crystal-clear waters meet lush tropical gardens. Designed for relaxation and rejuvenation, our pool area offers the perfect escape to unwind under the Sri Lankan sun.',
            poolDesc2: 'Whether you prefer a refreshing morning swim, an afternoon lounging session with a good book, or a peaceful evening dip, our pool area provides an idyllic setting. Surrounded by comfortable sun loungers, shaded cabanas, and attentive poolside service, every moment becomes a cherished memory.',
            poolFeature1: 'Temperature-controlled infinity pool',
            poolFeature2: 'Surrounded by tropical garden landscapes',
            poolFeature3: 'Poolside refreshments & healthy snacks',
            poolFeature4: 'Premium sun loungers with umbrellas',
            poolImageAlt: 'Relaxing pool area at Mahi Beach Resort',

            // Guest Departure Ceremony
            departureLabel: 'Farewell Tradition',
            departureTitle: 'Guest Departure Ceremony',
            departureDesc1: 'At Mahi Beach Ayurveda Resort, we honor your journey with us through a meaningful departure ceremony rooted in Sri Lankan tradition. As you prepare to leave, our team gathers to offer blessings for safe travels and continued wellness.',
            departureDesc2: 'This heartfelt ritual includes traditional blessings, a special farewell menu featuring authentic Sri Lankan delicacies, and a small gift to carry our warmth with you. It\'s our way of ensuring your memories of Mahi Beach remain cherished long after you depart.',
            departureFeature1: 'Traditional Buddhist blessings for safe travels',
            departureFeature2: 'Personalized farewell gifts and mementos',
            departureFeature3: 'Special departure menu with Sri Lankan delicacies',
            departureFeature4: 'Blessing ceremony with sacred rituals',
            departureImageAlt: 'Guest departure ceremony at Mahi Beach Resort',

            // TripAdvisor
            tripadvisorLabel: 'TripAdvisor',
            tripadvisorTitle: 'Guest Reviews',

            // Testimonials
            testimonialsTitle: 'Guests on their stay',
            testimonialsLabel: 'Guest Stories',

            // Video Section
            videoLabel: 'Immersive Experience',
            videoTitle: 'Discover Mahi Beach',
            videoDescription: 'Experience the beauty and tranquility of Mahi Beach Ayurveda Resort through our immersive video journey. Explore world-class amenities, pristine beaches, and rejuvenating wellness experiences.',

            // Featured Room
            featuredRoomLabel: 'Signature Accommodation',
            featuredRoomTitle: 'Deluxe Double Room with Sea View',

            // Booking Bar
            bookingResort: 'Resort',
            bookingResortName: 'Mahi Beach Ayurveda Resort',
            bookingCheckIn: 'Check-in',
            bookingCheckOut: 'Check-out',
            bookingGuests: 'Guests',
            booking1Guest: '1 Guest',
            booking2Guests: '2 Guests',
            booking3Guests: '3 Guests',
            bookingCheckAvailability: 'Check Availability',

            // Hero Buttons
            heroExploreButton: 'Explore Mahi Beach',
            heroBookButton: 'Book Deluxe Room'
        }

    },
    de: {
        navbar: {
            home: 'Startseite',
            aboutUs: 'Über uns',
            rooms: 'Zimmer',
            ayurveda: 'Ayurveda',
            yoga: 'Yoga',
            food: 'Essen',
            events: 'Veranstaltungen',
            blogs: 'Blogs',
            tours: 'Touren',
            contactUs: 'Kontakt',
            bookOnline: 'Online buchen',
            locationMaggona: 'Maggona Sri Lanka',
            selectResort: 'Resort wählen',
            language: 'Sprache',
            mainTitle: 'Mahi Beach Ayurveda Resort',
            resortBeach: 'Mahi Beach Ayurveda Resort'
        },
        footer: {
            description: 'Das Mahi Beach Ayurveda Resort bietet außergewöhnliche Gastfreundschaft und Wellness-Erlebnisse, damit sich jeder Gast wertgeschätzt und erholt fühlt.',
            linksTitle: 'Links',
            contactTitle: 'Kontakt',
            viewLocation: 'Standort anzeigen',
            navHome: 'Startseite',
            navAbout: 'Über uns',
            navContact: 'Kontakt',
            navRooms: 'Zimmer',
            navAyurveda: 'Ayurveda',
            copyright: '© Copyright {{year}} Mahi Beach Ayurveda Resort.',
            developedBy: 'Entwickelt von',
            developerName: 'Redev Solution +94 764 608 225'
        },
        tours: {
            heroTitle: 'Touren & Ausflüge',
            heroSubtitle: 'Entdecken Sie Sri Lankas Schönheit von Maggona',
            kandeAlt: 'Kande-Vihara-Tempel - Maggona',
            kandeTitle: 'Besuch des Kande-Vihara-Tempels',
            kandeBuddhaAlt: 'Riesige Buddha-Statue im Kande-Vihara-Tempel',
            bentotaTitle: 'Küsten-Bootsfahrt',
            bentotaAlt: 'Küsten-Bootsfahrt - Meeresleben und natürliche Schönheit',
            galleTitle: 'Galle-Altstadt-Tour',
            galleAlt: 'Galle-Altstadt-Tour',
            sigiriyaTitle: 'Sigiriya-Felsenfestung-Tour',
            sigiriyaAlt: 'Sigiriya-Felsenfestung-Tour',
            kandyTitle: 'Kandy-Kulturtour',
            kandyAlt: 'Kandy-Kulturtour',
            bookTour: 'Diese Tour buchen',
            viewDetails: 'Details anzeigen',
            introPara1: 'Sri Lanka ist ein Land zeitloser Schönheit, in dem goldene Strände, üppig grüne Landschaften, alte Tempel und lebendige Kultur in perfekter Harmonie zusammenkommen.',
            introPara2: 'Von der ruhigen Südwestküste bis zu historischen Städten, heiligen Stätten, Wildschutzgebieten und nebligen Berglandschaften bietet jede Reise ein einzigartiges und unvergessliches Erlebnis.',
            introPara3: 'Von unserem Mahi Beach Ayurveda Resort in Maggona aus sind unsere sorgfältig kuratieren Touren und Ausflüge darauf ausgerichtet, Ihren Aufenthalt zu bereichern und perfekt Balance zwischen Erkundung, Entspannung und Wohlbefinden zu schaffen.',
            kandeDetail1: 'Kande-Vihara-Tempel (Kande Viharaya) – einer der ikonischsten buddhistischen Tempel in der Nähe von Maggona.',
            kandeDetail2: 'Dieser 1734 gegründete, ruhige \'Bergtempel\' thront auf einem Hügel mit friedlichen Ausblicken auf die Küste.',
            kandeDetail3: 'Zu den Höhepunkten gehören die massive 48 Meter hohe sitzende Buddha-Statue (eine der höchsten Sri Lankas), aufwendige Kandyan-Fresken, eine alte Reliquienkammer, ein schöner Mondstein-Eingang und ein über 300 Jahre alter heiliger Bodhi-Baum.',
            kandeDetail4: 'Ein perfektes spirituelles und kulturelles Erlebnis für einen halben Tag – ideal für Morgenbesuche, um der Hitze zu entgehen.',
            bentotaDetail1: 'Genießen Sie eine ruhige und malerische Bootsfahrt entlang der Küstengewässer, einer der beliebtesten Naturexkursionen in der Nähe von Maggona.',
            bentotaDetail2: 'Gleiten Sie durch malerische Küstenrouten, ruhige Buchten und kristallklares Wasser und beobachten Sie dabei das lokale Meeresleben.',
            bentotaDetail3: 'Häufige Sichtungen sind Meeresschildkröten, Delfine, verschiedene Seevogelarten (Möwen, Reiher, Fregattvögel) und vielfältiges marines Leben.',
            bentotaDetail4: 'Ihr erfahrener Bootsführer/Reiseleiter zeigt Ihnen interessante Küstenformationen, traditionelle Fischereimethoden und die maritime Kultur der Küste.',
            bentotaDetail5: 'Perfekt für Naturliebhaber und Fotografen – ruhig, entspannend und eine Ergänzung zu Ihrem Ayurveda-Wellness-Aufenthalt.',
            galleDetail1: 'Erkunden Sie die historische Galle-Festung, ein UNESCO-Weltkulturerbe und eine der best erhaltenen Festungen aus der Kolonialzeit Sri Lankas.',
            galleDetail2: 'Wandeln Sie durch Kopfsteinpflasterstraßen, gesäumt von niederländischen Kolonialgebäuden, Boutique-Shops, Cafés und Kunstgalerien.',
            galleDetail3: 'Besuchen Sie Wahrzeichen wie den Galle-Leuchtturm, die niederländische reformierte Kirche, das Nationale Schifffahrtsmuseum und die Wälle mit herrlichem Meerblick.',
            galleDetail4: 'Erfahren Sie von Ihrem sachkundigen Reiseleiter mehr über die reiche Geschichte, Architektur und kulturelle Bedeutung der Festung.',
            galleDetail5: 'Ideal für Geschichtsliebhaber, Kulturfans und diejenigen, die Sri Lankas Kolonialvergangenheit erleben möchten.',
            sigiriyaDetail1: 'Entdecken Sie die antike Felsenfestung Sigiriya, eines der ikonischsten Wahrzeichen Sri Lankas und ein UNESCO-Weltkulturerbe.',
            sigiriyaDetail2: 'Klettern Sie auf den beeindruckenden Felsen und erkunden Sie die Ruinen des Palastes von König Kasyapa, verziert mit Fresken, Wassergärten und der berühmten Spiegelmauer.',
            sigiriyaDetail3: 'Genießen Sie Panoramablicke auf den umliegenden Dschungel und die Landschaft vom Gipfel.',
            sigiriyaDetail4: 'Erfahren Sie von Ihrem Experten über die faszinierende Geschichte, Architektur und Legenden von Sigiriya.',
            sigiriyaDetail5: 'Perfekt für Geschichtsbegeisterte, Abenteuerlustige und diejenigen, die sich für Sri Lankas reiches Kulturerbe interessieren.',
            kandyDetail1: 'Erleben Sie die lebendige Kultur von Kandy, Sri Lankas letzte Königshauptstadt und ein UNESCO-Weltkulturerbe.',
            kandyDetail2: 'Besuchen Sie den Tempel der heiligen Zahnreliquie (Sri Dalada Maligawa), eine der wichtigsten buddhistischen Stätten der Welt.',
            kandyDetail3: 'Erkunden Sie die Royal Botanical Gardens in Peradeniya mit einer großartigen Sammlung von Tropenpflanzen und Orchideen.',
            kandyDetail4: 'Genießen Sie eine traditionelle Kandyan-Tanzaufführung, die Sri Lankas reiches künstlerisches Erbe zeigt.',
            kandyDetail5: 'Ideal für Kulturfans, Geschichtsliebhaber und diejenigen, die sich in Sri Lankas Traditionen vertiefen möchten.',
            ellaTitle: 'Ella-Bergland-Abenteuer',
            ellaAlt: 'Ella-Bergland-Tour - Neun-Bogen-Brücke und Teeplantagen',
            ellaDetail1: 'Reise nach Ella, einem der malerischsten Bergland-Destinationen Sri Lankas, bekannt für seine atemberaubenden Bergpanoramen und kühles Klima.',
            ellaDetail2: 'Besuchen Sie die ikonische Neun-Bogen-Brücke, ein Eisenbahnwunder aus der Kolonialzeit inmitten üppigem Grün, perfekt zum Fotografieren und Beobachten vorbeifahrender Züge.',
            ellaDetail3: 'Erkunden Sie grüne Teeplantagen, lernen Sie über Ceylon-Tee-Produktion und genießen Sie Panoramablicke vom Little Adam\'s Peak oder Ella Rock.',
            ellaDetail4: 'Entdecken Sie kaskadierende Wasserfälle wie die Ravana-Fälle, wandern Sie auf malerischen Pfaden und erleben Sie die charmante Dorfatmosphäre.',
            ellaDetail5: 'Perfekt für Naturliebhaber, Abenteuerlustige und diejenigen, die in Sri Lankas atemberaubendes Hochland entfliehen möchten.'
        },
        blogs: {
            heroTitle: 'Mahi Beach Ayurveda Resort Blogs',
            heroSubtitle1: 'Geschichten von der Küste, Ayurveda-Rituale im',
            heroSubtitle2: 'Mahi Beach Ayurveda Resort',
            heroSubtitle3: '. Entdecken Sie Tipps, Geschichte und Einblicke hinter die Kulissen.',
            heroAlt: 'Resort-Strandweg bei Sonnenuntergang',
            sectionTitle: 'Mahi Beach Ayurveda Resort Blogs',
            sectionDescription: 'Anleitungen, Geschichten und Notizen aus unserem Küstenrefugium – von Ayurveda-Ritualen über Edelsteingeschichte bis hin zu Reisetipps rund um Bentota.',
            ayurvedaTitle: 'Das Herz des authentischen Ayurveda',
            ayurvedaExcerpt: 'Erleben Sie ehrwürdige Heiltraditionen, verwurzelt in Sri Lankas alter Weisheit.',
            ayurvedaDescription: 'Im Mahi Beach Ayurveda Resort ist Ayurveda mehr als eine Behandlung – es ist eine Lebensweise. Unsere Therapien basieren auf jahrhundertealtem Wissen, sind auf Ihren Körpertyp abgestimmt und werden von erfahrenen Ayurveda-Ärzten für tiefes, anhaltendes Gleichgewicht geleitet.',
            ayurvedaAlt: 'Ayurvedische Behandlung mit Kräuterölen und natürlichen Elementen',
            healingTitle: 'Personalisierte Heilreisen',
            healingExcerpt: 'Warum jedes Wellness-Programm einzigartig gestaltet ist.',
            healingDescription: 'Von der ersten Beratung bis zu den täglichen Behandlungen wird Ihre Heilreise sorgfältig auf Sie zugeschnitten. Kräutertherapien, therapeutische Massagen, Yoga und Meditation wirken zusammen, um die Harmonie zwischen Körper, Geist und Seele wiederherzustellen.',
            healingAlt: 'Ayurveda-Arzt berät einen Gast in ruhiger Umgebung',
            natureTitle: 'Heilung am Ozean',
            natureExcerpt: 'Wie Meeresbrise und tropische Umgebung Ihr Wohlbefinden verstärken.',
            natureDescription: 'Eingebettet an Sri Lankas ruhiger Küste bietet Mahi Beach eine natürlich heilende Umgebung. Das Rauschen der Wellen, frische Meeresluft und üppiges Grün verstärken die Wirkung von Ayurveda und schaffen tiefe Entspannung und Erneuerung.',
            natureAlt: 'Strandblick auf das Resort mit Palmen und Ozean',
            foodTitle: 'Ayurvedische Küche für inneres Gleichgewicht',
            foodExcerpt: 'Nahrhafte Mahlzeiten zur Unterstützung Ihrer Behandlung.',
            foodDescription: 'Unsere ayurvedische Küche wird frisch mit saisonalen, lokal bezogenen Zutaten zubereitet. Jede Mahlzeit ist auf Ihr Dosha abgestimmt und unterstützt Verdauung, Entgiftung und allgemeine Vitalität, während sie schmackhaft und befriedigend bleibt.',
            foodAlt: 'Traditionelle ayurvedische Mahlzeit in natürlichen Schalen serviert',
            yogaTitle: 'Yoga, Meditation & innere Stille',
            yogaExcerpt: 'Sanfte Praktiken, die den Geist beruhigen und den Körper stärken.',
            yogaDescription: 'Tägliche Yoga- und Meditationssitzungen ergänzen Ihre Behandlungen und verbessern Flexibilität, Atmung und geistige Klarheit. Diese achtsamen Praktiken helfen Ihnen, sich wieder mit sich selbst zu verbinden und ein Gefühl des Friedens über Ihren Aufenthalt hinaus zu bewahren.',
            yogaAlt: 'Gäste praktizieren Yoga mit Blick auf den Ozean bei Sonnenaufgang',
            lifestyleTitle: 'Ayurveda nach Hause bringen',
            lifestyleExcerpt: 'Einfache Lebensstilpraktiken zur Fortsetzung Ihrer Wellness-Reise.',
            lifestyleDescription: 'Vor Ihrer Abreise beraten unsere Experten Sie darüber, wie Sie durch tägliche Routinen, Ernährung und Selbstpflegerituale das Gleichgewicht aufrechterhalten können. Nehmen Sie mehr als Erinnerungen mit nach Hause – nehmen Sie einen nachhaltigen Weg zu gesünderem Leben mit.',
            lifestyleAlt: 'Gast entspannt mit Kräutertee in ruhiger Resort-Umgebung',
            readMore: 'Mehr lesen'
        },
        events: {
            heroEyebrow: 'Erlebnisse & Aktivitäten',
            heroTitle: 'Unsere Veranstaltungen',
            heroSubtitle: 'Kuratiertes Erleben, das sri-lankische Tradition mit Küstenluxus verbindet',
            heroAlt: 'Veranstaltungen bei Mahi Beach',
            availableDaily: 'Täglich verfügbar',
            bookNow: 'Jetzt buchen',
            highlightsTitle: 'Highlights',
            detailAlt: '{{title}} im Detail',
            ctaTitle: 'Bereit, Erinnerungen zu schaffen?',
            ctaDescription: 'Kontaktieren Sie unser Team, um Ihr perfektes Veranstaltungserlebnis im Mahi Beach Ayurveda Resort zu gestalten',
            ctaContact: 'Kontakt',
            ctaViewRooms: 'Zimmer ansehen',
            buddhistMonkMeditationTitle: 'Meditation mit buddhistischen Mönchen',
            buddhistMonkMeditationSubtitle: 'Traditionelle Achtsamkeitspraktiken',
            buddhistMonkMeditationDescription: 'Erleben Sie authentische buddhistische Meditation unter der Leitung erfahrener Mönche in unserem friedlichen Resort. Diese alten Praktiken fördern inneren Frieden, Achtsamkeit und spirituelles Wohlbefinden durch geführte Sitzungen mit traditionellem Chanten, Atemtechniken und stiller Meditation.',
            buddhistMonkMeditationHighlight1: 'Traditionelle buddhistische Meditationssitzungen',
            buddhistMonkMeditationHighlight2: 'Erfahrene Anleitung durch Mönche',
            buddhistMonkMeditationHighlight3: 'Friedliche Innenräume im Resort',
            buddhistMonkMeditationHighlight4: 'Achtsamkeits- und Atemtechniken',
            buddhistMonkMeditationHighlight5: 'Spirituelle Wellness-Praktiken',
            cookeryTitle: 'Kochprogramme',
            cookerySubtitle: 'Geschmack Sri Lankas',
            cookeryDescription: 'Tauchen Sie in die lebendigen Aromen der sri-lankischen Küche ein. Unsere Chefköche führen Sie durch praktische Kochsessions und vermitteln traditionelle Rezepte, die über Generationen weitergegeben wurden. Lernen Sie, aromatische Currys, Hoppers, Kokos-Sambol und mehr mit frischen lokalen Zutaten zuzubereiten.',
            cookeryHighlight1: 'Traditionelle sri-lankische Rezepte',
            cookeryHighlight2: 'Praktisches Kocherlebnis',
            cookeryHighlight3: 'Frische lokale Zutaten',
            cookeryHighlight4: 'Rezepte zum Mitnehmen',
            cookeryHighlight5: 'Gewürzgarten-Tour inklusive',
            meditationTitle: 'Meditationsprogramme',
            meditationSubtitle: 'Innere Ruhe & Achtsamkeit',
            meditationDescription: 'Finden Sie Ruhe in unseren geführten Meditationen vor der friedlichen Kulisse des Indischen Ozeans. Unsere erfahrenen Lehrkräfte führen Sie durch alte Achtsamkeitstechniken, Atemübungen und Yoga-Praktiken, die den Geist beruhigen und die Seele erneuern.',
            meditationHighlight1: 'Sonnenaufgangs- & Sonnenuntergangssitzungen',
            meditationHighlight2: 'Meditation am Strand',
            meditationHighlight3: 'Angeleitet von Experten',
            meditationHighlight4: 'Atemtechniken',
            meditationHighlight5: 'Yoga- & Achtsamkeitspraktiken',
            nightBeachPartiesTitle: 'Grillabend',
            nightBeachPartiesSubtitle: 'Kulinarisches Stranderlebnis',
            nightBeachPartiesDescription: 'Genießen Sie einen unvergesslichen Grillabend am Strand unter den Sternen. Kosten Sie frisch gegrillte Meeresfrüchte, Premium-Fleisch und buntes Gemüse, während Sie dem beruhigenden Rauschen der Meereswellen lauschen. Unsere erfahrenen Köche bereiten jedes Gericht perfekt zu und schaffen ein unvergessliches kulinarisches Erlebnis in magischer Küstenkulisse.',
            nightBeachPartiesHighlight1: 'Frisch gegrillte Meeresfrüchte und Fleisch',
            nightBeachPartiesHighlight2: 'Live-Grillvorführung von Köchen',
            nightBeachPartiesHighlight3: 'Dining-Atmosphäre am Meer',
            nightBeachPartiesHighlight4: 'Premium-BBQ-Buffet-Auswahl',
            nightBeachPartiesHighlight5: 'Strandambiente mit Lagerfeuer',
            bbqTitle: 'BBQ-Partys',
            bbqSubtitle: 'Feiern am Strand',
            bbqDescription: 'Erleben Sie unvergessliche Abende mit unseren BBQ-Partys am Strand. Genießen Sie frisch gegrillte Meeresfrüchte, Premium-Fleisch und vegetarische Köstlichkeiten, während die Wellen in der Nähe rauschen. Live-Musik, Feuertänzer und der Sternenhimmel schaffen die perfekte Atmosphäre für Feier und Verbindung.',
            bbqHighlight1: 'Frisch gegrillte Meeresfrüchte',
            bbqHighlight2: 'Essen am Ozean',
            bbqHighlight3: 'Live-Unterhaltung',
            bbqHighlight4: 'Lagerfeuer-Erlebnis',
            bbqHighlight5: 'Anpassbare Menüs',
            boatTitle: 'Bootsfahrten',
            boatSubtitle: 'Küstenabenteuer',
            boatDescription: 'Begeben Sie sich auf bezaubernde Bootstouren entlang der Küstengewässer und erkunden Sie die Schönheit des Indischen Ozeans. Gleiten Sie durch malerische Routen, beobachten Sie exotische Meeresbewohner und Seevögel oder genießen Sie romantische Sonnenuntergangsfahrten. Unsere Bootsfahrten bieten eine einzigartige Perspektive auf Sri Lankas natürliche Küstenschönheit und vielfältige marine Ökosysteme.',
            boatHighlight1: 'Küstenkreuzfahrten',
            boatHighlight2: 'Beobachtung der Meeresfauna',
            boatHighlight3: 'Wildtierbeobachtung',
            boatHighlight4: 'Sonnenuntergangs-Bootstouren',
            boatHighlight5: 'Private Charter verfügbar',
            ayurvedaLecturesTitle: 'Vorträge der Ayurveda-Ärzte',
            ayurvedaLecturesSubtitle: 'Alte Weisheit & modernes Wohlbefinden',
            ayurvedaLecturesDescription: 'Entdecken Sie die tiefgreifenden Prinzipien des Ayurveda in fachkundig geleiteten Vorträgen von zertifizierten Ayurveda-Ärzten und Praktikern. Erfahren Sie mehr über Dosha-Balancing, Kräuterheilmittel, ganzheitliche Heilpraktiken und wie alte Weisheit auf modernes Wohlbefinden angewendet wird. Unsere interaktiven Sitzungen entmystifizieren die ayurvedische Philosophie und ihre Anwendung im Alltag.',
            ayurvedaLecturesHighlight1: 'Zertifizierte Ayurveda-Ärzte',
            ayurvedaLecturesHighlight2: 'Personalisierte Dosha-Analyse',
            ayurvedaLecturesHighlight3: 'Wissen zu Kräuterheilmitteln',
            ayurvedaLecturesHighlight4: 'Fragerunden inklusive',
            ayurvedaLecturesHighlight5: 'Wellness-Leitfaden zum Mitnehmen',
            traditionalClothsTitle: 'Events zum Tragen traditioneller Kleidung',
            traditionalClothsSubtitle: 'Erlebnis des kulturellen Erbes',
            traditionalClothsDescription: 'Tauchen Sie in das sri-lankische Kulturerbe ein, indem Sie lernen, traditionelle Kleidung zu tragen und zu schätzen. Unsere Expertinnen und Experten zeigen Ihnen, wie man authentische kandyanische Saris und traditionelle Gewänder trägt, und erklären die kulturelle Bedeutung jedes Stücks. Perfekt für besondere Anlässe, kulturelle Wertschätzung oder unvergessliche Fotos.',
            traditionalClothsHighlight1: 'Styling durch Experten',
            traditionalClothsHighlight2: 'Authentische traditionelle Saris',
            traditionalClothsHighlight3: 'Kulturelle Bedeutung erklärt',
            traditionalClothsHighlight4: 'Professionelle Fotografie inklusive',
            traditionalClothsHighlight5: 'Fashion-Fusion-Workshops',
            shanthiKarmaTitle: 'Kulturtanz',
            shanthiKarmaSubtitle: 'Traditionelle Sri-Lankische Aufführungen',
            shanthiKarmaDescription: 'Tauchen Sie ein in die lebendige Welt des sri-lankischen Kulturtanzes. Erleben Sie faszinierende traditionelle Aufführungen mit farbenfrohen Kostümen, rhythmischem Trommeln und altem Geschichtenerzählen durch Bewegung. Unsere talentierten Tänzer präsentieren jahrhundertealte Volkstänze, Kandyan-Tanz und kulturelle Rituale, die das sri-lankische Erbe zum Leben erwecken.',
            shanthiKarmaHighlight1: 'Authentische traditionelle sri-lankische Tänze',
            shanthiKarmaHighlight2: 'Farbenfrohe traditionelle Kostüme und Make-up',
            shanthiKarmaHighlight3: 'Live-Trommelbegleitung',
            shanthiKarmaHighlight4: 'Kulturelles Geschichtenerzählen durch Bewegung',
            shanthiKarmaHighlight5: 'Kandyan- und Volkstanzaufführungen',
            musicTherapyTitle: 'Musiktherapie',
            musicTherapySubtitle: 'Heilung durch Klang',
            musicTherapyDescription: 'Entdecken Sie die therapeutische Kraft der Musik in unseren spezialisierten Sitzungen, die alte sri-lankische Instrumente mit modernen Heiltechniken kombinieren. Unsere zertifizierten Musiktherapeuten verwenden Klangvibrationen, rhythmische Muster und melodische Harmonien, um Stress zu reduzieren, emotionales Wohlbefinden zu fördern und tiefe Entspannung zu ermöglichen.',
            musicTherapyHighlight1: 'Traditionelle sri-lankische Instrumente',
            musicTherapyHighlight2: 'Zertifizierte Musiktherapeuten',
            musicTherapyHighlight3: 'Klangheilungsvibrationen',
            musicTherapyHighlight4: 'Stressreduktionstechniken',
            musicTherapyHighlight5: 'Gruppen- und Privatsitzungen',
            taiChiTitle: 'Tai Chi',
            taiChiSubtitle: 'Sanfte Bewegung & Balance',
            taiChiDescription: 'Erleben Sie die alte chinesische Kampfkunst Tai Chi, praktiziert in unserer ruhigen Strandumgebung. Diese sanfte, fließende Übung kombiniert langsame, bewusste Bewegungen mit tiefer Atmung und Meditation, um Gleichgewicht, Flexibilität und innere Ruhe zu verbessern. Perfekt für alle Altersgruppen und Fitnessniveaus.',
            taiChiHighlight1: 'Morgensitzungen am Strand',
            taiChiHighlight2: 'Erfahrene Tai-Chi-Lehrer',
            taiChiHighlight3: 'Verbessert Gleichgewicht und Flexibilität',
            taiChiHighlight4: 'Für alle Fitnessniveaus geeignet',
            taiChiHighlight5: 'Meditations- und Atemtechniken',
        },
        food: {
            heroTitle: 'Ayurvedisches Essen & Küstenküche',
            heroSubtitle: 'Authentische sri-lankische Aromen & frische Küstenküche',
            heroAlt: 'Kulinarisches Erlebnis bei Mahi Beach Ayurveda Resort',
            wellnessEyebrow: 'durch Essen',
            wellnessTitle: 'Die Bedeutung von',
            ayurvedicFood: 'Ayurvedischem Essen',
            wellnessIntro1: 'In der Ayurveda wird Essen als die größte Medizin betrachtet. Was man isst, beeinflusst direkt deine Doshas (Vata, Pitta, Kapha), Verdauung (agni) und das Gesamtgleichgewicht von Körper, Geist und Seele.',
            wellnessIntro2: 'Ayurvedische Ernährung betont frische, saisonale, ganze Lebensmittel, die mit Sorgfalt zubereitet und achtsam gegessen werden. Sie fördert sechs Geschmacksrichtungen (süß, sauer, salzig, pikant, bitter, adstringierend) in jeder Mahlzeit, um alle Sinne zu nähren und Harmonie zu bewahren.',
            wellnessIntro3: 'Richtige ayurvedische Ernährung unterstützt starke Verdauung, hilft beim Entfernen von Giftstoffen (ama), stärkt die Immunität, verbessert die Energie, reduziert Stress und verhindert viele chronische Erkrankungen. Bei Mahi Beach wird jedes Gericht sorgfältig zubereitet, um Ihrer einzigartigen Konstitution für tiefe Heilung und Vitalität zu entsprechen.',
            foodImage1Alt: 'Traditionelle ayurvedische Mahlzeit mit sechs Geschmacksrichtungen',
            foodImage2Alt: 'Ayurvedische Kräuter und Gewürze für ausgewogene Ernährung',
            culinaryPhilosophyEyebrow: 'Unsere kulinarische Philosophie',
            culinaryPhilosophyTitle: 'Ayurvedische',
            nutritionHighlight: 'Ernährung',
            culinaryPhilosophyResort: 'bei Mahi Beach Ayurveda Resort',
            nutritionTopImageAlt: 'Ayurvedische Küche bei Mahi Beach Ayurveda Resort',
            freshNourishingLabel: 'Frisch & Nahrhaft',
            healingIngredientsAlt: 'Gesunde ayurvedische Zutaten und Gewürze',
            healingIngredientsLabel: 'Heilende Zutaten',
            philosophyText1: 'Das Essen umfasst die sechs Hauptgeschmacksrichtungen (süß, sauer, salzig, bitter, pikant und adstringierend) mit vielen subtilen Variationen und wurde in klassischen ayurvedischen Texten beschrieben – einige stammen aus Zeiten vor über 5.000 Jahren – zusammen mit den wesentlichen Eigenschaften jedes Lebensmittels: Guna (inhärente Qualität), Virya (Potenz/wärmend oder kühlend), Vipaka (post-verdauungsauswirkung) und Prabhava (einzigartige besondere Wirkung).',
            philosophyText2: 'Infolgedessen spielt ayurvedische Ernährung eine zentrale Rolle bei Mahi Beach Ayurveda Resort. Dies bedeutet nicht ein starres, eintöniges Regime von geschmacklosen, geschmacklosen oder übermäßig bitteren vegetarischen Mahlzeiten, die ausschließlich von Ärzten vorgeschrieben werden. Im Gegenteil ist unsere Ayurveda-Küche eine unserer größten Stärken: Die Gerichte, die von unseren geschickten Köchen zubereitet werden, werden Sie jeden einzelnen Tag Ihres Aufenthalts überraschen und erfreuen!',
            philosophyText3: 'Zum Frühstück genießen Sie ein reichhaltiges Buffet mit frischen tropischen Früchten, frisch gepressten Säften, nährenden Kräutersuppen, selbstgebackenem Brot und leichten Keksen sowie einer Vielzahl authentischer sri-lankischer Frühstücksoptionen. Zum Mittagessen können Sie ein buntes und geschmackvolles Buffet mit milden Fischcurrys, Gemüsezubereitungen und kräuterinfundierten Gerichten genießen. Am Abend servieren wir ein festes vegetarisches Menü mit frischer Fischoption. Samstags feiern wir die „Sri-Lanka-Nacht" mit einem erweiterten Buffet – unsere Köche bereiten traditionelle lokale Spezialitäten direkt vor Ihnen zu und schaffen so ein lebhaftes und authentisches Erlebnis.',
            philosophyText4: 'In der Ayurveda werden Lebensmittel und Getränke auf vielfältige Weise klassifiziert – nach Geschmack und Eigenschaften, der Verdauungskapazität des Körpers (agni), Eignung für spezifische Gesundheitszustände, saisonale Angemessenheit und mehr. Bei Mahi Beach berücksichtigen wir sorgfältig alle diese Faktoren gleichzeitig und bemühen uns bewusst, alle sechs Geschmacksrichtungen in ausgewogenen Kombinationen einzubeziehen, die der individuellen Konstitution jedes Gastes entsprechen.',
            philosophyText5: 'Unsere Mahlzeiten bestehen aus frischem Gemüse, tropischen Früchten und verantwortungsvoll beschafftem Fisch. Wir servieren kein rotes Fleisch oder Alkohol.',
            philosophyText6: 'Während der Mahlzeiten steht Ihnen immer ein ayurvedischer Arzt oder qualifizierter Ernährungsberater zur Verfügung. Sie beraten Sie zu den am besten geeigneten Gemüsesorten, Kräutern und Gewürzen für Ihre aktuelle Behandlungsphase und helfen Ihnen, Gerichte entsprechend auszuwählen oder zu vermeiden. Ihr personalisiertes Kräuterelixier und alle spezifischen Anweisungen des Gesundheitszentrums werden auf Ihrem persönlichen Tisch platziert.',
            philosophyText7: 'Dieses Maß an persönlicher Aufmerksamkeit und Aufmerksamkeit für die Ernährung ist ein Markenzeichen der Mahi Beach Ayurveda Resort-Erfahrung.',
            philosophyText8: 'Essen wird als Prana – die lebenserhaltende Energie – für jeden Menschen betrachtet. Daher empfehlen wir Ihnen, jede Mahlzeit mit vollem Bewusstsein zu genießen: Genießen Sie die Aromen, erleben Sie die Geschmacksrichtungen, fühlen Sie die sanfte Wärme und genießen Sie die verlockenden Sensationen achtsam.',
            diningExperienceEyebrow: 'Speiseerlebnis',
            restaurantTitlePrefix: 'Unser',
            ayurvedicHighlight: 'Ayurvedisches',
            restaurantTitleSuffix: 'Restaurant',
            restaurantDetail1: 'Unser ayurvedisches Restaurant im Mahi Beach Ayurveda Resort bietet ein einzigartiges Speiseerlebnis, das traditionelle ayurvedische Prinzipien mit authentischer sri-lankischer Küstenküche verbindet. Wir legen Wert auf frische, lokal beschaffte Zutaten, um Mahlzeiten zu schaffen, die nicht nur den Gaumen erfreuen, sondern auch das allgemeine Wohlbefinden fördern.',
            restaurantDetail2: 'Die Speisekarte ist sorgfältig gestaltet, um die sechs Geschmacksrichtungen (süß, sauer, salzig, bitter, pikant und adstringierend) in jedem Gericht auszugleichen und ein nährendes und befriedigendes Erlebnis zu gewährleisten. Jede Mahlzeit wird mit Sorgfalt zubereitet und enthält ayurvedische Kräuter und Gewürze, die für ihre heilenden Eigenschaften bekannt sind.',
            restaurantDetail3: 'Gäste können eine Vielzahl von Gerichten genießen, die auf ihre individuelle Doshas (Körperkonstitutionen) zugeschnitten sind, mit Optionen für vegetarische, vegane und pescetarische Ernährung. Unsere Köche arbeiten eng mit ayurvedischen Praktizierenden zusammen, um sicherzustellen, dass jede Mahlzeit die Gesundheits- und Wellnessziele der Gäste unterstützt.',
            restaurantDetail4: 'Die Atmosphäre des Restaurants spiegelt die ruhige Küstenumgebung wider und bietet eine ruhige Umgebung zum achtsamen Essen. Egal ob Sie ein herzhaftes Frühstücksbuffet oder ein Gourmet-Abendessen genießen, jede Mahlzeit in unserem ayurvedischen Restaurant ist eine Gelegenheit, Körper und Seele zu nähren.',
            restaurantDetail5: 'Besuchen Sie uns im ayurvedischen Restaurant des Mahi Beach Ayurveda Resorts für eine kulinarische Reise, die die reichen Aromen Sri Lankas feiert und gleichzeitig die zeitlose Weisheit der Ayurveda umarmt.',
            restaurantImageAlt: 'Essen bei Mahi Beach Ayurveda Resort',
            premiumDiningLabel: 'Premium-Gastronomie',
            premiumDiningDescription: 'Genießen Sie authentische ayurvedische Küche in einer ruhigen Strandumgebung'
        },
        yoga: {
            heroTitle: 'Yoga im Resort',
            heroSubtitle: 'Finde Balance, Stärke & innere Ruhe in Maggona',
            heroAlt: 'Yoga im Mahi Beach Ayurveda Resort',
            importanceEyebrow: '& Balance',
            importanceTitle: 'Bedeutung von Yoga & Meditation',
            importanceImageAlt: 'Bedeutung von Yoga und Meditation',
            importanceText1: 'Yoga und Meditation sind uralte Praktiken, die zahlreiche körperliche, mentale und emotionale Vorteile bieten. Sie fördern Flexibilität, Stärke und Balance und reduzieren Stress und Angst.',
            importanceText2: 'Regelmäßige Praxis kann die Konzentration verbessern, die Schlafqualität steigern und das allgemeine Wohlbefinden fördern. Yoga ermutigt zudem zur Achtsamkeit, hilft die eigene innere Mitte zu finden und Ruhe im Alltag zu erleben.',
            importanceText3: 'Im Mahi Beach Ayurveda Resort bieten wir ruhige Umgebungen, die ideal für Yoga und Meditation sind, damit Gäste Körper, Geist und Seele regenerieren.',
            practiceEyebrow: 'Unsere Praxis',
            practiceTitle: 'Yoga-Praxis & Erfahrung',
            practiceImageAlt: 'Yoga-Praxis im Resort',
            practiceText1: 'Im Mahi Beach Ayurveda Resort wird Yoga hauptsächlich als traditionelles Hatha Yoga praktiziert, kombiniert mit Pranayama (Atemtechniken). Dieser ganzheitliche Ansatz soll das innere Bewusstsein wecken und die Kundalini (oft als drittes Auge bezeichnet) sanft stimulieren. Besonderer Wert wird auf Wirbelsäulen-Ausrichtung und Flexibilität gelegt, da eine geschmeidige Wirbelsäule als Schlüssel für langsameres Altern gilt — „Du bist nur so alt wie deine Wirbelsäule.“',
            practiceText2: 'Yoga-Sitzungen finden viermal pro Woche statt und sind sowohl für Anfänger als auch für Fortgeschrittene geeignet. Von Zeit zu Zeit werden spezielle Einheiten wie Ashtanga Yoga angeboten, sodass Gäste eine Vielfalt an Haltungen und Routinen erleben können. Unsere ayurvedischen Ärzte empfehlen regelmäßige Teilnahme, um das gesamte Behandlungsprogramm zu unterstützen und zu vertiefen.',
            practiceText3: 'Alle Yoga-Sitzungen finden in unserer dedizierten Yoga Shala statt, einem ruhigen Raum für Fokus, Balance und achtsame Bewegung. Jede Einheit beginnt typischerweise mit Sonnengrüßen, gefolgt von Pranayama und einer Sequenz sorgfältig ausgewählter Asanas zur Verbesserung von Flexibilität, Durchblutung und Wohlbefinden.',
            practiceText4: 'Unsere erfahrenen Yogalehrer passen jede Sitzung an die individuellen Bedürfnisse, Fähigkeiten und Gesundheitsbedingungen der Gäste an und sorgen so für ein sicheres, unterstützendes und tief wohltuendes Yoga-Erlebnis.',
            spiritualEyebrow: 'Spirituelle Reise',
            spiritualTitle: 'Meditation & spirituelle Aktivitäten',
            spiritualSubtitle: 'Vertiefe deine spirituelle Praxis mit unseren heiligen Zeremonien und geführten Meditationen',
            meditationImageAlt: 'Meditation und spirituelle Praxis im Resort',
            meditationTitle: 'Meditationssitzungen',
            meditationDesc: 'Gäste sind eingeladen, an geführten Meditationen teilzunehmen, die dreimal pro Woche stattfinden und von buddhistischen Traditionen inspiriert sind. Diese Sitzungen beruhigen den Geist, vertiefen das Bewusstsein und unterstützen emotionale sowie spirituelle Heilung. Die Meditation findet in einem friedlichen Inseltempel statt, den die Gäste per Boot erreichen — eine ruhige und bedeutungsvolle Reise, die das gesamte meditative Erlebnis bereichert.'
        },
        contact: {
            heroTitle: 'Kontakt',
            heroSubtitle: 'Mahi Beach Ayurveda Resort',
            heroAlt: 'Kontakt',
            sectionTitle: 'Kontaktieren Sie uns gerne',
            sectionSubtitle: 'Wir helfen Ihnen beim Entspannen & Regenerieren',
            sectionDescription: 'Kontaktieren Sie das Mahi Beach Ayurveda Resort bei Fragen zu Ihrem Ayurveda-Aufenthalt, Wellness-Paketen, Buchungen oder während Ihres Aufenthalts in Maggona, Moragalla.',
            callUs: 'Rufen Sie uns an',
            emailTitle: 'E-Mail',
            ourLocation: 'Unser Standort',
            locationAddress: 'No.112 rendagewatta Galle Rd, Maggona',
            socialNetwork: 'Soziale Netzwerke',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Kontakt aufnehmen',
            getInTouchDescription: 'Wir freuen uns auf Ihre Nachricht — unser Team unterstützt Sie gern bei Ihrer Wellness-Reise, beantwortet Fragen und hilft bei der Planung Ihres Aufenthalts.',
            nameLabel: 'Name',
            emailLabel: 'E-Mail',
            contactNumberLabel: 'Telefonnummer',
            messageLabel: 'Nachricht',
            sending: 'Wird gesendet...',
            sendMessage: 'Nachricht senden',
            successMessage: 'Ihre Nachricht wurde erfolgreich gesendet! Wir melden uns bald.',
            errorMessage: 'Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
            findUsOnMap: 'Finden Sie uns auf der Karte',
            whatsappSubject: 'Kontakt Mahi Beach Ayurveda Resort',
            whatsappName: 'Name',
            whatsappEmail: 'E-Mail',
            whatsappContactNumber: 'Telefonnummer',
            whatsappMessage: 'Nachricht'
        },

        about: {
            heroTitle: 'Über Uns',
            heroSubtitle: 'Mahi Beach Ayurveda Resort',
            heroBeachResort: 'Beach Resort',
            heroTagline1: 'Die alte Weisheit trifft auf modernes Wohlbefinden im Mahi Beach Ayurveda Resort',
            heroTagline2: 'Personalisierte Ayurveda-Behandlungen, Meerblick und echte sri-lankische Gastfreundschaft',
            heroDescription: 'Erleben Sie authentisches ayurvedisches Wohlbefinden in unserem charakteristischen Deluxe-Zimmer, wo Meeresruhe auf zeitlose Heilung trifft.',
            bookDeluxeRoom: 'Buchen Sie Ihr Deluxe-Zimmer',
            bookDeluxeRoomShort: 'Deluxe-Zimmer buchen',
            slide1: 'Deluxe Gelassenheit',
            slide2: 'Ayurvedische Harmonie',
            slide3: 'Strandluxus',
            slide4: 'Natürliche Eleganz',
            slide5: 'Heilende Flucht',
            historyLabel: 'Unsere Geschichte',
            historyTitle: 'Geschichte des Mahi Beach Ayurveda Resort',
            historyDesc1: 'Das Mahi Beach Ayurveda Resort wurde 2025 gegründet und entstand aus der Vision, ein Heiligtum zu schaffen, in dem die alte ayurvedische Weisheit auf die ruhige Schönheit der Südküste Sri Lankas trifft. In der ruhigen Küstenstadt Maggona gelegen, vereint unser Resort traditionelle Heilpraktiken mit modernem Luxus und Komfort.',
            historyDesc2: 'Unsere Gründer, inspiriert von Generationen traditioneller Ayurveda-Praktizierender, wollten diese bewährten Heilkünste bewahren und gleichzeitig Einrichtungen von Weltklasse und echte Sri-Lanka-Gastfreundschaft bieten. Seit unserer Eröffnung bleiben wir authentischen Ayurveda-Erlebnissen verpflichtet und bieten personalisierte Behandlungen und Pflege, die die alten Traditionen des ganzheitlichen Wohlbefindens ehren.',
            historyDesc3: 'Im Mahi Beach Ayurveda Resort begrüßen wir Gäste aus der ganzen Welt, um die transformative Kraft des authentischen Ayurveda zu erleben. Jeder Besucher wird Teil unserer Geschichte und findet Balance, Heilung und Verjüngung in unserem friedlichen Strandrefugium.',
            statYear: '2025',
            statYearLabel: 'Gegründet',
            statGuest: 'Weltklasse',
            statGuestLabel: 'Ayurveda-Erlebnis',
            experienceLegacy: 'Erleben Sie unsere Vision',
            established: 'Etabliert',
            since2010: 'Seit 2025',
            chairmanLabel: 'Vision des Vorsitzenden',
            chairmanTitle: 'In Tradition verwurzelt, von Wohlbefinden inspiriert',
            chairmanDesc1: 'Willkommen im Mahi Beach Ayurveda Resort. Unsere Vision seit 2025 ist es, ein Refugium zu schaffen, in dem uralte ayurvedische Weisheit auf modernen Komfort trifft, alles umhüllt von der echten Wärme sri-lankischer Gastfreundschaft.',
            chairmanDesc2: 'Jeder Aspekt unseres Resorts – von personalisierten Behandlungen und nährender Küche bis zum friedlichen Ambiente unserer Räume – ist sorgfältig gestaltet, um Ihren Weg zu Wellness, Ausgeglichen heit und innerem Frieden zu unterstützen. Es ist uns ein Privileg, Sie auf dieser transformativen Reise zu begleiten.',
            chairmanDesc3: 'Ich heiße Sie persönlich willkommen, die Harmonie, Authentizität und Gelassenheit zu entdecken, die das Fundament von Mahi Beach bilden.',
            chairmanSignature: '— Mr. Mahinda',
            chairmanBadge: 'Vorsitzender',
            chairmanName: 'Mr. Mahinda',
            chairmanImageAlt: 'Vorsitzender Mr. Mahinda',
            staffLabel: 'Unser Team',
            staffTitle: 'Treffen Sie unser engagiertes Personal',
            staffDesc1: 'Im Mahi Beach Ayurveda Resort ist unser Team das Herz von allem, was wir tun. Unsere Mitarbeiter sind sorgfältig ausgewählte und ausgebildete Fachleute, die eine tiefe Leidenschaft für Ayurveda-Wellness und echte Gastfreundschaft teilen.',
            staffDesc2: 'Von unseren erfahrenen Ayurveda-Praktizierenden und erfahrenen Massagetherapeuten bis zu unserem engagierten Gastfreundschaftsteam bringt jedes Mitglied jahrelange Expertise und echte Sorgfalt zu jeder Gastinteraktion. Wir glauben, dass echtes Wohlbefinden nicht nur aus Behandlungen kommt, sondern aus der Wärme und Aufmerksamkeit von Menschen, die sich wirklich um Ihre Reise kümmern.',
            staffDesc3: 'Unser Personal durchläuft kontinuierliche Schulungen in den neuesten Ayurveda-Praktiken und wahrt gleichzeitig die höchsten Standards für Professionalität und kulturelle Sensibilität. Wir sind stolz darauf, aussagekräftige Verbindungen mit unseren Gästen zu schaffen und sicherzustellen, dass jeder Besuch zu einer unvergesslichen und transformativen Erfahrung wird.',
            statStaff: '15+',
            statStaffLabel: 'Qualifizierte Fachleute',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Gästezufriedenheit',
            staffImageAlt: 'Unser engagiertes Personal-Team im Mahi Beach Ayurveda Resort',
            commitmentBadge: 'Unser Engagement',
            excellenceCare: 'Exzellenz & Sorgfalt',
            ctaLabel: 'Kontakt aufnehmen',
            ctaHeading: 'Bereit, Ihre Wellness-Reise zu beginnen?',
            ctaDesc: 'Wenden Sie sich an unser Team, um Ihren personalisierten Ayurveda-Rückzug zu buchen. Unabhängig davon, ob Sie Fragen zu unseren Therapien, Unterkünften oder speziellen Wellness-Paketen haben, können wir Ihnen helfen, Ihren perfekten Umgang zu schaffen.',
            ctaButtonContact: 'Kontaktieren Sie uns jetzt',
            ctaButtonRooms: 'Zimmer erkunden',
            contactUs: 'Kontakt',
            quickInfoCall: 'Rufen Sie uns an',
            quickInfoEmail: 'Schreiben Sie uns eine E-Mail',
            quickInfoLocation: 'Ort',
            locationCity: 'Maggona Sri Lanka'
        },

        ayurveda: {
            accordionTitle1: 'Panchakarma-Ayurveda verstehen',
            accordionDesc1: 'Ayurveda (Sanskrit für „Wissenschaft des Lebens") zählt zu den ältesten ganzheitlichen Heiltraditionen der Welt, entwickelt vor über 5.000 Jahren. Panchakarma beruht auf der Harmonie von Körper, Geist, Seele und Umwelt. Ziel ist es, Gesundheit zu stärken und Erkrankungen vorzubeugen – Behandlungen werden individuell angepasst.',
            accordionTitle2: 'Panchakarma und deine Lebensenergie',
            accordionDesc2: 'Ayurveda lehrt die Verbundenheit allen Lebens. Sind Geist, Körper und Seele im Gleichgewicht, entsteht Wohlbefinden; wird es gestört, können Beschwerden entstehen. Faktoren wie Veranlagung, Verletzungen, Jahreszeiten, Alter und Emotionen beeinflussen die Balance.\n\nDer Mensch setzt sich aus fünf Elementen zusammen: Raum, Luft, Feuer, Wasser und Erde. Daraus entstehen die drei Doshas: VATA (Raum/Luft), PITTA (Feuer/Wasser) und KAPHA (Wasser/Erde). Diese steuern Körperfunktionen.\n\nJeder Mensch trägt eine einzigartige Dosha-Mischung in sich, meist mit einer dominanten Energie. Die Balance dieser Kräfte prägt Gesundheit und Anfälligkeiten.',
            accordionTitle3: 'Vata Dosha',
            accordionDesc3: 'Vata gilt als besonders einflussreich und steuert Bewegung, Atmung, Kreislauf, Herzrhythmus und Ausscheidung. Auslöser für Ungleichgewicht sind unregelmäßige Mahlzeiten, Angst, Trauer und zu wenig Schlaf.\n\nBei Vata-Dominanz sind Menschen oft kreativ, schnell denkend und lebhaft, körperlich eher schlank und kälteempfindlich. Im Ungleichgewicht können Unruhe, Ängste oder Beschwerden wie Asthma und Gelenkprobleme auftreten.\n\nAusgleich schafft Erdung: Meditation, Massage, feste Routinen sowie warme, milde Speisen.',
            accordionTitle4: 'Pitta Dosha',
            accordionDesc4: 'Pitta steuert Verdauung, Stoffwechsel und appetitbezogene Hormone. Es kann durch scharfe oder saure Speisen, zu viel Sonne und ausgelassene Mahlzeiten erhöht werden.\n\nPitta-dominante Menschen sind zielstrebig, selbstbewusst und führungsstark, oft mit warmer Körpertemperatur und athletischem Bau. Im Ungleichgewicht zeigen sich Reizbarkeit oder Entzündungen.\n\nAusgleich gelingt mit kühlender, leichter Kost und beruhigenden Praktiken wie sanftem Yoga.',
            accordionTitle5: 'Kapha Dosha',
            accordionDesc5: 'Kapha gibt Stabilität, Kraft, Struktur und unterstützt das Immunsystem. Es wird durch zu viel Süßes, schwere Speisen und übermäßigen Schlaf gestärkt.\n\nKapha-dominante Menschen sind ruhig, geduldig und beständig, oft mit kräftigerer Statur. Im Ungleichgewicht treten Müdigkeit, Trägheit oder Gewichtszunahme auf.\n\nAusgleich schafft Leichtigkeit: mehr Obst und Gemüse sowie Bewegung, die den Kreislauf aktiviert.',
            close: 'Schließen',
            next: 'Weiter',
            previous: 'Zurück',
            treatmentsTitle: 'Unsere besonderen Panchakarma-Ayurveda-Behandlungen',
            treatmentsSubtitle: 'Traditionelle Rituale, die Balance schaffen, Spannungen lösen und Körper wie Geist erneuern.',
            bookTreatment: 'Diese Behandlung buchen',
            benefitsTitle: 'Warum Panchakarma wirkt',
            shirodhara: 'Shirodhara',
            shirodharaDesc: 'Warmer Kräuterölstrom über die Stirn beruhigt das Nervensystem.',
            shirodhara1: 'Lindert Stress und innere Unruhe',
            shirodhara2: 'Fördert erholsamen Schlaf',
            shirodhara3: 'Unterstützt geistige Klarheit',
            steamBath: 'Dampfbad',
            steamBathDesc: 'Kräuterdampf öffnet die Poren, unterstützt die Ausleitung und entspannt die Muskulatur.',
            steamBath1: 'Unterstützt sanfte Entgiftung',
            steamBath2: 'Fördert die Durchblutung',
            steamBath3: 'Löst Muskelverspannungen',
            flowerBath: 'Blumenbad',
            flowerBathDesc: 'Ein duftendes Blütenbad zur tiefen Entspannung.',
            flowerBath1: 'Beruhigt das Nervensystem',
            flowerBath2: 'Pflegt und hydratisiert die Haut',
            flowerBath3: 'Hebt die Stimmung',
            headMassage: 'Kopfmassage',
            headMassageDesc: 'Gezielte Kopfhautmassage, um Spannungen zu lösen.',
            headMassage1: 'Lindert Kopfdruck',
            headMassage2: 'Pflegt Kopfhaut und Haarwurzeln',
            headMassage3: 'Fördert tiefe Entspannung',
            faceMassage: 'Gesichtsmassage',
            faceMassageDesc: 'Sanfte Gesichtsmassage für frischen Glanz und weniger Stress.',
            faceMassage1: 'Verbessert den Teint',
            faceMassage2: 'Löst Gesichtsverspannungen',
            faceMassage3: 'Unterstützt den Lymphfluss',
            neckMassage: 'Nackenmassage',
            neckMassageDesc: 'Fokussierte Massage gegen Nackensteifheit.',
            neckMassage1: 'Lindert Nackenschmerzen',
            neckMassage2: 'Verbessert die Beweglichkeit',
            neckMassage3: 'Reduziert Stress',
            shoulderMassage: 'Schultermassage',
            shoulderMassageDesc: 'Therapeutische Massage, die verspannte Schultern lockert.',
            shoulderMassage1: 'Lindert Schulterschmerzen',
            shoulderMassage2: 'Unterstützt eine bessere Haltung',
            shoulderMassage3: 'Löst Muskelknoten',
            bodyMassage: 'Ganzkörpermassage',
            bodyMassageDesc: 'Ganzkörpermassage zum Loslassen und Auftanken.',
            bodyMassage1: 'Verbessert die Durchblutung',
            bodyMassage2: 'Lindert Muskelschmerzen',
            bodyMassage3: 'Fördert Entspannung',
            backMassage: 'Rückenmassage',
            backMassageDesc: 'Therapeutische Rückenmassage gegen Schmerz und Spannung.',
            backMassage1: 'Lindert Rückenschmerzen',
            backMassage2: 'Unterstützt die Wirbelsäule',
            backMassage3: 'Baut Stress ab',
            footMassage: 'Fußmassage',
            footMassageDesc: 'Erdende Fußmassage, die den ganzen Körper entspannt.',
            footMassage1: 'Regt die Durchblutung an',
            footMassage2: 'Entlastet müde Füße',
            footMassage3: 'Fördert Ruhe',
            purgative: 'Abführmittel',
            purgativeDesc: 'Reinigende Therapie, die überschüssiges Pitta und Verdauungstoxine ausleitet.',
            purgative1: 'Reinigt den Darm',
            purgative2: 'Bringt Pitta ins Gleichgewicht',
            purgative3: 'Unterstützt die Verdauung',
            nasalClearing: 'Nasenreinigung',
            nasalClearingDesc: 'Kräuter-Nasenbehandlung zur Klärung der Atemwege.',
            nasalClearing1: 'Lindert Verstopfung',
            nasalClearing2: 'Verbessert die Atmung',
            nasalClearing3: 'Entlastet die Nebenhöhlen',
            powderMassage: 'Pulvermassage',
            powderMassageDesc: 'Peelingmassage mit Kräuterpulvern für frische, belebte Haut.',
            powderMassage1: 'Entfernt abgestorbene Haut',
            powderMassage2: 'Verfeinert das Hautbild',
            powderMassage3: 'Regt die Durchblutung an',
            intensiveMassageDesc: 'Tiefenmassage für chronische Verspannungen und hartnäckige Knoten.',
            intensiveMassage1: 'Löst tiefe Muskelspannung',
            intensiveMassage2: 'Verbessert den Blutfluss',
            intensiveMassage3: 'Reduziert anhaltende Schmerzen',
            thermoMassage: 'Thermo-Massage',
            thermoMassageDesc: 'Wärmende Kräuteröle entspannen Gewebe und fördern die Heilung.',
            thermoMassage1: 'Lindert schmerzende Muskeln',
            thermoMassage2: 'Bringt tiefe Entspannung',
            thermoMassage3: 'Unterstützt den Energiefluss',
            synchronMassage: 'Synchron-Massage',
            synchronMassageDesc: 'Synchronmassage durch zwei Therapeuten für ganzheitliche Harmonie.',
            synchronMassage1: 'Ganzkörperliche Balance',
            synchronMassage2: 'Gleichmäßiger Energiefluss',
            synchronMassage3: 'Intensives Entspannungserlebnis',
            specialMassage: 'Spezial-Massage',
            specialMassageDesc: 'Individuell abgestimmte Massage für deine Wellness-Ziele.',
            specialMassage1: 'Auf dich zugeschnitten',
            specialMassage2: 'Fokussiert auf konkrete Beschwerden',
            specialMassage3: 'Gezielter Heilansatz',
            benefit1Title: 'Detox-Unterstützung:',
            benefit1Desc: 'Panchakarma hilft, angesammelte Toxine zu lösen und neue Vitalität zu gewinnen.',
            benefit2Title: 'Leichtere Verdauung:',
            benefit2Desc: 'Die Therapien fördern eine ruhige Verdauung und bessere Nährstoffaufnahme.',
            benefit3Title: 'Stress-Reset:',
            benefit3Desc: 'Beruhigende Anwendungen entspannen Geist und Körper und mindern Ängste.',
            benefit4Title: 'Immunstärkung:',
            benefit4Desc: 'Regelmäßige Behandlungen stärken die Abwehrkräfte und die Belastbarkeit.',
            benefit5Title: 'Erneuerung:',
            benefit5Desc: 'Unterstützt die Zellerneuerung für gesunde Haut und frischen Glow.',
            benefit6Title: 'Dosha-Balance:',
            benefit6Desc: 'Bringt Vata, Pitta und Kapha wieder in Einklang.',
            akkupancharTitle: 'Acupuncture-Therapie',
            akkupancharDesc1: 'ist eine alte therapeutische Praxis mit feinen Nadeln auf spezifischen Körperpunkten. Diese Behandlung stimuliert Energiekanäle und fördert Heilung.',
            akkupancharBenefit: 'Hauptvorteile:',
            akkupancharDesc2: 'Diese spezialisierte Therapie hilft bei chronischen Schmerzen, verbessert Gelenkflexibilität, fördert Durchblutung und stellt natürlichen Energiefluss wieder her.',
            akkupancharApplication: 'Therapeutische Anwendung:',
            akkupancharDesc3: 'Acupuncture wirkt auf spezifische Marma-Punkte mit sorgfältig ausgewählten Techniken zur Ausbalancierung der Doshas.',
            akkupancharTransform: 'Transformation erleben:',
            akkupancharDesc4: 'Im Mahi Beach Ayurveda Resort passen unsere erfahrenen Therapeuten jede Acupuncture-Sitzung an Ihre Gesundheitsbedürfnisse an.',
            experienceAkkupanchar: 'Erleben Sie Acupuncture heute',
            doctorsEyebrow: 'UNSER EXPERTENTEAM',
            doctorsSectionTitle: 'Unsere Ärzte',
            drSandyaName: 'Dr. M. Sandya Mendis',
            drSandyaProfession: 'Ayurveda-Ärztin',
            drSandyaSpecialization: 'Klinisches Ayurveda, Personalisierte Behandlungsplanung, Ayurveda-Pflege im Gastgewerbe',
            drSandyaProfileTitle: 'Berufsprofil',
            drSandyaProfile: 'Mitfühlende und engagierte Ayurveda-Fachfrau mit über 25 Jahren Erfahrung in personalisierter Pflege und Wellnesslösungen. Spezialisiert auf die Verbindung traditioneller ayurvedischer Prinzipien mit modernen therapeutischen Praktiken für ganzheitliche Heilungserlebnisse in Luxus-Wellness-Resorts.',
            drSandyaWorkExpTitle: 'Berufserfahrung',
            drSandyaWorkExp1: 'Chefärztin & Programmleitung - Mahi Beach Ayurveda Resort (2023 – Heute)',
            drSandyaWorkExp2: 'Senior Ayurveda-Ärztin - Sun Aqua Resort and Spa, Maggona (2008 – 2023)',
            drSandyaWorkExp3: 'Ayurveda-Beraterin - Amba Ayurveda Specialty Clinic (2006 – 2008)',
            drSandyaWorkExp4: 'Ayurveda-Ärztin & Panchakarma-Spezialistin - Paradise Road The Villa Bentota (2002 – 2006)',
            drSandyaWorkExp5: 'Ayurveda-Medizinerin - Hotel Blue Water (1996 – 2002)',
            drSandyaEducationTitle: 'Ausbildung & Berufliche Qualifikationen',
            drSandyaEdu1: 'Diplom in Ayurveda - Government Ayurveda College, Borella (1989 – 1993)',
            drSandyaEdu2: 'Reiki 2. Grad - Reiki Dasa Centre Negombo Sri Lanka (2015 – 2016)',
            drPandukaName: 'Dr. Panduka Ranaweera',
            drPandukaProfession: 'Ayurveda-Arzt',
            drPandukaQualification: 'B.A.M.S. (Bachelor of Ayurvedic Medicine and Surgery)',
            drPandukaProfileTitle: 'Berufsprofil',
            drPandukaProfile: 'Dr. Panduka Ranaweera ist ein qualifizierter und erfahrener Ayurveda-Arzt mit einem Bachelor of Ayurvedic Medicine and Surgery (B.A.M.S.) der Universität Colombo. Seine akademische Ausbildung basiert fest auf klassischen ayurvedischen Prinzipien und umfassender klinischer Ausbildung und unterstützt einen strukturierten, ethischen und evidenzbasierten Ansatz zur traditionellen Medizin.',
            drPandukaExpertiseTitle: 'Fachliche Expertise',
            drPandukaExpertise: 'Neben der klinischen Praxis hält Dr. Ranaweera professionelle Ayurveda-Vorträge für Gäste und Wellness-Programme und bietet klare Einblicke in die ayurvedische Philosophie, Krankheitsprävention, Lebensstilmanagement und die praktische Anwendung traditioneller Therapien. Diese Sitzungen verbessern das Verständnis und Engagement der Gäste und tragen zu nachhaltigen Gesundheitsergebnissen bei.',
            drPandukaSpecialtyTitle: 'Integrative Therapien',
            drPandukaSpecialty: 'Seine therapeutische Expertise erstreckt sich auch auf Akupunktur und Musiktherapie, die er gezielt zur Unterstützung von Schmerzmanagement, Stressreduzierung, neurologischem Gleichgewicht und emotionalem Wohlbefinden integriert. Durch die Kombination von Ayurveda mit diesen komplementären Modalitäten bietet Dr. Ranaweera ein wirklich integratives Heilungserlebnis.',
            drPandukaRoleTitle: 'Engagement für Exzellenz',
            drPandukaRole: 'In seiner Rolle im Hotel wahrt Dr. Ranaweera hohe klinische Standards, während er personalisierte Behandlungspläne und ganzheitliche Wellness-Beratung anbietet. Sein professioneller, ruhiger und mitfühlender Ansatz stellt sicher, dass jeder Gast sichere, authentische und ergebnisorientierte Pflege erhält, die auf langfristiges Gleichgewicht, Vitalität und allgemeines Wohlbefinden abzielt.',
            gallery1: 'Shirodhara-Therapie',
            gallery2: 'Dampfbad',
            gallery3: 'Blumenbad',
            gallery4: 'Kopfmassage',
            gallery5: 'Ganzkörpermassage',
            gallery6: 'Nackenmassage',
            gallery7: 'Gesichtsmassage',
            gallery8: 'Schultermassage',
            heroTitle: 'Panchakarma Ayurveda',
            heroSubtitle: 'Verjüngen Sie Körper, Geist und Seele in Maggona',
            heroTagline: 'Erleben Sie authentische sri-lankische Ayurveda-Heilung am Ozean',
            sectionEyebrow: 'PANCHAKARMA AYURVEDA IM MAHI BEACH AYURVEDA RESORT',
            sectionDescription: 'Entdecken Sie die alte Panchakarma-Heilkunst im Mahi Beach Ayurveda Resort in Maggona, Sri Lanka. Unser Ayurveda-Team entwickelt personalisierte Anwendungen zur Reinigung, Erneuerung und Harmonie von Körper, Geist und Seele.',
            treatmentProgramme: {
                title: 'Ayurveda-Behandlungsprogramm',
                subtitle: 'Ihre Reise zu Balance, Entgiftung und tieferer Erneuerung',
                intro: 'Erleben Sie authentische Ayurveda-Pflege in einem ruhigen Küsten-Retreat, das den Körper stärkt, den Geist beruhigt und neue Energie schenkt. Ab Ihrer Ankunft kümmern wir uns um alles, damit Sie sich ganz auf Ihr Wohlbefinden konzentrieren können.',
                welcomeTitle: 'Willkommen & sanfter Start',
                doctorTitle: 'Ärztliche Beratung & persönlicher Plan',
                dailyTherapiesTitle: 'Tägliche Ayurveda-Therapien',
                herbalMedicineTitle: 'Unterstützung durch Kräutermedizin',
                yogaMeditationTitle: 'Yoga & Meditation für Körper-Geist-Harmonie',
                wellnessTitle: 'Integrierte Wellness-Erlebnisse',
                closingTitle: 'Abschlussritual & Abreise',
                welcomePoints: [
                    'Flughafenabholung und Transfer zum Hotel',
                    'Herzlicher Empfang und Hotelführung',
                    'Einführung in Ihren wöchentlichen Wellness-Plan',
                    'Entspannungsmassage (Tag 1) im Ayurveda-Zentrum, um Reisemüdigkeit zu lindern und Ihren Körper auf Behandlungen vorzubereiten'
                ],
                doctorPoints: [
                    'Ayurvedische Ärztliche Beratung (Tag 2 – morgens)',
                    'Vollständige Bewertung Ihres Doshas/Körpertyps und Ihrer Gesundheitsbedenken',
                    'Übersetzer auf Anfrage verfügbar',
                    'Ihr Arzt erstellt einen personalisierten Behandlungsplan, der auf Ihre Bedürfnisse und Ziele zugeschnitten ist'
                ],
                dailyTherapiesPoints: [
                    '4–5 Behandlungen täglich (wie vom Arzt empfohlen)',
                    'Therapien basierend auf Ihrer Körperkonstitution und Ihrem Zustand ausgewählt',
                    'Spezielle Massagen können bei Bedarf hinzugefügt werden',
                    'Der Arzt überwacht täglich die Fortschritte und kann Behandlungen und Kräuterunterstützung anpassen, um beste Ergebnisse zu erreichen',
                    'Falls angemessen, kann ein sanfter Reinigungsprozess empfohlen werden'
                ],
                herbalMedicinePoints: [
                    'Vom Arzt verschriebene Kräuterheilmittel zweimal täglich:',
                    'Zum Frühstück',
                    'Zum Abendessen',
                    'Unterstützen innere Heilung, Entgiftung und langfristige Balance'
                ],
                yogaMeditationPoints: [
                    'Yoga-Sitzungen 4x pro Woche (ca. 1 Stunde)',
                    'Meditationssitzungen 2x pro Woche:',
                    'Ein einzigartiges spirituelles Erlebnis in einem Inseltempel, erreichbar mit dem Boot',
                    'Geführte Meditation von Mönchen geleitet (ca. 1 Stunde)'
                ],
                wellnessPoints: [
                    'Wöchentliche gesunde Kochdemonstration',
                    'Kostenlose Exkursion (Kultur-/Naturerlebnis)'
                ],
                closingPoints: [
                    'Ein wunderschönes Blütenbad (letzter Tag) – ein traditionelles Erneuerungsritual',
                    'Abschließende Ärztliche Beratung, um Fortschritte zu überprüfen und bereitszustellen:',
                    'Fortgesetzte Wellness-Anleitung',
                    'Verschreibungen und Empfehlungen für zu Hause',
                    'Transfer zurück zum Flughafen'
                ]
            },
        },
        rooms: {
            heroTitle: 'Ihr Heiligtum erwartet Sie',
            heroSubtitle: 'Handwerklich gefertigte Räume, die zum Heilen, Wiederherstellen und tiefem Frieden entworfen wurden.',
            heroAlt: 'Zimmer des Mahi Beach Ayurveda Resort',
            exploreRooms: 'Erkunden Sie unsere Zimmer',
            filterAll: 'Alle',
            filterLuxurySuite: 'Luxus-Suite',
            filterDeluxeRooms: 'Deluxe-Zimmer',
            filterDeluxeSeaView: 'Deluxe-Zimmer mit Meerblick',
            noRoomsFound: 'Keine Zimmer in dieser Kategorie gefunden.',
            allRoomsInclude: 'Alle Zimmer beinhalten',
            essentialComforts: 'Essentielle Annehmlichkeiten für Ihre Wellness-Reise',
            roomSize: 'Zimmergröße',
            guests: 'Gäste',
            amenities: 'Annehmlichkeiten',
            roomAmenities: 'Zimmerausstattung',
            specialFeatures: 'Besondere Merkmale',
            bookNow: 'Jetzt buchen',
            viewDetails: 'Details anzeigen',
            viewFullDetails: 'Vollständige Details anzeigen',
            highSpeedWifi: 'Hochgeschwindigkeits-WiFi',
            herbalTea: 'Auswahl an Kräutertees',
            climateControl: 'Klimakontrolle',
            rainShower: 'Regendusche',
            organicToiletries: 'Bio-Toilettenmittel',
            dailyHousekeeping: 'Tägliche Zimmerreinigung',
            concierge: '24/7 Concierge',
            yogaMat: 'Yogamatte & Requisiten',
            beginHealing: 'Beginnen Sie Ihre Heilungsreise',
            beginHealingDesc: 'Erleben Sie authentisches ayurvedisches Wohlbefinden in einer Umgebung, die Ihren Körper nähren, Ihren Geist beruhigen und Ihren Geist wiederherstellen soll.',
            reserveRoom: 'Zimmer reservieren',
            speakAdvisor: 'Mit Wellness-Berater sprechen',
            exploreOurRooms: 'Erkunden Sie unsere Zimmer',
            viewRoom: 'Zimmer ansehen',
            luxurySuiteName: 'Luxus-Suite',
            luxurySuiteCategory: 'Luxus-Suite',
            luxurySuiteDesc: 'Erleben Sie ultimative Ruhe in unserer geräumigen Luxus-Suite, entworfen mit traditionellen ayurvedischen Prinzipien und atemberaubendem Meerblick.',
            deluxeRoomName: 'Deluxe-Zimmer',
            deluxeRoomCategory: 'Deluxe-Zimmer',
            deluxeRoomDesc: 'Harmonisch gestaltetes Zimmer mit natürlichen Holzelementen und kühlenden Wassermerkmalen für perfekte Ruhe.',
            seaViewDeluxeName: 'Deluxe mit Meerblick',
            seaViewDeluxeCategory: 'Deluxe-Zimmer mit Meerblick',
            seaViewDeluxeDesc: 'Erwachen Sie zu beruhigenden Meeresbriesen und panoramalen Meerblicken in diesem elegant gestalteten Deluxe-Zimmer.',
            kingSizeBed: 'Kingsize-Bett',
            herbalTeaCoffee: 'Kräutertee & Kaffee',
            individuallyControlledAC: 'Individuell steuerbare Klimaanlage',
            premiumOrganicToiletries: 'Premium-Bio-Pflegeprodukte',
            dailyFreshFlowers: 'Täglich frische Blumen',
            beachView: 'Strandblick',
            signatureAccommodation: 'Signature-Unterkunft',
            inRoomComfort: 'Zimmerkomfort',
            deluxeRoomAmenities: 'Deluxe-Zimmer-Annehmlichkeiten',
            momentsInDeluxeRoom: 'Momente im Deluxe-Zimmer',
            experienceAyurvedicLiving: 'Erleben Sie authentisches ayurvedisches Leben in unserem Signature Deluxe-Zimmer',
            reserveYourStay: 'Reservieren Sie Ihren Aufenthalt',
            deluxeRoom: {
                resortName: 'Mahi Beach Ayurveda Resort',
                heroTitle: 'Deluxe-Zimmer mit Balkon und Meerblick',
                heroSubtitle: 'Entspannen Sie in einem beruhigenden Küstenrückzugsort inspiriert von den goldenen Stränden von Bentota, der moderne Annehmlichkeiten mit sanften Meeresbrisen verbindet.',
                bookThisRoom: 'Dieses Zimmer buchen',
                callReservations: 'Reservierungen anrufen',
                signatureFeatures: 'Charakteristische Merkmale',
                deluxeRoomName: 'Deluxe-Zimmer',
                discoverTheSpace: 'Entdecken Sie den Raum',
                whatsIncluded: 'Was ist enthalten',
                deluxeComfortCare: 'Deluxe-Komfort & Pflege',
                inclusions: 'Inklusivleistungen',
                coreAmenities: 'Kern-Annehmlichkeiten',
                amenityHighSpeedWifi: 'Hochgeschwindigkeits-WLAN',
                amenityHerbalTeaCoffee: 'Kräutertee & Kaffee',
                amenityIndividuallyControlledAC: 'Individuell steuerbare Klimaanlage',
                amenityRainShower: 'Regendusche',
                amenityOrganicToiletries: 'Bio-Pflegeprodukte',
                amenityDailyFreshFlowers: 'Täglich frische Blumen',
                beginYourHealingStay: 'Beginnen Sie Ihren Heilungsaufenthalt',
                experienceAyurvedicSerenity: 'Erleben Sie authentische ayurvedische Ruhe in unserem exklusiven Deluxe-Zimmer',
                checkAvailabilityBook: 'Verfügbarkeit prüfen & buchen',
                speakWithReservations: 'Sprechen Sie mit Reservierungen',
                reserveThisRoom: 'Reservieren Sie dieses Zimmer',
                navAll: 'Alle',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe mit Meerblick',
                navSuite: 'Suite',
                sectionTitle: 'Ein beruhigendes Küstenversteck',
                sectionDesc: 'Das Deluxe-Zimmer ist für langsame Morgen und ungehastete Sonnenuntergänge konzipiert. Weiche neutrale Töne, großzügige Verglasung und durchdachte Beleuchtung laden den Meerblick ein, während der Balkon Ihren eigenen Platz über der Küste bietet.',
                highlight1Title: 'Panoramische Strandaussichten',
                highlight1Desc: 'Wachen Sie mit azurblauen Gewässern und goldenen Sonnenaufgängen von Ihrem privaten Balkon auf.',
                highlight2Title: 'Elegante Küsteninterieure',
                highlight2Desc: 'Weiche neutrale Paletten, warme Holzakzente und großzügiges natürliches Licht.',
                highlight3Title: 'Ruhiges Schlaferlebnis',
                highlight3Desc: 'Plüsch-Kingsize-Bett mit Premium-Bettwäsche für erholsame Ruhe.',
                atAGlance: 'Auf einen Blick',
                statSize: 'Größe',
                statSizeValue: '41 qm',
                statView: 'Aussicht',
                statViewValue: 'Indischer Ozean',
                statGuests: 'Gäste',
                statGuestsValue: '2 Erwachsene',
                statBed: 'Bett',
                statBedValue: 'King oder Twin',
                reserve: 'Reservieren',
                galleryAlt: 'Deluxe-Zimmer-Galerie',
                inclusionsTitle: 'Im Aufenthalt enthalten',
                inclusionsSubtitle: 'Durchdachte Details, ganztägiger Komfort',
                enhancedCleanliness: 'Verbesserte Sauberkeits- und Sicherheitsstandards',
                inclusion1: 'Kostenloses Frühstück, Mittagessen, Abendessen im Breeze Restaurant',
                inclusion2: 'Hochgeschwindigkeits-WLAN und Arbeitsbereich im Zimmer',
                inclusion3: '24-Stunden-Zimmerservice und Concierge',
                inclusion4: 'Tägliche Zimmerreinigung mit Abend-Aufdeckservice',
                inclusion5: 'Zugang zum Infinity-Pool und Ayurveda-Spa-Einrichtungen',
                inclusion6: 'Kostenlose Parkplätze und Shuttle-Service zu nahegelegenen Sehenswürdigkeiten',
                amenityGroup1Title: 'Zimmerausstattung',
                amenityGroup1Item1: '41 qm Fläche',
                amenityGroup1Item2: 'Privater Balkon mit Sitzgelegenheit',
                amenityGroup1Item3: 'Klimaanlage mit Klimakontrolle',
                amenityGroup1Item4: 'Zimmersafe',
                amenityGroup2Title: 'Badeerlebnis',
                amenityGroup2Item1: 'Regendusche mit heißem und kaltem Wasser',
                amenityGroup2Item2: 'Premium-Badeausstattung',
                amenityGroup2Item3: 'Haartrockner',
                amenityGroup2Item4: 'Weiche Bademäntel und Hausschuhe',
                amenityGroup3Title: 'Zimmerkomfort',
                amenityGroup3Item1: '55" Smart-TV mit Kabel',
                amenityGroup3Item2: 'Kaffee- und Teestation',
                amenityGroup3Item3: 'Direktwahltelefon',
                amenityGroup4Title: 'Konnektivität',
                amenityGroup4Item1: 'Kostenloses WLAN',
                amenityGroup4Item2: 'Schreibtisch',
                amenityGroup4Item3: '24/7 Rezeptionsunterstützung',
                essentialsTitle: 'Zimmer-Essentials',
                essentialsHeading: 'Alles, was Sie brauchen, um sich wie zu Hause zu fühlen',
                essentialsDesc: 'Von nahtloser Konnektivität bis hin zu sorgfältig ausgewählten Erfrischungen verbindet das Deluxe-Zimmer Freizeit und Praktikabilität, damit Sie sich auf die Momente konzentrieren können, die zählen.',
                essential1: 'Kostenloses WLAN',
                essential2: 'Kaffee- und Teestation',
                essential3: '24/7 Zimmerservice',
                essential4: 'Regendusche',
                oceanTitle: 'Am Ozean',
                oceanSubtitle: 'Verlangsamen Sie, atmen Sie die Meeresluft ein',
                oceanAlt: 'Deluxe-Zimmer-Sitzbereich',
                ctaTitle: 'Bereit zu bleiben?',
                ctaHeading: 'Reservieren Sie das Deluxe-Zimmer noch heute',
                ctaDesc: 'Sprechen Sie mit unserem Reservierungsteam für die besten verfügbaren Preise und Sonderangebote.',
                checkAvailability: 'Verfügbarkeit prüfen'
            }
        },
        home: {
            // Hero Section
            heroTitle: 'Mahi Beach Ayurveda Resort',
            heroSubtitle1: 'Ayurveda am Meer',
            heroSubtitle2: 'Finden Sie Ausgewogenheit, atmen Sie freier, und erneuern Sie Ihre Energie in Maggona.',
            exploreResort: 'Resort erkunden',
            bookNow: 'Jetzt buchen',

            // Sections
            sections: {
                recommendations: {
                    title: 'Unsere charakteristischen Erlebnisse',
                    subtitle: 'Entdecken Sie, was Ihre Ayurveda-Reise transformiert'
                }
            },

            // Recommendations Section
            recommendations: {
                panchakarma: {
                    label: 'ANTIKE HEILUNG',
                    name: 'Panchakarma Ayurveda'
                },
                yoga: {
                    label: 'KÖRPER & GEIST',
                    name: 'Yoga & Meditation'
                },
                cuisine: {
                    label: 'WELLNESS-KÜCHE',
                    name: 'Ayurvedische Küche'
                },
                wellness: {
                    label: 'TOTALES WOHLBEFINDEN',
                    name: 'Wellness-Pakete'
                },
                spa: {
                    label: 'ENTSPANNUNG',
                    name: 'Spa-Therapien'
                }
            },

            // Welcome Section
            welcomeLabel: 'Willkommen',
            welcomeTitle: 'Mahi Beach Ayurveda Resort',
            welcomeDesc1: 'Es liegt an den makellos Ufern von Maggona und bietet eine harmonische Mischung aus alten Heilungstraditionen und moderner Strandluxus. Unser Heiligtum lädt Sie ein, eine transformative Wellness-Reise zu beginnen, wo der rhythmische Klang des Indischen Ozeans auf die zeitlose Weisheit des Ayurveda trifft.',
            welcomeDesc2: 'Erleben Sie personalisierte Ayurveda-Behandlungen, genießen Sie Nährstoffgerichte, die zum Ausgleich Ihres Doshas beitragen, und entspannen Sie sich in elegant gestalteten Zimmern mit atemberaubender Meeraussicht. Unabhängig davon, ob Sie Verjüngung, Entspannung oder spirituelle Erneuerung anstreben, steht unser engagiertes Team von Ayurveda-Fachleuten und Wellness-Experten bereit, Sie in jedem Schritt zu unterstützen.',
            learnMore: 'Mehr erfahren',
            contactUs: 'Kontaktieren Sie uns',
            welcomeImageAlt: 'Mahi Beach Ayurveda Resort',
            welcomeImageCaption: 'Ayurveda & Strandretreat',
            welcomeImageLocation: 'Maggona Sri Lanka',

            // Highlight Section
            highlightTitle: 'Ein Ayurveda-Heiligtum am Meer',
            highlightDesc: 'Entdecken Sie ganzheitliche Heilung an der Südwestküste Sri Lankas. Von maßgeschneiderten Behandlungen bis zu ruhigen Balkonen und achtsamem Essen - jedes Detail ist darauf ausgelegt, Ihren Rhythmus wiederherzustellen.',

            // Services
            service1Title: 'Ganzheitliche Ayurveda-Therapien',
            service1Desc: 'Personalisierte Beratungen, authentische Kräuteröle und tägliche Behandlungen unter Anleitung erfahrener Ayurveda-Ärzte.',
            service2Title: 'Strandfront-Zimmer & Suiten',
            service2Desc: 'Wachen Sie auf mit Meeresbrisen, privaten Balkonen und beruhigenden Innenräumen für tiefe Ruhe.',
            service3Title: 'Wellness-Küche',
            service3Desc: 'Frische sri-lankische Produkte, pflanzenorientierte Menüs und maßgeschneiderte Speisepläne, die Ihr Dosha ergänzen.',
            service4Title: 'Yoga & Achtsamkeit',
            service4Desc: 'Sunrise-Yoga, Sonnenuntergangmeditationen und Atemübungen vor dem Rhythmus der Wellen.',
            service5Title: 'Küstenausflüge',
            service5Desc: 'Küstenbootstouren, Schildkrötenbrutplätze, Gewürzgärten und Dorffahrradtouren.',

            // Rooms
            roomsTitle: 'Unsere Zimmer',
            roomsDesc: 'Wählen Sie das Heiligtum, das zu Ihrem Tempo passt, von luftigen Suiten bis zu gemütlichen Deluxe-Verstecken, alle mit weichen Leinen, warmem Holz und sonnenaufgangsreifen Balkonen.',
            roomBadge: 'Strandfront-Flucht',
            bookableNow: 'Jetzt buchbar',
            seaBreezeReady: 'Meeresbreise bereit',
            viewRoom: 'Zimmer anzeigen',
            room1Title: 'Suite-Zimmer',
            room1Desc: 'Große Suiten mit Loungebereichen, großzügigen Balkonen und beruhigender Farbpalette für langsame Morgen.',
            room2Title: 'Deluxe-Zimmer',
            room2Desc: 'Gemütliche Rückzugsorte mit luxuriösen Betten, Gartenblick und warmen Holzakzenten für alltägliche Leichtigkeit.',
            room3Title: 'Deluxe Meerblick',
            room3Desc: 'Wachen Sie mit dem Meereshorizont auf, mit weichen Leinen und privatem Balkon für goldene Sonnenuntergänge.',

            // Achievements
            achievementsTitle: 'Vertraute am Meer',
            achievement1Title: 'Glückliche Gäste',
            achievement1Count: '1.000+',
            achievement2Title: 'Ayurveda-Behandlungen',
            achievement2Count: '20+',
            achievement3Title: 'Jahre der Pflege',
            achievement3Count: '15+',
            achievement4Title: 'Reisende Akkumulationen',
            achievement4Count: '1.000+',

            // Experiences
            experiencesTitle: 'Entdecken Sie das Mahi Beach Ayurveda Resort',
            experiencesDesc: 'Von Ayurveda-Reisen bis zu kuratierten Ausflügen - wählen Sie die Erlebnisse, die Ihren Aufenthalt unvergesslich machen.',
            planYourStay: 'Planen Sie Ihren Aufenthalt',
            experience1Title: 'Zimmer & Suiten',
            experience1Desc: 'Luftige Räume mit Balkonen, Meer- oder Gartenblick und durchdachtem Komfort für entspannte Aufenthalte.',
            experience2Title: 'Ayurveda-Spa',
            experience2Desc: 'Authentische Therapien, Dampfbäder und restaurative Massagen mit zeitgeprüften Ritualen.',
            experience3Title: 'Gastronomisches Erlebnis',
            experience3Desc: 'Nahrhafte inländische und internationale Küche in unserem Restaurant, sorgfältig zubereitet, um Körper und Geist zu nähren.',
            experience4Title: 'Erlebnisse & Touren',
            experience4Desc: 'Flusssafaris, Tempelbesuche, Wassersportarten und kuratierte kulturelle Ausflüge rund um Bentota.',

            // Gallery
            galleryTitle: 'Momente im Mahi Beach Ayurveda Resort',
            galleryDesc: 'Ein Einblick in unser Strandheiligtum - Sonnenaufgänge, ruhige Behandlungen, nahrhafte Speisen und ruhige Ecken für Sie.',
            gallery1Alt: 'Sonniges palmengefäumtes Strand in Mahi Beach',
            gallery2Alt: 'Ayurveda-Ölbehandlung im Gange',
            gallery3Alt: 'Resort-Pool mit Liegestühlen',
            gallery4Alt: 'Kräuter vorbereitet für Spa',
            gallery5Alt: 'Paar genießt Sonnenuntergang am Meer',
            gallery6Alt: 'Yoga-Deck blickt auf das Meer',
            gallery7Alt: 'Pfad durch tropischen Garten',
            gallery8Alt: 'Gesundes Frühstück',
            gallery9Alt: 'Ruhiger Küstenblick',
            gallery10Alt: 'Warmbeleuchtete Strandresort bei Einbruch der Dunkelheit',
            gallery11Alt: 'Ayurveda-Kräuter- und Öl-Display',
            gallery12Alt: 'Gemütliche Sitzecke im Garten',

            // Resort Images
            resort1Alt: 'Open-Air-Lounge mit Begrünung',
            resort2Alt: 'Komfortables Zimmers Interieur',
            resort3Alt: 'Spa-Behandlungsraum',
            resort4Alt: 'Essbereich mit natürlichem Licht',
            resort5Alt: 'Entspannender Aussicht auf den Pool',

            // Sunset Section
            sunsetLabel: 'Das tägliche Meisterwerk der Natur',
            sunsetTitle: 'Abendsonnenuntergang',
            sunsetDesc1: 'Beobachten Sie, wie der Tag anmutig dem Zwielicht nachgibt, während der Himmel sich in eine Leinwand aus Bernstein, Karminrot und Gold verwandelt. Der sanfte Indische Ozean spiegelt dieses himmlische Schauspiel wider und erzeugt eine fesselnde Symphonie aus Licht und Wasser.',
            sunsetDesc2: 'Jeden Abend bei Mahi Beach bietet sich einen Platz in der ersten Reihe zu einer der atemberaubendsten Aufführungen der Natur. Finden Sie Ihren perfekten Aussichtspunkt - ob von Ihrem privaten Balkon, der Strandlounge oder unserem Sonnenuntergängs-Meditationsdeck - und lassen Sie die ruhige Schönheit über Sie hinweggehen.',
            sunsetFeature1: 'Ungehinderter Meerblick von überall',
            sunsetFeature2: 'Sonnenuntergängs-Ruhemeditation',
            sunsetFeature3: 'Kostenloser Kräutertee täglich serviert',
            sunsetFeature4: 'Fotogene Momente jeden Abend',
            sunsetImageAlt: 'Abendsonnenuntergang am Mahi Beach Ayurveda Resort',
            bestTime: 'Beste Zeit',
            sunsetTime: '18:00 Uhr - 18:45 Uhr',

            // Pool Section
            poolLabel: 'Aquatische Gelassenheit',
            poolTitle: 'Poolbereich',
            poolDesc1: 'Tauchen Sie ein in die Ruhe unseres makellosen Infinity-Pools, wo kristallklares Wasser auf üppige tropische Gärten trifft. Unser Poolbereich ist darauf ausgelegt, sich zu entspannen und verjüngt zu werden - die perfekte Flucht, um unter der sri-lankischen Sonne zu entspannen.',
            poolDesc2: 'Ob Sie ein erfrischendes morgendliches Bad, eine nachmittägliche Entspannungssession mit einem guten Buch oder ein ruhiges Abendbad bevorzugen, bietet unser Poolbereich eine ideale Umgebung. Umgeben von komfortablen Liegestühlen, schattigen Kabinen und aufmerksamen Poolservice-Team, wird jeder Moment zu einer wertvollen Erinnerung.',
            poolFeature1: 'Temperaturgesteuerter Infinity-Pool',
            poolFeature2: 'Umgeben von tropischen Gartenlandschaften',
            poolFeature3: 'Poolside Erfrischungs- & gesunde Snacks',
            poolFeature4: 'Premium-Liegestühle mit Schirmen',
            poolImageAlt: 'Entspannender Poolbereich im Mahi Beach Resort',

            // Gästeabschiedszeremonie
            departureLabel: 'Abschiedstradition',
            departureTitle: 'Gästeabschiedszeremonie',
            departureDesc1: 'Im Mahi Beach Ayurveda Resort ehren wir Ihre Reise mit uns durch eine bedeutungsvolle Abschiedszeremonie, die in der sri-lankischen Tradition verwurzelt ist. Wenn Sie sich auf die Abreise vorbereiten, versammelt sich unser Team, um Segen für sichere Reisen und anhaltende Gesundheit zu bieten.',
            departureDesc2: 'Dieses herzliche Ritual umfasst traditionelle Segen, ein spezielles Abschiedsmenü mit authentischen sri-lankischen Delikatessen und ein kleines Geschenk, um unsere Wärme mit Ihnen zu tragen. Es ist unsere Art sicherzustellen, dass Ihre Erinnerungen an Mahi Beach lange nach Ihrer Abreise geschätzt bleiben.',
            departureFeature1: 'Traditionelle buddhistische Segen für sichere Reisen',
            departureFeature2: 'Personalisierte Abschiedsgeschenke und Erinnerungsstücke',
            departureFeature3: 'Spezielles Abschiedsmenü mit sri-lankischen Spezialitäten',
            departureFeature4: 'Segenszeremonie mit heiligen Ritualen',
            departureImageAlt: 'Gästeabschiedszeremonie im Mahi Beach Resort',

            // TripAdvisor
            tripadvisorLabel: 'TripAdvisor',
            tripadvisorTitle: 'Gästebewertungen',

            // Testimonials
            testimonialsTitle: 'Gäste während ihres Aufenthalts',
            testimonialsLabel: 'Gästegeschichten',

            // Video Section
            videoLabel: 'Immersives Erlebnis',
            videoTitle: 'Entdecken Sie Mahi Beach',
            videoDescription: 'Erleben Sie die Schönheit und Ruhe des Mahi Beach Ayurveda Resort durch unsere immersive Videoreise. Erkunden Sie erstklassige Annehmlichkeiten, unberührte Strände und verjüngende Wellnesserlebnisse.',

            // Featured Room
            featuredRoomLabel: 'Signature-Unterkunft',
            featuredRoomTitle: 'Deluxe Doppelzimmer mit Meerblick',

            // Booking Bar
            bookingResort: 'Resort',
            bookingResortName: 'Mahi Beach Ayurveda Resort',
            bookingCheckIn: 'Check-in',
            bookingCheckOut: 'Check-out',
            bookingGuests: 'Gäste',
            booking1Guest: '1 Gast',
            booking2Guests: '2 Gäste',
            booking3Guests: '3 Gäste',
            bookingCheckAvailability: 'Verfügbarkeit prüfen',

            // Hero Buttons
            heroExploreButton: 'Erkunden Sie Mahi Beach',
            heroBookButton: 'Deluxe-Zimmer buchen'
        }

    },
    ru: {
        about: {
            heroTitle: 'О нас',
            heroSubtitle: 'Mahi Beach Ayurveda Resort',
            heroBeachResort: 'Beach Resort',
            heroTagline1: 'Древняя мудрость встречается с современным здоровьем в курорте Mahi Beach Ayurveda Resort',
            heroTagline2: 'Персональные аюрведические процедуры, вид на океан и подлинное шри-ланкийское гостеприимство',
            heroDescription: 'Испытайте подлинное аюрведическое оздоровление в нашем фирменном номере Делюкс, где морское спокойствие встречается с вечным исцелением.',
            bookDeluxeRoom: 'Забронируйте номер Делюкс',
            bookDeluxeRoomShort: 'Забронировать номер Делюкс',
            slide1: 'Делюкс Спокойствие',
            slide2: 'Аюрведическая Гармония',
            slide3: 'Роскошь на пляже',
            slide4: 'Природная Элегантность',
            slide5: 'Исцеляющий Отдых',
            historyLabel: 'Наше путешествие',
            historyTitle: 'История курорта Mahi Beach Ayurveda Resort',
            historyDesc1: 'Основанный в 2025 году, курорт Mahi Beach Ayurveda Resort был создан из видения создать святилище, где древняя аюрведическая мудрость встречается с спокойной красотой южного побережья Шри-Ланки. Мы создали одно из самых любимых мест Берувалы для холистического исцеления и омоложения.',
            historyDesc2: 'Наши основатели, вдохновленные поколениями традиционных практиков аюрведы, стремились сохранить эти проверенные временем целебные искусства, обеспечивая при этом современные удобства и подлинное шри-ланкийское гостеприимство. С момента нашего открытия мы оставались верны нашему обязательству перед подлинными оздоровительными впечатлениями, обеспечивая личную заботу, определяющую наше наследие.',
            historyDesc3: 'В курорте Mahi Beach Ayurveda Resort мы приветствуем гостей со всего мира. Каждый посетитель становится частью нашей истории, находя баланс, исцеление и трансформацию в нашем береговом убежище.',
            statYear: '2025',
            statYearLabel: 'Основано',
            statGuest: 'Мирового класса',
            statGuestLabel: 'Довольных гостей обслужено',
            experienceLegacy: 'Испытайте нашу концепцию',
            established: 'Основано',
            since2010: 'С 2025',
            chairmanLabel: 'Видение председателя',
            chairmanTitle: 'Укоренённый в традициях, вдохновлённый благополучием',
            chairmanDesc1: 'Добро пожаловать в курорт Mahi Beach Ayurveda Resort. Наше видение с 2025 года — создать убежище, где древняя аюрведическая мудрость встречается с современным комфортом, окутанное подлинной теплотой шри-ланкийского гостеприимства.',
            chairmanDesc2: 'Каждый аспект нашего курорта — от персонализированных процедур и питательной кухни до мирной атмосферы наших пространств — тщательно создан для поддержки вашего пути к благополучию, балансу и внутреннему покою. Это наша привилегия сопровождать вас в этом преобразующем путешествии.',
            chairmanDesc3: 'Я лично приветствую вас и приглашаю открыть для себя гармонию, аутентичность и спокойствие, которые являются основой Mahi Beach.',
            chairmanSignature: '— Mr. Mahinda',
            chairmanBadge: 'Председатель',
            chairmanName: 'Mr. Mahinda',
            chairmanImageAlt: 'Председатель Mr. Mahinda',
            staffLabel: 'Наша команда',
            staffTitle: 'Встретьте нашу преданную команду',
            staffDesc1: 'В курорте Mahi Beach Ayurveda Resort наша команда — сердце всего, что мы делаем. Члены нашего персонала — тщательно отобранные и обученные профессионалы, которые разделяют глубокую страсть к аюрведическому оздоровлению и подлинному гостеприимству.',
            staffDesc2: 'От наших опытных практиков аюрведы и квалифицированных массажистов до нашей преданной команды гостеприимства, каждый член приносит годы опыта и подлинную заботу к каждому взаимодействию с гостями. Мы верим, что истинное благополучие приходит не только из процедур, но из теплоты и внимания людей, которые искренне заботятся о вашем путешествии.',
            staffDesc3: 'Наш персонал постоянно проходит обучение по последним практикам аюрведы, поддерживая высочайшие стандарты профессионализма и культурной чувствительности. Мы гордимся созданием значимых связей с нашими гостями, обеспечивая, чтобы каждый визит становился памятным и трансформирующим опытом.',
            statStaff: '15+',
            statStaffLabel: 'Квалифицированные специалисты',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Удовлетворение гостей',
            staffImageAlt: 'Наша преданная команда персонала в курорте Mahi Beach Ayurveda Resort',
            commitmentBadge: 'Наше обязательство',
            excellenceCare: 'Совершенство и забота',
            ctaLabel: 'Связаться с нами',
            ctaHeading: 'Готовы начать свое оздоровительное путешествие?',
            ctaDesc: 'Свяжитесь с нашей командой, чтобы забронировать ваш персональный аюрведический retreat. Независимо от того, у вас есть вопросы о наших процедурах, проживании или специальных оздоровительных пакетах, мы здесь, чтобы помочь создать вашу идеальную побег.',
            ctaButtonContact: 'Свяжитесь с нами сейчас',
            ctaButtonRooms: 'Исследуйте номера',
            contactUs: 'Свяжитесь с нами',
            quickInfoCall: 'Позвоните нам',
            quickInfoEmail: 'Напишите нам',
            quickInfoLocation: 'Местоположение',
            locationCity: 'Берувала, Шри-Ланка'
        },
        rooms: {
            heroTitle: 'Ваше святилище ждет вас',
            heroSubtitle: 'Тщательно разработанные номера, предназначенные для исцеления, восстановления и глубокого спокойствия.',
            heroAlt: 'Комнаты Mahi Beach Ayurveda Resort',
            exploreRooms: 'Исследуйте наши номера',
            filterAll: 'Все',
            filterLuxurySuite: 'Люкс',
            filterDeluxeRooms: 'Номера Делюкс',
            filterDeluxeSeaView: 'Номер Делюкс с видом на море',
            noRoomsFound: 'В этой категории номеров не найдено.',
            allRoomsInclude: 'Все номера включают',
            essentialComforts: 'Основные удобства для вашего оздоровительного путешествия',
            roomSize: 'Размер номера',
            guests: 'Гости',
            amenities: 'Удобства',
            roomAmenities: 'Удобства номера',
            specialFeatures: 'Специальные возможности',
            bookNow: 'Забронировать сейчас',
            viewDetails: 'Просмотр деталей',
            viewFullDetails: 'Просмотр полных деталей',
            highSpeedWifi: 'Высокоскоростной WiFi',
            herbalTea: 'Выбор травяных чаев',
            climateControl: 'Климат-контроль',
            rainShower: 'Дождевой душ',
            organicToiletries: 'Органические косметические средства',
            dailyHousekeeping: 'Ежедневная уборка',
            concierge: 'Консьерж 24/7',
            yogaMat: 'Коврик для йоги и реквизит',
            beginHealing: 'Начните свое путешествие исцеления',
            beginHealingDesc: 'Испытайте подлинное аюрведическое благополучие в окружении, которое питает ваше тело, успокаивает ваш ум и восстанавливает ваш дух.',
            reserveRoom: 'Зарезервировать номер',
            speakAdvisor: 'Говорить с советником по здоровью',
            exploreOurRooms: 'Исследуйте наши номера',
            viewRoom: 'Просмотреть номер',
            luxurySuiteName: 'Люкс',
            luxurySuiteCategory: 'Люкс',
            luxurySuiteDesc: 'Испытайте главное спокойствие в нашем просторном люксе, спроектированном в соответствии с традиционными аюрведическими принципами с потрясающим видом на море.',
            deluxeRoomName: 'Номер Делюкс',
            deluxeRoomCategory: 'Номер Делюкс',
            deluxeRoomDesc: 'Гармонично оформленный номер с натуральными деревянными элементами и охлаждающими водными объектами для получения идеального спокойствия.',
            seaViewDeluxeName: 'Делюкс с видом на море',
            seaViewDeluxeCategory: 'Номер Делюкс с видом на море',
            seaViewDeluxeDesc: 'Просыпайтесь к успокаивающему морскому бризу и панорамному виду на море в этом элегантно оформленном номере Делюкс.',
            kingSizeBed: 'Кровать King-Size',
            herbalTeaCoffee: 'Травяной чай и кофе',
            individuallyControlledAC: 'Индивидуально управляемый кондиционер',
            premiumOrganicToiletries: 'Премиальные органические туалетные принадлежности',
            dailyFreshFlowers: 'Ежедневные свежие цветы',
            beachView: 'Вид на пляж',
            signatureAccommodation: 'Фирменное размещение',
            inRoomComfort: 'Комфорт в номере',
            deluxeRoomAmenities: 'Удобства номера Делюкс',
            momentsInDeluxeRoom: 'Моменты в номере Делюкс',
            experienceAyurvedicLiving: 'Испытайте подлинную аюрведическую жизнь в нашем фирменном номере Делюкс',
            reserveYourStay: 'Забронируйте ваше пребывание',
            deluxeRoom: {
                resortName: 'Mahi Beach Ayurveda Resort',
                heroTitle: 'Номер Делюкс с балконом и видом на море',
                heroSubtitle: 'Расслабьтесь в успокаивающем прибрежном убежище, вдохновленном золотыми пляжами Бентоты, сочетающем современные удобства с нежным морским бризом.',
                bookThisRoom: 'Забронировать этот номер',
                callReservations: 'Позвонить в службу бронирования',
                signatureFeatures: 'Характерные особенности',
                deluxeRoomName: 'Номер Делюкс',
                discoverTheSpace: 'Откройте для себя пространство',
                whatsIncluded: 'Что включено',
                deluxeComfortCare: 'Комфорт и уход Делюкс',
                inclusions: 'Включено',
                coreAmenities: 'Основные удобства',
                amenityHighSpeedWifi: 'Высокоскоростной Wi-Fi',
                amenityHerbalTeaCoffee: 'Травяной чай и кофе',
                amenityIndividuallyControlledAC: 'Индивидуально управляемый кондиционер',
                amenityRainShower: 'Дождевой душ',
                amenityOrganicToiletries: 'Органические туалетные принадлежности',
                amenityDailyFreshFlowers: 'Ежедневные свежие цветы',
                beginYourHealingStay: 'Начните своё исцеляющее пребывание',
                experienceAyurvedicSerenity: 'Испытайте подлинное аюрведическое спокойствие в нашем фирменном номере Делюкс',
                checkAvailabilityBook: 'Проверить доступность и забронировать',
                speakWithReservations: 'Связаться с службой бронирования',
                reserveThisRoom: 'Забронировать этот номер',
                navAll: 'Все',
                navDeluxe: 'Делюкс',
                navDeluxeSeaView: 'Делюкс с видом на море',
                navSuite: 'Люкс',
                sectionTitle: 'Успокаивающее прибрежное убежище',
                sectionDesc: 'Номер Делюкс создан для медленных утр и неспешных закатов. Мягкие нейтральные тона, обильное остекление и продуманное освещение приглашают вид на море, а балкон предлагает ваш собственный насест над береговой линией.',
                highlight1Title: 'Панорамный вид на пляж',
                highlight1Desc: 'Просыпайтесь с лазурными водами и золотыми восходами с вашего частного балкона.',
                highlight2Title: 'Элегантные прибрежные интерьеры',
                highlight2Desc: 'Мягкие нейтральные палитры, теплые деревянные акценты и обильный естественный свет.',
                highlight3Title: 'Безмятежный сон',
                highlight3Desc: 'Плюшевая кровать king-size с премиальным постельным бельем для восстановительного отдыха.',
                atAGlance: 'С первого взгляда',
                statSize: 'Размер',
                statSizeValue: '41 кв.м',
                statView: 'Вид',
                statViewValue: 'Индийский океан',
                statGuests: 'Гости',
                statGuestsValue: '2 взрослых',
                statBed: 'Кровать',
                statBedValue: 'King или Twin',
                reserve: 'Зарезервировать',
                galleryAlt: 'Галерея номера Делюкс',
                inclusionsTitle: 'Включено в ваше пребывание',
                inclusionsSubtitle: 'Продуманные детали, комфорт весь день',
                enhancedCleanliness: 'Повышенные стандарты чистоты и безопасности',
                inclusion1: 'Бесплатный завтрак, обед, ужин в ресторане Breeze',
                inclusion2: 'Высокоскоростной Wi-Fi и рабочее пространство в номере',
                inclusion3: '24-часовое обслуживание номеров и консьерж',
                inclusion4: 'Ежедневная уборка номера с вечерним включением',
                inclusion5: 'Доступ к бесконечному бассейну и аюрведическим спа-услугам',
                inclusion6: 'Бесплатная парковка и трансфер к близлежащим достопримечательностям',
                amenityGroup1Title: 'Особенности номера',
                amenityGroup1Item1: '41 кв.м площади',
                amenityGroup1Item2: 'Частный балкон с местами для сидения',
                amenityGroup1Item3: 'Кондиционер с климат-контролем',
                amenityGroup1Item4: 'Сейф в номере',
                amenityGroup2Title: 'Ванная комната',
                amenityGroup2Item1: 'Дождевой душ с горячей и холодной водой',
                amenityGroup2Item2: 'Премиальные банные принадлежности',
                amenityGroup2Item3: 'Фен',
                amenityGroup2Item4: 'Мягкие халаты и тапочки',
                amenityGroup3Title: 'Удобства в номере',
                amenityGroup3Item1: '55" Smart TV с кабельным ТВ',
                amenityGroup3Item2: 'Кофейная и чайная станция',
                amenityGroup3Item3: 'Телефон с прямым набором',
                amenityGroup4Title: 'Подключение',
                amenityGroup4Item1: 'Бесплатный Wi-Fi',
                amenityGroup4Item2: 'Рабочий стол',
                amenityGroup4Item3: 'Поддержка стойки регистрации 24/7',
                essentialsTitle: 'Основные удобства в номере',
                essentialsHeading: 'Все, что вам нужно, чтобы чувствовать себя как дома',
                essentialsDesc: 'От бесшовного подключения до тщательно подобранных напитков, номер Делюкс сочетает досуг и практичность, чтобы вы могли сосредоточиться на моментах, которые имеют значение.',
                essential1: 'Бесплатный Wi-Fi',
                essential2: 'Кофейная и чайная станция',
                essential3: 'Обслуживание номеров 24/7',
                essential4: 'Дождевой душ',
                oceanTitle: 'У океана',
                oceanSubtitle: 'Замедлитесь, вдохните морской воздух',
                oceanAlt: 'Зона отдыха в номере Делюкс',
                ctaTitle: 'Готовы остаться?',
                ctaHeading: 'Зарезервируйте номер Делюкс сегодня',
                ctaDesc: 'Поговорите с нашей командой по бронированию для получения лучших доступных цен и специальных предложений.',
                checkAvailability: 'Проверить доступность'
            }
        },

        navbar: {
            home: 'Главная',
            aboutUs: 'О нас',
            rooms: 'Номера',
            ayurveda: 'Аюрведа',
            yoga: 'Йога',
            food: 'Питание',
            events: 'События',
            blogs: 'Блог',
            tours: 'Туры',
            contactUs: 'Контакты',
            bookOnline: 'Забронировать онлайн',
            locationMaggona: 'Maggona Sri Lanka',
            selectResort: 'Выбрать курорт',
            language: 'Язык',
            mainTitle: 'Mahi Beach Ayurveda Resort',
            resortBeach: 'Mahi Beach Ayurveda Resort',
            resortRiver: 'Mahi Beach Ayurveda Resort'
        },
        footer: {
            description: 'Mahi Beach Ayurveda Resort стремится к исключительному гостеприимству и оздоровительным впечатлениям, чтобы каждый гость чувствовал заботу и восстановление.',
            linksTitle: 'Ссылки',
            contactTitle: 'Контакты',
            viewLocation: 'Посмотреть расположение',
            navHome: 'Главная',
            navAbout: 'О нас',
            navContact: 'Контакты',
            navRooms: 'Номера',
            navAyurveda: 'Аюрведа',
            copyright: '© Copyright {{year}} Mahi Beach Ayurveda Resort.',
            developedBy: 'Разработано',
            developerName: 'Redev Solution +94 764 608 225'
        },
        tours: {
            heroTitle: 'Туры и экскурсии',
            heroSubtitle: 'Откройте красоту Шри-Ланки из Берувалы',
            kandeAlt: 'Храм Канде Вихара - Берувала',
            kandeTitle: 'Посещение храма Канде Вихара',
            kandeBuddhaAlt: 'Гигантская статуя Будды в храме Канде Вихара',
            bentotaTitle: 'Речное сафари на реке Бентота',
            bentotaAlt: 'Речное сафари на реке Бентота - мангровые леса и дикая природа',
            galleTitle: 'Тур по старому городу Галле',
            galleAlt: 'Тур по старому городу Галле',
            sigiriyaTitle: 'Тур по скальной крепости Сигирия',
            sigiriyaAlt: 'Тур по скальной крепости Сигирия',
            kandyTitle: 'Культурный тур по Канди',
            kandyAlt: 'Культурный тур по Канди',
            bookTour: 'Забронировать этот тур',
            viewDetails: 'Просмотр деталей',
            introPara1: 'Шри-Ланка — земля вечной красоты, где золотые пляжи, пышные зеленые ландшафты, древние храмы и яркая культура сходятся в идеальной гармонии.',
            introPara2: 'От спокойного юго-западного побережья до исторических городов, священных мест, заповедников дикой природы и туманных горных районов каждое путешествие предлагает уникальный и незабываемый опыт.',
            introPara3: 'Начиная с Mahi Beach Ayurveda Resort в Берувале, наши тщательно подобранные туры и экскурсии разработаны для обогащения вашего пребывания, идеально балансируя исследование, релаксацию и оздоровление.',
            kandeDetail1: 'Храм Канде Вихара (Канде Вихарая) — один из самых культовых буддийских храмов рядом с Берувалой.',
            kandeDetail2: 'Основанный в 1734 году, этот спокойный \'Горный храм\' расположен на холме с мирными видами на побережье.',
            kandeDetail3: 'Достопримечательности включают массивную статую сидящего Будды высотой 48 метров (одна из самых высоких на Шри-Ланке), замысловатые фрески эпохи Канди, древнюю камеру для святых мощей, прекрасный лунный камень и священное дерево Бодхи, возраст которого превышает 300 лет.',
            kandeDetail4: 'Идеальный духовный и культурный опыт на полдня — лучше всего посещать утром, чтобы избежать жары.',
            bentotaDetail1: 'Насладитесь спокойным и живописным речным сафари по реке Бентота, одной из самых популярных природных экскурсий рядом с Берувалой.',
            bentotaDetail2: 'Скользите по пышным мангровым лесам, узким каналам и спокойным водам, наблюдая за дикой природой.',
            bentotaDetail3: 'Обычные наблюдения включают ящериц-мониторов, крокодилов, различные виды птиц (зимородки, цапли, орлы), обезьян и иногда выдр или водяных змей.',
            bentotaDetail4: 'Опытный лодочник/гид укажет вам интересную флору, традиционные способы рыболовства и жизнь в деревнях на берегу реки.',
            bentotaDetail5: 'Идеально для любителей природы и фотографов — спокойно, расслабляюще и дополняет ваш оздоровительный аюрведический отдых.',
            galleDetail1: 'Исследуйте историческую крепость Галле, объект всемирного наследия ЮНЕСКО и одну из лучше всего сохранившихся колониальных крепостей Шри-Ланки.',
            galleDetail2: 'Прогулянитесь по брусчатым улицам с голландскими колониальными зданиями, бутиками, кафе и художественными галереями.',
            galleDetail3: 'Посетите ключевые достопримечательности, такие как маяк Галле, голландская реформатская церковь, национальный морской музей и валы с потрясающим видом на океан.',
            galleDetail4: 'Узнайте о богатой истории, архитектуре и культурном значении крепости от вашего знающего гида.',
            galleDetail5: 'Идеально для любителей истории, поклонников культуры и тех, кто хочет ощутить колониальное прошлое Шри-Ланки.',
            sigiriyaDetail1: 'Откройте для себя древнюю скальную крепость Сигирия, одну из самых культовых достопримечательностей Шри-Ланки и объект всемирного наследия ЮНЕСКО.',
            sigiriyaDetail2: 'Взберитесь на впечатляющую скалу и исследуйте руины дворца царя Кашьяпы, украшенные фресками, водными садами и знаменитой Зеркальной стеной.',
            sigiriyaDetail3: 'Наслаждайтесь панорамными видами на окружающие джунгли и сельскую местность с вершины.',
            sigiriyaDetail4: 'Узнайте о увлекательной истории, архитектуре и легендах, связанных с Сигирией, от вашего опытного гида.',
            sigiriyaDetail5: 'Идеально для любителей истории, искателей приключений и тех, кто интересуется богатым культурным наследием Шри-Ланки.',
            kandyDetail1: 'Испытайте яркую культуру Канди, последнюю королевскую столицу Шри-Ланки и объект всемирного наследия ЮНЕСКО.',
            kandyDetail2: 'Посетите храм Святого Зуба Реликвии (Шри Далада Малигава), одно из самых важных буддийских мест в мире.',
            kandyDetail3: 'Исследуйте Королевские ботанические сады в Перадении с обширной коллекцией тропических растений и орхидей.',
            kandyDetail4: 'Насладитесь традиционным кандийским танцевальным представлением, демонстрирующим богатое художественное наследие Шри-Ланки.',
            kandyDetail5: 'Идеально для поклонников культуры, любителей истории и тех, кто хочет погрузиться в традиции Шри-Ланки.',
            ellaTitle: 'Приключение в горной стране Элла',
            ellaAlt: 'Тур по горной стране Элла - Мост Девяти Арок и чайные плантации',
            ellaDetail1: 'Путешествие в Эллу, одно из самых живописных высокогорных направлений Шри-Ланки, известное потрясающими горными видами и прохладным климатом.',
            ellaDetail2: 'Посетите культовый Мост Девяти Арок, железнодорожное чудо колониальной эпохи среди пышной зелени, идеальное для фотографии и наблюдения за проходящими поездами.',
            ellaDetail3: 'Исследуйте зеленые чайные плантации, узнайте о производстве цейлонского чая и насладитесь панорамными видами с Маленького Пика Адама или скалы Элла.',
            ellaDetail4: 'Откройте для себя каскадные водопады, включая водопады Равана, прогуляйтесь по живописным тропам и ощутите очаровательную деревенскую атмосферу.',
            ellaDetail5: 'Идеально для любителей природы, искателей приключений и тех, кто хочет сбежать в захватывающие дух высокогорья Шри-Ланки.'
        },
        blogs: {
            heroTitle: 'Блоги Mahi Beach Ayurveda Resort',
            heroSubtitle1: 'Истории с побережья, ритуалы Аюрведы в',
            heroSubtitle2: 'Mahi Beach Ayurveda Resort',
            heroSubtitle3: '. Погрузитесь в советы, историю и заметки за кулисами.',
            heroAlt: 'Пляжная дорожка курорта на закате',
            sectionTitle: 'Блоги Mahi Beach Ayurveda Resort',
            sectionDescription: 'Гиды, истории и заметки из нашего прибрежного убежища — от ритуалов Аюрведы до истории драгоценных камней и советов по путешествиям в окрестностях Бентоты.',
            ayurvedaTitle: 'Сердце аутентичной Аюрведы',
            ayurvedaExcerpt: 'Испытайте вековые традиции исцеления, укорененные в древней мудрости Шри-Ланки.',
            ayurvedaDescription: 'В Mahi Beach Ayurveda Resort Аюрведа — это больше, чем лечение, это образ жизни. Наши терапии основаны на многовековых знаниях, персонализированы под ваш тип тела и проводятся опытными аюрведическими врачами для глубокого и устойчивого баланса.',
            ayurvedaAlt: 'Установка аюрведического лечения с травяными маслами и натуральными элементами',
            healingTitle: 'Персонализированные путешествия исцеления',
            healingExcerpt: 'Почему оздоровительная программа каждого гостя уникально разработана.',
            healingDescription: 'От первичной консультации до ежедневных процедур ваше путешествие исцеления тщательно адаптировано. Травяные терапии, терапевтические массажи, йога и медитация работают вместе, чтобы восстановить гармонию между телом, разумом и духом.',
            healingAlt: 'Аюрведический врач консультирует гостя в спокойной обстановке',
            natureTitle: 'Исцеление у океана',
            natureExcerpt: 'Как морской бриз и тропическое окружение усиливают ваше благополучие.',
            natureDescription: 'Расположенный вдоль спокойного побережья Шри-Ланки, Mahi Beach предлагает естественную исцеляющую среду. Звук волн, свежий океанский воздух и пышная зелень усиливают эффекты Аюрведы, создавая глубокое расслабление и обновление.',
            natureAlt: 'Вид на пляж курорта с пальмами и океаном',
            foodTitle: 'Аюрведическая кухня для внутреннего баланса',
            foodExcerpt: 'Питательные блюда, созданные для поддержки вашего лечения.',
            foodDescription: 'Наша аюрведическая кухня свежеприготовлена с использованием сезонных, местных ингредиентов. Каждое блюдо соответствует вашей доше, поддерживая пищеварение, детоксикацию и общую жизненную силу, оставаясь при этом вкусным и сытным.',
            foodAlt: 'Традиционное аюрведическое блюдо, поданное в натуральных мисках',
            yogaTitle: 'Йога, медитация и внутренний покой',
            yogaExcerpt: 'Мягкие практики, которые успокаивают ум и укрепляют тело.',
            yogaDescription: 'Ежедневные занятия йогой и медитацией дополняют ваши процедуры, улучшая гибкость, дыхание и ясность ума. Эти осознанные практики помогают вам снова соединиться с собой и сохранить чувство покоя за пределами вашего пребывания.',
            yogaAlt: 'Гости практикуют йогу с видом на океан на рассвете',
            lifestyleTitle: 'Принести Аюрведу домой',
            lifestyleExcerpt: 'Простые практики образа жизни для продолжения вашего оздоровительного путешествия.',
            lifestyleDescription: 'Перед отъездом наши эксперты проконсультируют вас о поддержании баланса с помощью ежедневных рутин, диеты и ритуалов самообслуживания. Заберите домой больше, чем воспоминания — заберите устойчивый путь к более здоровой жизни.',
            lifestyleAlt: 'Гость расслабляется с травяным чаем в безмятежной обстановке курорта',
            readMore: 'Читать далее'
        },
        events: {
            heroEyebrow: 'Впечатления и активности',
            heroTitle: 'Наши события',
            heroSubtitle: 'Курируемые впечатления, соединяющие традиции Шри-Ланки с прибрежной роскошью',
            heroAlt: 'События в Mahi Beach',
            availableDaily: 'Доступно ежедневно',
            bookNow: 'Забронировать',
            highlightsTitle: 'Основные моменты',
            detailAlt: '{{title}} — деталь',
            ctaTitle: 'Готовы создать воспоминания?',
            ctaDescription: 'Свяжитесь с нашей командой, чтобы создать идеальный формат вашего события в Mahi Beach Ayurveda Resort',
            ctaContact: 'Связаться с нами',
            ctaViewRooms: 'Посмотреть номера',
            buddhistMonkMeditationTitle: 'Медитация с буддийскими монахами',
            buddhistMonkMeditationSubtitle: 'Традиционные практики осознанности',
            buddhistMonkMeditationDescription: 'Испытайте подлинную буддийскую медитацию под руководством опытных монахов в нашем спокойном курорте. Эти древние практики способствуют внутреннему покою, осознанности и духовному благополучию через управляемые сеансы с традиционными песнопениями, дыхательными техниками и тихой медитацией.',
            buddhistMonkMeditationHighlight1: 'Традиционные сеансы буддийской медитации',
            buddhistMonkMeditationHighlight2: 'Руководство опытных монахов',
            buddhistMonkMeditationHighlight3: 'Спокойная обстановка внутри курорта',
            buddhistMonkMeditationHighlight4: 'Техники осознанности и дыхания',
            buddhistMonkMeditationHighlight5: 'Практики духовного благополучия',
            cookeryTitle: 'Кулинарные программы',
            cookerySubtitle: 'Вкус Шри-Ланки',
            cookeryDescription: 'Погрузитесь в яркие вкусы шри-ланкийской кухни. Наши опытные шеф-повара проводят практические занятия, обучая традиционным рецептам, передаваемым из поколения в поколение. Научитесь готовить ароматные карри, хопперы, кокосовый самбол и многое другое из свежих местных ингредиентов.',
            cookeryHighlight1: 'Традиционные рецепты Шри-Ланки',
            cookeryHighlight2: 'Практический кулинарный опыт',
            cookeryHighlight3: 'Свежие местные ингредиенты',
            cookeryHighlight4: 'Заберите рецепты домой',
            cookeryHighlight5: 'Экскурсия в сад специй включена',
            meditationTitle: 'Программы медитации',
            meditationSubtitle: 'Внутренний покой и осознанность',
            meditationDescription: 'Найдите спокойствие на наших сеансах медитации на фоне умиротворяющего Индийского океана. Опытные инструкторы проводят вас через древние техники осознанности, дыхательные упражнения и практики йоги, созданные для успокоения ума и обновления духа.',
            meditationHighlight1: 'Сеансы на рассвете и закате',
            meditationHighlight2: 'Медитация у моря',
            meditationHighlight3: 'Под руководством экспертов',
            meditationHighlight4: 'Дыхательные техники',
            meditationHighlight5: 'Практики йоги и осознанности',
            nightBeachPartiesTitle: 'Вечер гриля',
            nightBeachPartiesSubtitle: 'Кулинарный опыт на пляже',
            nightBeachPartiesDescription: 'Насладитесь незабываемым вечером гриля на пляже под звездами. Попробуйте свежие морепродукты на гриле, премиальное мясо и яркие овощи, наслаждаясь успокаивающим звуком океанских волн. Наши опытные повара готовят каждое блюдо до совершенства, создавая незабываемый кулинарный опыт в волшебной прибрежной обстановке.',
            nightBeachPartiesHighlight1: 'Свежие морепродукты и мясо на гриле',
            nightBeachPartiesHighlight2: 'Живая демонстрация гриля шеф-поварами',
            nightBeachPartiesHighlight3: 'Атмосфера ужина у океана',
            nightBeachPartiesHighlight4: 'Выбор премиального барбекю-буфета',
            nightBeachPartiesHighlight5: 'Пляжная атмосфера с костром',
            bbqTitle: 'BBQ-вечеринки',
            bbqSubtitle: 'Пляжные праздники',
            bbqDescription: 'Проведите незабываемые вечера на наших пляжных BBQ-вечеринках. Наслаждайтесь свежими морепродуктами на гриле, премиальными мясными блюдами и вегетарианскими угощениями, пока рядом шепчут волны. Живая музыка, танцоры с огнем и звездное небо создают идеальную атмосферу для праздника и общения.',
            bbqHighlight1: 'Свежие морепродукты на гриле',
            bbqHighlight2: 'Ужин у океана',
            bbqHighlight3: 'Живая музыка',
            bbqHighlight4: 'Опыт у костра',
            bbqHighlight5: 'Настраиваемые меню',
            boatTitle: 'Прогулки на лодке',
            boatSubtitle: 'Речные и прибрежные приключения',
            boatDescription: 'Отправьтесь в очаровательные путешествия по реке Бентота и прибрежным водам. Скользите через мангровые леса, наблюдайте экзотических птиц и животных или наслаждайтесь романтическими закатными круизами. Наши прогулки на лодке открывают уникальный взгляд на природную красоту и экосистемы Шри-Ланки.',
            boatHighlight1: 'Круизы по реке Бентота',
            boatHighlight2: 'Исследование мангров',
            boatHighlight3: 'Наблюдение за дикой природой',
            boatHighlight4: 'Закатные туры на лодке',
            boatHighlight5: 'Доступна частная аренда',
            ayurvedaLecturesTitle: 'Лекции врачей по аюрведе',
            ayurvedaLecturesSubtitle: 'Древняя мудрость и современное благополучие',
            ayurvedaLecturesDescription: 'Откройте глубокие принципы аюрведы на лекциях, проводимых сертифицированными врачами и практиками. Узнайте о балансировке дош, травяных средствах, холистических практиках исцеления и о том, как древняя мудрость применима к современному благополучию. Наши интерактивные сессии проясняют философию аюрведы и её применение в повседневной жизни.',
            ayurvedaLecturesHighlight1: 'Сертифицированные врачи аюрведы',
            ayurvedaLecturesHighlight2: 'Персональный анализ доши',
            ayurvedaLecturesHighlight3: 'Обучение травяным средствам',
            ayurvedaLecturesHighlight4: 'Сессии вопросов и ответов',
            ayurvedaLecturesHighlight5: 'Памятка по оздоровлению с собой',
            traditionalClothsTitle: 'Мероприятия по ношению традиционной одежды',
            traditionalClothsSubtitle: 'Опыт культурного наследия',
            traditionalClothsDescription: 'Погрузитесь в культурное наследие Шри-Ланки, изучая традиционную одежду. Наши стилисты покажут, как носить аутентичные кандийские сари и традиционные наряды, объясняя культурное значение каждого элемента. Идеально для особых случаев, культурного знакомства или памятных фотографий.',
            traditionalClothsHighlight1: 'Профессиональные советы по стилю',
            traditionalClothsHighlight2: 'Аутентичные традиционные сари',
            traditionalClothsHighlight3: 'Объяснение культурного значения',
            traditionalClothsHighlight4: 'Профессиональная фотосъёмка включена',
            traditionalClothsHighlight5: 'Мастер-классы по фьюжн-стилю',
            shanthiKarmaTitle: 'Культурный танец',
            shanthiKarmaSubtitle: 'Традиционные шри-ланкийские представления',
            shanthiKarmaDescription: 'Погрузитесь в яркий мир шри-ланкийского культурного танца. Насладитесь завораживающими традиционными представлениями с красочными костюмами, ритмичными барабанами и древним повествованием через движение. Наши талантливые танцоры демонстрируют вековые народные танцы, кандийский танец и культурные ритуалы, которые оживляют наследие Шри-Ланки.',
            shanthiKarmaHighlight1: 'Аутентичные традиционные шри-ланкийские танцы',
            shanthiKarmaHighlight2: 'Красочные традиционные костюмы и грим',
            shanthiKarmaHighlight3: 'Живой барабанный аккомпанемент',
            shanthiKarmaHighlight4: 'Культурное повествование через движение',
            shanthiKarmaHighlight5: 'Представления кандийского и народного танца',
            musicTherapyTitle: 'Музыкальная терапия',
            musicTherapySubtitle: 'Исцеление через звук',
            musicTherapyDescription: 'Откройте для себя терапевтическую силу музыки на наших специализированных сеансах, сочетающих древние шри-ланкийские инструменты с современными техниками исцеления. Наши сертифицированные музыкальные терапевты используют звуковые вибрации, ритмические паттерны и мелодичные гармонии для снижения стресса, улучшения эмоционального благополучия и глубокого расслабления.',
            musicTherapyHighlight1: 'Традиционные шри-ланкийские инструменты',
            musicTherapyHighlight2: 'Сертифицированные музыкальные терапевты',
            musicTherapyHighlight3: 'Звуковые целительные вибрации',
            musicTherapyHighlight4: 'Техники снижения стресса',
            musicTherapyHighlight5: 'Групповые и индивидуальные сеансы',
            taiChiTitle: 'Тай Чи',
            taiChiSubtitle: 'Мягкое движение и баланс',
            taiChiDescription: 'Испытайте древнее китайское боевое искусство Тай Чи, практикуемое в нашей спокойной прибрежной обстановке. Это мягкое, плавное упражнение сочетает медленные, осознанные движения с глубоким дыханием и медитацией для улучшения баланса, гибкости и внутреннего спокойствия. Подходит для всех возрастов и уровней физической подготовки.',
            taiChiHighlight1: 'Утренние сеансы на берегу моря',
            taiChiHighlight2: 'Опытные инструкторы Тай Чи',
            taiChiHighlight3: 'Улучшает баланс и гибкость',
            taiChiHighlight4: 'Подходит для всех уровней подготовки',
            taiChiHighlight5: 'Техники медитации и дыхания',
        },
        food: {
            heroTitle: 'Аюрведическое питание и прибрежная кухня',
            heroSubtitle: 'Аутентичные шри-ланкийские вкусы и свежая прибрежная кухня',
            heroAlt: 'Кулинарный опыт на пляжном курорте Mahi Beach',
            wellnessEyebrow: 'Здоровье через пищу',
            wellnessTitle: 'Значение',
            ayurvedicFood: 'аюрведической пищи',
            wellnessIntro1: 'В аюрведе пища считается величайшей медициной. То, что вы едите, непосредственно влияет на ваши доши (Вата, Питта, Капха), пищеварение (агни) и общий баланс тела, ума и духа.',
            wellnessIntro2: 'Аюрведическое питание подчеркивает свежие, сезонные, цельные продукты, приготовленные с заботой и внимательным питанием. Оно поощряет шесть вкусов (сладкий, кислый, соленый, пикантный, горький, вяжущий) в каждом блюде для питания всех чувств и поддержания гармонии.',
            wellnessIntro3: 'Правильная аюрведическая пища поддерживает сильное пищеварение, помогает удалять токсины (ама), повышает иммунитет, улучшает энергию, снижает стресс и предотвращает многие хронические заболевания. В Mahi Beach каждое блюдо тщательно готовится в соответствии с вашей уникальной конституцией для глубокого исцеления и жизненной силы.',
            foodImage1Alt: 'Традиционный аюрведический прием пищи с шестью вкусами',
            foodImage2Alt: 'Аюрведические травы и специи для сбалансированного питания',
            culinaryPhilosophyEyebrow: 'Наша кулинарная философия',
            culinaryPhilosophyTitle: 'Аюрведическое',
            nutritionHighlight: 'питание',
            culinaryPhilosophyResort: 'в Mahi Beach Ayurveda Resort',
            nutritionTopImageAlt: 'Аюрведическая кухня в Mahi Beach Ayurveda Resort',
            freshNourishingLabel: 'Свежее и питательное',
            healingIngredientsAlt: 'Здоровые аюрведические ингредиенты и специи',
            healingIngredientsLabel: 'Целебные ингредиенты',
            philosophyText1: 'Пища, которая включает в себя шесть основных вкусов (сладкий, кислый, соленый, горький, пикантный и вяжущий) с множеством тонких вариаций, была описана в классических аюрведических текстах — некоторые датируются более 5000 лет назад — вместе с существенными свойствами каждой пищи: Гуна (врожденное качество), Вирья (потенция/тепло или охлаждение), Випака (постпищеварительное воздействие) и Прабхава (уникальное специальное действие).',
            philosophyText2: 'В результате аюрведическое питание играет центральную роль в Mahi Beach Ayurveda Resort. Это не означает жесткий, однообразный режим пресных, безвкусных или чрезмерно горьких вегетарианских блюд, предписанных исключительно врачами. Напротив, наша аюрведическая кухня является одной из наших величайших сильных сторон: блюда, приготовленные нашими опытными поварами, будут удивлять и радовать вас каждый день вашего пребывания!',
            philosophyText3: 'На завтрак вы получите обильный буфет с свежими тропическими фруктами, свежевыжатыми соками, питательными травяными супами, домашним хлебом и легким печеньем, а также разнообразными аутентичными шри-ланкийскими вариантами завтрака. На обед насладитесь красочным и ароматным буфетом с мягкими рыбными карри, овощными блюдами и травяными блюдами. Вечером мы подаем установленное вегетарианское меню с опцией свежей рыбы. По субботам мы отмечаем «ночь Шри-Ланки» с расширенным буфетом — наши повара готовят традиционные местные специалитеты прямо перед вами, создавая оживленный и аутентичный опыт.',
            philosophyText4: 'В аюрведе пищевые продукты и напитки классифицируются множеством способов — по вкусу и свойствам, пищеварительной способности организма (агни), пригодности для конкретных состояний здоровья, сезонной уместности и многому другому. В Mahi Beach мы тщательно учитываем все эти факторы одновременно, сознательно стремясь включить все шесть вкусов в сбалансированные комбинации, адаптированные к индивидуальной конституции каждого гостя.',
            philosophyText5: 'Наши блюда включают свежие овощи, тропические фрукты и ответственно добытую рыбу. Мы не подаем красное мясо или алкоголь.',
            philosophyText6: 'Во время приема пищи аюрведический врач или квалифицированный диетолог всегда готов помочь вам. Они посоветуют вам наиболее подходящие овощи, травы и специи для вашего текущего этапа лечения и помогут вам выбирать или избегать блюд соответственно. Ваш персональный травяной эликсир и любые конкретные инструкции от команды центра здоровья будут размещены на вашем индивидуальном столе.',
            philosophyText7: 'Этот уровень личной заботы и внимания к диете является отличительной чертой опыта Mahi Beach Ayurveda Resort.',
            philosophyText8: 'Пища рассматривается как Прана — жизненная энергия, поддерживающая жизнь — для каждого человека. Вот почему мы поощряем вас подходить к каждому приему пищи с полным осознанием: наслаждаясь ароматами, переживая вкусы, ощущая мягкое тепло и наслаждаясь ароматными ощущениями внимательно.',
            diningExperienceEyebrow: 'Опыт питания',
            restaurantTitlePrefix: 'Наш',
            ayurvedicHighlight: 'аюрведический',
            restaurantTitleSuffix: 'ресторан',
            restaurantDetail1: 'Наш аюрведический ресторан на пляжном курорте Mahi Beach предлагает уникальный опыт питания, который гармонирует традиционные аюрведические принципы с аутентичной шри-ланкийской прибрежной кухней. Мы уделяем приоритет свежим, местным ингредиентам для создания блюд, которые не только радуют небо, но и способствуют целостному благополучию.',
            restaurantDetail2: 'Меню тщательно разработано для поддержания баланса шести вкусов (сладкий, кислый, соленый, горький, пикантный и вяжущий) в каждом блюде, обеспечивая питательный и удовлетворительный опыт. Каждое блюдо готовится с заботой, включая аюрведические травы и специи, известные своими целебными свойствами.',
            restaurantDetail3: 'Гости могут наслаждаться разнообразными блюдами, адаптированными к их индивидуальным дошам (типам телосложения), с вариантами для вегетарианской, веганской и пескетарианской диет. Наши повара тесно сотрудничают с практикующими аюрведистами, чтобы гарантировать, что каждое блюдо поддерживает цели здоровья и благополучия гостей.',
            restaurantDetail4: 'Атмосфера ресторана отражает спокойную прибрежную среду, предоставляя безмятежную обстановку для внимательного питания. Независимо от того, наслаждаетесь ли вы обильным завтраком в буфете или смакуете гурманский ужин, каждый прием пищи в нашем аюрведическом ресторане — это возможность питать тело и душу.',
            restaurantDetail5: 'Присоединяйтесь к нам в аюрведическом ресторане Mahi Beach Ayurveda Resort в кулинарном путешествии, которое отмечает богатые вкусы Шри-Ланки при одновременном принятии безвременной мудрости Аюрведы.',
            restaurantImageAlt: 'Ужин в Mahi Beach Ayurveda Resort',
            premiumDiningLabel: 'Премиум-обеды',
            premiumDiningDescription: 'Испытайте аутентичную аюрведическую кухню в спокойной речной обстановке'
        },
        yoga: {
            heroTitle: 'Йога на курорте',
            heroSubtitle: 'Найдите баланс, силу и внутренний покой в Берувале',
            heroAlt: 'Йога в Mahi Beach Ayurveda Resort',
            importanceEyebrow: 'Здоровье и баланс',
            importanceTitle: 'Значение йоги и медитации',
            importanceImageAlt: 'Значение йоги и медитации',
            importanceText1: 'Йога и медитация — древние практики, дающие множество физических, ментальных и эмоциональных преимуществ. Они развивают гибкость, силу и баланс, снижая стресс и тревожность.',
            importanceText2: 'Регулярная практика улучшает концентрацию, качество сна и общее самочувствие. Йога также развивает осознанность, помогая человеку соединиться с внутренним «я» и найти спокойствие среди повседневной суеты.',
            importanceText3: 'В Mahi Beach Ayurveda Resort мы создаем спокойную среду, идеально подходящую для йоги и медитации, чтобы гости могли восстановить ум, тело и дух.',
            practiceEyebrow: 'Наша практика',
            practiceTitle: 'Практика йоги и опыт',
            practiceImageAlt: 'Практика йоги на курорте',
            practiceText1: 'В Mahi Beach Ayurveda Resort йога практикуется преимущественно как традиционная хатха-йога в сочетании с пранаямой (дыхательными техниками). Этот целостный подход направлен на пробуждение внутреннего осознания и мягкую стимуляцию кундалини (часто называемой «третьим глазом»). Особое внимание уделяется выравниванию позвоночника и гибкости, поскольку считается, что гибкий позвоночник замедляет старение — «Вы настолько молоды, насколько молод ваш позвоночник».',
            practiceText2: 'Занятия проводятся четыре раза в неделю и подходят как новичкам, так и опытным практикам. Время от времени вводятся специальные сессии, такие как аштанга-йога, позволяя гостям попробовать разнообразные позы и последовательности. Наши аюрведические врачи поощряют регулярное участие для поддержки и усиления общей программы лечения.',
            practiceText3: 'Все занятия проходят в нашей Yoga Shala — спокойном и гармоничном пространстве, созданном для концентрации, баланса и осознанного движения. Каждая сессия обычно начинается с «Приветствия Солнцу», затем следует пранаяма и последовательность тщательно отобранных асан для улучшения гибкости, кровообращения и общего самочувствия.',
            practiceText4: 'Наши опытные преподаватели йоги адаптируют каждую сессию под индивидуальные потребности, способности и состояние здоровья гостей, обеспечивая безопасный, поддерживающий и глубоко полезный опыт для каждого.',
            spiritualEyebrow: 'Духовное путешествие',
            spiritualTitle: 'Медитация и духовные практики',
            spiritualSubtitle: 'Углубите духовную практику с нашими священными церемониями и сеансами управляемой медитации',
            meditationImageAlt: 'Медитация и духовная практика на курорте',
            meditationTitle: 'Сеансы медитации',
            meditationDesc: 'Гости приглашаются на управляемые медитационные сессии, проходящие три раза в неделю и вдохновленные буддийскими традициями. Эти занятия предназначены для успокоения ума, углубления осознанности и поддержки эмоционального и духовного исцеления. Медитации проходят в тихом храме на острове, до которого гости добираются на лодке — это добавляет особое чувство спокойствия и значимости, усиливая общий медитативный опыт.'
        },
        contact: {
            heroTitle: 'Свяжитесь с нами',
            heroSubtitle: 'Mahi Beach Ayurveda Resort',
            heroAlt: 'Свяжитесь с нами',
            sectionTitle: 'Свяжитесь с нами в любое время',
            sectionSubtitle: 'Мы поможем вам расслабиться и восстановиться',
            sectionDescription: 'Свяжитесь с Mahi Beach Ayurveda Resort по вопросам Ayurveda-программ, оздоровительных пакетов, бронирований или любых вопросов во время вашего пребывания в Берувале, Морагалла.',
            callUs: 'Позвоните нам',
            emailTitle: 'Эл. почта',
            ourLocation: 'Наш адрес',
            locationAddress: 'No.112 rendagewatta Galle Rd, Maggona',
            socialNetwork: 'Социальные сети',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Связаться',
            getInTouchDescription: 'Мы будем рады вашему сообщению — наша команда готова помочь с вашим wellness-путешествием, ответить на вопросы и спланировать отдых.',
            nameLabel: 'Имя',
            emailLabel: 'Эл. почта',
            contactNumberLabel: 'Телефон',
            messageLabel: 'Сообщение',
            sending: 'Отправка...',
            sendMessage: 'Отправить сообщение',
            successMessage: 'Ваше сообщение успешно отправлено! Мы свяжемся с вами в ближайшее время.',
            errorMessage: 'Произошла ошибка при отправке. Пожалуйста, попробуйте еще раз.',
            findUsOnMap: 'Найдите нас на карте',
            whatsappSubject: 'Контакт Mahi Beach Ayurveda Resort',
            whatsappName: 'Имя',
            whatsappEmail: 'Эл. почта',
            whatsappContactNumber: 'Телефон',
            whatsappMessage: 'Сообщение'
        },


        ayurveda: {
            accordionTitle1: 'Понимание Панчакармы',
            accordionDesc1: 'Аюрведа («наука о жизни») — одна из древнейших целостных систем исцеления, созданная более 5000 лет назад. Панчакарма основана на гармонии разума, тела, духа и окружающей среды. Её цель — укреплять здоровье и предупреждать болезни, а процедуры подбираются под конкретные потребности.',
            accordionTitle2: 'Панчакарма и жизненная энергия',
            accordionDesc2: 'Аюрведа учит взаимосвязи всего сущего. Когда ум, тело и дух в согласии, сохраняется здоровье; при нарушении баланса появляются недомогания. На равновесие влияют наследственность, травмы, сезоны, возраст и эмоции.\n\nСогласно аюрведе, человек состоит из пяти элементов: пространство, воздух, огонь, вода и земля. Они образуют три доши: ВАТА (пространство/воздух), ПИТТА (огонь/вода) и КАПХА (вода/земля). Эти энергии управляют функциями организма.\n\nУ каждого свой уникальный баланс дош, обычно с доминирующей. От него зависят склонности к здоровью и возможным нарушениям.',
            accordionTitle3: 'Вата Доша',
            accordionDesc3: 'Вата считается самой влиятельной и управляет движением, дыханием, кровообращением, сердечным ритмом и выведением. Её нарушают нерегулярное питание, страх, горе и поздние ночи.\n\nПри доминировании Ваты человек часто быстрый, творческий и энергичный, с худощавым телосложением и чувствительностью к холоду. В дисбалансе возможны тревожность, беспокойство, забывчивость и проблемы с дыханием или суставами.\n\nБаланс Ваты поддерживают заземляющие практики: медитация, массаж, стабильный режим и тёплая мягкая пища.',
            accordionTitle4: 'Питта Доша',
            accordionDesc4: 'Питта отвечает за пищеварение, обмен веществ и гормоны аппетита. Её усиливают острые и кислые продукты, жара и пропуски приёмов пищи.\n\nПитта-доминантные люди целеустремлённые, уверенные и лидерские, часто с «тёплой» конституцией. В дисбалансе проявляются раздражительность, вспыльчивость и воспалительные реакции.\n\nДля гармонизации Питты подходят охлаждающие лёгкие блюда и спокойные практики, например мягкая йога.',
            accordionTitle5: 'Капха Доша',
            accordionDesc5: 'Капха обеспечивает структуру, устойчивость, силу и иммунитет. Её усиливают тяжёлая пища, избыток сладкого и длительный сон.\n\nПри доминировании Капхи человек обычно спокойный, терпеливый и устойчивый, с более плотным телосложением. В дисбалансе возможны усталость, вялость, прибавка веса и застойные явления.\n\nБаланс Капхи поддерживают лёгкая диета, больше фруктов и овощей и активное движение.',
            close: 'Закрыть',
            next: 'Далее',
            previous: 'Назад',
            treatmentsTitle: 'Наши фирменные процедуры Панчакармы',
            treatmentsSubtitle: 'Традиционные ритуалы, которые возвращают баланс, снимают напряжение и обновляют тело и ум.',
            bookTreatment: 'Забронировать эту процедуру',
            benefitsTitle: 'Почему Панчакарма полезна',
            shirodhara: 'Широдхара',
            shirodharaDesc: 'Тёплое травяное масло мягко струится на лоб, успокаивая нервную систему.',
            shirodhara1: 'Снимает стресс и тревожные мысли',
            shirodhara2: 'Помогает более глубокому сну',
            shirodhara3: 'Повышает ясность и спокойствие ума',
            steamBath: 'Паровая баня',
            steamBathDesc: 'Травяной пар раскрывает поры, поддерживает детокс и расслабляет мышцы.',
            steamBath1: 'Поддерживает очищение через мягкое потоотделение',
            steamBath2: 'Улучшает кровообращение',
            steamBath3: 'Снимает мышечную скованность',
            flowerBath: 'Цветочная ванна',
            flowerBathDesc: 'Ароматная цветочная ванна для расслабления и перезагрузки.',
            flowerBath1: 'Успокаивает нервную систему',
            flowerBath2: 'Смягчает и увлажняет кожу',
            flowerBath3: 'Поднимает настроение',
            headMassage: 'Массаж головы',
            headMassageDesc: 'Массаж кожи головы снимает накопленное напряжение.',
            headMassage1: 'Уменьшает давление в голове',
            headMassage2: 'Питает кожу головы и корни волос',
            headMassage3: 'Способствует глубокому расслаблению',
            faceMassage: 'Массаж лица',
            faceMassageDesc: 'Нежный массаж лица, возвращающий сияние и уменьшающий стресс.',
            faceMassage1: 'Освежает тон кожи',
            faceMassage2: 'Снимает напряжение лица',
            faceMassage3: 'Поддерживает лимфоток',
            neckMassage: 'Массаж шеи',
            neckMassageDesc: 'Прицельная работа для снятия скованности в шее.',
            neckMassage1: 'Уменьшает дискомфорт в шее',
            neckMassage2: 'Улучшает подвижность',
            neckMassage3: 'Снижает стресс',
            shoulderMassage: 'Массаж плеч',
            shoulderMassageDesc: 'Терапевтический массаж для расслабления плеч.',
            shoulderMassage1: 'Снимает боль в плечах',
            shoulderMassage2: 'Поддерживает осанку',
            shoulderMassage3: 'Расслабляет мышечные узлы',
            bodyMassage: 'Массаж всего тела',
            bodyMassageDesc: 'Полный массаж тела для восстановления и расслабления.',
            bodyMassage1: 'Улучшает циркуляцию',
            bodyMassage2: 'Снимает мышечную усталость',
            bodyMassage3: 'Дарит общее расслабление',
            backMassage: 'Массаж спины',
            backMassageDesc: 'Терапия спины для снятия напряжения и боли.',
            backMassage1: 'Успокаивает боль в спине',
            backMassage2: 'Поддерживает комфорт позвоночника',
            backMassage3: 'Снижает стресс',
            footMassage: 'Массаж стоп',
            footMassageDesc: 'Заземляющий массаж стоп, расслабляющий всё тело.',
            footMassage1: 'Стимулирует кровообращение',
            footMassage2: 'Снимает усталость ног',
            footMassage3: 'Помогает успокоиться',
            purgative: 'Слабительное',
            purgativeDesc: 'Очищающее лечение для выведения избытка Питты и токсинов из пищеварения.',
            purgative1: 'Очищает кишечник',
            purgative2: 'Балансирует Питту',
            purgative3: 'Поддерживает пищеварение',
            nasalClearing: 'Очищение носа',
            nasalClearingDesc: 'Травяная процедура для очищения носовых ходов и дыхания.',
            nasalClearing1: 'Снимает заложенность',
            nasalClearing2: 'Улучшает дыхание',
            nasalClearing3: 'Уменьшает давление в пазухах',
            powderMassage: 'Порошковый массаж',
            powderMassageDesc: 'Скраб-массаж травяными порошками для обновления кожи.',
            powderMassage1: 'Удаляет тусклые, мёртвые клетки',
            powderMassage2: 'Выравнивает текстуру кожи',
            powderMassage3: 'Усиливает кровоток',
            intensiveMassageDesc: 'Глубокая терапия для хронического напряжения и стойких узлов.',
            intensiveMassage1: 'Снимает глубокие зажимы',
            intensiveMassage2: 'Улучшает кровоснабжение',
            intensiveMassage3: 'Уменьшает длительную боль',
            thermoMassage: 'Термо-массаж',
            thermoMassageDesc: 'Тёплые травяные масла расслабляют ткани и поддерживают восстановление.',
            thermoMassage1: 'Успокаивает ноющие мышцы',
            thermoMassage2: 'Погружает в глубокий релакс',
            thermoMassage3: 'Поддерживает ровный поток энергии',
            synchronMassage: 'Синхронный массаж',
            synchronMassageDesc: 'Синхронный массаж двумя терапевтами для гармонии всего тела.',
            synchronMassage1: 'Полная телесная гармония',
            synchronMassage2: 'Стабильный поток энергии',
            synchronMassage3: 'Глубокое расслабление',
            specialMassage: 'Специальный массаж',
            specialMassageDesc: 'Индивидуальная процедура, созданная под ваши цели здоровья.',
            specialMassage1: 'Персональная настройка',
            specialMassage2: 'Фокус на конкретных запросах',
            specialMassage3: 'Целенаправленное восстановление',
            benefit1Title: 'Детокс-поддержка:',
            benefit1Desc: 'Панчакарма помогает вывести накопленные токсины и освежить жизненный тонус.',
            benefit2Title: 'Лёгкое пищеварение:',
            benefit2Desc: 'Терапии помогают пищеварению и улучшают усвоение нутриентов.',
            benefit3Title: 'Сброс стресса:',
            benefit3Desc: 'Успокаивающие процедуры снижают напряжение и тревожность.',
            benefit4Title: 'Иммунная устойчивость:',
            benefit4Desc: 'Регулярные сеансы укрепляют защитные силы организма.',
            benefit5Title: 'Обновление:',
            benefit5Desc: 'Поддерживает клеточное обновление и здоровое сияние кожи.',
            benefit6Title: 'Баланс дош:',
            benefit6Desc: 'Восстанавливает гармонию Ваты, Питты и Капхи для устойчивого благополучия.',
            akkupancharTitle: 'Терапия Акупунктуры',
            akkupancharDesc1: 'древняя терапевтическая практика с использованием тонких игл на специфических точках тела. Эта процедура стимулирует энергетические каналы и способствует исцелению.',
            akkupancharBenefit: 'Ключевые преимущества:',
            akkupancharDesc2: 'Эта специализированная терапия помогает при хронической боли, улучшает гибкость суставов, кровообращение и восстанавливает естественный поток энергии.',
            akkupancharApplication: 'Терапевтическое применение:',
            akkupancharDesc3: 'Акупунктура воздействует на специфические точки марма с тщательно подобранными методами для баланса дош.',
            akkupancharTransform: 'Испытайте трансформацию:',
            akkupancharDesc4: 'В Mahi Beach Ayurveda Resort наши опытные специалисты настраивают каждую сессию акупунктуры под ваши уникальные потребности.',
            experienceAkkupanchar: 'Испытайте акупунктуру сегодня',
            doctorsEyebrow: 'НАША КОМАНДА ЭКСПЕРТОВ',
            doctorsSectionTitle: 'Наши врачи',
            drSandyaName: 'Др. М. Сандья Мендис',
            drSandyaProfession: 'Врач аюрведической медицины',
            drSandyaSpecialization: 'Клиническая аюрведа, Персонализированное планирование лечения, Аюрведический уход в гостиничной индустрии',
            drSandyaProfileTitle: 'Профессиональный профиль',
            drSandyaProfile: 'Отзывчивый и преданный специалист аюрведы с более чем 25-летним опытом предоставления персонализированного ухода и оздоровительных решений. Специализируется на сочетании традиционных аюрведических принципов с современными терапевтическими практиками для целостного исцеления в роскошных оздоровительных курортах.',
            drSandyaWorkExpTitle: 'Опыт работы',
            drSandyaWorkExp1: 'Главный врач и руководитель программ - Mahi Beach Ayurveda Resort (2023 – настоящее время)',
            drSandyaWorkExp2: 'Старший врач аюрведы - Sun Aqua Resort and Spa, Маггона (2008 – 2023)',
            drSandyaWorkExp3: 'Консультант аюрведы - Amba Ayurveda Specialty Clinic (2006 – 2008)',
            drSandyaWorkExp4: 'Врач аюрведы и специалист по Панчакарме - Paradise Road The Villa Bentota (2002 – 2006)',
            drSandyaWorkExp5: 'Медицинский работник аюрведы - Hotel Blue Water (1996 – 2002)',
            drSandyaEducationTitle: 'Образование и профессиональная квалификация',
            drSandyaEdu1: 'Диплом по аюрведе - Government Ayurveda College, Борелла (1989 – 1993)',
            drSandyaEdu2: 'Рейки 2-й степени - Reiki Dasa Centre Негомбо Шри-Ланка (2015 – 2016)',
            drPandukaName: 'Др. Пандука Ранавира',
            drPandukaProfession: 'Врач аюрведы',
            drPandukaQualification: 'B.A.M.S. (Бакалавр аюрведической медицины и хирургии)',
            drPandukaProfileTitle: 'Профессиональный профиль',
            drPandukaProfile: 'Др. Пандука Ранавира — квалифицированный и опытный врач аюрведы, имеющий степень бакалавра аюрведической медицины и хирургии (B.A.M.S.) Университета Коломбо. Его академическая подготовка прочно основана на классических аюрведических принципах и всестороннем клиническом образовании, поддерживая структурированный, этический и научно обоснованный подход к традиционной медицине.',
            drPandukaExpertiseTitle: 'Профессиональная экспертиза',
            drPandukaExpertise: 'Помимо клинической практики, доктор Ранавира проводит профессиональные лекции по аюрведе для гостей и оздоровительных программ, предлагая четкое понимание аюрведической философии, профилактики заболеваний, управления образом жизни и практического применения традиционных терапий. Эти сессии улучшают понимание и вовлеченность гостей, способствуя устойчивым результатам в области здоровья.',
            drPandukaSpecialtyTitle: 'Интегративные терапии',
            drPandukaSpecialty: 'Его терапевтический опыт также распространяется на акупунктуру и музыкальную терапию, которые он выборочно интегрирует для поддержки управления болью, снижения стресса, неврологического баланса и эмоционального благополучия. Сочетая аюрведу с этими дополнительными модальностями, доктор Ранавира обеспечивает действительно интегративный опыт исцеления.',
            drPandukaRoleTitle: 'Приверженность совершенству',
            drPandukaRole: 'В своей роли в отеле доктор Ранавира поддерживает высокие клинические стандарты, предоставляя персонализированные планы лечения и целостное руководство по здоровью. Его профессиональный, спокойный и сострадательный подход гарантирует, что каждый гость получает безопасный, аутентичный и ориентированный на результат уход, направленный на долгосрочный баланс, жизненную силу и общее благополучие.',
            gallery1: 'Терапия Широдхара',
            gallery2: 'Паровая баня',
            gallery3: 'Цветочная ванна',
            gallery4: 'Массаж головы',
            gallery5: 'Массаж тела',
            gallery6: 'Массаж шеи',
            gallery7: 'Массаж лица',
            gallery8: 'Массаж плеч',
            heroTitle: 'Панчакарма Аюрведа',
            heroSubtitle: 'Омолодите тело, ум и дух в Берувале',
            heroTagline: 'Испытайте подлинное шри-ланкийское аюрведическое исцеление у океана',
            sectionEyebrow: 'ПАНЧАКАРМА АЮРВЕДА В MAHI BEACH AYURVEDA RESORT',
            sectionDescription: 'Познайте древнее искусство Панчакармы в Mahi Beach Ayurveda Resort в Маггоне, Шри-Ланка. Наша команда подбирает персональные процедуры для очищения, восстановления и гармонии тела, ума и духа.',
            treatmentProgramme: {
                title: 'Программа аюрведического лечения',
                subtitle: 'Ваш путь к равновесию, детоксикации и глубокому обновлению',
                intro: 'Погрузитесь в подлинную аюрведу в спокойном прибрежном ретрите, который поддерживает тело, успокаивает ум и возвращает энергию. С момента прибытия мы берём на себя детали, чтобы вы могли сосредоточиться на благополучии.',
                welcomeTitle: 'Добро пожаловать и нежное начало',
                doctorTitle: 'Консультация врача и личный план',
                dailyTherapiesTitle: 'Ежедневные аюрведические процедуры',
                herbalMedicineTitle: 'Поддержка лечебными травами',
                yogaMeditationTitle: 'Йога и медитация для гармонии тела и ума',
                wellnessTitle: 'Включенные оздоровительные мероприятия',
                closingTitle: 'Заключительный ритуал и отъезд',
                welcomePoints: [
                    'Трансфер из аэропорта и доставка в отель',
                    'Теплый прием и ориентация по отелю',
                    'Введение в вашу еженедельную программу здоровья',
                    'Расслабляющий массаж (День 1) в центре аюрведы для облегчения усталости от путешествия и подготовки тела к процедурам'
                ],
                doctorPoints: [
                    'Консультация врача аюрведы (День 2 – утро)',
                    'Полная оценка вашей доши/типа тела и проблем со здоровьем',
                    'Переводчик доступен по запросу',
                    'Ваш врач создает персональный план лечения, соответствующий вашим потребностям и целям'
                ],
                dailyTherapiesPoints: [
                    '4–5 процедур в день (как рекомендовано врачом)',
                    'Процедуры подобраны на основе вашей конституции тела и состояния',
                    'Специальные массажи могут быть добавлены при необходимости',
                    'Врач ежедневно отслеживает прогресс и может корректировать процедуры и травяную поддержку для получения лучших результатов',
                    'При необходимости может быть рекомендован мягкий процесс очищения'
                ],
                herbalMedicinePoints: [
                    'Травяные лекарства, назначенные врачом, два раза в день:',
                    'Во время завтрака',
                    'Во время ужина',
                    'Поддерживают внутреннее исцеление, детоксикацию и долгосрочное равновесие'
                ],
                yogaMeditationPoints: [
                    'Занятия йогой 4 раза в неделю (приблизительно 1 час)',
                    'Сеансы медитации 2 раза в неделю:',
                    'Уникальный духовный опыт в храме на острове, доступный на лодке',
                    'Управляемая медитация под руководством монахов (приблизительно 1 час)'
                ],
                wellnessPoints: [
                    'Еженедельные демонстрации здорового приготовления пищи',
                    'Бесплатная экскурсия (культурный/природный опыт)'
                ],
                closingPoints: [
                    'Прекрасная ванна из цветов (последний день) – традиционный ритуал обновления',
                    'Заключительная консультация врача для проверки прогресса и предоставления:',
                    'Продолжение рекомендаций по благополучию',
                    'Рецепты и рекомендации для дома',
                    'Трансфер обратно в аэропорт'
                ]
            }
        },
        home: {
            // Hero Section
            heroTitle: 'Курорт Mahi Beach Ayurveda Resort Beach',
            heroSubtitle1: 'Аюрведа у океана',
            heroSubtitle2: 'Найдите баланс, дышите легче и обновите свою энергию в Беруваде.',
            exploreResort: 'Изучить курорт',
            bookNow: 'Забронировать сейчас',

            // Welcome Section
            welcomeLabel: 'Добро пожаловать',
            welcomeTitle: 'Курорт Mahi Beach Ayurveda Resort Beach',
            welcomeDesc1: 'Расположенный на нетронутом берегу Беруваде, курорт Mahi Beach Ayurveda Resort Beach предлагает гармоничное сочетание древних целебных традиций и современного пляжного стиля жизни. Наш святилище приглашает вас начать трансформирующий путь благополучия, где ритмичные звуки Индийского океана встречаются с вечной мудростью Аюрведы.',
            welcomeDesc2: 'Испытайте персонализированные аюрведические процедуры, попробуйте питательные блюда, приготовленные для баланса вашей доши, и расслабьтесь в элегантно оформленных номерах с захватывающим видом на океан. Независимо от того, ищете ли вы омоложение, релаксацию или духовное возрождение, наша преданная команда врачей Аюрведы и экспертов по оздоровлению охотно поможет вам на каждом этапе.',
            learnMore: 'Узнать больше',
            contactUs: 'Свяжитесь с нами',
            welcomeImageAlt: 'Курорт Mahi Beach Ayurveda Resort Beach',
            welcomeImageCaption: 'Аюрведа Велнесс и пляжный ретрит',
            welcomeImageLocation: 'Беруваде, Шри-Ланка',

            // Highlight Section
            highlightTitle: 'Святилище Аюрведы у моря',
            highlightDesc: 'Откройте для себя целостное исцеление на юго-западном побережье Шри-Ланки. От персонализированных процедур до тихих балконов и осознанной кухни - каждая деталь разработана для восстановления вашего ритма.',

            // Services
            service1Title: 'Целостные аюрведические процедуры',
            service1Desc: 'Персональные консультации, подлинные травяные масла и ежедневные процедуры под руководством опытных врачей Аюрведы.',
            service2Title: 'Номера и люкс на пляже',
            service2Desc: 'Проснитесь с морским бризом, приватными балконами и успокаивающим интерьером, предназначенным для глубокого отдыха.',
            service3Title: 'Кухня благополучия',
            service3Desc: 'Свежие шри-ланкийские продукты, растительные меню и индивидуальные планы питания, дополняющие вашу дошу.',
            service4Title: 'Йога и внимательность',
            service4Desc: 'Йога на восходе солнца, медитация на закате и дыхательные упражнения в ритме волн.',
            service5Title: 'Экскурсии по реке и побережью',
            service5Desc: 'Прогулки на лодке по реке Бентота, посещение инкубатория черепах, прогулки по саду специй и велосипедные туры по деревням.',

            // Rooms
            roomsTitle: 'Наши номера',
            roomsDesc: 'Выберите святилище, соответствующее вашему стилю, от просторных люксов до уютных делюкс-номеров, каждый с мягким бельем, теплым деревом и балконами, готовыми к восходу солнца.',
            roomBadge: 'Побег на пляж',
            bookableNow: 'Доступна брон',
            seaBreezeReady: 'Готов к морскому бризу',
            viewRoom: 'Просмотреть номер',
            room1Title: 'Номера люкс',
            room1Desc: 'Просторные люкс-номера с зоной отдыха, просторными балконами и успокаивающей палитрой для неспешных утр.',
            room2Title: 'Номера делюкс',
            room2Desc: 'Уютные номера с мягкими кроватями, видом на сад и теплыми деревянными акцентами для повседневного комфорта.',
            room3Title: 'Делюкс с видом на море',
            room3Desc: 'Пробудитесь с морским горизонтом, мягким бельем и приватным балконом для золотых закатов.',

            // Achievements
            achievementsTitle: 'Доверенное благополучие у моря',
            achievement1Title: 'Счастливые гости',
            achievement1Count: '1 000+',
            achievement2Title: 'Аюрведические процедуры',
            achievement2Count: '20+',
            achievement3Title: 'Годы заботы',
            achievement3Count: '15+',
            achievement4Title: 'Путешественники похвалились',
            achievement4Count: '1 000+',

            // Experiences
            experiencesTitle: 'Исследуйте курорт Mahi Beach Ayurveda Resort Beach',
            experiencesDesc: 'От путешествий Аюрведы к кураторским экскурсиям - выбирайте впечатления, которые сделают ваш отдых незабываемым.',
            planYourStay: 'Спланируйте свой отдых',
            experience1Title: 'Номера и люкс',
            experience1Desc: 'Просторные номера с балконами, видом на океан или сад и продуманным комфортом для спокойных отдыхов.',
            experience2Title: 'Аюрведа спа',
            experience2Desc: 'Подлинные процедуры, паровые ванны и восстановительные массажи, проведенные с соблюдением древних ритуалов.',
            experience3Title: 'Опыт ужина',
            experience3Desc: 'Питательная шри-ланкийская и международная кухня в нашем ресторане, тщательно приготовленная для питания тела и разума.',
            experience4Title: 'Впечатления и туры',
            experience4Desc: 'Речные сафари, посещение храмов, водные виды спорта и кураторские культурные экскурсии вокруг Бентоты.',

            // Gallery
            galleryTitle: 'Моменты в курорте Mahi Beach Ayurveda Resort Beach',
            galleryDesc: 'Взгляд в наше побережное святилище - восходы солнца, безмятежные процедуры, питательные блюда и спокойные уголки для вас.',
            gallery1Alt: 'Залитый солнцем пляж, окруженный пальмами в Mahi Beach',
            gallery2Alt: 'Аюрведическое масляное лечение в процессе',
            gallery3Alt: 'Курортный бассейн с шезлонгами',
            gallery4Alt: 'Травы, подготовленные для спа',
            gallery5Alt: 'Пара наслаждается закатом на море',
            gallery6Alt: 'Йога-дека, выходящая на океан',
            gallery7Alt: 'Путь через тропический сад',
            gallery8Alt: 'Здоровый завтрак',
            gallery9Alt: 'Безмятежный вид на реку',
            gallery10Alt: 'Тепло освещенный курорт на берегу на закате',
            gallery11Alt: 'Выставка аюрведических трав и масел',
            gallery12Alt: 'Уютное место в саду',

            // Resort Images
            resort1Alt: 'Открытая гостиная с зеленью',
            resort2Alt: 'Удобный номер интерьер',
            resort3Alt: 'Спа-процедурный кабинет',
            resort4Alt: 'Столовая с естественным светом',
            resort5Alt: 'Расслабляющий вид на бассейн',

            // Sunset Section
            sunsetLabel: 'Ежедневный шедевр природы',
            sunsetTitle: 'Вечерний закат',
            sunsetDesc1: 'Наблюдайте, как день переходит в сумерки, небо превращается в холст амбры, малиновых и золотых тонов. Мягкий Индийский океан отражает это небесное зрелище, создавая завораживающую симфонию света и воды.',
            sunsetDesc2: 'Каждый вечер в Mahi Beach предлагает вам лучший вид на одно из самых захватывающих представлений природы. Найдите идеальную точку зрения - будь то с вашего частного балкона, пляжного лаунжа или нашей медитационной палубы заката - и дайте безмятежной красоте охватить вас.',
            sunsetFeature1: 'Беспрепятственный вид на океан со всех уголков',
            sunsetFeature2: 'Успокаивающая медитация на закате',
            sunsetFeature3: 'Бесплатный травяной чай подается ежедневно',
            sunsetFeature4: 'Фотогеничные моменты каждый вечер',
            sunsetImageAlt: 'Вечерний закат на курорте Mahi Beach Beach',
            bestTime: 'Лучшее время',
            sunsetTime: '18:00 - 18:45',

            // Pool Section
            poolLabel: 'Акватическое спокойствие',
            poolTitle: 'Бассейн',
            poolDesc1: 'Погрузитесь в спокойствие нашего кристально чистого бассейна с бесконечностью, где хрусталь-чистая вода встречается с пышными тропическими садами. Наш бассейн разработан для расслабления и омоложения - идеальное место для отдыха под шри-ланкийским солнцем.',
            poolDesc2: 'Независимо от того, предпочитаете ли вы освежающее утреннее купание, спокойный полдень с хорошей книгой или мирный вечерний спуск, наш бассейн предлагает идеальное место. Окруженный удобными шезлонгами, тенистыми кабинками и внимательным сервисом, каждый момент становится драгоценным воспоминанием.',
            poolFeature1: 'Бассейн с контролируемой температурой',
            poolFeature2: 'Окружен тропическими садами и ландшафтами',
            poolFeature3: 'Освежающие напитки на берегу бассейна, здоровые закуски',
            poolFeature4: 'Премиум шезлонги с зонтиками',
            poolImageAlt: 'Расслабляющий бассейн в курорте Mahi Beach',

            // Церемония прощания гостей
            departureLabel: 'Традиция прощания',
            departureTitle: 'Церемония прощания гостей',
            departureDesc1: 'В Mahi Beach Ayurveda Resort мы чтим ваше путешествие с нами через значимую церемонию прощания, укорененную в шри-ланкийской традиции. Когда вы готовитесь к отъезду, наша команда собирается, чтобы предложить благословения для безопасного путешествия и постоянного благополучия.',
            departureDesc2: 'Этот душевный ритуал включает традиционные благословения, специальное прощальное меню с аутентичными шри-ланкийскими деликатесами и небольшой подарок, чтобы вы взяли с собой наше тепло. Это наш способ обеспечить, чтобы ваши воспоминания о Mahi Beach оставались драгоценными долго после вашего отъезда.',
            departureFeature1: 'Традиционные буддийские благословения для безопасного путешествия',
            departureFeature2: 'Персонализированные прощальные подарки и сувениры',
            departureFeature3: 'Специальное прощальное меню с шри-ланкийскими деликатесами',
            departureFeature4: 'Церемония благословения со священными ритуалами',
            departureImageAlt: 'Церемония прощания гостей в курорте Mahi Beach',

            // TripAdvisor
            tripadvisorLabel: 'TripAdvisor',
            tripadvisorTitle: 'Отзывы гостей',

            // Testimonials
            testimonialsTitle: 'Гости во время их отдыха',
            testimonialsLabel: 'Истории гостей',

            // Video Section
            videoLabel: 'Погружающий опыт',
            videoTitle: 'Откройте для себя Mahi Beach',
            videoDescription: 'Испытайте красоту и спокойствие курорта Mahi Beach через наше погружающее видеопутешествие. Исследуйте удобства мирового класса, нетронутые пляжи и омолаживающие велнес-впечатления.',

            // Featured Room
            featuredRoomLabel: 'Фирменное размещение',
            featuredRoomTitle: 'Делюкс двухместный номер с видом на море',

            // Booking Bar
            bookingResort: 'Курорт',
            bookingResortName: 'Mahi Beach Ayurveda Resort',
            bookingCheckIn: 'Заезд',
            bookingCheckOut: 'Выезд',
            bookingGuests: 'Гости',
            booking1Guest: '1 гость',
            booking2Guests: '2 гостя',
            booking3Guests: '3 гостя',
            bookingCheckAvailability: 'Проверить наличие',

            // Hero Buttons
            heroExploreButton: 'Исследуйте Mahi Beach',
            heroBookButton: 'Забронировать номер Делюкс'
        }

    },

    it: {
        about: {
            heroTitle: 'Chi Siamo',
            heroSubtitle: 'Mahi Beach Ayurveda Resort',
            heroBeachResort: 'Beach Resort',
            heroTagline1: 'La saggezza antica incontra il benessere moderno presso Mahi Beach Ayurveda Resort',
            heroTagline2: 'Trattamenti ayurvedici personalizzati, viste sull\'oceano e vera ospitalità dello Sri Lanka',
            heroDescription: 'Sperimenta il benessere ayurvedico autentico nella nostra Deluxe Room caratteristica, dove la serenità dell\'oceano incontra la guarigione senza tempo.',
            bookDeluxeRoom: 'Prenota la Tua Camera Deluxe',
            bookDeluxeRoomShort: 'Prenota Camera Deluxe',
            slide1: 'Serenità Deluxe',
            slide2: 'Armonia Ayurvedica',
            slide3: 'Lusso sul Mare',
            slide4: 'Eleganza Naturale',
            slide5: 'Fuga Curativa',
            historyLabel: 'Il nostro viaggio',
            historyTitle: 'Storia di Mahi Beach Ayurveda Resort',
            historyDesc1: 'Fondato nel 2025, Mahi Beach Ayurveda Resort è nato dalla visione di creare un santuario dove la saggezza ayurvedica antica incontra la bellezza tranquilla della costa meridionale dello Sri Lanka. Abbiamo creato una delle destinazioni più care di Maggona per la guarigione olistica e il ringiovanimento.',
            historyDesc2: 'I nostri fondatori, ispirati da generazioni di praticanti tradizionali dell\'ayurveda, hanno cercato di preservare queste arti curative collaudate nel tempo fornendo comfort moderni e vera ospitalità dello Sri Lanka. Dalla nostra apertura, siamo rimasti fedeli al nostro impegno per le autentiche esperienze di benessere, fornendo la cura personalizzata che definisce il nostro patrimonio.',
            historyDesc3: 'Al Mahi Beach Ayurveda Resort, accogliamo ospiti da tutto il mondo. Ogni visitatore diventa parte della nostra storia, trovando equilibrio, guarigione e trasformazione nel nostro rifugio balneare.',
            statYear: '2025',
            statYearLabel: 'Fondato',
            statGuest: 'Di classe mondiale',
            statGuestLabel: 'Ospiti felici serviti',
            experienceLegacy: 'Sperimenta la nostra visione',
            established: 'Fondato',
            since2010: 'Dal 2025',
            chairmanLabel: 'Visione del presidente',
            chairmanTitle: 'Radicato nella tradizione, ispirato dal benessere',
            chairmanDesc1: 'Benvenuti a Mahi Beach Ayurveda Resort. La nostra visione dal 2025 è stata quella di creare un santuario dove l\'antica saggezza ayurvedica incontra il comfort moderno, il tutto avvolto nel calore genuino dell\'ospitalità dello Sri Lanka.',
            chairmanDesc2: 'Ogni aspetto del nostro resort — dai trattamenti personalizzati e dalla cucina nutriente all\'atmosfera pacifica dei nostri spazi — è attentamente realizzato per supportare il tuo percorso verso il benessere, l\'equilibrio e la pace interiore. È nostro privilegio accompagnarti in questo viaggio trasformativo.',
            chairmanDesc3: 'Vi do personalmente il benvenuto a scoprire l\'armonia, l\'autenticità e la tranquillità che sono le fondamenta di Mahi Beach.',
            chairmanSignature: '— Mr. Mahinda',
            chairmanBadge: 'Presidente',
            chairmanName: 'Mr. Mahinda',
            chairmanImageAlt: 'Presidente Mr. Mahinda',
            staffLabel: 'Il nostro team',
            staffTitle: 'Conosci il nostro team dedicato',
            staffDesc1: 'A Mahi Beach Ayurveda Resort, il nostro team è il cuore di tutto ciò che facciamo. I membri del nostro staff sono professionisti accuratamente selezionati e addestrati che condividono una profonda passione per il benessere ayurvedico e l\'ospitalità autentica.',
            staffDesc2: 'Dai nostri esperti praticanti ayurvedici e abili terapeuti del massaggio al nostro team dedicato all\'ospitalità, ogni membro porta anni di expertise e vera cura a ogni interazione con gli ospiti. Crediamo che il vero benessere non venga solo dai trattamenti, ma dal calore e dall\'attenzione di persone che sinceramente si preoccupano del tuo viaggio.',
            staffDesc3: 'Il nostro staff segue una formazione continua nelle ultime pratiche ayurvediche mentre mantiene gli standard più elevati di professionalità e sensibilità culturale. Siamo orgogliosi di creare connessioni significative con i nostri ospiti, assicurando che ogni visita diventi un\'esperienza memorabile e trasformativa.',
            statStaff: '15+',
            statStaffLabel: 'Professionisti qualificati',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Soddisfazione degli ospiti',
            staffImageAlt: 'Il nostro team di staff dedicato a Mahi Beach Ayurveda Resort',
            commitmentBadge: 'Il nostro impegno',
            excellenceCare: 'Eccellenza e cura',
            ctaLabel: 'Mettiti in contatto',
            ctaHeading: 'Pronto a iniziare il tuo viaggio di benessere?',
            ctaDesc: 'Contatta il nostro team per prenotare il tuo ritiro ayurvedico personalizzato. Che tu abbia domande sui nostri trattamenti, alloggi o pacchetti benessere speciali, siamo qui per aiutare a creare la tua fuga perfetta.',
            ctaButtonContact: 'Contattaci ora',
            ctaButtonRooms: 'Esplora le camere',
            contactUs: 'Contattaci',
            quickInfoCall: 'Chiamaci',
            quickInfoEmail: 'Inviaci un\'email',
            quickInfoLocation: 'Posizione',
            locationCity: 'Maggona Sri Lanka'
        },
        rooms: {
            heroTitle: 'Il tuo santuario ti aspetta',
            heroSubtitle: 'Camere meticolosamente progettate per la guarigione, il ripristino e la profonda pace.',
            heroAlt: 'Camere del Mahi Beach Ayurveda Resort',
            exploreRooms: 'Esplora le nostre camere',
            filterAll: 'Tutto',
            filterLuxurySuite: 'Suite Lusso',
            filterDeluxeRooms: 'Camere Deluxe',
            filterDeluxeSeaView: 'Camera Deluxe con vista sul mare',
            noRoomsFound: 'Nessuna camera trovata in questa categoria.',
            allRoomsInclude: 'Tutte le camere includono',
            essentialComforts: 'Comfort essenziali per il tuo viaggio di benessere',
            roomSize: 'Dimensioni della camera',
            guests: 'Ospiti',
            amenities: 'Servizi',
            roomAmenities: 'Servizi della camera',
            specialFeatures: 'Caratteristiche speciali',
            bookNow: 'Prenota ora',
            viewDetails: 'Visualizza dettagli',
            viewFullDetails: 'Visualizza tutti i dettagli',
            highSpeedWifi: 'WiFi ad alta velocità',
            herbalTea: 'Selezione di tè alle erbe',
            climateControl: 'Controllo del clima',
            rainShower: 'Doccia a pioggia',
            organicToiletries: 'Articoli da toilette biologici',
            dailyHousekeeping: 'Pulizia giornaliera della camera',
            concierge: 'Concierge 24/7',
            yogaMat: 'Tappetino yoga e accessori',
            beginHealing: 'Inizia il tuo viaggio di guarigione',
            beginHealingDesc: 'Sperimenta il benessere ayurvedico autentico in un ambiente progettato per nutrire il tuo corpo, calmare la tua mente e ripristinare il tuo spirito.',
            reserveRoom: 'Prenota una camera',
            speakAdvisor: 'Parla con un consulente del benessere',
            exploreOurRooms: 'Esplora le nostre camere',
            viewRoom: 'Visualizza camera',
            luxurySuiteName: 'Suite Lusso',
            luxurySuiteCategory: 'Suite Lusso',
            luxurySuiteDesc: 'Sperimenta la massima tranquillità nella nostra spaziosa suite di lusso, progettata secondo i principi ayurvedici tradizionali con una vista panoramica sul mare.',
            deluxeRoomName: 'Camera Deluxe',
            deluxeRoomCategory: 'Camera Deluxe',
            deluxeRoomDesc: 'Camera armoniosamente progettata con elementi in legno naturale e caratteristiche dolci con acqua per una tranquillità perfetta.',
            seaViewDeluxeName: 'Deluxe con vista sul mare',
            seaViewDeluxeCategory: 'Camera Deluxe con vista sul mare',
            seaViewDeluxeDesc: 'Svegliati con una brezza marina tranquillizzante e viste panoramiche sul mare in questa camera deluxe elegantemente progettata.',
            kingSizeBed: 'Letto King-Size',
            herbalTeaCoffee: 'Tè alle erbe e caffè',
            individuallyControlledAC: 'Aria condizionata a controllo individuale',
            premiumOrganicToiletries: 'Prodotti da toilette biologici premium',
            dailyFreshFlowers: 'Fiori freschi giornalieri',
            beachView: 'Vista spiaggia',
            signatureAccommodation: 'Alloggio esclusivo',
            inRoomComfort: 'Comfort in camera',
            deluxeRoomAmenities: 'Servizi camera Deluxe',
            momentsInDeluxeRoom: 'Momenti nella camera Deluxe',
            experienceAyurvedicLiving: 'Vivi un\'autentica esperienza ayurvedica nella nostra camera Deluxe',
            reserveYourStay: 'Prenota il tuo soggiorno',
            deluxeRoom: {
                resortName: 'Mahi Beach Ayurveda Resort',
                heroTitle: 'Camera Deluxe con balcone e vista mare',
                heroSubtitle: 'Rilassati in un tranquillo rifugio costiero ispirato alle spiagge dorate di Bentota, che unisce comfort moderni con dolci brezze marine.',
                bookThisRoom: 'Prenota questa camera',
                callReservations: 'Chiama per prenotazioni',
                signatureFeatures: 'Caratteristiche distintive',
                deluxeRoomName: 'Camera Deluxe',
                discoverTheSpace: 'Scopri lo spazio',
                whatsIncluded: 'Cosa è incluso',
                deluxeComfortCare: 'Comfort e cura Deluxe',
                inclusions: 'Servizi inclusi',
                coreAmenities: 'Servizi principali',
                amenityHighSpeedWifi: 'Wi-Fi ad alta velocità',
                amenityHerbalTeaCoffee: 'Tè alle erbe e caffè',
                amenityIndividuallyControlledAC: 'Aria condizionata a controllo individuale',
                amenityRainShower: 'Doccia a pioggia',
                amenityOrganicToiletries: 'Prodotti da toilette biologici',
                amenityDailyFreshFlowers: 'Fiori freschi giornalieri',
                beginYourHealingStay: 'Inizia il tuo soggiorno di guarigione',
                experienceAyurvedicSerenity: 'Vivi un\'autentica serenità ayurvedica nella nostra camera Deluxe esclusiva',
                checkAvailabilityBook: 'Controlla disponibilità e prenota',
                speakWithReservations: 'Parla con le prenotazioni',
                reserveThisRoom: 'Prenota questa camera',
                navAll: 'Tutte',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe con vista sul mare',
                navSuite: 'Suite',
                sectionTitle: 'Un rifugio costiero rilassante',
                sectionDesc: 'La Camera Deluxe è realizzata per mattine lente e tramonti senza fretta. Toni neutri morbidi, ampie vetrate e illuminazione accurata invitano la vista sul mare, mentre il balcone offre il tuo perché sopra la costa.',
                highlight1Title: 'Viste panoramiche sulla spiaggia',
                highlight1Desc: 'Svegliati con acque azzurre e albe dorate dal tuo balcone privato.',
                highlight2Title: 'Interni costieri eleganti',
                highlight2Desc: 'Palette neutre morbide, accenti di legno caldo e abbondante luce naturale.',
                highlight3Title: 'Esperienza di sonno serena',
                highlight3Desc: 'Letto king plush con lenzuola premium curate per un riposo ristoratore.',
                atAGlance: 'A colpo d\'occhio',
                statSize: 'Dimensioni',
                statSizeValue: '41 mq',
                statView: 'Vista',
                statViewValue: 'Oceano Indiano',
                statGuests: 'Ospiti',
                statGuestsValue: '2 Adulti',
                statBed: 'Letto',
                statBedValue: 'King o Twin',
                reserve: 'Prenota',
                galleryAlt: 'Galleria camera Deluxe',
                inclusionsTitle: 'Incluso nel soggiorno',
                inclusionsSubtitle: 'Tocchi premurosi, comfort tutto il giorno',
                enhancedCleanliness: 'Standard di pulizia e sicurezza migliorati',
                inclusion1: 'Colazione, pranzo, cena gratuiti al ristorante Breeze',
                inclusion2: 'Wi-Fi ad alta velocità e area di lavoro in camera',
                inclusion3: 'Servizio in camera e concierge 24 ore',
                inclusion4: 'Pulizia giornaliera della camera con apertura serale',
                inclusion5: 'Accesso alla piscina a sfioro e alle strutture spa ayurvediche',
                inclusion6: 'Parcheggio gratuito e servizio navetta per le attrazioni vicine',
                amenityGroup1Title: 'Caratteristiche della camera',
                amenityGroup1Item1: '41 mq di spazio',
                amenityGroup1Item2: 'Balcone privato con posti a sedere',
                amenityGroup1Item3: 'Aria condizionata con controllo climatico',
                amenityGroup1Item4: 'Cassaforte in camera',
                amenityGroup2Title: 'Esperienza bagno',
                amenityGroup2Item1: 'Doccia a pioggia con acqua calda e fredda',
                amenityGroup2Item2: 'Articoli da bagno premium',
                amenityGroup2Item3: 'Asciugacapelli',
                amenityGroup2Item4: 'Morbidi accappatoi e pantofole',
                amenityGroup3Title: 'Comfort in camera',
                amenityGroup3Item1: 'Smart TV da 55" con cavo',
                amenityGroup3Item2: 'Stazione caffè e tè',
                amenityGroup3Item3: 'Telefono a selezione diretta',
                amenityGroup4Title: 'Connettività',
                amenityGroup4Item1: 'Wi-Fi gratuito',
                amenityGroup4Item2: 'Scrivania',
                amenityGroup4Item3: 'Supporto reception 24/7',
                essentialsTitle: 'Essenziali in camera',
                essentialsHeading: 'Tutto ciò di cui hai bisogno per sentirti a casa',
                essentialsDesc: 'Dalla connettività senza soluzione di continuità ai rinfreschi scelti con cura, la Camera Deluxe fonde svago e praticità in modo che tu possa concentrarti sui momenti che contano.',
                essential1: 'Wi-Fi gratuito',
                essential2: 'Stazione caffè e tè',
                essential3: 'Servizio in camera 24/7',
                essential4: 'Doccia a pioggia',
                oceanTitle: 'Vicino all\'oceano',
                oceanSubtitle: 'Rallenta, respira l\'aria del mare',
                oceanAlt: 'Area soggiorno camera Deluxe',
                ctaTitle: 'Pronto per soggiornare?',
                ctaHeading: 'Prenota la Camera Deluxe oggi',
                ctaDesc: 'Parla con il nostro team di prenotazioni per le migliori tariffe disponibili e offerte speciali.',
                checkAvailability: 'Verifica disponibilità'
            }
        },

        navbar: {
            home: 'Home',
            aboutUs: 'Chi siamo',
            rooms: 'Camere',
            ayurveda: 'Ayurveda',
            yoga: 'Yoga',
            food: 'Cucina',
            events: 'Eventi',
            blogs: 'Blog',
            tours: 'Tour',
            contactUs: 'Contatti',
            bookOnline: 'Prenota online',
            locationMaggona: 'Maggona Sri Lanka',
            selectResort: 'Seleziona resort',
            language: 'Lingua',
            mainTitle: 'Mahi Beach Ayurveda Resort',
            resortBeach: 'Mahi Beach Ayurveda Resort',
            resortRiver: 'Mahi Beach Ayurveda Resort'
        },
        footer: {
            description: 'Mahi Beach Ayurveda Resort si impegna a offrire un’ospitalità eccezionale e esperienze di benessere, affinché ogni ospite si senta valorizzato e rigenerato.',
            linksTitle: 'Link',
            contactTitle: 'Contatti',
            viewLocation: 'Vedi posizione',
            navHome: 'Home',
            navAbout: 'Chi siamo',
            navContact: 'Contatti',
            navRooms: 'Camere',
            navAyurveda: 'Ayurveda',
            copyright: '© Copyright {{year}} Mahi Beach Ayurveda Resort.',
            developedBy: 'Sviluppato da',
            developerName: 'Redev Solution +94 764 608 225'
        }, tours: {
            heroTitle: 'Tour e Escursioni',
            heroSubtitle: 'Scopri la bellezza dello Sri Lanka da Maggona',
            kandeAlt: 'Tempio Kande Vihara - Maggona',
            kandeTitle: 'Visita del Tempio Kande Vihara',
            kandeBuddhaAlt: 'Gigantesca statua del Buddha al tempio Kande Vihara',
            bentotaTitle: 'Safari in barca sul fiume Bentota',
            bentotaAlt: 'Safari in barca sul fiume Bentota - Mangrovie e Fauna',
            galleTitle: 'Tour della Città Vecchia di Galle',
            galleAlt: 'Tour della Città Vecchia di Galle',
            sigiriyaTitle: 'Tour della Fortezza Rocciosa di Sigiriya',
            sigiriyaAlt: 'Tour della Fortezza Rocciosa di Sigiriya',
            kandyTitle: 'Tour Culturale di Kandy',
            kandyAlt: 'Tour Culturale di Kandy',
            bookTour: 'Prenota questo tour',
            viewDetails: 'Visualizza dettagli',
            introPara1: 'Lo Sri Lanka è una terra di bellezza senza tempo, dove spiagge dorate, paesaggi verdeggianti, templi antichi e cultura vibrante si uniscono in perfetta armonia.',
            introPara2: 'Dalla tranquilla costa sud-occidentale alle città storiche, ai siti sacri, alle riserve naturali e alle colline nebbiose, ogni viaggio offre un\'esperienza unica e indimenticabile.',
            introPara3: 'Partendo dal Mahi Beach Ayurveda Resort a Maggona, i nostri tour e le escursioni accuratamente curati sono progettati per arricchire il vostro soggiorno, bilanciando perfettamente l\'esplorazione, il relax e il benessere.',
            kandeDetail1: 'Tempio Kande Vihara (Kande Viharaya) – uno dei templi buddhisti più iconici vicino a Maggona.',
            kandeDetail2: 'Fondato nel 1734, questo sereno \'Tempio della Montagna\' si trova in cima a una collina con viste tranquille sulla costa.',
            kandeDetail3: 'I punti salienti includono la massiccia statua del Buddha seduto di 48 metri (una delle più alte dello Sri Lanka), affreschi intricati dell\'era Kandyan, un\'antica camera reliquiaria, un bellissimo ingresso in pietra di luna e un antico albero di Bodhi sacro di oltre 300 anni.',
            kandeDetail4: 'Un\'esperienza spirituale e culturale perfetta per mezza giornata – ideale per visite mattutine per evitare il caldo.',
            bentotaDetail1: 'Goditi un tranquillo e pittoresco safari in barca lungo il fiume Bentota, una delle escursioni naturalistiche più popolari vicino a Maggona.',
            bentotaDetail2: 'Scivola attraverso lussureggianti mangrovie, canali stretti e acque serene mentre osservi la fauna locale.',
            bentotaDetail3: 'Gli avvistamenti comuni includono lucertole monitor, coccodrilli, varie specie di uccelli (martin pescatori, aironi, aquile), scimmie e occasionalmente lontre o serpenti acquatici.',
            bentotaDetail4: 'Il vostro barcaiolo/guida esperto vi indicherà flora interessante, metodi di pesca tradizionali e la vita nei villaggi fluviali.',
            bentotaDetail5: 'Perfetto per gli amanti della natura e i fotografi – tranquillo, rilassante e complementare al vostro soggiorno ayurvedico di benessere.',
            galleDetail1: 'Esplora il Forte storico di Galle, un Sito Patrimonio dell\'Umanità UNESCO e uno dei forti coloniali meglio conservati dello Sri Lanka.',
            galleDetail2: 'Passeggia per le strade acciottolate fiancheggiate da edifici coloniali olandesi, negozi boutique, caffetterie e gallerie d\'arte.',
            galleDetail3: 'Visita i monumenti chiave come il Faro di Galle, la Chiesa Riformata Olandese, il Museo Marittimo Nazionale e i bastioni che offrono splendide viste sull\'oceano.',
            galleDetail4: 'Scopri la ricca storia, l\'architettura e il significato culturale della fortezza dalla tua guida esperta.',
            galleDetail5: 'Ideale per gli appassionati di storia, gli amanti della cultura e coloro che desiderano sperimentare il passato coloniale dello Sri Lanka.',
            sigiriyaDetail1: 'Scopri l\'antica fortezza rocciosa di Sigiriya, uno dei monumenti più iconici dello Sri Lanka e un Sito Patrimonio dell\'Umanità UNESCO.',
            sigiriyaDetail2: 'Arrampicati sulla roccia impressionante per esplorare le rovine del palazzo del Re Kasyapa, ornato di affreschi, giardini d\'acqua e il famoso Muro degli Specchi.',
            sigiriyaDetail3: 'Goditi le viste panoramiche della giungla circostante e della campagna dalla vetta.',
            sigiriyaDetail4: 'Scopri la affascinante storia, l\'architettura e le leggende associate a Sigiriya dalla tua guida esperta.',
            sigiriyaDetail5: 'Perfetto per gli amanti della storia, i cercatori di avventure e coloro interessati al ricco patrimonio culturale dello Sri Lanka.',
            kandyDetail1: 'Sperimenta la cultura vibrante di Kandy, l\'ultima capitale reale dello Sri Lanka e un Sito Patrimonio dell\'Umanità UNESCO.',
            kandyDetail2: 'Visita il Tempio della Reliquia del Dente Sacro (Sri Dalada Maligawa), uno dei siti buddhisti più importanti del mondo.',
            kandyDetail3: 'Esplora i Giardini Botanici Reali a Peradeniya, sede di una vasta collezione di piante tropicali e orchidee.',
            kandyDetail4: 'Goditi un tradizionale spettacolo di danza Kandyan, che mostra il ricco patrimonio artistico dello Sri Lanka.',
            kandyDetail5: 'Ideale per gli amanti della cultura, i buffi della storia e coloro che desiderano immergersi nelle tradizioni dello Sri Lanka.',
            ellaTitle: 'Avventura nella Regione Montuosa di Ella',
            ellaAlt: 'Tour della Regione Montuosa di Ella - Ponte a Nove Archi e Piantagioni di Tè',
            ellaDetail1: 'Viaggio a Ella, una delle destinazioni montane più pittoresche dello Sri Lanka, rinomata per le sue splendide viste montane e il clima fresco.',
            ellaDetail2: 'Visita l\'iconico Ponte a Nove Archi, una meraviglia ferroviaria dell\'era coloniale immersa nel verde lussureggiante, perfetta per la fotografia e per guardare i treni passare.',
            ellaDetail3: 'Esplora le verdi piantagioni di tè, impara sulla produzione del tè di Ceylon e goditi le viste panoramiche dal Little Adam\'s Peak o dalla roccia di Ella.',
            ellaDetail4: 'Scopri le cascate a cascata tra cui le Cascate di Ravana, passeggia attraverso sentieri panoramici e vivi l\'atmosfera affascinante del villaggio.',
            ellaDetail5: 'Perfetto per gli amanti della natura, i cercatori di avventure e coloro che desiderano fuggire negli altipiani mozzafiato dello Sri Lanka.'
        },
        blogs: {
            heroTitle: 'Blog di Mahi Beach Ayurveda Resort',
            heroSubtitle1: 'Storie dalla riva, rituali Ayurveda al',
            heroSubtitle2: 'Mahi Beach Ayurveda Resort',
            heroSubtitle3: '. Immergiti in suggerimenti, storia e note dietro le quinte.',
            heroAlt: 'Passerella sulla spiaggia del resort al tramonto',
            sectionTitle: 'Blog di Mahi Beach Ayurveda Resort',
            sectionDescription: 'Guide, storie e note dal nostro rifugio costiero — dai rituali Ayurveda alla storia delle gemme e consigli di viaggio intorno a Bentota.',
            ayurvedaTitle: 'Il cuore dell\'Ayurveda autentico',
            ayurvedaExcerpt: 'Sperimenta tradizioni di guarigione antiche radicate nell\'antica saggezza dello Sri Lanka.',
            ayurvedaDescription: 'Al Mahi Beach Ayurveda Resort, l\'Ayurveda è più di un trattamento — è uno stile di vita. Le nostre terapie si basano su conoscenze secolari, personalizzate per il tuo tipo di corpo e guidate da medici ayurvedici esperti per un equilibrio profondo e duraturo.',
            ayurvedaAlt: 'Allestimento di trattamento ayurvedico con oli alle erbe ed elementi naturali',
            healingTitle: 'Percorsi di guarigione personalizzati',
            healingExcerpt: 'Perché il programma di benessere di ogni ospite è progettato in modo unico.',
            healingDescription: 'Dalle consultazioni iniziali ai trattamenti quotidiani, il tuo percorso di guarigione è accuratamente personalizzato. Terapie a base di erbe, massaggi terapeutici, yoga e meditazione lavorano insieme per ripristinare l\'armonia tra corpo, mente e spirito.',
            healingAlt: 'Medico ayurvedico che consulta un ospite in un ambiente tranquillo',
            natureTitle: 'Guarigione in riva all\'oceano',
            natureExcerpt: 'Come la brezza marina e i dintorni tropicali migliorano il tuo benessere.',
            natureDescription: 'Situato lungo la tranquilla costa dello Sri Lanka, Mahi Beach offre un ambiente naturalmente curativo. Il suono delle onde, l\'aria fresca dell\'oceano e la vegetazione rigogliosa amplificano gli effetti dell\'Ayurveda, creando profondo relax e rinnovamento.',
            natureAlt: 'Vista sulla spiaggia del resort con palme e oceano',
            foodTitle: 'Cucina ayurvedica per l\'equilibrio interiore',
            foodExcerpt: 'Pasti nutrienti creati per supportare il tuo trattamento.',
            foodDescription: 'La nostra cucina ayurvedica è preparata fresca utilizzando ingredienti stagionali di provenienza locale. Ogni pasto è allineato con il tuo dosha, supportando la digestione, la disintossicazione e la vitalità complessiva pur rimanendo gustoso e soddisfacente.',
            foodAlt: 'Pasto ayurvedico tradizionale servito in ciotole naturali',
            yogaTitle: 'Yoga, meditazione e quiete interiore',
            yogaExcerpt: 'Pratiche gentili che calmano la mente e rafforzano il corpo.',
            yogaDescription: 'Le sessioni quotidiane di yoga e meditazione completano i tuoi trattamenti, migliorando flessibilità, respirazione e chiarezza mentale. Queste pratiche consapevoli ti aiutano a riconnetterti con te stesso e a portare un senso di pace oltre il tuo soggiorno.',
            yogaAlt: 'Ospiti che praticano yoga di fronte all\'oceano all\'alba',
            lifestyleTitle: 'Portare l\'Ayurveda a casa',
            lifestyleExcerpt: 'Pratiche di stile di vita semplici per continuare il tuo percorso di benessere.',
            lifestyleDescription: 'Prima della partenza, i nostri esperti ti guidano nel mantenere l\'equilibrio attraverso routine quotidiane, dieta e rituali di cura di sé. Porta a casa più dei ricordi — porta a casa un percorso sostenibile verso una vita più sana.',
            lifestyleAlt: 'Ospite che si rilassa con tè alle erbe in un ambiente sereno del resort',
            readMore: 'Leggi di più'
        },
        events: {
            heroEyebrow: 'Esperienze e attività',
            heroTitle: 'I nostri eventi',
            heroSubtitle: 'Esperienze curate che uniscono tradizione srilankese e lusso costiero',
            heroAlt: 'Eventi a Mahi Beach',
            availableDaily: 'Disponibile ogni giorno',
            bookNow: 'Prenota ora',
            highlightsTitle: 'Punti salienti',
            detailAlt: 'Dettaglio {{title}}',
            ctaTitle: 'Pronto a creare ricordi?',
            ctaDescription: 'Contatta il nostro team per personalizzare la tua esperienza evento perfetta al Mahi Beach Ayurveda Resort',
            ctaContact: 'Contattaci',
            ctaViewRooms: 'Vedi camere',
            buddhistMonkMeditationTitle: 'Meditazione con monaci buddisti',
            buddhistMonkMeditationSubtitle: 'Pratiche tradizionali di consapevolezza',
            buddhistMonkMeditationDescription: 'Sperimenta l\'autentica meditazione buddista guidata da monaci esperti nella tranquilla atmosfera del nostro resort. Queste antiche pratiche promuovono pace interiore, consapevolezza e benessere spirituale attraverso sessioni guidate che combinano canti tradizionali, tecniche di respirazione e meditazione silenziosa.',
            buddhistMonkMeditationHighlight1: 'Sessioni di meditazione buddista tradizionale',
            buddhistMonkMeditationHighlight2: 'Guida di monaci esperti',
            buddhistMonkMeditationHighlight3: 'Ambiente tranquillo all\'interno del resort',
            buddhistMonkMeditationHighlight4: 'Tecniche di consapevolezza e respirazione',
            buddhistMonkMeditationHighlight5: 'Pratiche di benessere spirituale',
            cookeryTitle: 'Programmi di cucina',
            cookerySubtitle: 'Il gusto dello Sri Lanka',
            cookeryDescription: 'Immergiti nei sapori vivaci della cucina srilankese. I nostri chef esperti ti guidano in sessioni di cucina pratica, insegnando ricette tradizionali tramandate di generazione in generazione. Impara a preparare curry aromatici, hoppers, sambol al cocco e altro con ingredienti locali freschi.',
            cookeryHighlight1: 'Ricette tradizionali srilankesi',
            cookeryHighlight2: 'Esperienza pratica di cucina',
            cookeryHighlight3: 'Ingredienti locali freschi',
            cookeryHighlight4: 'Porta a casa le ricette',
            cookeryHighlight5: 'Tour del giardino delle spezie incluso',
            meditationTitle: 'Programmi di meditazione',
            meditationSubtitle: 'Pace interiore e consapevolezza',
            meditationDescription: 'Trova tranquillità nelle nostre sessioni di meditazione guidata con lo sfondo sereno dell\'Oceano Indiano. I nostri istruttori esperti ti guidano attraverso antiche tecniche di consapevolezza, esercizi di respirazione e pratiche di yoga progettate per calmare la mente e rigenerare lo spirito.',
            meditationHighlight1: 'Sessioni all\'alba e al tramonto',
            meditationHighlight2: 'Meditazione fronte mare',
            meditationHighlight3: 'Guidato da esperti',
            meditationHighlight4: 'Tecniche di respirazione',
            meditationHighlight5: 'Pratiche di yoga e mindfulness',
            nightBeachPartiesTitle: 'Serata alla griglia',
            nightBeachPartiesSubtitle: 'Esperienza culinaria in riva al mare',
            nightBeachPartiesDescription: 'Concediti un\'indimenticabile serata alla griglia in riva al mare sotto le stelle. Assapora frutti di mare appena grigliati, carni premium e verdure vivaci mentre godi del suono rilassante delle onde dell\'oceano. I nostri chef esperti preparano ogni piatto alla perfezione, creando un\'esperienza culinaria memorabile in un magico ambiente costiero.',
            nightBeachPartiesHighlight1: 'Frutti di mare e carni appena grigliate',
            nightBeachPartiesHighlight2: 'Dimostrazione dal vivo dello chef alla griglia',
            nightBeachPartiesHighlight3: 'Atmosfera per cenare di fronte all\'oceano',
            nightBeachPartiesHighlight4: 'Selezione buffet BBQ premium',
            nightBeachPartiesHighlight5: 'Ambiente sulla spiaggia con falò',
            bbqTitle: 'Feste BBQ',
            bbqSubtitle: 'Celebrazioni in spiaggia',
            bbqDescription: 'Vivi serate indimenticabili con le nostre feste BBQ in spiaggia. Gusta frutti di mare appena grigliati, carni premium e delizie vegetariane mentre le onde sussurrano nelle vicinanze. Musica dal vivo, danzatori del fuoco e il cielo stellato creano l\'atmosfera perfetta per festeggiare e connettersi.',
            bbqHighlight1: 'Frutti di mare alla griglia',
            bbqHighlight2: 'Cenare fronte oceano',
            bbqHighlight3: 'Intrattenimento dal vivo',
            bbqHighlight4: 'Esperienza con falò',
            bbqHighlight5: 'Menu personalizzabili',
            boatTitle: 'Giri in barca',
            boatSubtitle: 'Avventure fluviali e costiere',
            boatDescription: 'Parti per incantevoli viaggi in barca lungo il fiume Bentota e le acque costiere. Scivola tra le mangrovie, osserva uccelli esotici e fauna selvatica o goditi romantiche crociere al tramonto. I nostri giri in barca offrono una prospettiva unica della bellezza naturale e degli ecosistemi dello Sri Lanka.',
            boatHighlight1: 'Crociere sul fiume Bentota',
            boatHighlight2: 'Esplorazione delle mangrovie',
            boatHighlight3: 'Avvistamento della fauna',
            boatHighlight4: 'Tour in barca al tramonto',
            boatHighlight5: 'Noleggio privato disponibile',
            ayurvedaLecturesTitle: 'Lezioni dei medici ayurvedici',
            ayurvedaLecturesSubtitle: 'Saggezza antica e benessere moderno',
            ayurvedaLecturesDescription: 'Scopri i principi profondi dell\'Ayurveda attraverso lezioni guidate da medici ayurvedici certificati e praticanti. Impara il bilanciamento dei dosha, i rimedi erboristici, le pratiche di guarigione olistica e come la saggezza antica si applica al benessere moderno. Le nostre sessioni interattive rendono chiara la filosofia ayurvedica e la sua applicazione nella vita quotidiana.',
            ayurvedaLecturesHighlight1: 'Medici ayurvedici certificati',
            ayurvedaLecturesHighlight2: 'Analisi dosha personalizzata',
            ayurvedaLecturesHighlight3: 'Educazione sui rimedi erboristici',
            ayurvedaLecturesHighlight4: 'Sessioni di domande e risposte',
            ayurvedaLecturesHighlight5: 'Guida al benessere da portare a casa',
            traditionalClothsTitle: 'Eventi di abbigliamento tradizionale',
            traditionalClothsSubtitle: 'Esperienza di patrimonio culturale',
            traditionalClothsDescription: 'Immergiti nel patrimonio culturale dello Sri Lanka imparando a indossare e apprezzare l\'abbigliamento tradizionale. I nostri esperti stylist ti guidano nel vestirti con autentici saree kandiani e abiti tradizionali, spiegando il significato culturale di ogni pezzo. Perfetto per occasioni speciali, apprezzamento culturale o foto memorabili.',
            traditionalClothsHighlight1: 'Guida di styling esperta',
            traditionalClothsHighlight2: 'Saree tradizionali autentici',
            traditionalClothsHighlight3: 'Significato culturale spiegato',
            traditionalClothsHighlight4: 'Fotografia professionale inclusa',
            traditionalClothsHighlight5: 'Workshop di fashion fusion',
            shanthiKarmaTitle: 'Danza culturale',
            shanthiKarmaSubtitle: 'Spettacoli tradizionali dello Sri Lanka',
            shanthiKarmaDescription: 'Immergiti nel vibrante mondo della danza culturale dello Sri Lanka. Vivi spettacoli tradizionali affascinanti con costumi colorati, tamburi ritmici e antiche narrazioni attraverso il movimento. I nostri talentuosi ballerini presentano danze popolari secolari, danza Kandyan e rituali culturali che danno vita al patrimonio dello Sri Lanka.',
            shanthiKarmaHighlight1: 'Autentiche danze tradizionali dello Sri Lanka',
            shanthiKarmaHighlight2: 'Costumi e trucco tradizionali colorati',
            shanthiKarmaHighlight3: 'Accompagnamento dal vivo con tamburi',
            shanthiKarmaHighlight4: 'Narrazione culturale attraverso il movimento',
            shanthiKarmaHighlight5: 'Spettacoli di danza Kandyan e popolare',
            musicTherapyTitle: 'Musicoterapia',
            musicTherapySubtitle: 'Guarigione attraverso il suono',
            musicTherapyDescription: 'Scopri il potere terapeutico della musica nelle nostre sessioni specializzate che combinano strumenti antichi dello Sri Lanka con tecniche di guarigione moderne. I nostri musicoterapeuti certificati utilizzano vibrazioni sonore, schemi ritmici e armonie melodiche per ridurre lo stress, migliorare il benessere emotivo e promuovere un profondo rilassamento.',
            musicTherapyHighlight1: 'Strumenti tradizionali dello Sri Lanka',
            musicTherapyHighlight2: 'Musicoterapeuti certificati',
            musicTherapyHighlight3: 'Vibrazioni di guarigione sonora',
            musicTherapyHighlight4: 'Tecniche di riduzione dello stress',
            musicTherapyHighlight5: 'Sessioni di gruppo e private',
            taiChiTitle: 'Tai Chi',
            taiChiSubtitle: 'Movimento gentile & equilibrio',
            taiChiDescription: 'Sperimenta l\'antica arte marziale cinese del Tai Chi, praticata nel nostro sereno ambiente fronte mare. Questo esercizio gentile e fluido combina movimenti lenti e deliberati con respirazione profonda e meditazione per migliorare equilibrio, flessibilità e calma interiore. Perfetto per tutte le età e livelli di fitness.',
            taiChiHighlight1: 'Sessioni mattutine fronte mare',
            taiChiHighlight2: 'Istruttori esperti di Tai Chi',
            taiChiHighlight3: 'Migliora equilibrio e flessibilità',
            taiChiHighlight4: 'Adatto a tutti i livelli di fitness',
            taiChiHighlight5: 'Tecniche di meditazione e respirazione',
        },
        food: {
            heroTitle: 'Cucina ayurvedica e costiera',
            heroSubtitle: 'Autentici sapori dello Sri Lanka e cucina costiera fresca',
            heroAlt: 'Esperienza culinaria al Mahi Beach Ayurveda Resort',
            wellnessEyebrow: 'Benessere attraverso il cibo',
            wellnessTitle: 'L\'importanza del',
            ayurvedicFood: 'cibo ayurvedico',
            wellnessIntro1: 'Nell\'ayurveda, il cibo è considerato la più grande medicina. Ciò che mangi influenza direttamente i tuoi dosha (Vata, Pitta, Kapha), la digestione (agni) e l\'equilibrio generale di corpo, mente e spirito.',
            wellnessIntro2: 'La nutrizione ayurvedica enfatizza cibi freschi, stagionali e integrali preparati con cura e mangiati consapevolmente. Promuove sei sapori (dolce, acido, salato, piccante, amaro, astringente) in ogni pasto per nutrire tutti i sensi e mantenere l\'armonia.',
            wellnessIntro3: 'Il corretto cibo ayurvedico supporta una forte digestione, aiuta a rimuovere le tossine (ama), aumenta l\'immunità, migliora l\'energia, riduce lo stress e previene molte condizioni croniche. A Mahi Beach, ogni piatto è creato con cura per allinearsi alla tua costituzione unica per una guarigione profonda e una vitalità.',
            foodImage1Alt: 'Pasto ayurvedico tradizionale con sei sapori',
            foodImage2Alt: 'Erbe ayurvediche e spezie per una nutrizione equilibrata',
            culinaryPhilosophyEyebrow: 'La nostra filosofia culinaria',
            culinaryPhilosophyTitle: 'Nutrizione',
            nutritionHighlight: 'ayurvedica',
            culinaryPhilosophyResort: 'al Mahi Beach Ayurveda Resort',
            nutritionTopImageAlt: 'Cucina ayurvedica al Mahi Beach Ayurveda Resort',
            freshNourishingLabel: 'Fresco e nutriente',
            healingIngredientsAlt: 'Ingredienti e spezie ayurvediche salutari',
            healingIngredientsLabel: 'Ingredienti curativi',
            philosophyText1: 'Il cibo, che comprende i sei sapori principali (dolce, acido, salato, amaro, piccante e astringente) insieme a molte variazioni sottili, è stato descritto in testi ayurvedici classici — alcuni risalenti a oltre 5.000 anni fa — insieme alle proprietà essenziali di ogni cibo: Guna (qualità intrinseca), Virya (potenza/riscaldamento o raffreddamento), Vipaka (impatto post-digestivo) e Prabhava (azione speciale unica).',
            philosophyText2: 'Di conseguenza, la nutrizione ayurvedica gioca un ruolo centrale al Mahi Beach Ayurveda Resort. Questo non significa un regime rigido e monotono di pasti insipidi, senza sapore o eccessivamente amari determinati esclusivamente dai medici. Al contrario, la nostra cucina ayurvedica è una delle nostre più grandi forze: i piatti preparati dai nostri abili chef ti sorprenderanno e delizieranno ogni giorno del tuo soggiorno!',
            philosophyText3: 'A colazione, goditi un generoso buffet con frutta tropicale fresca, succhi appena spremuti, zuppe alle erbe nutrienti, pane fatto in casa e biscotti leggeri, più una varietà di autentiche opzioni di colazione dello Sri Lanka. A pranzo, assapora un colorato e saporito buffet con miti curry di pesce, preparazioni di verdure e piatti infusi di erbe. La sera, serviamo un menu vegetariano fisso con opzione di pesce fresco disponibile. Nel fine settimana, celebriamo la "Notte dello Sri Lanka" con un buffet ampliato — i nostri chef preparano specialità locali tradizionali direttamente davanti a te, creando un\'esperienza vivace e autentica.',
            philosophyText4: 'Nell\'ayurveda, i cibi e le bevande sono classificati in molti modi — secondo il gusto e le proprietà, la capacità digestiva del corpo (agni), l\'idoneità per condizioni di salute specifiche, l\'appropriatezza stagionale e altro ancora. A Mahi Beach, consideriamo attentamente tutti questi fattori simultaneamente, facendo uno sforzo consapevole di includere tutti e sei i sapori in combinazioni equilibrate su misura per la costituzione individuale di ogni ospite.',
            philosophyText5: 'I nostri pasti presentano verdure fresche, frutta tropicale e pesce approvvigionato in modo responsabile. Non serviamo carne rossa o alcol.',
            philosophyText6: 'Durante i pasti, un medico ayurvedico o un dietista qualificato è sempre disponibile per guidarti. Ti consiglieranno sulle verdure, erbe e spezie più adatte per la tua fase di trattamento attuale e ti aiuteranno a selezionare o evitare i piatti di conseguenza. Il tuo elisir alle erbe personalizzato e le istruzioni specifiche dal team del centro sanitario saranno posizionati sul tuo tavolo individuale.',
            philosophyText7: 'Questo livello di cura personale e attenzione alla dieta è un marchio distintivo dell\'esperienza al Mahi Beach Ayurveda Resort.',
            philosophyText8: 'Il cibo è considerato Prana — l\'energia vitale che sostiene la vita — per ogni essere umano. Ecco perché ti incoraggiamo ad affrontare ogni pasto con piena consapevolezza: assaporando gli aromi, vivendo i sapori, sentendo il calore delicato e godendo delle sensazioni affascinanti consapevolmente.',
            diningExperienceEyebrow: 'Esperienza culinaria',
            restaurantTitlePrefix: 'Il nostro',
            ayurvedicHighlight: 'ayurvedico',
            restaurantTitleSuffix: 'ristorante',
            restaurantDetail1: 'Il nostro ristorante ayurvedico al Mahi Beach Ayurveda Resort offre un\'esperienza culinaria unica che armonizza i principi ayurvedici tradizionali con l\'autentica cucina costiera dello Sri Lanka. Diamo priorità agli ingredienti freschi e a livello locale per creare piatti che non solo deliziano il palato ma promuovono anche il benessere olistico.',
            restaurantDetail2: 'Il menu è sapientemente realizzato per bilanciare i sei sapori (dolce, acido, salato, amaro, piccante e astringente) in ogni piatto, garantendo un\'esperienza nutriente e soddisfacente. Ogni pasto è preparato con cura, incorporando erbe e spezie ayurvediche note per le loro proprietà curative.',
            restaurantDetail3: 'Gli ospiti possono godere di una varietà di piatti su misura per i loro dosha individuali (costituzioni del corpo), con opzioni per diete vegetariane, vegane e pescetariane. I nostri chef lavorano a stretto contatto con i praticanti ayurvedici per assicurare che ogni pasto supporti gli obiettivi di salute e benessere degli ospiti.',
            restaurantDetail4: 'L\'atmosfera del ristorante riflette l\'ambiente costiero sereno, fornendo un\'impostazione tranquilla per il mangiare consapevole. Che tu stia godendo di un generoso buffet per la colazione o assaporando una cena gourmet, ogni pasto nel nostro ristorante ayurvedico è un\'opportunità per nutrire corpo e anima.',
            restaurantDetail5: 'Unisciti a noi nel ristorante ayurvedico del Mahi Beach Ayurveda Resort per un viaggio culinario che celebra i ricchi sapori dello Sri Lanka mentre abbraccia la saggezza senza tempo dell\'Ayurveda.',
            restaurantImageAlt: 'Cena al Mahi Beach Ayurveda Resort',
            premiumDiningLabel: 'Cucina premium',
            premiumDiningDescription: 'Sperimenta l\'autentica cucina ayurvedica in un\'impostazione fluviale serena'
        },
        yoga: {
            heroTitle: 'Yoga al Resort',
            heroSubtitle: 'Trova equilibrio, forza e pace interiore a Maggona',
            heroAlt: 'Yoga al Mahi Beach Ayurveda Resort',
            importanceEyebrow: 'Benessere & equilibrio',
            importanceTitle: 'Importanza di Yoga e Meditazione',
            importanceImageAlt: 'Importanza dello Yoga e della Meditazione',
            importanceText1: 'Yoga e meditazione sono pratiche antiche che offrono numerosi benefici fisici, mentali ed emotivi. Promuovono flessibilità, forza ed equilibrio riducendo stress e ansia.',
            importanceText2: 'La pratica regolare può migliorare la concentrazione, la qualità del sonno e aumentare il benessere generale. Lo yoga incoraggia anche la consapevolezza, aiutando le persone a connettersi con il proprio io interiore e trovare pace nel caos della vita quotidiana.',
            importanceText3: 'Al Mahi Beach Ayurveda Resort offriamo ambienti sereni perfetti per praticare yoga e meditazione, permettendo agli ospiti di rigenerare mente, corpo e spirito.',
            practiceEyebrow: 'La nostra pratica',
            practiceTitle: 'Pratica e esperienza di Yoga',
            practiceImageAlt: 'Pratica di yoga al resort',
            practiceText1: 'Al Mahi Beach Ayurveda Resort lo yoga viene praticato principalmente come Hatha Yoga tradizionale, combinato con il Pranayama (tecniche di respirazione). Questo approccio olistico è progettato per risvegliare la consapevolezza interiore e stimolare dolcemente la Kundalini (spesso chiamata terzo occhio). Si pone particolare enfasi sull\'allineamento della colonna vertebrale e sulla flessibilità, poiché una colonna flessibile si ritiene rallenti il processo di invecchiamento — “Si è giovani quanto la propria colonna vertebrale.”',
            practiceText2: 'Le sessioni di yoga si svolgono quattro volte a settimana e sono adatte sia ai principianti che ai praticanti esperti. Di tanto in tanto vengono introdotte sessioni speciali come l\'Ashtanga Yoga, consentendo agli ospiti di sperimentare una varietà di posture e routine. I nostri medici ayurvedici incoraggiano la partecipazione regolare per sostenere e potenziare il programma di trattamento complessivo.',
            practiceText3: 'Tutte le sessioni di yoga si tengono nella nostra Yoga Shala dedicata, uno spazio calmo e sereno progettato per supportare la concentrazione, l\'equilibrio e il movimento consapevole. Ogni sessione inizia tipicamente con i Saluti al Sole, seguiti dal Pranayama e da una sequenza di asana attentamente selezionate per migliorare flessibilità, circolazione e benessere generale.',
            practiceText4: 'I nostri insegnanti di yoga esperti adattano ogni sessione alle esigenze individuali, alle capacità e alle condizioni di salute degli ospiti, garantendo un\'esperienza sicura, di supporto e profondamente benefica per tutti.',
            spiritualEyebrow: 'Viaggio spirituale',
            spiritualTitle: 'Meditazione e attività spirituali',
            spiritualSubtitle: 'Approfondisci la tua pratica spirituale con le nostre cerimonie sacre e sessioni di meditazione guidata',
            meditationImageAlt: 'Meditazione e pratica spirituale al resort',
            meditationTitle: 'Sessioni di meditazione',
            meditationDesc: 'Gli ospiti sono invitati a partecipare a sessioni di meditazione guidata tenute tre volte a settimana, ispirate alle tradizioni buddiste. Queste sessioni sono progettate per calmare la mente, approfondire la consapevolezza e sostenere la guarigione emotiva e spirituale. La meditazione si svolge in un tranquillo tempio su un\'isola, raggiunto dagli ospiti in barca — un viaggio sereno e significativo che arricchisce l\'esperienza meditativa complessiva.'
        },
        contact: {
            heroTitle: 'Contattaci',
            heroSubtitle: 'Mahi Beach Ayurveda Resort',
            heroAlt: 'Contattaci',
            sectionTitle: 'Non esitare a contattarci',
            sectionSubtitle: 'Siamo qui per aiutarti a rilassarti e rigenerarti',
            sectionDescription: 'Contatta Mahi Beach Ayurveda Resort per informazioni sul tuo soggiorno ayurvedico, pacchetti wellness, prenotazioni o qualsiasi domanda durante la tua permanenza a Maggona, Moragalla.',
            callUs: 'Chiamaci',
            emailTitle: 'Email',
            ourLocation: 'La nostra posizione',
            locationAddress: 'No.112 rendagewatta Galle Rd, Maggona',
            socialNetwork: 'Social Network',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Mettiti in contatto',
            getInTouchDescription: 'Ci piacerebbe sentirti — il nostro team è pronto ad aiutarti nel tuo percorso di benessere, rispondere alle domande e pianificare un soggiorno rigenerante.',
            nameLabel: 'Nome',
            emailLabel: 'Email',
            contactNumberLabel: 'Numero di contatto',
            messageLabel: 'Messaggio',
            sending: 'Invio...',
            sendMessage: 'Invia messaggio',
            successMessage: 'Il tuo messaggio è stato inviato con successo! Ti risponderemo presto.',
            errorMessage: 'Si è verificato un errore durante l\'invio. Riprova.',
            findUsOnMap: 'Trovaci sulla mappa',
            whatsappSubject: 'Contatto Mahi Beach Ayurveda Resort',
            whatsappName: 'Nome',
            whatsappEmail: 'Email',
            whatsappContactNumber: 'Numero di contatto',
            whatsappMessage: 'Messaggio'
        },


        ayurveda: {
            accordionTitle1: 'Capire il Panchakarma Ayurveda',
            accordionDesc1: 'L\'Ayurveda ("scienza della vita") è tra i sistemi olistici più antichi al mondo, sviluppato oltre 5.000 anni fa. Il Panchakarma si fonda sull\'armonia tra mente, corpo, spirito e ambiente. La sua missione è rafforzare la salute e prevenire i disturbi, con trattamenti personalizzati.',
            accordionTitle2: 'Panchakarma e l\'energia vitale',
            accordionDesc2: 'L\'Ayurveda insegna che tutto è interconnesso. Quando mente, corpo e spirito sono in equilibrio, il benessere è naturale; quando si rompe l\'armonia, possono emergere disagi. Eredità, traumi, stagioni, età ed emozioni possono alterarla.\n\nOgni persona è composta da cinque elementi: spazio, aria, fuoco, acqua e terra. Questi generano tre dosha: VATA (spazio/aria), PITTA (fuoco/acqua) e KAPHA (acqua/terra), che guidano le funzioni del corpo.\n\nCiascuno ha una combinazione unica di dosha, spesso con uno dominante. Il loro equilibrio influenza predisposizioni e salute.',
            accordionTitle3: 'Dosha Vata',
            accordionDesc3: 'Vata è considerato il più influente: regola movimento, respiro, circolazione, ritmo cardiaco ed eliminazione. Può essere disturbato da pasti irregolari, paura, dolore emotivo e notti tarde.\n\nCon Vata dominante sei spesso rapido, creativo ed energico; fisicamente puoi essere snello e freddoloso. In squilibrio possono comparire ansia, agitazione e disturbi respiratori o articolari.\n\nSi riequilibra con pratiche di radicamento: meditazione, massaggi, routine regolari e cibi caldi e leggeri.',
            accordionTitle4: 'Dosha Pitta',
            accordionDesc4: 'Pitta governa digestione, metabolismo e ormoni dell\'appetito. Si altera con cibi piccanti o acidi, eccesso di sole e pasti saltati.\n\nSe Pitta è dominante sei determinato, competitivo e sicuro di te, spesso con una costituzione più calda. In squilibrio emergono irritabilità e infiammazioni.\n\nL\'equilibrio arriva con alimenti freschi e pratiche calmanti come lo yoga dolce.',
            accordionTitle5: 'Dosha Kapha',
            accordionDesc5: 'Kapha sostiene struttura, forza, stabilità e immunità. Si appesantisce con dolci, cibi salati o pasti abbondanti e troppo riposo.\n\nLe persone Kapha sono calme, pazienti e stabili, spesso con corporatura più robusta. In squilibrio compaiono stanchezza, lentezza e aumento di peso.\n\nPer bilanciarlo servono leggerezza: più frutta e verdura e movimento energizzante.',
            close: 'Chiudi',
            next: 'Avanti',
            previous: 'Indietro',
            treatmentsTitle: 'I nostri rituali Panchakarma distintivi',
            treatmentsSubtitle: 'Rituali tradizionali che riportano equilibrio, sciolgono le tensioni e rinnovano corpo e mente.',
            bookTreatment: 'Prenota questo trattamento',
            benefitsTitle: 'Perché il Panchakarma fa bene',
            shirodhara: 'Shirodhara',
            shirodharaDesc: 'Un filo di olio erboristico caldo sulla fronte per calmare il sistema nervoso.',
            shirodhara1: 'Riduce stress e ansia',
            shirodhara2: 'Favorisce un sonno più profondo',
            shirodhara3: 'Aumenta lucidità e calma mentale',
            steamBath: 'Bagno turco',
            steamBathDesc: 'Il vapore alle erbe apre i pori, sostiene la detossinazione e rilassa i muscoli.',
            steamBath1: 'Favorisce una detossinazione delicata',
            steamBath2: 'Stimola la circolazione',
            steamBath3: 'Allenta le tensioni muscolari',
            flowerBath: 'Bagno floreale',
            flowerBathDesc: 'Bagno profumato di fiori per rilassarsi e rigenerarsi.',
            flowerBath1: 'Calma il sistema nervoso',
            flowerBath2: 'Idrata e ammorbidisce la pelle',
            flowerBath3: 'Solleva l\'umore',
            headMassage: 'Massaggio alla testa',
            headMassageDesc: 'Massaggio del cuoio capelluto per sciogliere le tensioni.',
            headMassage1: 'Allevia la pressione alla testa',
            headMassage2: 'Nutre cuoio capelluto e radici',
            headMassage3: 'Invita a un relax profondo',
            faceMassage: 'Massaggio viso',
            faceMassageDesc: 'Massaggio viso delicato che riaccende il glow e riduce lo stress.',
            faceMassage1: 'Rende il colorito più luminoso',
            faceMassage2: 'Scioglie le tensioni del viso',
            faceMassage3: 'Favorisce il drenaggio linfatico',
            neckMassage: 'Massaggio al collo',
            neckMassageDesc: 'Lavoro mirato per ridurre rigidità al collo.',
            neckMassage1: 'Riduce il fastidio cervicale',
            neckMassage2: 'Aumenta la mobilità',
            neckMassage3: 'Diminuisce lo stress',
            shoulderMassage: 'Massaggio alle spalle',
            shoulderMassageDesc: 'Massaggio terapeutico per spalle tese.',
            shoulderMassage1: 'Allevia il dolore alle spalle',
            shoulderMassage2: 'Aiuta la postura',
            shoulderMassage3: 'Scioglie i nodi muscolari',
            bodyMassage: 'Massaggio corpo',
            bodyMassageDesc: 'Rituale completo per distendere e ricaricare.',
            bodyMassage1: 'Migliora la circolazione',
            bodyMassage2: 'Allevia i dolori muscolari',
            bodyMassage3: 'Favorisce il rilassamento',
            backMassage: 'Massaggio alla schiena',
            backMassageDesc: 'Trattamento della schiena per sciogliere tensioni e dolori.',
            backMassage1: 'Lenisce il mal di schiena',
            backMassage2: 'Sostiene il benessere della colonna',
            backMassage3: 'Riduce lo stress',
            footMassage: 'Massaggio ai piedi',
            footMassageDesc: 'Massaggio ai piedi che rilassa tutto il corpo.',
            footMassage1: 'Stimola la circolazione',
            footMassage2: 'Allevia i piedi stanchi',
            footMassage3: 'Favorisce calma e leggerezza',
            purgative: 'Purgativo',
            purgativeDesc: 'Terapia di pulizia per eliminare l\'eccesso di Pitta e le tossine digestive.',
            purgative1: 'Purifica l\'intestino',
            purgative2: 'Equilibra Pitta',
            purgative3: 'Sostiene la digestione',
            nasalClearing: 'Pulizia nasale',
            nasalClearingDesc: 'Terapia nasale alle erbe per liberare le vie respiratorie.',
            nasalClearing1: 'Riduce la congestione',
            nasalClearing2: 'Migliora la respirazione',
            nasalClearing3: 'Allevia la pressione ai seni',
            powderMassage: 'Massaggio con polvere',
            powderMassageDesc: 'Esfoliazione con polveri alle erbe per una pelle fresca.',
            powderMassage1: 'Rimuove le cellule spente',
            powderMassage2: 'Affina la grana della pelle',
            powderMassage3: 'Attiva la circolazione',
            intensiveMassageDesc: 'Trattamento profondo per tensioni croniche e nodi ostinati.',
            intensiveMassage1: 'Scioglie le tensioni profonde',
            intensiveMassage2: 'Migliora il flusso sanguigno',
            intensiveMassage3: 'Riduce indolenzimento persistente',
            thermoMassage: 'Massaggio Termico',
            thermoMassageDesc: 'Oli alle erbe caldi per rilassare i tessuti e favorire la guarigione.',
            thermoMassage1: 'Lenisce i muscoli indolenziti',
            thermoMassage2: 'Invita a un rilassamento profondo',
            thermoMassage3: 'Favorisce il flusso energetico',
            synchronMassage: 'Massaggio Sincronizzato',
            synchronMassageDesc: 'Massaggio sincronizzato a quattro mani per armonia totale.',
            synchronMassage1: 'Armonia di tutto il corpo',
            synchronMassage2: 'Flusso energetico equilibrato',
            synchronMassage3: 'Profonda esperienza di relax',
            specialMassage: 'Massaggio Speciale',
            specialMassageDesc: 'Massaggio personalizzato in base alle tue esigenze di benessere.',
            specialMassage1: 'Trattamento su misura',
            specialMassage2: 'Focalizzato su bisogni specifici',
            specialMassage3: 'Percorso di guarigione mirato',
            benefit1Title: 'Supporto detox:',
            benefit1Desc: 'Il Panchakarma aiuta a eliminare le tossine accumulate e a ritrovare vitalità.',
            benefit2Title: 'Digestione più facile:',
            benefit2Desc: 'Le terapie favoriscono una digestione fluida e un migliore assorbimento dei nutrienti.',
            benefit3Title: 'Reset dello stress:',
            benefit3Desc: 'Trattamenti calmanti che riducono tensione e ansia.',
            benefit4Title: 'Resilienza immunitaria:',
            benefit4Desc: 'Sessioni regolari rafforzano le difese dell\'organismo.',
            benefit5Title: 'Rinnovo:',
            benefit5Desc: 'Sostiene la rigenerazione cellulare per una pelle più sana e luminosa.',
            benefit6Title: 'Equilibrio dei dosha:',
            benefit6Desc: 'Ripristina l\'armonia di Vata, Pitta e Kapha per un benessere duraturo.',
            akkupancharTitle: 'Terapia di Agopuntura',
            akkupancharDesc1: 'è un antica pratica terapeutica che utilizza aghi sottili applicati su punti specifici del corpo.Questo trattamento stimola i canali energetici vitali e promuove la guarigione.',
            akkupancharBenefit: 'Benefici chiave:',
            akkupancharDesc2: 'Questa terapia specializzata aiuta ad alleviare il dolore cronico, migliorare la flessibilità articolare, la circolazione sanguigna e ripristinare il flusso energetico naturale del corpo.',
            akkupancharApplication: 'Applicazione terapeutica:',
            akkupancharDesc3: 'L\'agopuntura agisce su punti marma specifici con tecniche accuratamente selezionate per bilanciare i dosha.',
            akkupancharTransform: 'Sperimenta la trasformazione:',
            akkupancharDesc4: 'Al Mahi Beach Ayurveda Resort, i nostri esperti personalizzano ogni sessione di agopuntura in base alle vostre esigenze di salute uniche.',
            experienceAkkupanchar: 'Prova l\'agopuntura oggi',
            doctorsEyebrow: 'IL NOSTRO TEAM DI ESPERTI',
            doctorsSectionTitle: 'I nostri medici',
            drSandyaName: 'Dr. M. Sandya Mendis',
            drSandyaProfession: 'Medico di medicina ayurvedica',
            drSandyaSpecialization: 'Ayurveda clinica, Pianificazione del trattamento personalizzato, Cura ayurvedica nel settore alberghiero',
            drSandyaProfileTitle: 'Profilo professionale',
            drSandyaProfile: 'Professionista ayurvedica compassionevole e dedicata con oltre 25 anni di esperienza nella fornitura di cure personalizzate e soluzioni per il benessere. Specializzata nella combinazione di principi ayurvedici tradizionali con pratiche terapeutiche moderne per offrire esperienze di guarigione olistica negli resort benessere di lusso.',
            drSandyaWorkExpTitle: 'Esperienza lavorativa',
            drSandyaWorkExp1: 'Medico capo e responsabile sviluppo programmi - Mahi Beach Ayurveda Resort (2023 – Presente)',
            drSandyaWorkExp2: 'Medico ayurvedico senior - Sun Aqua Resort and Spa, Maggona (2008 – 2023)',
            drSandyaWorkExp3: 'Consulente ayurvedico - Amba Ayurveda Specialty Clinic (2006 – 2008)',
            drSandyaWorkExp4: 'Medico ayurvedico e specialista Panchakarma - Paradise Road The Villa Bentota (2002 – 2006)',
            drSandyaWorkExp5: 'Ufficiale medico ayurvedico - Hotel Blue Water (1996 – 2002)',
            drSandyaEducationTitle: 'Istruzione e qualifiche professionali',
            drSandyaEdu1: 'Diploma in Ayurveda - Government Ayurveda College, Borella (1989 – 1993)',
            drSandyaEdu2: 'Reiki 2° grado - Reiki Dasa Centre Negombo Sri Lanka (2015 – 2016)',
            drPandukaName: 'Dr. Panduka Ranaweera',
            drPandukaProfession: 'Medico ayurvedico',
            drPandukaQualification: 'B.A.M.S. (Bachelor of Ayurvedic Medicine and Surgery)',
            drPandukaProfileTitle: 'Profilo professionale',
            drPandukaProfile: 'Il Dr. Panduka Ranaweera è un medico ayurvedico qualificato ed esperto, in possesso di una laurea in Medicina e Chirurgia Ayurvedica (B.A.M.S.) dell\'Università di Colombo. La sua formazione accademica si basa saldamente su principi ayurvedici classici e un\'educazione clinica completa, supportando un approccio strutturato, etico e basato sull\'evidenza alla medicina tradizionale.',
            drPandukaExpertiseTitle: 'Competenza professionale',
            drPandukaExpertise: 'Oltre alla pratica clinica, il Dr. Ranaweera conduce conferenze professionali di Ayurveda per gli ospiti e programmi di benessere, offrendo chiare intuizioni sulla filosofia ayurvedica, prevenzione delle malattie, gestione dello stile di vita e applicazione pratica delle terapie tradizionali. Queste sessioni migliorano la comprensione e il coinvolgimento degli ospiti, contribuendo a risultati di salute sostenibili.',
            drPandukaSpecialtyTitle: 'Terapie integrative',
            drPandukaSpecialty: 'La sua competenza terapeutica si estende anche all\'agopuntura e alla musicoterapia, che integra selettivamente per supportare la gestione del dolore, la riduzione dello stress, l\'equilibrio neurologico e il benessere emotivo. Combinando l\'Ayurveda con queste modalità complementari, il Dr. Ranaweera offre un\'esperienza di guarigione veramente integrativa.',
            drPandukaRoleTitle: 'Impegno per l\'eccellenza',
            drPandukaRole: 'Nel suo ruolo presso l\'hotel, il Dr. Ranaweera mantiene elevati standard clinici fornendo piani di trattamento personalizzati e orientamento olistico al benessere. Il suo approccio professionale, calmo e compassionevole garantisce che ogni ospite riceva cure sicure, autentiche e orientate ai risultati, mirate all\'equilibrio a lungo termine, vitalità e benessere generale.',
            gallery1: 'Terapia Shirodhara',
            gallery2: 'Bagno turco',
            gallery3: 'Bagno floreale',
            gallery4: 'Massaggio alla testa',
            gallery5: 'Massaggio corpo',
            gallery6: 'Massaggio al collo',
            gallery7: 'Massaggio viso',
            gallery8: 'Massaggio alle spalle',
            heroTitle: 'Panchakarma Ayurveda',
            heroSubtitle: 'Ringiovanisci Corpo, Mente e Anima a Maggona',
            heroTagline: 'Sperimenta lautentica guarigione ayurvedica dello Sri Lanka vicino all oceano',
            sectionEyebrow: 'PANCHAKARMA AYURVEDA AL MAHI BEACH AYURVEDA RESORT',
            sectionDescription: 'Scopri l\'arte antica del Panchakarma al Mahi Beach Ayurveda Resort di Maggona, Sri Lanka. Il nostro team ayurvedico crea trattamenti personalizzati per purificare, rigenerare e armonizzare corpo, mente e spirito.',
            treatmentProgramme: {
                title: 'Programma di trattamento ayurvedico',
                subtitle: 'Il vostro viaggio verso l equilibrio la disintossicazione e il profondo rinnovamento',
                intro: 'Vivi la vera cura ayurvedica in un ritiro costiero tranquillo che ristora il corpo, calma la mente e ricarica l\'energia. Dal tuo arrivo ci occupiamo di ogni dettaglio, così puoi concentrarti sul benessere.',
                welcomeTitle: 'Benvenuto e dolce inizio',
                doctorTitle: 'Consultazione medica e piano personalizzato',
                dailyTherapiesTitle: 'Terapie ayurvediche quotidiane',
                herbalMedicineTitle: 'Supporto con medicina a base di erbe',
                yogaMeditationTitle: 'Yoga e meditazione per l armonia corpo- mente',
                wellnessTitle: 'Esperienze benessere incluse',
                closingTitle: 'Rituale di chiusura e partenza',
                welcomePoints: [
                    'Ritiro dallaeroporto e trasferimento all hotel',
                    'Accoglienza calorosa e orientamento dell hotel',
                    'Introduzione al vostro programma di benessere settimanale',
                    'Massaggio rilassante (Giorno 1) presso il centro ayurvedico per alleviare la fatica da viaggio e preparare il corpo ai trattamenti'
                ],
                doctorPoints: [
                    'Consultazione medica ayurvedica (Giorno 2 – mattina)',
                    'Valutazione completa della vostra Dosha/tipo di corpo e problemi di salute',
                    'Traduttore disponibile su richiesta',
                    'Il vostro medico crea un piano di trattamento personalizzato adatto alle vostre esigenze e obiettivi'
                ],
                dailyTherapiesPoints: [
                    '4–5 trattamenti al giorno (come consigliato dal medico)',
                    'Terapie selezionate in base alla vostra costituzione corporea e condizione',
                    'Massaggi speciali possono essere aggiunti se necessario',
                    'Il medico monitora i progressi giornalmente e può adattare i trattamenti e il supporto erboristico per garantire i migliori risultati',
                    'Se appropriato, può essere consigliato un dolce processo di purificazione'
                ],
                herbalMedicinePoints: [
                    'Medicinali a base di erbe prescritti dal medico due volte al giorno:',
                    'Durante la colazione',
                    'Durante la cena',
                    'Sostengono la guarigione interna, la disintossicazione e l equilibrio duraturo'
                ],
                yogaMeditationPoints: [
                    'Sessioni di yoga 4 volte a settimana (circa 1 ora)',
                    'Sessioni di meditazione 2 volte a settimana:',
                    'Un esperienza spirituale unica in un tempio sull isola, raggiungibile in barca',
                    'Meditazione guidata diretta da monaci (circa 1 ora)'
                ],
                wellnessPoints: [
                    'Dimostrazioni settimanali di cucina salutare',
                    'Escursione gratuita (esperienza culturale/naturalistica)'
                ],
                closingPoints: [
                    'Un bellissimo bagno di fiori (ultimo giorno) – un rituale tradizionale di rinnovamento',
                    'Consultazione medica finale per rivedere i progressi e fornire:',
                    'Guida continua al benessere',
                    'Prescrizioni e raccomandazioni per la casa',
                    'Trasferimento di ritorno all aeroporto'
                ]
            }
        },
        home: {
            // Hero Section
            heroTitle: 'Mahi Beach Ayurveda Resort',
            heroSubtitle1: 'Ayurveda dall\'oceano',
            heroSubtitle2: 'Trova l\'equilibrio, respira consapevolmente e rinvigorisci la tua energia a Maggona.',
            exploreResort: 'Esplora il resort',
            bookNow: 'Prenota ora',

            // Welcome Section
            welcomeLabel: 'Benvenuti',
            welcomeTitle: 'Mahi Beach Ayurveda Resort',
            welcomeDesc1: 'Situato sulle sponde incontaminate di Maggona, Mahi Beach Ayurveda Resort offre un\'armoniosa fusione di antiche tradizioni di guarigione e lusso costiero moderno. Il nostro santuario ti invita a intraprendere un viaggio trasformativo di benessere, dove i suoni ritmici dell\'Oceano Indiano incontrano la saggezza senza tempo dell\'Ayurveda.',
            welcomeDesc2: 'Sperimenta trattamenti ayurvedici personalizzati, assapora piatti nutrienti elaborati per bilanciare la tua dosha, e rilassati in camere elegantemente arredate con vista mozzafiato sull\'oceano. Che tu cerchi ringiovanimento, rilassamento o rinascita spirituale, il nostro dedicato team di professionisti ayurvedici ed esperti di benessere è qui per guidarti ad ogni passo.',
            learnMore: 'Scopri di più',
            contactUs: 'Contattaci',
            welcomeImageAlt: 'Mahi Beach Ayurveda Resort',
            welcomeImageCaption: 'Ayurveda Benessere & Beach Retreat',
            welcomeImageLocation: 'Maggona Sri Lanka',

            // Highlight Section
            highlightTitle: 'Un santuario ayurvedico sul mare',
            highlightDesc: 'Scopri la guarigione olistica sulla costa sud-ovest dello Sri Lanka. Dai trattamenti personalizzati ai balconi tranquilli e alla cucina consapevole, ogni dettaglio è progettato per ripristinare il tuo ritmo.',

            // Services
            service1Title: 'Terapie Ayurvediche Olistiche',
            service1Desc: 'Consultazioni personalizzate, oli erboristici autentici e trattamenti quotidiani guidati da esperti medici ayurvedici.',
            service2Title: 'Camere e Suite Fronte Spiaggia',
            service2Desc: 'Svegliati con la brezza marina, balconi privati e interni calmanti progettati per un riposo profondo.',
            service3Title: 'Cucina del Benessere',
            service3Desc: 'Prodotti freschi dello Sri Lanka, menu plant-forward e piani alimentari personalizzati che completano la tua dosha.',
            service4Title: 'Yoga e Consapevolezza',
            service4Desc: 'Yoga all\'alba, meditazione al tramonto e esercizi di respirazione al ritmo delle onde.',
            service5Title: 'Escursioni Fluviali e Costiere',
            service5Desc: 'Crociere sul fiume Bentota, visite a incubatori di tartarughe, passeggiate in giardini di spezie e tour in bicicletta nei villaggi.',

            // Rooms
            roomsTitle: 'Le Nostre Camere',
            roomsDesc: 'Scegli il santuario che corrisponde al tuo ritmo, da suite spaziose a confortevoli rifugi deluxe, ognuno caratterizzato da biancheria morbida, legno caldo e balconi pronti all\'alba.',
            roomBadge: 'Fuga Fronte Spiaggia',
            bookableNow: 'Prenotabile ora',
            seaBreezeReady: 'Pronto per la brezza marina',
            viewRoom: 'Visualizza Camera',
            room1Title: 'Camere Suite',
            room1Desc: 'Suite spaziose con area salotto, balconi generosi e palette calmanti per le mattine lente.',
            room2Title: 'Camere Deluxe',
            room2Desc: 'Ritiri accoglienti con letti lussuosi, vista giardino e accenti in legno caldo per la facilità quotidiana.',
            room3Title: 'Deluxe Vista Mare',
            room3Desc: 'Svegliati con l\'orizzonte dell\'oceano, biancheria morbida e un balcone privato realizzato per i tramonti dorati.',

            // Achievements
            achievementsTitle: 'Benessere affidabile sul mare',
            achievement1Title: 'Ospiti Felici',
            achievement1Count: '1.000+',
            achievement2Title: 'Trattamenti Ayurvedici',
            achievement2Count: '20+',
            achievement3Title: 'Anni di Assistenza',
            achievement3Count: '15+',
            achievement4Title: 'Acclamazioni Viaggiatori',
            achievement4Count: '1.000+',

            // Experiences
            experiencesTitle: 'Esplora Mahi Beach Ayurveda Resort',
            experiencesDesc: 'Dai percorsi ayurvedici alle escursioni curate, scegli le esperienze che rendono il tuo soggiorno indimenticabile.',
            planYourStay: 'Pianifica il tuo soggiorno',
            experience1Title: 'Camere e Suite',
            experience1Desc: 'Spazi ariosi con balconi, vista océان o giardino e comfort premurosi per soggiorni indisturbati.',
            experience2Title: 'Spa Ayurvedica',
            experience2Desc: 'Terapie autentiche, bagni a vapore e massaggi rigeneranti offerti con rituali consacrati dal tempo.',
            experience3Title: 'Esperienza Culinaria',
            experience3Desc: 'Cucina nutriente dello Sri Lanka e internazionale servita nel nostro ristorante, scrupolosamente preparata per nutrire corpo e mente.',
            experience4Title: 'Esperienze e Tour',
            experience4Desc: 'Safari fluviali, visite ai templi, sport acquatici e escursioni culturali curate intorno a Bentota.',

            // Gallery
            galleryTitle: 'Momenti a Mahi Beach Ayurveda Resort',
            galleryDesc: 'Uno sguardo nel nostro santuario costiero - albe, trattamenti sereni, piatti nutrienti e angoli tranquilli realizzati per te.',
            gallery1Alt: 'Spiaggia circondata da palme al sole a Mahi Beach',
            gallery2Alt: 'Trattamento ayurvedico con olio in atto',
            gallery3Alt: 'Piscina del resort con lettini',
            gallery4Alt: 'Erbe preparate per la spa',
            gallery5Alt: 'Coppia che gode del tramonto in riva al mare',
            gallery6Alt: 'Ponte yoga fronte oceano',
            gallery7Alt: 'Sentiero giardino tropicale',
            gallery8Alt: 'Colazione salutare',
            gallery9Alt: 'Vista serena del fiume',
            gallery10Alt: 'Resort esternamente illuminato al tramonto',
            gallery11Alt: 'Display erbe e oli ayurvedici',
            gallery12Alt: 'Accogliente seduta in giardino',

            // Resort Images
            resort1Alt: 'Lounge all\'aperto con verde',
            resort2Alt: 'Interno camera confortevole',
            resort3Alt: 'Spazio trattamenti spa',
            resort4Alt: 'Area ristorazione con luce naturale',
            resort5Alt: 'Vista rilassante della piscina',

            // Sunset Section
            sunsetLabel: 'Capolavoro Quotidiano della Natura',
            sunsetTitle: 'Tramonto Serale',
            sunsetDesc1: 'Guarda come il giorno gracefully si arrende al crepuscolo, il cielo si trasforma in una tela di ambra, cremisi e oro. Il dolce Oceano Indiano specchia questo spettacolo celeste, creando una sinfonia affascinante di luce e acqua.',
            sunsetDesc2: 'Ogni sera a Mahi Beach offre i migliori posti in prima fila per uno dei più straordinari spettacoli della natura. Trova il tuo punto di vantaggio perfetto - che sia dal tuo balcone privato, dalla lounge sulla spiaggia o dal nostro ponte di meditazione al tramonto - e lascia che la bellezza serena ti avvolga.',
            sunsetFeature1: 'Vista sull\'oceano ininterrotta da ogni angolo',
            sunsetFeature2: 'Meditazione serenità al tramonto',
            sunsetFeature3: 'Tè alle erbe complimentare servito quotidianamente',
            sunsetFeature4: 'Momenti fotogenici ogni sera',
            sunsetImageAlt: 'Tramonto serale presso Mahi Beach Ayurveda Resort',
            bestTime: 'Miglior Tempo',
            sunsetTime: '18:00 - 18:45',

            // Pool Section
            poolLabel: 'Serenità Acquatica',
            poolTitle: 'Area Piscina',
            poolDesc1: 'Immergiti nella serenità della nostra piscina infinity incontaminata, dove le acque cristalline incontrano i lussureggianti giardini tropicali. Progettata per rilassamento e ringiovanimento, la nostra area piscina offre il rifugio perfetto per rilassarsi sotto il sole dello Sri Lanka.',
            poolDesc2: 'Che tu preferisca un rinfrescante bagno mattutino, una seduta pomeridiana con un buon libro o un tranquillo tuffo serale, la nostra area piscina offre un ambiente idilliaco. Circondata da confortevoli lettini, cabine ombreggiate e servizio attentivo, ogni momento diventa un ricordo caro.',
            poolFeature1: 'Piscina infinity con controllo della temperatura',
            poolFeature2: 'Circondata da paesaggi da giardino tropicale',
            poolFeature3: 'Rinfrescanti e snack salutari a bordo piscina',
            poolFeature4: 'Lettini premium con ombrelloni',
            poolImageAlt: 'Rilassante area piscina presso Mahi Beach Resort',

            // Cerimonia di Partenza degli Ospiti
            departureLabel: 'Tradizione di Addio',
            departureTitle: 'Cerimonia di Partenza degli Ospiti',
            departureDesc1: 'Al Mahi Beach Ayurveda Resort, onoriamo il vostro viaggio con noi attraverso una cerimonia di partenza significativa radicata nella tradizione dello Sri Lanka. Mentre vi preparate a partire, il nostro team si riunisce per offrire benedizioni per viaggi sicuri e benessere continuo.',
            departureDesc2: 'Questo rituale sentito include benedizioni tradizionali, un menu di addio speciale con autentiche prelibatezze dello Sri Lanka e un piccolo regalo per portare con voi il nostro calore. È il nostro modo di assicurare che i vostri ricordi di Mahi Beach rimangano cari molto tempo dopo la vostra partenza.',
            departureFeature1: 'Benedizioni buddiste tradizionali per viaggi sicuri',
            departureFeature2: 'Regali di addio personalizzati e ricordi',
            departureFeature3: 'Menu speciale di partenza con prelibatezze dello Sri Lanka',
            departureFeature4: 'Cerimonia di benedizione con rituali sacri',
            departureImageAlt: 'Cerimonia di partenza degli ospiti presso Mahi Beach Resort',

            // TripAdvisor
            tripadvisorLabel: 'TripAdvisor',
            tripadvisorTitle: 'Recensioni degli Ospiti',

            // Testimonials
            testimonialsTitle: 'Ospiti durante il loro soggiorno',
            testimonialsLabel: 'Storie degli Ospiti',

            // Video Section
            videoLabel: 'Esperienza Immersiva',
            videoTitle: 'Scopri Mahi Beach',
            videoDescription: 'Vivi la bellezza e la tranquillità del Mahi Beach Ayurveda Resort attraverso il nostro viaggio video immersivo. Esplora servizi di classe mondiale, spiagge incontaminate ed esperienze di benessere ringiovanenti.',

            // Featured Room
            featuredRoomLabel: 'Alloggio Signature',
            featuredRoomTitle: 'Camera Doppia Deluxe con Vista Mare',

            // Booking Bar
            bookingResort: 'Resort',
            bookingResortName: 'Mahi Beach Ayurveda Resort',
            bookingCheckIn: 'Check-in',
            bookingCheckOut: 'Check-out',
            bookingGuests: 'Ospiti',
            booking1Guest: '1 Ospite',
            booking2Guests: '2 Ospiti',
            booking3Guests: '3 Ospiti',
            bookingCheckAvailability: 'Verifica Disponibilità',

            // Hero Buttons
            heroExploreButton: 'Esplora Mahi Beach',
            heroBookButton: 'Prenota Camera Deluxe'
        },
    },

    fr: {
        about: {
            heroTitle: 'À Propos de Nous',
            heroSubtitle: 'Mahi Beach Ayurveda Resort',
            heroBeachResort: 'Beach Resort',
            heroTagline1: 'La sagesse ancienne rencontre le bien-être moderne au Mahi Beach Ayurveda Resort',
            heroTagline2: 'Traitements ayurvédiques personnalisés, vue sur l\'océan et hospitalité authentique du Sri Lanka',
            heroDescription: 'Découvrez le bien-être ayurvédique authentique dans notre Chambre Deluxe caractéristique, où la sérénité océanique rencontre la guérison intemporelle.',
            bookDeluxeRoom: 'Réservez Votre Chambre Deluxe',
            bookDeluxeRoomShort: 'Réserver Chambre Deluxe',
            slide1: 'Sérénité Deluxe',
            slide2: 'Harmonie Ayurvédique',
            slide3: 'Luxe en Bord de Mer',
            slide4: 'Élégance Naturelle',
            slide5: 'Évasion Curative',
            historyLabel: 'Notre voyage',
            historyTitle: 'Histoire du Mahi Beach Ayurveda Resort',
            historyDesc1: 'Établi en 2025, le Mahi Beach Ayurveda Resort est né d\'une vision de créer un sanctuaire où la sagesse ayurvédique ancienne rencontre la beauté tranquille de la côte sud du Sri Lanka. Nous avons créé l\'une des destinations les plus chères de Maggona pour la guérison holistique et rajeunissement.',
            historyDesc2: 'Nos fondateurs, inspirés par des générations de praticiens ayurvédiques traditionnels, ont cherché à préserver ces arts de guérison éprouvés tout en fournissant des conforts modernes et une authentique hospitalité du Sri Lanka. Depuis notre ouverture, nous sommes restés fidèles à notre engagement envers les expériences de bien-être authentiques, en fournissant les soins personnalisés qui définissent notre héritage.',
            historyDesc3: 'Au Mahi Beach Ayurveda Resort, nous accueillons des clients du monde entier. Chaque visiteur devient une partie de notre histoire, trouvant équilibre, guérison et transformation dans notre havre balnéaire.',
            statYear: '2025',
            statYearLabel: 'Établi',
            statGuest: 'De classe mondiale',
            statGuestLabel: 'Clients heureux servis',
            experienceLegacy: 'Expérimentez notre vision',
            established: 'Établi',
            since2010: 'Depuis 2025',
            chairmanLabel: 'Vision du président',
            chairmanTitle: 'Enraciné dans la tradition, inspiré par le bien-être',
            chairmanDesc1: 'Bienvenue au Mahi Beach Ayurveda Resort. Notre vision depuis 2025 a été de créer un sanctuaire où la sagesse ayurvédique ancienne rencontre le confort moderne, le tout enveloppé dans la chaleur authentique de l\'hospitalité du Sri Lanka.',
            chairmanDesc2: 'Chaque aspect de notre resort — des traitements personnalisés et de la cuisine nourrissante à l\'ambiance paisible de nos espaces — est soigneusement conçu pour soutenir votre chemin vers le bien-être, l\'équilibre et la paix intérieure. C\'est notre privilège de vous accompagner dans ce voyage transformateur.',
            chairmanDesc3: 'Je vous souhaite personnellement la bienvenue pour découvrir l\'harmonie, l\'authenticité et la tranquillité qui sont les fondations de Mahi Beach.',
            chairmanSignature: '— Mr. Mahinda',
            chairmanBadge: 'Président',
            chairmanName: 'Mr. Mahinda',
            chairmanImageAlt: 'Président Mr. Mahinda',
            staffLabel: 'Notre équipe',
            staffTitle: 'Rencontrez notre équipe dévouée',
            staffDesc1: 'Au Mahi Beach Ayurveda Resort, notre équipe est le cœur de tout ce que nous faisons. Les membres de notre personnel sont des professionnels soigneusement sélectionnés et formés qui partagent une passion profonde pour le bien-être ayurvédique et l\'hospitalité authentique.',
            staffDesc2: 'De nos praticiens ayurvédiques expérimentés et thérapeutes en massage compétents à notre équipe d\'hospitalité dévouée, chaque membre apporte des années d\'expertise et une véritable bienveillance à chaque interaction avec les clients. Nous croyons que le véritable bien-être ne vient pas seulement des traitements, mais de la chaleur et l\'attention de personnes qui se soucient sincèrement de votre parcours.',
            staffDesc3: 'Notre personnel subit une formation continue aux dernières pratiques ayurvédiques tout en maintenant les normes les plus élevées de professionnalisme et de sensibilité culturelle. Nous sommes fiers de créer des connections significatives avec nos clients, en veillant à ce que chaque visite devienne une expérience mémorable et transformatrice.',
            statStaff: '15+',
            statStaffLabel: 'Professionnels qualifiés',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Satisfaction client',
            staffImageAlt: 'Notre équipe de personnel dévouée au Mahi Beach Ayurveda Resort',
            commitmentBadge: 'Notre engagement',
            excellenceCare: 'Excellence et bienveillance',
            ctaLabel: 'Nous contacter',
            ctaHeading: 'Prêt à commencer votre parcours de bien-être?',
            ctaDesc: 'Contactez notre équipe pour réserver votre retraite ayurvédique personnalisée. Que vous ayez des questions sur nos thérapies, hébergements ou packages bien-être spéciaux, nous sommes là pour aider à créer votre évasion parfaite.',
            ctaButtonContact: 'Nous contacter maintenant',
            ctaButtonRooms: 'Explorez les chambres',
            contactUs: 'Nous contacter',
            quickInfoCall: 'Appelez-nous',
            quickInfoEmail: 'Nous envoyer un email',
            quickInfoLocation: 'Localisation',
            locationCity: 'Maggona Sri Lanka'
        },
        home: {
            // Hero Section
            heroTitle: 'Mahi Beach Ayurveda Resort',
            heroSubtitle1: 'Ayurveda au bord de l’océan',
            heroSubtitle2: 'Trouvez l’équilibre, respirez librement et renouvelez votre énergie à Maggona.',
            exploreResort: 'Découvrir le resort',
            bookNow: 'Réserver maintenant',

            // Sections
            sections: {
                recommendations: {
                    title: 'Nos Expériences Signature',
                    subtitle: 'Découvrez ce qui rend votre parcours ayurvédique transformateur'
                }
            },

            // Recommendations Section
            recommendations: {
                panchakarma: {
                    label: 'GUÉRISON ANCIENNE',
                    name: 'Panchakarma Ayurveda'
                },
                yoga: {
                    label: 'CORPS & ESPRIT',
                    name: 'Yoga & Méditation'
                },
                cuisine: {
                    label: 'NUTRITION WELLNESS',
                    name: 'Cuisine Ayurvédique'
                },
                wellness: {
                    label: 'BIEN-ÊTRE TOTAL',
                    name: 'Forfaits Wellness'
                },
                spa: {
                    label: 'RELAXATION',
                    name: 'Thérapies Spa'
                }
            },

            // Welcome Section
            welcomeLabel: 'Bienvenue',
            welcomeTitle: 'Mahi Beach Ayurveda Resort',
            welcomeDesc1: 'Niché le long des plages immaculées de Maggona, le Mahi Beach Ayurveda Resort offre un mélange harmonieux de traditions de guérison anciennes et de luxe côtier moderne. Notre sanctuaire vous invite à entreprendre un voyage transformateur de bien-être, où les sons rythmés de l’océan Indien rencontrent la sagesse intemporelle de l’Ayurveda.',
            welcomeDesc2: 'Vivez des traitements ayurvédiques personnalisés, savourez une cuisine nourrissante adaptée à votre dosha et détendez-vous dans des chambres élégamment aménagées avec vue imprenable sur l’océan. Que vous recherchiez le rajeunissement, la relaxation ou le renouveau spirituel, notre équipe dédiée de praticiens ayurvédiques et d’experts en bien-être est là pour vous guider à chaque étape.',
            learnMore: 'En savoir plus',
            contactUs: 'Nous contacter',
            welcomeImageAlt: 'Mahi Beach Ayurveda Resort',
            welcomeImageCaption: 'Bien-être ayurvédique & Retraite balnéaire',
            welcomeImageLocation: 'Maggona Sri Lanka',

            // Highlight Section
            highlightTitle: 'Un sanctuaire ayurvédique au bord de la mer',
            highlightDesc: 'Découvrez la guérison holistique sur la côte sud-ouest du Sri Lanka. Des traitements sur mesure aux balcons calmes et à la cuisine consciente, chaque détail est conçu pour restaurer votre rythme.',

            // Services
            service1Title: 'Thérapies ayurvédiques holistiques',
            service1Desc: 'Consultations personnalisées, huiles herbales authentiques et traitements quotidiens guidés par des médecins ayurvédiques expérimentés.',
            service2Title: 'Chambres & Suites en bord de plage',
            service2Desc: 'Réveillez-vous avec la brise marine, des balcons privés et des intérieurs apaisants conçus pour un repos profond.',
            service3Title: 'Cuisine bien-être',
            service3Desc: 'Produits frais du Sri Lanka, menus à base de plantes et plans de repas adaptés à votre dosha.',
            service4Title: 'Yoga et pleine conscience',
            service4Desc: 'Yoga au lever du soleil, méditation au coucher du soleil et sessions de respiration face au rythme des vagues.',
            service5Title: 'Excursions fluviales et côtières',
            service5Desc: 'Balades en bateau sur la rivière Bentota, visites de la ferme de tortues, promenades dans les jardins d’épices et circuits à vélo dans les villages.',

            // Rooms
            roomsTitle: 'Nos chambres',
            roomsDesc: 'Choisissez le sanctuaire qui correspond à votre rythme, des suites aérées aux retraites deluxe cosy, chacune agrémentée de draps doux, de bois chaleureux et de balcons prêts pour le lever du soleil.',
            roomBadge: 'Évasion face à l’océan',
            bookableNow: 'Réservable maintenant',
            seaBreezeReady: 'Prêt pour la brise marine',
            viewRoom: 'Voir la chambre',
            room1Title: 'Chambres Suite',
            room1Desc: 'Suites spacieuses avec salon, grands balcons et palettes apaisantes pour des matins lents.',
            room2Title: 'Chambres Deluxe',
            room2Desc: 'Retraites cosy avec lits moelleux, vues sur le jardin et accents en bois chaleureux pour un confort quotidien.',
            room3Title: 'Deluxe Vue Mer',
            room3Desc: 'Réveillez-vous face à l’horizon marin, avec des draps doux et un balcon privé idéal pour les couchers de soleil dorés.',

            // Achievements
            achievementsTitle: 'Bien-être de confiance au bord de la mer',
            achievement1Title: 'Clients heureux',
            achievement1Count: '1 000+',
            achievement2Title: 'Traitements ayurvédiques',
            achievement2Count: '20+',
            achievement3Title: 'Années de soin',
            achievement3Count: '15+',
            achievement4Title: 'Reconnaissances des voyageurs',
            achievement4Count: '1 000+',

            // Experiences
            experiencesTitle: 'Découvrez Mahi Beach Ayurveda Resort',
            experiencesDesc: 'Des voyages ayurvédiques aux excursions organisées, choisissez les expériences qui rendront votre séjour inoubliable.',
            planYourStay: 'Planifiez votre séjour',
            experience1Title: 'Chambres & Suites',
            experience1Desc: 'Espaces aérés avec balcons, vues sur l’océan ou le jardin, et conforts pensés pour des séjours sans hâte.',
            experience2Title: 'Spa ayurvédique',
            experience2Desc: 'Thérapies authentiques, bains de vapeur et massages régénérants réalisés selon des rituels ancestraux.',
            experience3Title: 'Expérience culinaire',
            experience3Desc: 'Cuisine sri-lankaise et internationale nourrissante servie dans notre restaurant, soigneusement préparée pour nourrir corps et esprit.',
            experience4Title: 'Expériences & Excursions',
            experience4Desc: 'Safaris fluviaux, visites de temples, sports nautiques et excursions culturelles autour de Bentota.',

            // Gallery
            galleryTitle: 'Instants au Mahi Beach Ayurveda Resort',
            galleryDesc: 'Un aperçu de notre sanctuaire côtier — levers de soleil, traitements sereins, assiettes nourrissantes et coins tranquilles faits pour vous.',
            gallery1Alt: 'Plage ensoleillée bordée de palmiers à Mahi Beach',
            gallery2Alt: 'Traitement à l’huile ayurvédique en cours',
            gallery3Alt: 'Piscine du resort avec transats',
            gallery4Alt: 'Ingrédients herbaux préparés pour le spa',
            gallery5Alt: 'Couple profitant du coucher de soleil au bord de la mer',
            gallery6Alt: 'Plateforme yoga face à l’océan',
            gallery7Alt: 'Allée dans le jardin tropical',
            gallery8Alt: 'Petit-déjeuner sain',
            gallery9Alt: 'Vue paisible sur la rivière',
            gallery10Alt: 'Extérieur du resort illuminé au crépuscule',
            gallery11Alt: 'Présentation d’herbes et huiles ayurvédiques',
            gallery12Alt: 'Coin salon cosy près du jardin',

            // Resort Images
            resort1Alt: 'Salon en plein air avec verdure',
            resort2Alt: 'Intérieur de chambre confortable',
            resort3Alt: 'Espace de traitement spa',
            resort4Alt: 'Coin repas avec lumière naturelle',
            resort5Alt: 'Vue relaxante sur la piscine',

            // Sunset Section
            sunsetLabel: 'Chef-d’œuvre quotidien de la nature',
            sunsetTitle: 'Coucher de soleil du soir',
            sunsetDesc1: 'Alors que le jour cède gracieusement la place au crépuscule, regardez le ciel se transformer en toile d’ambre, de cramoisi et d’or. L’océan Indien reflète ce spectacle céleste, créant une symphonie envoûtante de lumière et d’eau.',
            sunsetDesc2: 'Chaque soir au Mahi Beach offre des places au premier rang pour l’un des spectacles les plus époustouflants de la nature. Trouvez votre point de vue idéal — depuis votre balcon privé, le lounge en bord de plage ou notre terrasse de méditation au coucher du soleil — et laissez la beauté sereine vous envelopper.',
            sunsetFeature1: 'Vues dégagées sur l’océan depuis tous les coins',
            sunsetFeature2: 'Méditation calme au coucher du soleil',
            sunsetFeature3: 'Thé aux herbes offert quotidiennement',
            sunsetFeature4: 'Moments parfaits pour les photos chaque soir',
            sunsetImageAlt: 'Coucher de soleil du soir au Mahi Beach Ayurveda Resort',
            bestTime: 'Meilleur moment',
            sunsetTime: '18h00 - 18h45',

            // Pool Section
            poolLabel: 'Sérénité aquatique',
            poolTitle: 'Zone piscine',
            poolDesc1: 'Plongez dans la tranquillité de notre piscine à débordement immaculée, où des eaux cristallines rencontrent des jardins tropicaux luxuriants. Conçue pour la détente et le rajeunissement, notre zone piscine offre l’évasion parfaite pour se relaxer sous le soleil sri-lankais.',
            poolDesc2: 'Que vous préfériez une baignade rafraîchissante le matin, une séance de détente l’après-midi avec un bon livre ou un bain paisible le soir, notre zone piscine offre un cadre idyllique. Entourée de transats confortables, de cabanes ombragées et d’un service attentif au bord de la piscine, chaque instant devient un souvenir précieux.',
            poolFeature1: 'Piscine à débordement à température contrôlée',
            poolFeature2: 'Entourée de paysages de jardin tropical',
            poolFeature3: 'Rafraîchissements et snacks sains au bord de la piscine',
            poolFeature4: 'Transats premium avec parasols',
            poolImageAlt: 'Zone piscine relaxante au Mahi Beach Resort',

            // Cérémonie de Départ des Invités
            departureLabel: 'Tradition d\'Adieu',
            departureTitle: 'Cérémonie de Départ des Invités',
            departureDesc1: 'Au Mahi Beach Ayurveda Resort, nous honorons votre voyage avec nous à travers une cérémonie de départ significative enracinée dans la tradition sri-lankaise. Alors que vous vous préparez à partir, notre équipe se rassemble pour offrir des bénédictions pour des voyages sûrs et un bien-être continu.',
            departureDesc2: 'Ce rituel sincère comprend des bénédictions traditionnelles, un menu d\'adieu spécial mettant en vedette des délices authentiques du Sri Lanka et un petit cadeau pour emporter notre chaleur avec vous. C\'est notre façon d\'assurer que vos souvenirs de Mahi Beach restent précieux longtemps après votre départ.',
            departureFeature1: 'Bénédictions bouddhistes traditionnelles pour des voyages sûrs',
            departureFeature2: 'Cadeaux d\'adieu personnalisés et souvenirs',
            departureFeature3: 'Menu de départ spécial avec des délices du Sri Lanka',
            departureFeature4: 'Cérémonie de bénédiction avec des rituels sacrés',
            departureImageAlt: 'Cérémonie de départ des invités au Mahi Beach Resort',

            // TripAdvisor
            tripadvisorLabel: 'TripAdvisor',
            tripadvisorTitle: 'Avis des Clients',

            // Testimonials
            testimonialsTitle: 'Avis de nos hôtes sur leur séjour',
            testimonialsLabel: 'Histoires des Clients',

            // Video Section
            videoLabel: 'Expérience Immersive',
            videoTitle: 'Découvrez Mahi Beach',
            videoDescription: 'Découvrez la beauté et la tranquillité du Mahi Beach Ayurveda Resort à travers notre voyage vidéo immersif. Explorez des équipements de classe mondiale, des plages immaculées et des expériences de bien-être rajeunissantes.',

            // Featured Room
            featuredRoomLabel: 'Hébergement Signature',
            featuredRoomTitle: 'Chambre Double Deluxe avec Vue sur la Mer',

            // Booking Bar
            bookingResort: 'Resort',
            bookingResortName: 'Mahi Beach Ayurveda Resort',
            bookingCheckIn: 'Arrivée',
            bookingCheckOut: 'Départ',
            bookingGuests: 'Invités',
            booking1Guest: '1 Invité',
            booking2Guests: '2 Invités',
            booking3Guests: '3 Invités',
            bookingCheckAvailability: 'Vérifier la Disponibilité',

            // Hero Buttons
            heroExploreButton: 'Explorer Mahi Beach',
            heroBookButton: 'Réserver Chambre Deluxe'
        },
        rooms: {
            heroTitle: 'Votre sanctuaire vous attend',
            heroSubtitle: 'Des chambres méticuleusement conçues pour la guérison, la restauration et la paix profonde.',
            heroAlt: 'Chambres du Mahi Beach Ayurveda Resort',
            exploreRooms: 'Explorez nos chambres',
            filterAll: 'Tout',
            filterLuxurySuite: 'Suite Luxe',
            filterDeluxeRooms: 'Chambres Deluxe',
            filterDeluxeSeaView: 'Chambre Deluxe avec vue sur la mer',
            noRoomsFound: 'Aucune chambre trouvée dans cette catégorie.',
            allRoomsInclude: 'Toutes les chambres incluent',
            essentialComforts: 'Conforts essentiels pour votre voyage bien-être',
            roomSize: 'Taille de la chambre',
            guests: 'Invités',
            amenities: 'Équipements',
            roomAmenities: 'Équipements de la chambre',
            specialFeatures: 'Caractéristiques spéciales',
            bookNow: 'Réserver maintenant',
            viewDetails: 'Afficher les détails',
            viewFullDetails: 'Afficher tous les détails',
            highSpeedWifi: 'WiFi haut débit',
            herbalTea: 'Sélection de thés à base de plantes',
            climateControl: 'Contrôle climatique',
            rainShower: 'Douche à effet pluie',
            organicToiletries: 'Articles de toilette biologiques',
            dailyHousekeeping: 'Nettoyage quotidien de la chambre',
            concierge: 'Concierge 24/7',
            yogaMat: 'Tapis de yoga et accessoires',
            beginHealing: 'Commencez votre voyage de guérison',
            beginHealingDesc: 'Découvrez le bien-être ayurvédique authentique dans un environnement conçu pour nourrir votre corps, calmer votre esprit et restaurer votre âme.',
            reserveRoom: 'Réserver une chambre',
            speakAdvisor: 'Parler à un conseiller en bien-être',
            exploreOurRooms: 'Explorez nos chambres',
            viewRoom: 'Afficher la chambre',
            luxurySuiteName: 'Suite Luxe',
            luxurySuiteCategory: 'Suite Luxe',
            luxurySuiteDesc: 'Découvrez la tranquillité ultime dans notre suite luxe spacieuse, conçue selon les principes ayurvédiques traditionnels avec une vue spectaculaire sur la mer.',
            deluxeRoomName: 'Chambre Deluxe',
            deluxeRoomCategory: 'Chambre Deluxe',
            deluxeRoomDesc: 'Chambre harmonieusement conçue avec des éléments en bois naturel et des caractéristiques d\'eau apaisantes pour une tranquillité parfaite.',
            seaViewDeluxeName: 'Deluxe avec vue sur la mer',
            seaViewDeluxeCategory: 'Chambre Deluxe avec vue sur la mer',
            seaViewDeluxeDesc: 'Réveillez-vous avec une brise marine apaisante et des vues panoramiques sur la mer dans cette chambre deluxe élégamment conçue.',
            kingSizeBed: 'Lit King-Size',
            herbalTeaCoffee: 'Thé aux herbes et café',
            individuallyControlledAC: 'Climatisation à contrôle individuel',
            premiumOrganicToiletries: 'Articles de toilette biologiques premium',
            dailyFreshFlowers: 'Fleurs fraîches quotidiennes',
            beachView: 'Vue sur la plage',
            signatureAccommodation: 'Hébergement signature',
            inRoomComfort: 'Confort en chambre',
            deluxeRoomAmenities: 'Équipements de la chambre Deluxe',
            momentsInDeluxeRoom: 'Moments dans la chambre Deluxe',
            experienceAyurvedicLiving: 'Vivez une authentique vie ayurvédique dans notre chambre Deluxe signature',
            reserveYourStay: 'Réservez votre séjour',
            deluxeRoom: {
                resortName: 'Mahi Beach Ayurveda Resort',
                heroTitle: 'Chambre Deluxe avec balcon et vue sur la mer',
                heroSubtitle: 'Détendez-vous dans une retraite côtière apaisante inspirée des plages dorées de Bentota, alliant équipements modernes et douces brises marines.',
                bookThisRoom: 'Réserver cette chambre',
                callReservations: 'Appeler les réservations',
                signatureFeatures: 'Caractéristiques signature',
                deluxeRoomName: 'Chambre Deluxe',
                discoverTheSpace: 'Découvrez l’espace',
                whatsIncluded: 'Ce qui est inclus',
                deluxeComfortCare: 'Confort et soins Deluxe',
                inclusions: 'Prestations incluses',
                coreAmenities: 'Équipements principaux',
                amenityHighSpeedWifi: 'Wi-Fi haut débit',
                amenityHerbalTeaCoffee: 'Thé aux herbes et café',
                amenityIndividuallyControlledAC: 'Climatisation à contrôle individuel',
                amenityRainShower: 'Douche à effet pluie',
                amenityOrganicToiletries: 'Articles de toilette biologiques',
                amenityDailyFreshFlowers: 'Fleurs fraîches quotidiennes',
                beginYourHealingStay: 'Commencez votre séjour de guérison',
                experienceAyurvedicSerenity: 'Vivez une authentique sérénité ayurvédique dans notre chambre Deluxe signature',
                checkAvailabilityBook: 'Vérifier la disponibilité et réserver',
                speakWithReservations: 'Parler avec les réservations',
                reserveThisRoom: 'Réserver cette chambre',
                navAll: 'Tout',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe avec vue sur la mer',
                navSuite: 'Suite',
                sectionTitle: 'Un refuge côtier apaisant',
                sectionDesc: 'La Chambre Deluxe est conçue pour les matins lents et les couchers de soleil sans hâte. Des tons neutres doux, un vitrage généreux et un éclairage réfléchi invitent la vue sur la mer, tandis que le balcon offre votre propre perchoir au-dessus du rivage.',
                highlight1Title: 'Vues panoramiques sur la plage',
                highlight1Desc: 'Réveillez-vous avec des eaux azur et des levers de soleil dorés depuis votre balcon privé.',
                highlight2Title: 'Intérieurs côtiers élégants',
                highlight2Desc: 'Palettes neutres douces, accents de bois chaleureux et lumière naturelle généreuse.',
                highlight3Title: 'Expérience de sommeil sereine',
                highlight3Desc: 'Lit king-size moelleux avec linge de lit haut de gamme sélectionné pour un repos réparateur.',
                atAGlance: 'En un coup d\'\u0153il',
                statSize: 'Taille',
                statSizeValue: '41 m²',
                statView: 'Vue',
                statViewValue: 'Océan Indien',
                statGuests: 'Invités',
                statGuestsValue: '2 Adultes',
                statBed: 'Lit',
                statBedValue: 'King ou Twin',
                reserve: 'Réserver',
                galleryAlt: 'Galerie chambre Deluxe',
                inclusionsTitle: 'Inclus dans votre séjour',
                inclusionsSubtitle: 'Touches attentionnées, confort toute la journée',
                enhancedCleanliness: 'Normes de propreté et de sécurité améliorées',
                inclusion1: 'Petit-déjeuner, déjeuner, dîner gratuits au restaurant Breeze',
                inclusion2: 'Wi-Fi haut débit et espace de travail dans la chambre',
                inclusion3: 'Service en chambre et concierge 24 heures',
                inclusion4: 'Ménage quotidien avec ouverture du lit le soir',
                inclusion5: 'Accès à la piscine à débordement et aux installations de spa ayurvédique',
                inclusion6: 'Parking gratuit et service de navette vers les attractions à proximité',
                amenityGroup1Title: 'Caractéristiques de la chambre',
                amenityGroup1Item1: '41 m² d\'espace',
                amenityGroup1Item2: 'Balcon privé avec sièges',
                amenityGroup1Item3: 'Climatisation avec contrôle climatique',
                amenityGroup1Item4: 'Coffre-fort dans la chambre',
                amenityGroup2Title: 'Expérience bain',
                amenityGroup2Item1: 'Douche à effet pluie avec eau chaude et froide',
                amenityGroup2Item2: 'Articles de bain haut de gamme',
                amenityGroup2Item3: 'Sèche-cheveux',
                amenityGroup2Item4: 'Peignoirs et pantoufles doux',
                amenityGroup3Title: 'Conforts dans la chambre',
                amenityGroup3Item1: 'Smart TV 55" avec câble',
                amenityGroup3Item2: 'Station café et thé',
                amenityGroup3Item3: 'Téléphone à sélection directe',
                amenityGroup4Title: 'Connectivité',
                amenityGroup4Item1: 'Wi-Fi gratuit',
                amenityGroup4Item2: 'Bureau',
                amenityGroup4Item3: 'Support réception 24/7',
                essentialsTitle: 'Éléments essentiels en chambre',
                essentialsHeading: 'Tout ce dont vous avez besoin pour vous sentir chez vous',
                essentialsDesc: 'D\'une connectivité transparente à des rafraîchissements soigneusement choisis, la Chambre Deluxe allie loisirs et praticité afin que vous puissiez vous concentrer sur les moments qui comptent.',
                essential1: 'Wi-Fi gratuit',
                essential2: 'Station café et thé',
                essential3: 'Service en chambre 24/7',
                essential4: 'Douche à effet pluie',
                oceanTitle: 'Près de l\'océan',
                oceanSubtitle: 'Ralentissez, respirez l\'air marin',
                oceanAlt: 'Coin salon chambre Deluxe',
                ctaTitle: 'Prêt à séjourner?',
                ctaHeading: 'Réservez la Chambre Deluxe aujourd\'hui',
                ctaDesc: 'Parlez avec notre équipe de réservations pour les meilleurs tarifs disponibles et offres spéciales.',
                checkAvailability: 'Vérifier la disponibilité'
            }
        },

        navbar: {
            home: 'Accueil',
            aboutUs: 'À propos',
            rooms: 'Chambres',
            ayurveda: 'Ayurveda',
            yoga: 'Yoga',
            food: 'Restauration',
            events: 'Événements',
            blogs: 'Blog',
            tours: 'Circuits',
            contactUs: 'Contact',
            bookOnline: 'Réserver en ligne',
            locationMaggona: 'Maggona Sri Lanka',
            selectResort: 'Sélectionner le resort',
            language: 'Langue',
            mainTitle: 'Mahi Beach Ayurveda Resort',
            resortBeach: 'Mahi Beach Ayurveda Resort',
            resortRiver: 'Mahi Beach Ayurveda Resort'
        },
        footer: {
            description: 'Mahi Beach Ayurveda Resort s’engage à offrir une hospitalité et des expériences bien‑être d’exception, afin que chaque client se sente apprécié et régénéré.',
            linksTitle: 'Liens',
            contactTitle: 'Contact',
            viewLocation: 'Voir l’emplacement',
            navHome: 'Accueil',
            navAbout: 'À propos',
            navContact: 'Contact',
            navRooms: 'Chambres',
            navAyurveda: 'Ayurveda',
            copyright: '© Copyright {{year}} Mahi Beach Ayurveda Resort.',
            developedBy: 'Développé par',
            developerName: 'Redev Solution +94 764 608 225'
        }, tours: {
            heroTitle: 'Circuits et excursions',
            heroSubtitle: 'Découvrez la beauté du Sri Lanka depuis Maggona',
            kandeAlt: 'Temple Kande Vihara - Maggona',
            kandeTitle: 'Visite du Temple Kande Vihara',
            kandeBuddhaAlt: 'Gigantesque statue de Bouddha au temple Kande Vihara',
            bentotaTitle: 'Safari en bateau sur le fleuve Bentota',
            bentotaAlt: 'Safari en bateau sur le fleuve Bentota - Mangroves et Faune',
            galleTitle: 'Visite de la Vieille Ville de Galle',
            galleAlt: 'Visite de la Vieille Ville de Galle',
            sigiriyaTitle: 'Visite de la Forteresse Rocheuse de Sigiriya',
            sigiriyaAlt: 'Visite de la Forteresse Rocheuse de Sigiriya',
            kandyTitle: 'Circuit Culturel de Kandy',
            kandyAlt: 'Circuit Culturel de Kandy',
            bookTour: 'Réserver ce circuit',
            viewDetails: 'Afficher les détails',
            introPara1: 'Le Sri Lanka est une terre d\'une beauté intemporelle, où les plages dorées, les paysages verdoyants, les temples anciens et la culture vibrante se rencontrent en parfaite harmonie.',
            introPara2: 'De la côte sud‑ouest tranquille aux villes historiques, aux sites sacrés, aux réserves fauniques et à la région des collines brumeuses, chaque voyage offre une expérience unique et inoubliable.',
            introPara3: 'À partir de Mahi Beach Ayurveda Resort à Maggona, nos circuits et excursions soigneusement sélectionnés sont conçus pour enrichir votre séjour tout en équilibrant parfaitement l\'exploration, la détente et le bien‑être.',
            kandeDetail1: 'Temple Kande Vihara (Kande Viharaya) – l\'un des temples bouddhistes les plus emblématiques près de Maggona.',
            kandeDetail2: 'Fondé en 1734, ce serein \'Temple de la Montagne\' est situé au sommet d\'une colline offrant des vues paisibles sur la côte.',
            kandeDetail3: 'Parmi les points forts figurent la massive statue de Bouddha assis de 48 mètres (l\'une des plus hautes du Sri Lanka), les fresques complexes de l\'époque Kandyan, une ancienne chambre de relique, une belle entrée en pierre de lune et un ancien arbre Bodhi sacré datant de plus de 300 ans.',
            kandeDetail4: 'Une parfaite expérience spirituelle et culturelle d\'une demi‑journée – idéale pour les visites matinales afin d\'éviter la chaleur.',
            bentotaDetail1: 'Profitez d\'un safari en bateau paisible et pittoresque sur le fleuve Bentota, l\'une des excursions naturelles les plus populaires près de Maggona.',
            bentotaDetail2: 'Glissez à travers les luxuriantes mangroves, les canaux étroits et les eaux sereines tout en observant la faune locale.',
            bentotaDetail3: 'Les observations communes incluent les iguanes, les crocodiles, diverses espèces d\'oiseaux (martins‑pêcheurs, hérons, aigles), les singes, et occasionnellement les loutres ou les serpents d\'eau.',
            bentotaDetail4: 'Votre batelier/guide expérimenté vous montrera une flore intéressante, les méthodes de pêche traditionnelles et la vie dans les villages fluviaux.',
            bentotaDetail5: 'Parfait pour les amoureux de la nature et les photographes – calme, relaxant et complémentaire à votre séjour de bien‑être ayurvédique.',
            galleDetail1: 'Explorez le Fort historique de Galle, un Site du Patrimoine Mondial de l\'UNESCO et l\'un des forts coloniaux les mieux préservés du Sri Lanka.',
            galleDetail2: 'Errez dans les ruelles pavées bordées de bâtiments coloniaux néerlandais, boutiques, cafés et galeries d\'art.',
            galleDetail3: 'Visitez les monuments clés tels que le Phare de Galle, l\'Église Réformée Néerlandaise, le Musée Maritime National et les remparts offrant de superbes vues sur l\'océan.',
            galleDetail4: 'Découvrez la riche histoire, l\'architecture et l\'importance culturelle du fort grâce à votre guide compétent.',
            galleDetail5: 'Idéal pour les passionnés d\'histoire, les amateurs de culture et ceux qui souhaitent découvrir le passé colonial du Sri Lanka.',
            sigiriyaDetail1: 'Découvrez la forteresse rocheuse antique de Sigiriya, l\'un des monuments les plus emblématiques du Sri Lanka et un Site du Patrimoine Mondial de l\'UNESCO.',
            sigiriyaDetail2: 'Grimpez sur le rocher impressionnant pour explorer les ruines du palais du roi Kasyapa, orné de fresques, de jardins d\'eau et du célèbre Mur des Miroirs.',
            sigiriyaDetail3: 'Profitez des vues panoramiques sur la jungle environnante et la campagne du sommet.',
            sigiriyaDetail4: 'Découvrez l\'histoire fascinante, l\'architecture et les légendes associées à Sigiriya grâce à votre guide expert.',
            sigiriyaDetail5: 'Parfait pour les passionnés d\'histoire, les chercheurs d\'aventure et ceux intéressés par le riche patrimoine culturel du Sri Lanka.',
            kandyDetail1: 'Découvrez la culture vibrante de Kandy, la dernière capitale royale du Sri Lanka et un Site du Patrimoine Mondial de l\'UNESCO.',
            kandyDetail2: 'Visitez le Temple de la Relique Sacrée de la Dent (Sri Dalada Maligawa), l\'un des sites bouddhistes les plus importants du monde.',
            kandyDetail3: 'Explorez les Jardins Botaniques Royaux de Peradeniya, abritant une vaste collection de plantes tropicales et d\'orchidées.',
            kandyDetail4: 'Profitez d\'un spectacle de danse traditionnelle Kandyan, mettant en valeur le riche patrimoine artistique du Sri Lanka.',
            kandyDetail5: 'Idéal pour les amateurs de culture, les passionnés d\'histoire et ceux qui souhaitent s\'immerger dans les traditions du Sri Lanka.',
            ellaTitle: 'Aventure dans les Montagnes d\'Ella',
            ellaAlt: 'Circuit dans les Montagnes d\'Ella - Pont à Neuf Arches et Plantations de Thé',
            ellaDetail1: 'Voyage à Ella, l\'une des destinations montagneuses les plus pittoresques du Sri Lanka, réputée pour ses vues spectaculaires sur les montagnes et son climat frais.',
            ellaDetail2: 'Visitez le célèbre Pont à Neuf Arches, une merveille ferroviaire de l\'époque coloniale nichée dans une verdure luxuriante, parfaite pour la photographie et pour observer les trains passer.',
            ellaDetail3: 'Explorez les plantations de thé verdoyantes, apprenez-en davantage sur la production du thé de Ceylan et profitez de vues panoramiques depuis le Little Adam\'s Peak ou Ella Rock.',
            ellaDetail4: 'Découvrez les cascades, dont les chutes de Ravana, randonnez sur des sentiers pittoresques et vivez l\'atmosphère charmante du village.',
            ellaDetail5: 'Parfait pour les amoureux de la nature, les chercheurs d\'aventure et ceux qui souhaitent s\'échapper vers les hautes terres à couper le souffle du Sri Lanka.'
        },
        blogs: {
            heroTitle: 'Blogs de Mahi Beach Ayurveda Resort',
            heroSubtitle1: 'Histoires du rivage, rituels Ayurveda au',
            heroSubtitle2: 'Mahi Beach Ayurveda Resort',
            heroSubtitle3: '. Plongez dans les conseils, l\'histoire et les notes en coulisses.',
            heroAlt: 'Allée de la plage du resort au coucher du soleil',
            sectionTitle: 'Blogs de Mahi Beach Ayurveda Resort',
            sectionDescription: 'Guides, histoires et notes de notre retraite côtière — couvrant les rituels Ayurveda, l\'histoire des pierres précieuses et les conseils de voyage autour de Bentota.',
            ayurvedaTitle: 'Le cœur de l\'Ayurveda authentique',
            ayurvedaExcerpt: 'Découvrez des traditions de guérison ancestrales enracinées dans la sagesse ancienne du Sri Lanka.',
            ayurvedaDescription: 'Au Mahi Beach Ayurveda Resort, l\'Ayurveda est plus qu\'un traitement — c\'est un mode de vie. Nos thérapies sont basées sur des connaissances séculaires, personnalisées selon votre type corporel et guidées par des médecins ayurvédiques expérimentés pour un équilibre profond et durable.',
            ayurvedaAlt: 'Installation de traitement ayurvédique avec huiles à base de plantes et éléments naturels',
            healingTitle: 'Parcours de guérison personnalisés',
            healingExcerpt: 'Pourquoi chaque programme de bien-être est conçu de manière unique.',
            healingDescription: 'Des consultations initiales aux traitements quotidiens, votre parcours de guérison est soigneusement adapté. Thérapies à base de plantes, massages thérapeutiques, yoga et méditation travaillent ensemble pour restaurer l\'harmonie entre le corps, l\'esprit et l\'âme.',
            healingAlt: 'Médecin ayurvédique consultant un client dans un cadre calme',
            natureTitle: 'Guérison au bord de l\'océan',
            natureExcerpt: 'Comment la brise marine et l\'environnement tropical améliorent votre bien-être.',
            natureDescription: 'Niché le long du littoral tranquille du Sri Lanka, Mahi Beach offre un environnement naturellement curatif. Le bruit des vagues, l\'air frais de l\'océan et la verdure luxuriante amplifient les effets de l\'Ayurveda, créant une détente profonde et un renouveau.',
            natureAlt: 'Vue sur la plage du resort avec palmiers et océan',
            foodTitle: 'Cuisine ayurvédique pour l\'équilibre intérieur',
            foodExcerpt: 'Repas nourrissants conçus pour soutenir votre traitement.',
            foodDescription: 'Notre cuisine ayurvédique est fraîchement préparée avec des ingrédients de saison et d\'origine locale. Chaque repas est aligné sur votre dosha, favorisant la digestion, la détoxification et la vitalité globale tout en restant savoureux et satisfaisant.',
            foodAlt: 'Repas ayurvédique traditionnel servi dans des bols naturels',
            yogaTitle: 'Yoga, méditation et sérénité intérieure',
            yogaExcerpt: 'Pratiques douces qui calment l\'esprit et renforcent le corps.',
            yogaDescription: 'Les séances quotidiennes de yoga et de méditation complètent vos traitements, améliorant la flexibilité, la respiration et la clarté mentale. Ces pratiques conscientes vous aident à vous reconnecter avec vous-même et à emporter un sentiment de paix au-delà de votre séjour.',
            yogaAlt: 'Clients pratiquant le yoga face à l\'océan au lever du soleil',
            lifestyleTitle: 'Ramener l\'Ayurveda à la maison',
            lifestyleExcerpt: 'Pratiques de vie simples pour poursuivre votre parcours de bien-être.',
            lifestyleDescription: 'Avant votre départ, nos experts vous guident pour maintenir l\'équilibre à travers des routines quotidiennes, l\'alimentation et les rituels de soins personnels. Ramenez plus que des souvenirs — ramenez un chemin durable vers une vie plus saine.',
            lifestyleAlt: 'Client se détendant avec du thé aux herbes dans un cadre serein du resort',
            readMore: 'Lire la suite'
        },
        events: {
            heroEyebrow: 'Expériences & activités',
            heroTitle: 'Nos événements',
            heroSubtitle: 'Des expériences soigneusement conçues mêlant tradition sri-lankaise et luxe côtier',
            heroAlt: 'Événements à Mahi Beach',
            availableDaily: 'Disponible tous les jours',
            bookNow: 'Réserver',
            highlightsTitle: 'Points forts',
            detailAlt: '{{title}} en détail',
            ctaTitle: 'Prêt à créer des souvenirs ?',
            ctaDescription: 'Contactez notre équipe pour personnaliser votre expérience événement idéale au Mahi Beach Ayurveda Resort',
            ctaContact: 'Contactez-nous',
            ctaViewRooms: 'Voir les chambres',
            buddhistMonkMeditationTitle: 'Méditation avec moines bouddhistes',
            buddhistMonkMeditationSubtitle: 'Pratiques traditionnelles de pleine conscience',
            buddhistMonkMeditationDescription: 'Découvrez l\'authentique méditation bouddhiste dirigée par des moines expérimentés dans notre resort paisible. Ces pratiques anciennes favorisent la paix intérieure, la pleine conscience et le bien-être spirituel à travers des séances guidées combinant chants traditionnels, techniques de respiration et méditation silencieuse.',
            buddhistMonkMeditationHighlight1: 'Séances de méditation bouddhiste traditionnelle',
            buddhistMonkMeditationHighlight2: 'Guidance par des moines expérimentés',
            buddhistMonkMeditationHighlight3: 'Cadre intérieur paisible du resort',
            buddhistMonkMeditationHighlight4: 'Techniques de pleine conscience et respiration',
            buddhistMonkMeditationHighlight5: 'Pratiques de bien-être spirituel',
            cookeryTitle: 'Programmes de cuisine',
            cookerySubtitle: 'Saveurs du Sri Lanka',
            cookeryDescription: 'Plongez dans les saveurs vibrantes de la cuisine sri-lankaise. Nos chefs experts vous guident lors de sessions de cuisine pratique, en enseignant des recettes traditionnelles transmises de génération en génération. Apprenez à préparer des currys aromatiques, des hoppers, du sambol à la noix de coco et bien plus encore avec des ingrédients locaux frais.',
            cookeryHighlight1: 'Recettes sri-lankaises traditionnelles',
            cookeryHighlight2: 'Expérience de cuisine pratique',
            cookeryHighlight3: 'Ingrédients locaux frais',
            cookeryHighlight4: 'Emportez les recettes chez vous',
            cookeryHighlight5: 'Visite du jardin d’épices incluse',
            meditationTitle: 'Programmes de méditation',
            meditationSubtitle: 'Paix intérieure & pleine conscience',
            meditationDescription: 'Trouvez la tranquillité lors de nos séances de méditation guidée avec pour toile de fond l’océan Indien. Nos instructeurs expérimentés vous guident à travers des techniques anciennes de pleine conscience, des exercices de respiration et des pratiques de yoga conçues pour apaiser l’esprit et revitaliser l’âme.',
            meditationHighlight1: 'Séances au lever et au coucher du soleil',
            meditationHighlight2: 'Méditation en bord de mer',
            meditationHighlight3: 'Guidé par des experts',
            meditationHighlight4: 'Techniques de respiration',
            meditationHighlight5: 'Pratiques de yoga et de pleine conscience',
            nightBeachPartiesTitle: 'Soirée grill',
            nightBeachPartiesSubtitle: 'Expérience culinaire en bord de mer',
            nightBeachPartiesDescription: 'Savourez une soirée grill inoubliable en bord de mer sous les étoiles. Dégustez des fruits de mer fraîchement grillés, des viandes premium et des légumes colorés tout en profitant du son apaisant des vagues de l\'océan. Nos chefs experts préparent chaque plat à la perfection, créant une expérience culinaire mémorable dans un cadre côtier magique.',
            nightBeachPartiesHighlight1: 'Fruits de mer et viandes fraîchement grillés',
            nightBeachPartiesHighlight2: 'Démonstration de grillade en direct par les chefs',
            nightBeachPartiesHighlight3: 'Ambiance de dîner face à l\'océan',
            nightBeachPartiesHighlight4: 'Sélection de buffet BBQ premium',
            nightBeachPartiesHighlight5: 'Ambiance de plage avec feu de camp',
            bbqTitle: 'Soirées BBQ',
            bbqSubtitle: 'Célébrations en bord de mer',
            bbqDescription: 'Vivez des soirées inoubliables avec nos BBQ en bord de plage. Savourez des fruits de mer fraîchement grillés, des viandes premium et des délices végétariens tandis que les vagues murmurent à proximité. Musique live, danseurs de feu et ciel étoilé créent l’ambiance parfaite pour célébrer et se connecter.',
            bbqHighlight1: 'Fruits de mer grillés frais',
            bbqHighlight2: 'Dîner face à l’océan',
            bbqHighlight3: 'Divertissement en direct',
            bbqHighlight4: 'Expérience autour du feu',
            bbqHighlight5: 'Menus personnalisables',
            boatTitle: 'Balades en bateau',
            boatSubtitle: 'Aventures fluviales et côtières',
            boatDescription: 'Partez pour des voyages enchanteurs le long de la rivière Bentota et des eaux côtières. Glissez à travers les mangroves, observez des oiseaux exotiques et la faune, ou profitez de croisières romantiques au coucher du soleil. Nos balades en bateau offrent une perspective unique sur la beauté naturelle et les écosystèmes du Sri Lanka.',
            boatHighlight1: 'Croisières sur la rivière Bentota',
            boatHighlight2: 'Exploration des mangroves',
            boatHighlight3: 'Observation de la faune',
            boatHighlight4: 'Balades en bateau au coucher du soleil',
            boatHighlight5: 'Location privée disponible',
            ayurvedaLecturesTitle: 'Conférences de médecins ayurvédiques',
            ayurvedaLecturesSubtitle: 'Sagesse ancienne & bien-être moderne',
            ayurvedaLecturesDescription: 'Découvrez les principes profonds de l’Ayurveda grâce à des conférences animées par des médecins ayurvédiques certifiés et des praticiens. Apprenez l’équilibrage des doshas, les remèdes à base de plantes, les pratiques de guérison holistique et comment la sagesse ancienne s’applique au bien-être moderne. Nos sessions interactives démystifient la philosophie ayurvédique et son application au quotidien.',
            ayurvedaLecturesHighlight1: 'Médecins ayurvédiques certifiés',
            ayurvedaLecturesHighlight2: 'Analyse dosha personnalisée',
            ayurvedaLecturesHighlight3: 'Éducation aux remèdes à base de plantes',
            ayurvedaLecturesHighlight4: 'Sessions de questions-réponses',
            ayurvedaLecturesHighlight5: 'Guide bien-être à emporter',
            traditionalClothsTitle: 'Événements de port de tenues traditionnelles',
            traditionalClothsSubtitle: 'Expérience du patrimoine culturel',
            traditionalClothsDescription: 'Immergez-vous dans le patrimoine culturel sri-lankais en apprenant à porter et à apprécier les tenues traditionnelles. Nos stylistes experts vous guident pour revêtir des sarees kandyan authentiques et des vêtements traditionnels, en expliquant la signification culturelle de chaque pièce. Idéal pour des occasions spéciales, l’appréciation culturelle ou des photos mémorables.',
            traditionalClothsHighlight1: 'Conseils de stylisme experts',
            traditionalClothsHighlight2: 'Sarees traditionnels authentiques',
            traditionalClothsHighlight3: 'Signification culturelle expliquée',
            traditionalClothsHighlight4: 'Photographie professionnelle incluse',
            traditionalClothsHighlight5: 'Ateliers de fusion mode',
            shanthiKarmaTitle: 'Danse culturelle',
            shanthiKarmaSubtitle: 'Spectacles traditionnels du Sri Lanka',
            shanthiKarmaDescription: 'Plongez dans le monde vibrant de la danse culturelle sri-lankaise. Découvrez des spectacles traditionnels fascinants avec des costumes colorés, des tambours rythmiques et une narration ancienne à travers le mouvement. Nos danseurs talentueux présentent des danses folkloriques séculaires, la danse Kandyan et des rituels culturels qui donnent vie au patrimoine du Sri Lanka.',
            shanthiKarmaHighlight1: 'Danses traditionnelles authentiques du Sri Lanka',
            shanthiKarmaHighlight2: 'Costumes et maquillage traditionnels colorés',
            shanthiKarmaHighlight3: 'Accompagnement de tambours en direct',
            shanthiKarmaHighlight4: 'Narration culturelle à travers le mouvement',
            shanthiKarmaHighlight5: 'Spectacles de danse Kandyan et folklorique',
            musicTherapyTitle: 'Musicothérapie',
            musicTherapySubtitle: 'Guérison par le son',
            musicTherapyDescription: 'Découvrez le pouvoir transformateur de la musicothérapie dans notre cadre océanique serein. Des praticiens expérimentés utilisent des instruments traditionnels et modernes pour créer des expériences sonores thérapeutiques qui favorisent la relaxation profonde, la libération émotionnelle et la guérison holistique.',
            musicTherapyHighlight1: 'Sessions thérapeutiques guidées par des professionnels',
            musicTherapyHighlight2: 'Instruments traditionnels et modernes',
            musicTherapyHighlight3: 'Thérapie de relaxation et de libération émotionnelle',
            musicTherapyHighlight4: 'Ateliers de méditation sonore',
            musicTherapyHighlight5: 'Harmonisation de l\'esprit-corps-esprit',
            taiChiTitle: 'Tai Chi',
            taiChiSubtitle: 'Mouvement doux et équilibre',
            taiChiDescription: 'Pratiquez l\'art ancien du Tai Chi dans notre jardin en bord de mer tranquille. Ces mouvements gracieux et fluides améliorent l\'équilibre, la flexibilité et la force intérieure tout en calmant l\'esprit. Convient à tous les niveaux de forme physique et d\'âge.',
            taiChiHighlight1: 'Cours quotidiens au lever du soleil',
            taiChiHighlight2: 'Instruit par des maîtres certifiés',
            taiChiHighlight3: 'Améliore l\'équilibre et la flexibilité',
            taiChiHighlight4: 'Approprié pour tous les âges',
            taiChiHighlight5: 'Arts martiaux et pratiques de méditation',
        },
        contact: {
            heroTitle: 'Contactez-nous',
            heroSubtitle: 'Mahi Beach Ayurveda Resort',
            heroAlt: 'Contactez-nous',
            sectionTitle: 'N\'hésitez pas à nous contacter',
            sectionSubtitle: 'Nous sommes là pour vous aider à vous détendre et vous ressourcer',
            sectionDescription: 'Contactez Mahi Beach Ayurveda Resort pour toute question sur votre séjour ayurvédique, les forfaits bien‑être, les réservations ou votre séjour à Maggona, Moragalla.',
            callUs: 'Appelez-nous',
            emailTitle: 'Email',
            ourLocation: 'Notre adresse',
            locationAddress: 'No.112 rendagewatta Galle Rd, Maggona',
            socialNetwork: 'Réseaux sociaux',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Entrer en contact',
            getInTouchDescription: 'Nous serions ravis d\'échanger avec vous — notre équipe est prête à vous accompagner, répondre à vos questions et planifier un séjour ressourçant.',
            nameLabel: 'Nom',
            emailLabel: 'Email',
            contactNumberLabel: 'Numéro de contact',
            messageLabel: 'Message',
            sending: 'Envoi...',
            sendMessage: 'Envoyer le message',
            successMessage: 'Votre message a bien été envoyé ! Nous vous répondrons bientôt.',
            errorMessage: 'Une erreur est survenue lors de l\'envoi. Veuillez réessayer.',
            findUsOnMap: 'Nous trouver sur la carte',
            whatsappSubject: 'Contact Mahi Beach Ayurveda Resort',
            whatsappName: 'Nom',
            whatsappEmail: 'Email',
            whatsappContactNumber: 'Numéro de contact',
            whatsappMessage: 'Message'
        },


        ayurveda: {
            accordionTitle1: 'Comprendre le Panchakarma',
            accordionDesc1: 'L\'Ayurvéda (« science de la vie ») est l\'une des plus anciennes approches holistiques, née il y a plus de 5 000 ans. Le Panchakarma repose sur l\'harmonie entre esprit, corps, âme et environnement. Son objectif est de renforcer la santé et prévenir les troubles, avec des soins personnalisés.',
            accordionTitle2: 'Panchakarma et énergie vitale',
            accordionDesc2: 'L\'Ayurvéda enseigne l\'interconnexion de toute chose. Quand l\'esprit, le corps et l\'âme sont alignés, le bien‑être s\'installe ; quand l\'équilibre se rompt, des déséquilibres apparaissent. Hérédité, blessures, saisons, âge et émotions peuvent l\'influencer.\n\nL\'être humain se compose de cinq éléments : espace, air, feu, eau et terre. Ils forment trois doshas : VATA (espace/air), PITTA (feu/eau) et KAPHA (eau/terre), qui régulent les fonctions du corps.\n\nChaque personne possède un mélange unique, souvent avec un dosha dominant. L\'équilibre de ces forces influence la santé et les sensibilités.',
            accordionTitle3: 'Dosha Vata',
            accordionDesc3: 'Vata est considéré comme le plus influent : il gouverne le mouvement, la respiration, la circulation, le rythme cardiaque et l\'élimination. Les repas irréguliers, la peur, le chagrin et les nuits tardives peuvent le déséquilibrer.\n\nAvec Vata dominant, on est souvent vif, créatif et énergique, avec une constitution fine et une sensibilité au froid. En déséquilibre, anxiété et agitation peuvent apparaître.\n\nPour l\'apaiser, l\'Ayurvéda recommande des pratiques d\'ancrage : méditation, massages, routines régulières et aliments chauds et doux.',
            accordionTitle4: 'Dosha Pitta',
            accordionDesc4: 'Pitta régit la digestion, le métabolisme et les hormones liées à l\'appétit. Il peut être aggravé par les aliments acides ou épicés, la chaleur et les repas sautés.\n\nLes profils Pitta sont déterminés, compétitifs et confiants, souvent avec une chaleur corporelle marquée. En déséquilibre, irritabilité et inflammations peuvent survenir.\n\nOn rééquilibre Pitta avec des aliments rafraîchissants et des pratiques apaisantes comme le yoga doux.',
            accordionTitle5: 'Dosha Kapha',
            accordionDesc5: 'Kapha apporte stabilité, force, structure et immunité. Il s\'alourdit avec l\'excès de sucré, les repas lourds et trop de sommeil.\n\nLes profils Kapha sont calmes, patients et constants, avec une constitution plus robuste. En déséquilibre, fatigue, lenteur et prise de poids peuvent apparaître.\n\nPour équilibrer Kapha, privilégiez la légèreté : plus de fruits et légumes et une activité qui stimule l\'énergie.',
            close: 'Fermer',
            next: 'Suivant',
            previous: 'Précédent',
            treatmentsTitle: 'Nos traitements Panchakarma Ayurvédiques signature',
            treatmentsSubtitle: 'Des soins traditionnels qui rétablissent l’équilibre, relâchent les tensions et renouvellent corps et esprit.',
            bookTreatment: 'Réserver ce soin',
            benefitsTitle: 'Pourquoi le Panchakarma est précieux',
            shirodhara: 'Shirodhara',
            shirodharaDesc: 'Un filet d’huile chaude aux herbes sur le front pour apaiser le système nerveux.',
            shirodhara1: 'Apaise stress et anxiété',
            shirodhara2: 'Favorise un sommeil plus profond',
            shirodhara3: 'Clarifie l’esprit',
            steamBath: 'Bain de vapeur',
            steamBathDesc: 'La vapeur aux herbes ouvre les pores, soutient la détox et détend les muscles.',
            steamBath1: 'Soutient la détox en douceur',
            steamBath2: 'Améliore la circulation',
            steamBath3: 'Relâche les tensions musculaires',
            flowerBath: 'Bain floral',
            flowerBathDesc: 'Bain floral parfumé pour se relaxer et se recentrer.',
            flowerBath1: 'Apaise le système nerveux',
            flowerBath2: 'Adoucit et hydrate la peau',
            flowerBath3: 'Remonte le moral',
            headMassage: 'Massage de la tête',
            headMassageDesc: 'Massage du cuir chevelu pour dissoudre les tensions.',
            headMassage1: 'Soulage la pression dans la tête',
            headMassage2: 'Nourrit le cuir chevelu et les racines',
            headMassage3: 'Invite à une détente profonde',
            faceMassage: 'Massage du visage',
            faceMassageDesc: 'Massage facial doux qui ravive l’éclat et réduit le stress.',
            faceMassage1: 'Illumine le teint',
            faceMassage2: 'Détend les traits',
            faceMassage3: 'Soutient le drainage lymphatique',
            neckMassage: 'Massage du cou',
            neckMassageDesc: 'Travail ciblé pour relâcher la nuque.',
            neckMassage1: 'Diminue l’inconfort cervical',
            neckMassage2: 'Améliore la mobilité',
            neckMassage3: 'Réduit le stress',
            shoulderMassage: 'Massage des épaules',
            shoulderMassageDesc: 'Massage thérapeutique pour dénouer les épaules.',
            shoulderMassage1: 'Apaise les douleurs d’épaule',
            shoulderMassage2: 'Améliore la posture',
            shoulderMassage3: 'Libère les nœuds musculaires',
            bodyMassage: 'Massage du corps',
            bodyMassageDesc: 'Rituel complet pour se détendre et se régénérer.',
            bodyMassage1: 'Stimule la circulation',
            bodyMassage2: 'Apaise les courbatures',
            bodyMassage3: 'Favorise la relaxation',
            backMassage: 'Massage du dos',
            backMassageDesc: 'Soin du dos pour dissiper tensions et douleurs.',
            backMassage1: 'Soulage le mal de dos',
            backMassage2: 'Soutient le confort de la colonne',
            backMassage3: 'Réduit le stress',
            footMassage: 'Massage des pieds',
            footMassageDesc: 'Massage des pieds qui apaise tout le corps.',
            footMassage1: 'Relance la circulation',
            footMassage2: 'Allège les pieds fatigués',
            footMassage3: 'Apporte calme et ancrage',
            purgative: 'Purgatif',
            purgativeDesc: 'Thérapie de purification pour éliminer l’excès de Pitta et les toxines digestives.',
            purgative1: 'Nettoie les intestins',
            purgative2: 'Équilibre Pitta',
            purgative3: 'Soutient la digestion',
            nasalClearing: 'Nettoyage nasal',
            nasalClearingDesc: 'Soin nasal aux herbes pour dégager les voies respiratoires.',
            nasalClearing1: 'Réduit la congestion',
            nasalClearing2: 'Améliore le souffle',
            nasalClearing3: 'Soulage la pression des sinus',
            powderMassage: 'Massage à la poudre',
            powderMassageDesc: 'Exfoliation aux poudres d’herbes pour raviver la peau.',
            powderMassage1: 'Élimine les cellules ternes',
            powderMassage2: 'Affine le grain de peau',
            powderMassage3: 'Active la circulation',
            intensiveMassageDesc: 'Massage profond pour tensions chroniques et nœuds persistants.',
            intensiveMassage1: 'Libère les tensions profondes',
            intensiveMassage2: 'Améliore la circulation sanguine',
            intensiveMassage3: 'Réduit les douleurs résiduelles',
            thermoMassage: 'Massage Thermo',
            thermoMassageDesc: 'Huiles aux herbes chauffées pour détendre les tissus et soutenir la guérison.',
            thermoMassage1: 'Apaise les muscles endoloris',
            thermoMassage2: 'Invite à une détente profonde',
            thermoMassage3: 'Favorise l’équilibre énergétique',
            synchronMassage: 'Massage Synchronisé',
            synchronMassageDesc: 'Massage synchronisé à deux praticiens pour une harmonie totale.',
            synchronMassage1: 'Harmonie du corps entier',
            synchronMassage2: 'Flux d’énergie équilibré',
            synchronMassage3: 'Expérience de relaxation profonde',
            specialMassage: 'Massage Spécial',
            specialMassageDesc: 'Massage sur mesure selon vos besoins de santé.',
            specialMassage1: 'Soin personnalisé',
            specialMassage2: 'Ciblé sur vos besoins',
            specialMassage3: 'Approche de guérison ciblée',
            benefit1Title: 'Soutien détox :',
            benefit1Desc: 'Le Panchakarma aide à éliminer les toxines accumulées et à retrouver de la vitalité.',
            benefit2Title: 'Digestion facilitée :',
            benefit2Desc: 'Les thérapies favorisent une digestion fluide et une meilleure assimilation.',
            benefit3Title: 'Reset du stress :',
            benefit3Desc: 'Des soins apaisants qui réduisent la tension et l’anxiété.',
            benefit4Title: 'Résilience immunitaire :',
            benefit4Desc: 'Des séances régulières renforcent les défenses naturelles.',
            benefit5Title: 'Renouveau :',
            benefit5Desc: 'Soutient la régénération cellulaire pour une peau saine et lumineuse.',
            benefit6Title: 'Équilibre des doshas :',
            benefit6Desc: 'Rétablit l’harmonie de Vata, Pitta et Kapha pour un bien-être durable.',
            akkupancharTitle: 'Thérapie d Acupuncture',
            akkupancharDesc1: 'est une ancienne pratique thérapeutique utilisant de fines aiguilles appliquées sur des points spécifiques du corps. Ce traitement stimule les canaux énergétiques vitaux et favorise la guérison.',
            akkupancharBenefit: 'Avantages clés :',
            akkupancharDesc2: 'Cette thérapie spécialisée aide à soulager la douleur chronique, améliorer la flexibilité articulaire, la circulation sanguine et restaurer le flux énergétique naturel du corps.',
            akkupancharApplication: 'Application thérapeutique :',
            akkupancharDesc3: 'L acupuncture agit sur des points marma spécifiques avec des techniques soigneusement sélectionnées pour équilibrer les doshas.',
            akkupancharTransform: 'Expérimentez la transformation :',
            akkupancharDesc4: 'Au Mahi Beach Ayurveda Resort, nos praticiens expérimentés personnalisent chaque session d acupuncture pour répondre à vos besoins de santé uniques.',
            experienceAkkupanchar: 'Découvrez l\'acupuncture aujourd\'hui',
            doctorsEyebrow: 'NOTRE ÉQUIPE D\'EXPERTS',
            doctorsSectionTitle: 'Nos médecins',
            drSandyaName: 'Dr. M. Sandya Mendis',
            drSandyaProfession: 'Médecin ayurvédique',
            drSandyaSpecialization: 'Ayurveda clinique, Planification de traitement personnalisé, Soins ayurvédiques en hôtellerie',
            drSandyaProfileTitle: 'Profil professionnel',
            drSandyaProfile: 'Professionnelle ayurvédique compassionnée et dévouée avec plus de 25 ans d\'expérience dans la fourniture de soins personnalisés et de solutions de bien-être. Spécialisée dans la combinaison de principes ayurvédiques traditionnels avec des pratiques thérapeutiques modernes pour offrir des expériences de guérison holistiques dans les centres de bien-être de luxe.',
            drSandyaWorkExpTitle: 'Expérience professionnelle',
            drSandyaWorkExp1: 'Médecin en chef et responsable du développement des programmes - Mahi Beach Ayurveda Resort (2023 – Présent)',
            drSandyaWorkExp2: 'Médecin ayurvédique senior - Sun Aqua Resort and Spa, Maggona (2008 – 2023)',
            drSandyaWorkExp3: 'Consultante ayurvédique - Amba Ayurveda Specialty Clinic (2006 – 2008)',
            drSandyaWorkExp4: 'Médecin ayurvédique et spécialiste Panchakarma - Paradise Road The Villa Bentota (2002 – 2006)',
            drSandyaWorkExp5: 'Médecin ayurvédique - Hotel Blue Water (1996 – 2002)',
            drSandyaEducationTitle: 'Formation et qualifications professionnelles',
            drSandyaEdu1: 'Diplôme en Ayurveda - Government Ayurveda College, Borella (1989 – 1993)',
            drSandyaEdu2: 'Reiki 2e degré - Reiki Dasa Centre Negombo Sri Lanka (2015 – 2016)',
            drPandukaName: 'Dr. Panduka Ranaweera',
            drPandukaProfession: 'Médecin ayurvédique',
            drPandukaQualification: 'B.A.M.S. (Bachelor of Ayurvedic Medicine and Surgery)',
            drPandukaProfileTitle: 'Profil professionnel',
            drPandukaProfile: 'Le Dr Panduka Ranaweera est un médecin ayurvédique qualifié et expérimenté, titulaire d\'un Bachelor of Ayurvedic Medicine and Surgery (B.A.M.S.) de l\'Université de Colombo. Sa formation académique est fermement basée sur les principes ayurvédiques classiques et une éducation clinique complète, soutenant une approche structurée, éthique et fondée sur des preuves de la médecine traditionnelle.',
            drPandukaExpertiseTitle: 'Expertise professionnelle',
            drPandukaExpertise: 'En plus de la pratique clinique, le Dr Ranaweera donne des conférences professionnelles sur l\'Ayurveda pour les clients et les programmes de bien-être, offrant des informations claires sur la philosophie ayurvédique, la prévention des maladies, la gestion du mode de vie et l\'application pratique des thérapies traditionnelles. Ces sessions améliorent la compréhension et l\'engagement des clients, contribuant à des résultats de santé durables.',
            drPandukaSpecialtyTitle: 'Thérapies intégratives',
            drPandukaSpecialty: 'Son expertise thérapeutique s\'étend également à l\'acupuncture et à la musicothérapie, qu\'il intègre sélectivement pour soutenir la gestion de la douleur, la réduction du stress, l\'équilibre neurologique et le bien-être émotionnel. En combinant l\'Ayurveda avec ces modalités complémentaires, le Dr Ranaweera offre une expérience de guérison véritablement intégrative.',
            drPandukaRoleTitle: 'Engagement envers l\'excellence',
            drPandukaRole: 'Dans son rôle à l\'hôtel, le Dr Ranaweera maintient des normes cliniques élevées tout en fournissant des plans de traitement personnalisés et des conseils holistiques en matière de bien-être. Son approche professionnelle, calme et compatissante garantit que chaque client reçoit des soins sûrs, authentiques et axés sur les résultats visant l\'équilibre à long terme, la vitalité et le bien-être général.',
            gallery1: 'Thérapie Shirodhara',
            gallery2: 'Bain de vapeur',
            gallery3: 'Bain floral',
            gallery4: 'Massage de la tête',
            gallery5: 'Massage du corps',
            gallery6: 'Massage du cou',
            gallery7: 'Massage du visage',
            gallery8: 'Massage des épaules',
            heroTitle: 'Panchakarma Ayurvéda',
            heroSubtitle: 'Rajeunissez Corps, Esprit et Âme à Maggona',
            heroTagline: 'Découvrez la guérison ayurvédique authentique du Sri Lanka au bord de l’océan',
            sectionEyebrow: 'PANCHAKARMA AYURVÉDA AU MAHI BEACH AYURVEDA RESORT',
            sectionDescription: 'Découvrez l\'art ancien du Panchakarma au Mahi Beach Ayurveda Resort à Maggona, Sri Lanka. Notre équipe ayurvédique conçoit des soins personnalisés pour purifier, restaurer et harmoniser corps, esprit et âme.',
            treatmentProgramme: {
                title: 'Programme de Traitement Ayurvédique',
                subtitle: 'Votre Voyage vers l\'Équilibre, la Détox et le Renouveau Profond',
                intro: 'Vivez une véritable cure ayurvédique dans un refuge côtier paisible qui restaure le corps, apaise l\'esprit et recharge l\'énergie. Dès votre arrivée, nous gérons chaque détail pour que vous puissiez vous concentrer sur votre bien-être.',
                welcomeTitle: 'Accueil et Début en Douceur',
                welcomePoints: [
                    'Prise en charge à l\'aéroport et transfert à l\'hôtel',
                    'Accueil chaleureux et orientation de l\'hôtel',
                    'Présentation de votre programme de bien-être hebdomadaire',
                    'Massage de Relaxation (Jour 1) au Centre Ayurveda pour éliminer la fatigue du voyage et préparer votre corps aux traitements'
                ],
                doctorTitle: 'Consultation Médicale et Plan Personnalisé',
                doctorPoints: [
                    'Consultation avec le Médecin Ayurvédique (Jour 2 – matin)',
                    'Évaluation complète de votre Dosha/type de corps et problèmes de santé',
                    'Traducteur disponible sur demande',
                    'Votre médecin crée un plan de traitement personnalisé adapté à vos besoins et objectifs'
                ],
                dailyTherapiesTitle: 'Thérapies Ayurvédiques Quotidiennes',
                dailyTherapiesPoints: [
                    '4–5 traitements quotidiens (selon les recommandations du médecin)',
                    'Thérapies sélectionnées en fonction de votre constitution corporelle et de votre état',
                    'Des massages spéciaux peuvent être ajoutés si nécessaire',
                    'Le médecin surveille les progrès quotidiennement et peut ajuster les traitements et le soutien à base de plantes pour garantir les meilleurs résultats',
                    'Si approprié, un processus de nettoyage/purge doux peut être recommandé'
                ],
                herbalMedicineTitle: 'Soutien par Médecine à Base de Plantes',
                herbalMedicinePoints: [
                    'Médicaments à base de plantes prescrits par le médecin servis deux fois par jour:',
                    'Pendant le petit-déjeuner',
                    'Pendant le dîner',
                    'Soutenant la guérison interne, la détoxification et l\'équilibre durable'
                ],
                yogaMeditationTitle: 'Yoga et Méditation pour l\'Harmonie Corps-Esprit',
                yogaMeditationPoints: [
                    'Séances de yoga 4 fois par semaine (environ 1 heure)',
                    'Séances de méditation 2 fois par semaine:',
                    'Une expérience spirituelle unique dans un temple insulaire, accessible en bateau',
                    'Méditation guidée dirigée par des moines (environ 1 heure)'
                ],
                wellnessTitle: 'Expériences de Bien-être Incluses',
                wellnessPoints: [
                    'Démonstrations culinaires saines hebdomadaires',
                    'Excursion gratuite (expérience culturelle/nature)'
                ],
                closingTitle: 'Rituel de Clôture et Départ',
                closingPoints: [
                    'Un magnifique Bain de Fleurs (dernier jour)—un rituel traditionnel de renouveau',
                    'Consultation finale avec le médecin pour examiner les progrès et fournir:',
                    'Conseils de bien-être continus',
                    'Prescriptions et recommandations pour la maison',
                    'Transfert de retour à l\'aéroport'
                ]
            },
        },
        food: {
            heroTitle: 'Cuisine ayurvédique et cuisine côtière',
            heroSubtitle: 'Saveurs authentiques du Sri Lanka et cuisine côtière fraîche',
            heroAlt: 'Expérience culinaire au Mahi Beach Ayurveda Resort',
            wellnessEyebrow: 'Bien-être par la nourriture',
            wellnessTitle: 'L\'importance du',
            ayurvedicFood: 'aliment ayurvédique',
            wellnessIntro1: 'En Ayurveda, la nourriture est considérée comme la plus grande médecine. Ce que vous mangez influence directement vos doshas (Vata, Pitta, Kapha), votre digestion (agni) et l\'équilibre global de votre corps, esprit et âme.',
            wellnessIntro2: 'La nutrition ayurvédique met l\'accent sur les aliments frais, saisonniers et complets préparés avec soin et mangés en pleine conscience. Elle promeut six saveurs (sucrée, acide, salée, piquante, amère, astringente) dans chaque repas pour nourrir tous les sens et maintenir l\'harmonie.',
            wellnessIntro3: 'La bonne nourriture ayurvédique soutient une digestion forte, aide à éliminer les toxines (ama), renforce l\'immunité, améliore l\'énergie, réduit le stress et prévient de nombreuses maladies chroniques. À Mahi Beach, chaque plat est soigneusement préparé pour s\'aligner sur votre constitution unique pour une guérison profonde et une vitalité.',
            foodImage1Alt: 'Repas ayurvédique traditionnel avec six saveurs',
            foodImage2Alt: 'Herbes ayurvédiques et épices pour une nutrition équilibrée',
            culinaryPhilosophyEyebrow: 'Notre philosophie culinaire',
            culinaryPhilosophyTitle: 'Nutrition',
            nutritionHighlight: 'ayurvédique',
            culinaryPhilosophyResort: 'au Mahi Beach Ayurveda Resort',
            nutritionTopImageAlt: 'Cuisine ayurvédique au Mahi Beach Ayurveda Resort',
            freshNourishingLabel: 'Frais et nourrissant',
            healingIngredientsAlt: 'Ingrédients et épices ayurvédiques sains',
            healingIngredientsLabel: 'Ingrédients curatifs',
            philosophyText1: 'La nourriture, qui englobe les six saveurs principales (sucrée, acide, salée, amère, piquante et astringente) ainsi que de nombreuses variations subtiles, a été décrite dans des textes ayurvédiques classiques — certains datant de plus de 5 000 ans — ainsi que les propriétés essentielles de chaque aliment : Guna (qualité inhérente), Virya (potentialité/réchauffement ou refroidissement), Vipaka (impact post-digestif) et Prabhava (action spéciale unique).',
            philosophyText2: 'En conséquence, la nutrition ayurvédique joue un rôle central au Mahi Beach Ayurveda Resort. Cela ne signifie pas un régime rigide et monotone de repas insipides, sans saveur ou excessivement amers dictés uniquement par les médecins. Au contraire, notre cuisine ayurvédique est l\'une de nos plus grandes forces : les plats préparés par nos cuisiniers compétents vous surprendront et vous raviront chaque jour de votre séjour !',
            philosophyText3: 'Au petit-déjeuner, profitez d\'un généreux buffet avec des fruits tropicaux frais, des jus fraîchement pressés, des soupes aux herbes nourrissantes, du pain fait maison et des biscuits légers, plus une variété d\'options d\'authentique petit-déjeuner sri-lankais. Au déjeuner, savourez un buffet coloré et savoureux avec des currys de poisson doux, des préparations de légumes et des plats infusés d\'herbes. Le soir, nous servons un menu végétarien défini avec option de poisson frais disponible. Le samedi, nous célébrons la « Nuit du Sri Lanka » avec un buffet élargi — nos chefs préparent des spécialités locales traditionnelles directement devant vous, créant une expérience animée et authentique.',
            philosophyText4: 'En Ayurveda, les aliments et les boissons sont classés de nombreuses façons — selon le goût et les propriétés, la capacité digestive du corps (agni), l\'adéquation pour des conditions de santé spécifiques, l\'opportunité saisonnière, et plus encore. À Mahi Beach, nous considérons soigneusement tous ces facteurs simultanément, en faisant un effort conscient pour inclure les six saveurs dans des combinaisons équilibrées adaptées à la constitution individuelle de chaque invité.',
            philosophyText5: 'Nos repas mettent en vedette des légumes frais, des fruits tropicaux et du poisson d\'approvisionnement responsable. Nous ne servons pas de viande rouge ni d\'alcool.',
            philosophyText6: 'Pendant les repas, un médecin ayurvédique ou un diététicien qualifié est toujours disponible pour vous guider. Ils vous conseilleront sur les légumes, herbes et épices les plus appropriés pour votre phase de traitement actuelle et vous aideront à sélectionner ou à éviter les plats en conséquence. Votre élixir à base de plantes personnalisé et tout instructions spécifiques de l\'équipe du centre de santé seront placés sur votre table individuelle.',
            philosophyText7: 'Ce niveau de soins personnalisés et d\'attention au régime alimentaire est un trait distinctif de l\'expérience Mahi Beach Ayurveda Resort.',
            philosophyText8: 'La nourriture est considérée comme Prana — l\'énergie vitale qui soutient la vie — pour chaque être humain. C\'est pourquoi nous vous encourageons à aborder chaque repas avec une pleine conscience : en savourant les arômes, en vivant les saveurs, en ressentant la chaleur douce et en profitant des sensations savoureuses de manière consciente.',
            diningExperienceEyebrow: 'Expérience culinaire',
            restaurantTitlePrefix: 'Notre',
            ayurvedicHighlight: 'ayurvédique',
            restaurantTitleSuffix: 'restaurant',
            restaurantDetail1: 'Notre restaurant ayurvédique au Mahi Beach Ayurveda Resort offre une expérience culinaire unique qui harmonise les principes ayurvédiques traditionnels avec l\'authentique cuisine côtière du Sri Lanka. Nous accordons la priorité aux ingrédients frais et locaux pour créer des repas qui non seulement enchantent le palais mais favorisent également le bien-être global.',
            restaurantDetail2: 'Le menu est soigneusement conçu pour équilibrer les six saveurs (sucrée, acide, salée, amère, piquante et astringente) dans chaque plat, assurant une expérience nourrissante et satisfaisante. Chaque repas est préparé avec soin, incorporant des herbes et des épices ayurvédiques connues pour leurs propriétés curatives.',
            restaurantDetail3: 'Les invités peuvent profiter d\'une variété de plats adaptés à leurs doshas individuels (constitutions corporelles), avec des options pour les régimes végétariens, végétaliens et pescatariens. Nos chefs travaillent en étroite collaboration avec les praticiens ayurvédiques pour s\'assurer que chaque repas soutient les objectifs de santé et de bien-être des invités.',
            restaurantDetail4: 'L\'atmosphère du restaurant reflète l\'environnement côtier serein, offrant un cadre tranquille pour une alimentation consciente. Que vous profitiez d\'un généreux buffet de petit-déjeuner ou que vous dégustiez un dîner gastronomique, chaque repas dans notre restaurant ayurvédique est une occasion de nourrir le corps et l\'âme.',
            restaurantDetail5: 'Rejoignez-nous au restaurant ayurvédique du Mahi Beach Ayurveda Resort pour un voyage culinaire qui célèbre les saveurs riches du Sri Lanka tout en embrassant la sagesse intemporelle de l\'Ayurveda.',
            restaurantImageAlt: 'Dîner au Mahi Beach Ayurveda Resort',
            premiumDiningLabel: 'Gastronomie premium',
            premiumDiningDescription: 'Découvrez une authentique cuisine ayurvédique dans un cadre fluvial serein'
        },
        yoga: {
            heroTitle: 'Yoga au resort',
            heroSubtitle: 'Trouvez équilibre, force et paix intérieure à Maggona',
            heroAlt: 'Yoga au Mahi Beach Ayurveda Resort',
            importanceEyebrow: 'Bien-être & équilibre',
            importanceTitle: 'Importance du yoga et de la méditation',
            importanceImageAlt: 'Importance du yoga et de la méditation',
            importanceText1: 'Le yoga et la méditation sont des pratiques anciennes qui offrent de nombreux bienfaits physiques, mentaux et émotionnels. Ils favorisent la souplesse, la force et l’équilibre tout en réduisant le stress et l’anxiété.',
            importanceText2: 'Une pratique régulière peut améliorer la concentration, la qualité du sommeil et renforcer le bien-être général. Le yoga encourage aussi la pleine conscience, aidant chacun à se connecter à son moi intérieur et à trouver la paix au milieu du quotidien.',
            importanceText3: 'Au Mahi Beach Ayurveda Resort, nous offrons des environnements sereins parfaits pour pratiquer le yoga et la méditation, permettant aux invités de régénérer l’esprit, le corps et l’âme.',
            practiceEyebrow: 'Notre pratique',
            practiceTitle: 'Pratique & expérience du yoga',
            practiceImageAlt: 'Pratique du yoga au resort',
            practiceText1: 'Au Mahi Beach Ayurveda Resort, le yoga est principalement pratiqué sous forme de Hatha Yoga traditionnel, associé au Pranayama (techniques de respiration). Cette approche holistique vise à éveiller la conscience intérieure et à stimuler doucement la Kundalini (souvent appelée le troisième œil). Une attention particulière est portée à l’alignement de la colonne vertébrale et à la flexibilité, car une colonne souple est censée ralentir le vieillissement — « Vous n’avez que l’âge de votre colonne vertébrale. »',
            practiceText2: 'Les séances de yoga ont lieu quatre fois par semaine et conviennent aussi bien aux débutants qu’aux pratiquants expérimentés. De temps en temps, des sessions spéciales comme l’Ashtanga Yoga sont proposées, permettant aux invités de découvrir une variété de postures et de routines. Nos médecins ayurvédiques encouragent une participation régulière pour soutenir et renforcer le programme de traitement global.',
            practiceText3: 'Toutes les séances se déroulent dans notre Yoga Shala dédié, un espace calme conçu pour favoriser la concentration, l’équilibre et le mouvement conscient. Chaque session commence généralement par des salutations au soleil, suivies du Pranayama et d’une séquence d’asanas soigneusement sélectionnées visant à améliorer la souplesse, la circulation et le bien-être général.',
            practiceText4: 'Nos professeurs de yoga expérimentés adaptent chaque séance aux besoins, aux capacités et aux conditions de santé des invités, garantissant une expérience sûre, bienveillante et profondément bénéfique pour tous.',
            spiritualEyebrow: 'Voyage spirituel',
            spiritualTitle: 'Méditation & activités spirituelles',
            spiritualSubtitle: 'Approfondissez votre pratique spirituelle avec nos cérémonies sacrées et nos séances de méditation guidée',
            meditationImageAlt: 'Méditation et pratique spirituelle au resort',
            meditationTitle: 'Séances de méditation',
            meditationDesc: 'Les invités sont invités à participer à des séances de méditation guidée organisées trois fois par semaine, inspirées des traditions bouddhistes. Ces séances sont conçues pour apaiser l’esprit, approfondir la conscience et soutenir la guérison émotionnelle et spirituelle. La méditation se déroule dans un temple paisible sur une île, accessible en bateau — un voyage serein et significatif qui enrichit l’expérience méditative globale.'
        }
    },
    zh: {
        about: {
            heroTitle: '关于我们',
            heroSubtitle: 'Mahi Beach 阿育吠陀',
            heroBeachResort: 'Beach Resort',
            heroTagline1: '古老的智慧与现代养生在穆图穆尼阿育吠陀海滨度假村相遇',
            heroTagline2: '个性化阿育吠陀治疗、海景和地道的斯里兰卡款待',
            heroDescription: '在我们标志性的豪华房中体验正宗阿育吠陀养生，在这里海洋宁静与永恒疗愈相遇。',
            bookDeluxeRoom: '预订您的豪华房',
            bookDeluxeRoomShort: '预订豪华房',
            slide1: '豪华宁静',
            slide2: '阿育吠陀和谐',
            slide3: '海滨奢华',
            slide4: '自然优雅',
            slide5: '疗愈逃跑',
            historyLabel: '我们的历程',
            historyTitle: 'Mahi Beach阿育吠陀海滨度假村的历史',
            historyDesc1: 'Mahi Beach阿育吠陀海滨度假村建立于2025年，源于创建一个圣地的愿景，将古老的阿育吠陀智慧与斯里兰卡南部海岸宁静的美融为一体。我们创造了贝鲁瓦拉最受欢迎的全面疗愈和复兴目的地。',
            historyDesc2: '我们的创始人受到几代传统阿育吠陀医生的启发，致力于在提供现代便利和地道斯里兰卡款待的同时，保留这些历时考验的治疗艺术。自我们开业以来，我们始终坚持对真正养生体验的承诺，提供定义我们遗产的个性化关怀。',
            historyDesc3: '在Mahi Beach阿育吠陀海滨度假村，我们迎接来自世界各地的宾客。每位访客都成为我们故事的一部分，在我们的海滨天堂中找到平衡、疗愈和蜕变。',
            statYear: '2025',
            statYearLabel: '建立于',
            statGuest: '世界级',
            statGuestLabel: '欢乐宾客服务数',
            experienceLegacy: '体验我们的愿景',
            established: '建立于',
            since2010: '自2025年起',
            chairmanLabel: '董事长的愿景',
            chairmanTitle: '植根于传统，受健康启发',
            chairmanDesc1: '欢迎来到Mahi Beach阿育吠陀海滨度假村。自2025年以来，我们的愿景是创建一个庇护所，古老的阿育吠陀智慧与现代舒适相融合，一切都包裹在斯里兰卡真诚的热情款待中。',
            chairmanDesc2: '我们度假村的每个方面——从个性化治疗和滋养美食到我们空间的宁静氛围——都经过精心设计，支持您通往健康、平衡和内心平静的道路。陪伴您踏上这段变革之旅是我们的荣幸。',
            chairmanDesc3: '我个人欢迎您来发现和谐、真实和宁静，这些都是Mahi Beach的基石。',
            chairmanSignature: '— Mr. Mahinda',
            chairmanBadge: '董事长',
            chairmanName: 'Mr. Mahinda',
            chairmanImageAlt: '董事长 Mr. Mahinda',
            staffLabel: '我们的团队',
            staffTitle: '认识我们敬业的员工',
            staffDesc1: '在穆图穆尼阿育吠陀海滨度假村，我们的团队是一切工作的核心。我们的员工是精心甄选和培训的专业人士，对阿育吠陀养生和真正的款待怀有深厚的热情。',
            staffDesc2: '从我们经验丰富的阿育吠陀医生和技术精湛的按摩治疗师到我们敬业的款待团队，每位成员都为与每位宾客的互动带来多年的专业知识和真诚的关怀。我们相信真正的养生不仅来自治疗，更来自真正关心您旅程的人的温暖和关注。',
            staffDesc3: '我们的员工接受持续培训，掌握最新的阿育吠陀实践，同时保持专业和文化敏感性的最高标准。我们为与宾客建立有意义的联系而自豪，确保每次访问都成为难忘和蜕变的体验。',
            statStaff: '15+',
            statStaffLabel: '熟练专业人士',
            statSatisfaction: '100%',
            statSatisfactionLabel: '宾客满意度',
            staffImageAlt: '我们在穆图穆尼阿育吠陀海滨度假村的敬业员工团队',
            commitmentBadge: '我们的承诺',
            excellenceCare: '卓越与关怀',
            ctaLabel: '联系我们',
            ctaHeading: '准备好开始您的养生之旅了吗？',
            ctaDesc: '联系我们的团队预订您的个性化阿育吠陀静修。无论您对我们的治疗、住宿或特殊养生套餐有任何疑问，我们都在这里帮助您创建完美的逃脱。',
            ctaButtonContact: '立即联系我们',
            ctaButtonRooms: '探索客房',
            contactUs: '联系我们',
            quickInfoCall: '致电我们',
            quickInfoEmail: '发送邮件',
            quickInfoLocation: '位置',
            locationCity: '贝鲁瓦拉，斯里兰卡'
        },
        rooms: {
            heroTitle: '您的圣殿在等待',
            heroSubtitle: '精心设计的客房，专为治愈、恢复和深度平和而打造。',
            heroAlt: '木木尼阿育吠陀海滩度假村客房',
            exploreRooms: '探索我们的客房',
            filterAll: '全部',
            filterLuxurySuite: '豪华套房',
            filterDeluxeRooms: '豪华客房',
            filterDeluxeSeaView: '豪华海景客房',
            noRoomsFound: '该类别没有找到客房。',
            allRoomsInclude: '所有客房均包括',
            essentialComforts: '您的健康之旅的基本舒适设施',
            roomSize: '客房尺寸',
            guests: '客人',
            amenities: '便利设施',
            roomAmenities: '客房设施',
            specialFeatures: '特殊功能',
            bookNow: '立即预订',
            viewDetails: '查看详情',
            viewFullDetails: '查看完整详情',
            highSpeedWifi: '高速WiFi',
            herbalTea: '草本茶精选',
            climateControl: '气候控制',
            rainShower: '雨淋喷头',
            organicToiletries: '有机洗浴用品',
            dailyHousekeeping: '每日客房打扫',
            concierge: '24/7 礼宾服务',
            yogaMat: '瑜伽垫和配件',
            beginHealing: '开始您的治愈之旅',
            beginHealingDesc: '在一个旨在滋养您的身体、平静您的心灵和恢复您的精神的环境中体验真正的阿育吠陀健康。',
            reserveRoom: '预订客房',
            speakAdvisor: '与健康顾问交谈',
            exploreOurRooms: '探索我们的客房',
            viewRoom: '查看客房',
            luxurySuiteName: '豪华套房',
            luxurySuiteCategory: '豪华套房',
            luxurySuiteDesc: '在我们宽敞的豪华套房中体验终极宁静，采用传统阿育吠陀原则设计，拥有壮观的海景。',
            deluxeRoomName: '豪华客房',
            deluxeRoomCategory: '豪华客房',
            deluxeRoomDesc: '设计简洁的客房，采用天然木质元素和舒缓的水功能，营造完美的宁静。',
            seaViewDeluxeName: '豪华海景客房',
            seaViewDeluxeCategory: '豪华海景客房',
            seaViewDeluxeDesc: '在这间设计优雅的豪华客房中，醒来时吹着宁静的海风和全景海景。',
            kingSizeBed: '特大号床',
            herbalTeaCoffee: '草本茶和咖啡',
            individuallyControlledAC: '独立控制空调',
            premiumOrganicToiletries: '高级有机洗浴用品',
            dailyFreshFlowers: '每日鲜花',
            beachView: '海滩景观',
            signatureAccommodation: '标志性住宿',
            inRoomComfort: '客房舒适设施',
            deluxeRoomAmenities: '豪华客房设施',
            momentsInDeluxeRoom: '豪华客房的时光',
            experienceAyurvedicLiving: '在我们的标志性豪华客房中体验正宗的阿育吠陀生活',
            reserveYourStay: '预订您的住宿',
            deluxeRoom: {
                resortName: 'Mahi Beach Ayurveda Resort',
                heroTitle: '豪华客房配有阳台和海景',
                heroSubtitle: '在受到本托塔金色海滩启发的宁静海滨退居地中放松身心，将现代设施与温和的海风相结合。',
                bookThisRoom: '预订此客房',
                callReservations: '致电预订',
                signatureFeatures: '标志性特点',
                deluxeRoomName: '豪华客房',
                discoverTheSpace: '探索空间',
                whatsIncluded: '包含内容',
                deluxeComfortCare: '豪华舒适与关怀',
                inclusions: '包含服务',
                coreAmenities: '核心设施',
                amenityHighSpeedWifi: '高速Wi-Fi',
                amenityHerbalTeaCoffee: '草本茶和咖啡',
                amenityIndividuallyControlledAC: '独立控制空调',
                amenityRainShower: '雨淋浴',
                amenityOrganicToiletries: '有机洗浴用品',
                amenityDailyFreshFlowers: '每日鲜花',
                beginYourHealingStay: '开始您的疗养之旅',
                experienceAyurvedicSerenity: '在我们的标志性豪华客房中体验正宗的阿育吠陀宁静',
                checkAvailabilityBook: '查看空房并预订',
                speakWithReservations: '与预订部联系',
                reserveThisRoom: '预订此客房',
                navAll: '全部',
                navDeluxe: '豪华',
                navDeluxeSeaView: '豪华海景',
                navSuite: '套房',
                sectionTitle: '宁静的海滨隐藏地',
                sectionDesc: '豪华客房专为慢节奏的早晨和悠闲的日落而打造。柔和的中性色调、宽敞的玻璃和精心的照明将海景引入，而阳台则为您提供了自己的海岸观景台。',
                highlight1Title: '全景海滩景观',
                highlight1Desc: '从您的私人阳台醒来，欣赏蓝色海水和金色日出。',
                highlight2Title: '优雅的海滨内饰',
                highlight2Desc: '柔和的中性调色板、温暖的木材装饰和充足的自然光。',
                highlight3Title: '宁静的睡眠体验',
                highlight3Desc: '毛绒的特大号床和高端床上用品，为您提供恢复性休息。',
                atAGlance: '一览',
                statSize: '面积',
                statSizeValue: '41 平方米',
                statView: '景观',
                statViewValue: '印度洋',
                statGuests: '住客',
                statGuestsValue: '2 位成人',
                statBed: '床型',
                statBedValue: '特大号或双人',
                reserve: '预订',
                galleryAlt: '豪华客房画廊',
                inclusionsTitle: '您的住宿包括',
                inclusionsSubtitle: '体贴的细节，全天舒适',
                enhancedCleanliness: '加强的清洁和安全标准',
                inclusion1: 'Breeze 餐厅免费早餐、午餐、晚餐',
                inclusion2: '高速 Wi-Fi 和房间办公区',
                inclusion3: '24 小时客房服务和礼宾服务',
                inclusion4: '每日客房清洁和晚间整理',
                inclusion5: '使用无边泳池和阿育吠陀spa设施',
                inclusion6: '免费停车和往返附近景点的班车服务',
                amenityGroup1Title: '客房设施',
                amenityGroup1Item1: '41 平方米空间',
                amenityGroup1Item2: '带座位的私人阳台',
                amenityGroup1Item3: '带温度控制的空调',
                amenityGroup1Item4: '房间保险箱',
                amenityGroup2Title: '浴室体验',
                amenityGroup2Item1: '带冷热水的雨淋喷头',
                amenityGroup2Item2: '高端浴室用品',
                amenityGroup2Item3: '电吹风',
                amenityGroup2Item4: '柔软浴袍和拖鞋',
                amenityGroup3Title: '房间舒适',
                amenityGroup3Item1: '55英寸智能电视和有线电视',
                amenityGroup3Item2: '咖啡和茶站',
                amenityGroup3Item3: '直播电话',
                amenityGroup4Title: '连接性',
                amenityGroup4Item1: '免费 Wi-Fi',
                amenityGroup4Item2: '办公桌',
                amenityGroup4Item3: '24/7 前台支持',
                essentialsTitle: '房间必需品',
                essentialsHeading: '让您宾至如归的一切',
                essentialsDesc: '从无缝连接到精心选择的饮料，豪华客房融合了休闲和实用性，让您能够专注于重要的时刻。',
                essential1: '免费 Wi-Fi',
                essential2: '咖啡和茶站',
                essential3: '24/7 客房服务',
                essential4: '雨淋喷头',
                oceanTitle: '海边',
                oceanSubtitle: '放慢脚步，呼吸海洋空气',
                oceanAlt: '豪华客房座位区',
                ctaTitle: '准备好入住了吗？',
                ctaHeading: '今天就预订豪华客房',
                ctaDesc: '与我们的预订团队联系，了解最佳可用价格和特别优惠。',
                checkAvailability: '查询空房'
            }
        },

        navbar: {
            home: '首页',
            aboutUs: '关于我们',
            rooms: '客房',
            ayurveda: '阿育吠陀',
            yoga: '瑜伽',
            food: '美食',
            events: '活动',
            blogs: '博客',
            tours: '旅游',
            contactUs: '联系我们',
            bookOnline: '在线预订',
            locationMaggona: 'Maggona Sri Lanka',
            selectResort: '选择度假村',
            language: '语言',
            mainTitle: 'Mahi Beach Ayurveda Resort',
            resortBeach: 'Mahi Beach Ayurveda Resort',
            resortRiver: 'Mahi Beach Ayurveda Resort'
        },
        footer: {
            description: 'Mahi Beach Ayurveda Resort 致力于提供卓越的待客之道与身心疗愈体验，确保每位宾客都倍感珍视与焕然一新。',
            linksTitle: '链接',
            contactTitle: '联系我们',
            viewLocation: '查看位置',
            navHome: '首页',
            navAbout: '关于我们',
            navContact: '联系我们',
            navRooms: '客房',
            navAyurveda: '阿育吠陀',
            copyright: '© Copyright {{year}} Mahi Beach Ayurveda Resort.',
            developedBy: '开发者',
            developerName: 'Redev Solution +94 764 608 225'
        },
        tours: {
            heroTitle: '旅游与游览',
            heroSubtitle: '从贝鲁沃拉发现斯里兰卡之美',
            kandeAlt: '甘地维哈拉寺庙 - 贝鲁沃拉',
            kandeTitle: '甘地维哈拉寺庙之旅',
            kandeBuddhaAlt: '甘地维哈拉寺庙的巨大佛像',
            bentotaTitle: '本托塔河船游',
            bentotaAlt: '本托塔河船游 - 红树林和野生动物',
            galleTitle: '加勒古城之旅',
            galleAlt: '加勒古城之旅',
            sigiriyaTitle: '狮子岩堡垒之旅',
            sigiriyaAlt: '狮子岩堡垒之旅',
            kandyTitle: '康提文化之旅',
            kandyAlt: '康提文化之旅',
            bookTour: '预订此旅游',
            viewDetails: '查看详情',
            introPara1: '斯里兰卡是一片永恒美丽的土地，黄金海滩、郁郁葱葱的风景、古老的寺庙和充满活力的文化在此完美和谐地汇聚。',
            introPara2: '从宁静的西南海岸到历史悠久的城市、神圣遗址、野生动物保护区和雾蒙蒙的山区，每一次旅程都能为您提供独特而难忘的体验。',
            introPara3: '从位于贝鲁沃拉的穆图穆尼阿育吠陀海滩度假村开始，我们精心策划的旅游和游览是为了丰富您的住宿体验，同时完美平衡了探索、放松和健康。',
            kandeDetail1: '甘地维哈拉寺庙（Kande Viharaya）— 贝鲁沃拉附近最具标志性的佛教寺庙之一。',
            kandeDetail2: '这座宁静的"山寺"建于1734年，坐落在山顶上，可俯瞰宁静的海岸风景。',
            kandeDetail3: '亮点包括48米高的巨大坐佛像（斯里兰卡最高的之一）、复杂的康提时代壁画、古老的舍利室、美丽的月光石入口和一棵树龄超过300年的神圣菩提树。',
            kandeDetail4: '完美的半天精神和文化体验 – 理想的上午参观时间，可避免炎热。',
            bentotaDetail1: '沿本托塔河享受宁静而风景优美的河流游船，这是贝鲁沃拉附近最受欢迎的自然游览之一。',
            bentotaDetail2: '在观察当地野生动物的同时，在郁郁葱葱的红树林、狭窄的运河和宁静的回水中滑行。',
            bentotaDetail3: '常见的观看对象包括水蜥、鳄鱼、各种鸟类（翠鸟、苍鹭、鹰）、猴子，偶尔还能看到水獭或水蛇。',
            bentotaDetail4: '您经验丰富的船夫/导游会为您指出有趣的植被、传统捕鱼方法和河边村庄的生活。',
            bentotaDetail5: '非常适合热爱大自然的人和摄影师 – 宁静、放松，与您的阿育吠陀健康之旅相得益彰。',
            galleDetail1: '探索历史悠久的加勒堡，这是联合国教科文组织世界遗产，也是斯里兰卡保存最完好的殖民地堡垒之一。',
            galleDetail2: '漫步在鹅卵石街道上，两旁是荷兰殖民建筑、精品店、咖啡馆和艺术画廊。',
            galleDetail3: '参观关键地标，如加勒灯塔、荷兰改革教会、国家海事博物馆和提供壮观海景的城堡。',
            galleDetail4: '从您知识渊博的导游那里了解这座堡垒的丰富历史、建筑和文化意义。',
            galleDetail5: '非常适合历史爱好者、文化爱好者以及那些想要体验斯里兰卡殖民地过去的人。',
            sigiriyaDetail1: '探索狮子岩这座古老的岩石堡垒，这是斯里兰卡最具标志性的地标之一，也是联合国教科文组织世界遗产。',
            sigiriyaDetail2: '爬上印象深刻的岩石，探索卡什亚帕国王宫殿的遗迹，这里装饰着壁画、水园和著名的镜墙。',
            sigiriyaDetail3: '从山顶享受周围丛林和乡村的全景。',
            sigiriyaDetail4: '从您的专家导游那里了解与狮子岩相关的迷人历史、建筑和传说。',
            sigiriyaDetail5: '非常适合历史爱好者、冒险寻求者以及对斯里兰卡丰富文化遗产感兴趣的人。',
            kandyDetail1: '体验康提充满活力的文化，这是斯里兰卡最后的皇家首都，也是联合国教科文组织世界遗产。',
            kandyDetail2: '参观神圣牙齿舍利寺（斯里达拉达玛利加瓦），这是世界上最重要的佛教遗址之一。',
            kandyDetail3: '探索佩拉德尼亚皇家植物园，拥有大量的热带植物和兰花集合。',
            kandyDetail4: '欣赏传统的康提舞蹈表演，展示斯里兰卡丰富的艺术遗产。',
            kandyDetail5: '非常适合文化爱好者、历史爱好者以及想要沉浸在斯里兰卡传统中的人。',
            ellaTitle: '埃拉山区冒险',
            ellaAlt: '埃拉山区之旅 - 九拱桥和茶园',
            ellaDetail1: '前往埃拉，这是斯里兰卡最风景如画的山区目的地之一，以壮丽的山景和凉爽的气候而闻名。',
            ellaDetail2: '参观标志性的九拱桥，这是殖民时代的铁路奇迹，坐落在郁郁葱葱的绿色植被中，非常适合摄影和观看火车通过。',
            ellaDetail3: '探索翠绿的茶园，了解锡兰茶的生产，并从小亚当峰或埃拉岩石欣赏全景。',
            ellaDetail4: '发现包括拉瓦纳瀑布在内的瀑布，徒步穿越风景优美的小径，体验迷人的村庄氛围。',
            ellaDetail5: '非常适合自然爱好者、冒险寻求者以及想要逃往斯里兰卡壮丽高地的人。'
        },
        blogs: {
            heroTitle: 'Mahi Beach Ayurveda Resort 博客',
            heroSubtitle1: '来自海岸的故事，阿育吠陀仪式在',
            heroSubtitle2: 'Mahi Beach Ayurveda Resort',
            heroSubtitle3: '。深入了解技巧、历史和幕后笔记。',
            heroAlt: '日落时度假村海滨步道',
            sectionTitle: 'Mahi Beach Ayurveda Resort 博客',
            sectionDescription: '来自我们海岸度假胜地的指南、故事和笔记——涵盖阿育吠陀仪式、宝石传说以及本托塔周边的旅行提示。',
            ayurvedaTitle: '正宗阿育吠陀的核心',
            ayurvedaExcerpt: '体验植根于斯里兰卡古老智慧的悠久疗愈传统。',
            ayurvedaDescription: '在Mahi Beach Ayurveda Resort，阿育吠陀不仅仅是一种治疗——它是一种生活方式。我们的疗法基于几个世纪的知识，根据您的体质进行个性化，并由经验丰富的阿育吠陀医生指导，以实现深刻持久的平衡。',
            ayurvedaAlt: '阿育吠陀疗愈设置，包括草药油和天然元素',
            healingTitle: '个性化疗愈之旅',
            healingExcerpt: '为什么每位客人的健康计划都是独特设计的。',
            healingDescription: '从初步咨询到日常治疗，您的疗愈之旅都经过精心定制。草药疗法、治疗性按摩、瑜伽和冥想共同作用，恢复身体、心灵和精神之间的和谐。',
            healingAlt: '阿育吠陀医生在平静的环境中咨询客人',
            natureTitle: '海洋疗愈',
            natureExcerpt: '海风和热带环境如何增强您的健康。',
            natureDescription: '坐落在斯里兰卡宁静的海岸线上，Mahi Beach提供了自然疗愈的环境。海浪声、清新的海洋空气和茂盛的绿色植物放大了阿育吠陀的效果，创造深度放松和更新。',
            natureAlt: '度假村海滩景色，配有棕榈树和海洋',
            foodTitle: '阿育吠陀美食促进内在平衡',
            foodExcerpt: '精心制作的营养餐食以支持您的疗程。',
            foodDescription: '我们的阿育吠陀美食使用当季、本地采购的食材新鲜制作。每顿餐都与您的体质相一致，支持消化、排毒和整体活力，同时保持美味和令人满意。',
            foodAlt: '传统阿育吠陀餐食盛在天然碗中',
            yogaTitle: '瑜伽、冥想与内心的宁静',
            yogaExcerpt: '平静心灵和强健身体的温和练习。',
            yogaDescription: '每日瑜伽和冥想课程补充您的治疗，提高灵活性、呼吸和心智清晰度。这些正念练习帮助您重新与自己联系，并在您的住宿之后带走一种平和的感觉。',
            yogaAlt: '客人在日出时面向海洋练习瑜伽',
            lifestyleTitle: '将阿育吠陀带回家',
            lifestyleExcerpt: '简单的生活方式实践以继续您的健康之旅。',
            lifestyleDescription: '在您离开之前，我们的专家会指导您通过日常生活习惯、饮食和自我护理仪式保持平衡。带走的不仅仅是回忆——带走通往更健康生活的可持续道路。',
            lifestyleAlt: '客人在度假村宁静的环境中品尝草药茶放松身心',
            readMore: '阅读更多'
        },
        events: {
            heroEyebrow: '体验与活动',
            heroTitle: '我们的活动',
            heroSubtitle: '将斯里兰卡传统与海岸奢华融合的精心体验',
            heroAlt: 'Mahi Beach 活动',
            availableDaily: '每日可参加',
            bookNow: '立即预订',
            highlightsTitle: '亮点',
            detailAlt: '{{title}} 细节',
            ctaTitle: '准备创造回忆了吗？',
            ctaDescription: '联系我们的团队，为您定制在 Mahi Beach Ayurveda Resort 的理想活动体验',
            ctaContact: '联系我们',
            ctaViewRooms: '查看房型',
            buddhistMonkMeditationTitle: '佛教僧侣冥想',
            buddhistMonkMeditationSubtitle: '传统正念练习',
            buddhistMonkMeditationDescription: '在我们宁静的度假村环境中,体验由经验丰富的僧侣带领的正宗佛教冥想。这些古老的练习通过结合传统诵经、呼吸技巧和静默冥想的引导课程,促进内心平静、正念和精神健康。',
            buddhistMonkMeditationHighlight1: '传统佛教冥想课程',
            buddhistMonkMeditationHighlight2: '经验丰富的僧侣指导',
            buddhistMonkMeditationHighlight3: '度假村内宁静环境',
            buddhistMonkMeditationHighlight4: '正念和呼吸技巧',
            buddhistMonkMeditationHighlight5: '精神健康实践',
            cookeryTitle: '烹饪课程',
            cookerySubtitle: '斯里兰卡风味',
            cookeryDescription: '沉浸在充满活力的斯里兰卡美食风味中。我们的专业厨师带领您进行动手烹饪课程，教授代代相传的传统食谱。学习使用新鲜本地食材制作香气四溢的咖喱、hoppers、椰子 sambol 等美食。',
            cookeryHighlight1: '传统斯里兰卡食谱',
            cookeryHighlight2: '动手烹饪体验',
            cookeryHighlight3: '新鲜本地食材',
            cookeryHighlight4: '带回家食谱',
            cookeryHighlight5: '包含香料园参观',
            meditationTitle: '冥想课程',
            meditationSubtitle: '内心平和与正念',
            meditationDescription: '在印度洋宁静的背景下参加我们的冥想课程，寻找内在的宁静。经验丰富的导师引导您进行古老的正念技巧、呼吸练习和瑜伽练习，帮助安抚心灵、焕新精神。',
            meditationHighlight1: '日出与日落课程',
            meditationHighlight2: '海滨冥想',
            meditationHighlight3: '专家指导',
            meditationHighlight4: '呼吸技巧',
            meditationHighlight5: '瑜伽与正念练习',
            nightBeachPartiesTitle: '烧烤之夜',
            nightBeachPartiesSubtitle: '海滨美食体验',
            nightBeachPartiesDescription: '在星空下享受难忘的海滨烧烤之夜。品尝新鲜烤制的海鲜、优质肉类和新鲜蔬菜,聆听舒缓的海浪声。我们的专业厨师将每道菜品烤至完美,在魔幻的海岸环境中打造难忘的用餐体验。',
            nightBeachPartiesHighlight1: '新鲜烤制的海鲜和肉类',
            nightBeachPartiesHighlight2: '厨师现场烧烤演示',
            nightBeachPartiesHighlight3: '面朝大海的用餐氛围',
            nightBeachPartiesHighlight4: '精选烧烤自助餐',
            nightBeachPartiesHighlight5: '配有篝火的海滩氛围',
            bbqTitle: '烧烤派对',
            bbqSubtitle: '海滨庆典',
            bbqDescription: '在海边烧烤派对中度过难忘的夜晚。品尝新鲜烤制的海鲜、优质肉类和素食美味，同时聆听海浪低语。现场音乐、火舞表演与星空共同营造庆祝与交流的完美氛围。',
            bbqHighlight1: '新鲜烤海鲜',
            bbqHighlight2: '海景用餐',
            bbqHighlight3: '现场表演',
            bbqHighlight4: '篝火体验',
            bbqHighlight5: '可定制菜单',
            boatTitle: '乘船之旅',
            boatSubtitle: '河流与海岸探险',
            boatDescription: '沿着本托塔河和海岸水域开启迷人的航行。穿越红树林，观赏珍稀鸟类与野生动物，或享受浪漫的日落巡航。我们的乘船之旅带来欣赏斯里兰卡自然之美和多样生态系统的独特视角。',
            boatHighlight1: '本托塔河巡航',
            boatHighlight2: '红树林探索',
            boatHighlight3: '野生动物观赏',
            boatHighlight4: '日落船游',
            boatHighlight5: '提供私人包船',
            ayurvedaLecturesTitle: '阿育吠陀医生讲座',
            ayurvedaLecturesSubtitle: '古老智慧与现代健康',
            ayurvedaLecturesDescription: '通过认证阿育吠陀医生和从业者的专家讲座，探索阿育吠陀的深奥原则。了解体质平衡、草本疗法、整体疗愈实践，以及古老智慧如何应用于现代健康。我们的互动课程为您揭开阿育吠陀哲学及其日常应用的奥秘。',
            ayurvedaLecturesHighlight1: '认证阿育吠陀医生',
            ayurvedaLecturesHighlight2: '个性化体质分析',
            ayurvedaLecturesHighlight3: '草本疗法知识',
            ayurvedaLecturesHighlight4: '包含问答环节',
            ayurvedaLecturesHighlight5: '可带走的健康指南',
            traditionalClothsTitle: '传统服饰体验活动',
            traditionalClothsSubtitle: '文化遗产体验',
            traditionalClothsDescription: '通过学习穿着和欣赏传统服饰，沉浸在斯里兰卡的文化遗产中。我们的专家造型师指导您穿着正宗的康提纱丽和传统服装，解释每一件服饰的文化意义。非常适合特殊场合、文化体验或留下难忘照片。',
            traditionalClothsHighlight1: '专业造型指导',
            traditionalClothsHighlight2: '正宗传统纱丽',
            traditionalClothsHighlight3: '解释文化意义',
            traditionalClothsHighlight4: '包含专业摄影',
            traditionalClothsHighlight5: '时尚融合工作坊',
            shanthiKarmaTitle: '文化舞蹈',
            shanthiKarmaSubtitle: '斯里兰卡传统表演',
            shanthiKarmaDescription: '沉浸在斯里兰卡文化舞蹈的生动世界中。欣赏令人着迷的传统表演,包括色彩缤纷的服装、有节奏的鼓声和通过动作讲述的古老故事。我们才华横溢的舞者展示数百年历史的民间舞蹈、康提舞和文化仪式,使斯里兰卡遗产栩栩如生。',
            shanthiKarmaHighlight1: '正宗的斯里兰卡传统舞蹈',
            shanthiKarmaHighlight2: '色彩缤纷的传统服装和化妆',
            shanthiKarmaHighlight3: '现场鼓乐伴奏',
            shanthiKarmaHighlight4: '通过动作讲述文化故事',
            shanthiKarmaHighlight5: '康提舞和民间舞表演',
            musicTherapyTitle: '音乐疗法',
            musicTherapySubtitle: '声音治愈',
            musicTherapyDescription: '在我们宁静的海滨环境中体验音乐疗法的变革力量。经验丰富的治疗师使用传统和现代乐器创造治疗性声音体验,促进深度放松、情感释放和整体治愈。',
            musicTherapyHighlight1: '专业指导的治疗课程',
            musicTherapyHighlight2: '传统和现代乐器',
            musicTherapyHighlight3: '放松和情感释放疗法',
            musicTherapyHighlight4: '声音冥想工作坊',
            musicTherapyHighlight5: '身心灵和谐',
            taiChiTitle: '太极',
            taiChiSubtitle: '柔和运动与平衡',
            taiChiDescription: '在我们宁静的海滨花园练习古老的太极艺术。这些优雅流畅的动作可改善平衡、灵活性和内在力量,同时平静心灵。适合所有健康水平和年龄。',
            taiChiHighlight1: '日出时分的每日课程',
            taiChiHighlight2: '认证大师指导',
            taiChiHighlight3: '改善平衡和灵活性',
            taiChiHighlight4: '适合所有年龄',
            taiChiHighlight5: '武术和冥想练习',
        },
        contact: {
            heroTitle: '联系我们',
            heroSubtitle: 'Mahi Beach Ayurveda Resort',
            heroAlt: '联系我们',
            sectionTitle: '欢迎随时联系',
            sectionSubtitle: '我们在此帮助您放松身心',
            sectionDescription: '如需了解阿育吠陀疗程、康养套餐、预订或在贝鲁沃拉（Moragalla）住宿期间的任何问题，请联系 Mahi Beach Ayurveda Resort。',
            callUs: '致电我们',
            emailTitle: '邮箱',
            ourLocation: '我们的地址',
            locationAddress: 'No.112 rendagewatta Galle Rd, Maggona',
            socialNetwork: '社交网络',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: '保持联系',
            getInTouchDescription: '期待您的来信——我们的团队随时为您的康养之旅提供帮助，解答问题并规划焕活之旅。',
            nameLabel: '姓名',
            emailLabel: '邮箱',
            contactNumberLabel: '联系电话',
            messageLabel: '留言',
            sending: '发送中...',
            sendMessage: '发送消息',
            successMessage: '您的消息已成功发送！我们会尽快回复您。',
            errorMessage: '发送时出错，请重试。',
            findUsOnMap: '在地图上找到我们',
            whatsappSubject: 'Mahi Beach Ayurveda Resort 联系',
            whatsappName: '姓名',
            whatsappEmail: '邮箱',
            whatsappContactNumber: '联系电话',
            whatsappMessage: '留言'
        },


        ayurveda: {
            accordionTitle1: '了解五业净化阿育吠陀',
            accordionDesc1: '阿育吠陀（意为“生命科学”）是最古老的整体疗愈体系之一，已有五千多年历史。五业净化强调身心灵与环境的和谐平衡，目标是 укреп健康、预防疾病，并根据个人状况制定疗程。',
            accordionTitle2: '五业净化与生命能量',
            accordionDesc2: '阿育吠陀认为万物相互关联。当身心灵协调一致，健康便自然显现；失衡时则容易出现不适。遗传、创伤、季节变化、年龄与情绪都会影响平衡。\n\n人体由五种元素构成：空间、空气、火、水和土，它们形成三种体质（多沙）：瓦塔（空间/空气）、皮塔（火/水）、卡法（水/土），主导身体功能。\n\n每个人都有独特的体质组合，通常会有一种体质更突出；其平衡决定了健康倾向与易感点。',
            accordionTitle3: '瓦塔体质',
            accordionDesc3: '瓦塔被视为最具影响力的体质，掌管运动、呼吸、循环、心律与排泄。饮食不规律、恐惧、悲伤与熬夜易使其失衡。\n\n瓦塔主导者常思维敏捷、富有创造力，体型偏瘦且怕冷。失衡时可能出现焦虑、躁动或呼吸与关节问题。\n\n通过冥想、按摩、规律作息及温和热食可稳定瓦塔。',
            accordionTitle4: '皮塔体质',
            accordionDesc4: '皮塔掌管消化、代谢与食欲相关激素。辛辣或酸性食物、过度日晒与错过用餐会加剧其失衡。\n\n皮塔主导者多目标明确、自信且具有领导力，体温偏高。失衡时易怒或出现炎症。\n\n清凉轻食与温和瑜伽等舒缓练习可平衡皮塔。',
            accordionTitle5: '卡法体质',
            accordionDesc5: '卡法提供稳定、力量与免疫力。过多甜食、油重饮食及睡眠过量会使其偏重。\n\n卡法主导者通常平和、耐心、体格较壮。失衡时可能疲劳、迟缓或体重上升。\n\n增加清淡饮食、多吃水果蔬菜并保持活动可平衡卡法。',
            close: '关闭',
            next: '下一个',
            previous: '上一个',
            treatmentsTitle: '我们的特色五业净化疗法',
            treatmentsSubtitle: '传承疗程帮助恢复平衡、舒缓紧张，焕新身心。',
            bookTreatment: '预订此疗程',
            benefitsTitle: '五业净化的益处',
            shirodhara: '额头滴油疗法',
            shirodharaDesc: '温热草药油缓缓滴落额头，安抚神经系统。',
            shirodhara1: '缓解压力与焦虑',
            shirodhara2: '帮助更深度睡眠',
            shirodhara3: '提升清晰与专注',
            steamBath: '蒸汽浴',
            steamBathDesc: '草本蒸汽打开毛孔，促进排毒并放松肌肉。',
            steamBath1: '温和排毒出汗',
            steamBath2: '促进血液循环',
            steamBath3: '缓解肌肉紧绷',
            flowerBath: '花瓣浴',
            flowerBathDesc: '芳香花浴让身心放松、重新充电。',
            flowerBath1: '安抚神经系统',
            flowerBath2: '滋养并保湿肌肤',
            flowerBath3: '改善情绪',
            headMassage: '头部按摩',
            headMassageDesc: '头皮按摩帮助释放累积的紧张。',
            headMassage1: '减轻头部压力',
            headMassage2: '滋养头皮与发根',
            headMassage3: '带来深度放松',
            faceMassage: '面部按摩',
            faceMassageDesc: '温和面部按摩，唤醒光泽并减轻压力。',
            faceMassage1: '提亮肤色',
            faceMassage2: '放松面部紧张',
            faceMassage3: '促进淋巴循环',
            neckMassage: '颈部按摩',
            neckMassageDesc: '针对性手法缓解颈部僵硬。',
            neckMassage1: '缓解颈部不适',
            neckMassage2: '提高活动度',
            neckMassage3: '降低压力',
            shoulderMassage: '肩部按摩',
            shoulderMassageDesc: '理疗按摩放松紧绷肩部。',
            shoulderMassage1: '减轻肩部酸痛',
            shoulderMassage2: '改善体态',
            shoulderMassage3: '松解肌肉结节',
            bodyMassage: '全身按摩',
            bodyMassageDesc: '全身疗程，帮助身心放松与恢复。',
            bodyMassage1: '促进循环',
            bodyMassage2: '缓解肌肉酸痛',
            bodyMassage3: '提升整体放松',
            backMassage: '背部按摩',
            backMassageDesc: '背部理疗，释放紧张与疼痛。',
            backMassage1: '缓解背部疼痛',
            backMassage2: '呵护脊柱舒适',
            backMassage3: '降低压力',
            footMassage: '足部按摩',
            footMassageDesc: '足部按摩让全身更放松、扎根。',
            footMassage1: '促进血液循环',
            footMassage2: '缓解足部疲劳',
            footMassage3: '带来宁静',
            purgative: '泻药疗法',
            purgativeDesc: '清理过量皮塔与消化毒素的净化疗法。',
            purgative1: '清洁肠道',
            purgative2: '平衡皮塔体质',
            purgative3: '支持消化功能',
            nasalClearing: '鼻腔清洁',
            nasalClearingDesc: '草本鼻疗清理通道，帮助顺畅呼吸。',
            nasalClearing1: '缓解鼻塞',
            nasalClearing2: '改善呼吸',
            nasalClearing3: '减轻鼻窦压力',
            powderMassage: '粉末按摩',
            powderMassageDesc: '草本粉末去角质，焕活肌肤。',
            powderMassage1: '去除暗沉角质',
            powderMassage2: '改善肌肤质感',
            powderMassage3: '促进循环',
            intensiveMassageDesc: '深层疗程针对顽固紧张与结节。',
            intensiveMassage1: '释放深层肌肉紧绷',
            intensiveMassage2: '改善血流',
            intensiveMassage3: '减轻持续酸痛',
            thermoMassage: '热疗按摩',
            thermoMassageDesc: '热草药油放松组织，促进修复。',
            thermoMassage1: '舒缓酸痛肌肉',
            thermoMassage2: '引导深度放松',
            thermoMassage3: '促进能量流动',
            synchronMassage: '同步按摩',
            synchronMassageDesc: '双人同步按摩带来全身和谐。',
            synchronMassage1: '全身平衡',
            synchronMassage2: '能量流更顺畅',
            synchronMassage3: '深度放松体验',
            specialMassage: '特别按摩',
            specialMassageDesc: '根据个人需求定制的专属疗程。',
            specialMassage1: '个性化定制',
            specialMassage2: '聚焦具体问题',
            specialMassage3: '针对性疗愈',
            benefit1Title: '排毒支持：',
            benefit1Desc: '帮助清除积存毒素，焕发活力。',
            benefit2Title: '消化顺畅：',
            benefit2Desc: '促进消化与营养吸收。',
            benefit3Title: '压力重置：',
            benefit3Desc: '舒缓身心，降低紧张与焦虑。',
            benefit4Title: '免疫韧性：',
            benefit4Desc: '规律疗程增强防护力。',
            benefit5Title: '焕新：',
            benefit5Desc: '支持细胞更新，令肌肤更健康透亮。',
            benefit6Title: '体质平衡：',
            benefit6Desc: '恢复瓦塔、皮塔、卡法的协调，带来持久健康。',
            akkupancharTitle: '穴位疗法',
            akkupancharDesc1: '是一种古老的阿育吠陀疗法，在特定的身体点上使用草药膏和油。这种疗法刺激能量通道并促进愈合。',
            akkupancharBenefit: '主要益处：',
            akkupancharDesc2: '这种专业疗法有助于慢性疼痛，改善关节灵活性，促进血液循环，并恢复自然能量流动。',
            akkupancharApplication: '治疗应用：',
            akkupancharDesc3: '穴位疗法在特定的玛尔玛点上作用，配以精心挑选的草药制剂以平衡体质。',
            akkupancharTransform: '体验转变：',
            akkupancharDesc4: '在穆图穆尼阿育吠陀海滩度假村，我们经验丰富的治疗师根据您的健康需求定制每次疗程。',
            experienceAkkupanchar: '今天体验针疗法',
            doctorsEyebrow: '我们的专家团队',
            doctorsSectionTitle: '我们的医生',
            drSandyaName: 'M. 桑迪亚·门迪斯医生',
            drSandyaProfession: '阿育吠陀医师',
            drSandyaSpecialization: '临床阿育吠陀，个性化治疗规划，酒店阿育吠陀护理',
            drSandyaProfileTitle: '专业简介',
            drSandyaProfile: '富有同情心且敬业的阿育吠陀专业人士，拥有超过25年提供个性化护理和健康解决方案的经验。专长于将传统阿育吠陀原则与现代治疗实践相结合，为豪华健康度假村的客人提供整体疗愈体验。',
            drSandyaWorkExpTitle: '工作经历',
            drSandyaWorkExp1: '首席医师兼项目开发负责人 - 玛希海滩阿育吠陀度假村（2023年至今）',
            drSandyaWorkExp2: '高级阿育吠陀医师 - Sun Aqua Resort and Spa, 马贡纳（2008年至2023年）',
            drSandyaWorkExp3: '阿育吠陀顾问 - Amba Ayurveda Specialty Clinic（2006年至2008年）',
            drSandyaWorkExp4: '阿育吠陀医师及五业净化专家 - Paradise Road The Villa Bentota（2002年至2006年）',
            drSandyaWorkExp5: '阿育吠陀医务人员 - Hotel Blue Water（1996年至2002年）',
            drSandyaEducationTitle: '教育及专业资格',
            drSandyaEdu1: '阿育吠陀文凭 - 政府阿育吠陀学院，博雷拉（1989年至1993年）',
            drSandyaEdu2: '灵气二级 - Reiki Dasa Centre 尼甘布 斯里兰卡（2015年至2016年）',
            drPandukaName: 'Panduka Ranaweera医生',
            drPandukaProfession: '阿育吠陀医师',
            drPandukaQualification: 'B.A.M.S. (阿育吠陀医学与外科学士)',
            drPandukaProfileTitle: '专业简介',
            drPandukaProfile: 'Panduka Ranaweera医生是一位合格且经验丰富的阿育吠陀医师，拥有科伦坡大学阿育吠陀医学与外科学士学位（B.A.M.S.）。他的学术培训牢固地基于经典阿育吠陀原则和全面的临床教育，支持对传统医学采取结构化、道德和循证的方法。',
            drPandukaExpertiseTitle: '专业专长',
            drPandukaExpertise: '除了临床实践外，Ranaweera医生还为客人和健康项目开展专业的阿育吠陀讲座，提供关于阿育吠陀哲学、疾病预防、生活方式管理和传统疗法实际应用的清晰见解。这些课程增强了客人的理解和参与，有助于可持续的健康成果。',
            drPandukaSpecialtyTitle: '综合疗法',
            drPandukaSpecialty: '他的治疗专长还延伸到针灸和音乐疗法，他有选择地整合这些方法来支持疼痛管理、压力减轻、神经平衡和情绪健康。通过将阿育吠陀与这些互补方式相结合，Ranaweera医生提供了真正的综合治疗体验。',
            drPandukaRoleTitle: '追求卓越',
            drPandukaRole: '在酒店的职责中，Ranaweera医生维持高临床标准，同时提供个性化治疗计划和整体健康指导。他专业、冷静和富有同情心的方法确保每位客人获得安全、真实和以结果为导向的护理，旨在实现长期平衡、活力和整体健康。',
            gallery1: '额头滴油疗法',
            gallery2: '蒸汽浴',
            gallery3: '花瓣浴',
            gallery4: '头部按摩',
            gallery5: '全身按摩',
            gallery6: '颈部按摩',
            gallery7: '面部按摩',
            gallery8: '肩部按摩',
            heroTitle: '五业净化阿育吠陀',
            heroSubtitle: '在贝鲁瓦拉焕活身心灵',
            heroTagline: '体验海边的正宗斯里兰卡阿育吠陀疗愈',
            sectionEyebrow: '穆图穆尼阿育吠陀海滩度假村的五业净化阿育吠陀',
            sectionDescription: '在斯里兰卡马戈纳的 Mahi Beach Ayurveda Resort 探索古老的五业净化疗法。我们的阿育吠陀团队提供个性化疗程，帮助净化、修复并协调身心灵。',
            treatmentProgramme: {
                title: '阿育吠陀治疗计划',
                subtitle: '您通往平衡、排毒和深度更新的旅程',
                intro: '在宁静的海岸静修中体验正宗阿育吠陀护理，恢复身体、安定心灵、重焕能量。从抵达起我们会安排好所有细节，让您专注于健康。',
                welcomeTitle: '欢迎与温和开始',
                welcomePoints: [
                    '机场接机并转送至酒店',
                    '热情欢迎和酒店介绍',
                    '介绍您的每周健康计划',
                    '阿育吠陀中心放松按摩（第1天），释放旅途疲劳并让您的身体为治疗做好准备'
                ],
                doctorTitle: '医生咨询与个人计划',
                doctorPoints: [
                    '阿育吠陀医生咨询（第2天 – 上午）',
                    '全面评估您的体质类型和健康问题',
                    '可应要求提供翻译',
                    '您的医生会制定个性化的治疗计划，根据您的需求和目标量身定制'
                ],
                dailyTherapiesTitle: '每日阿育吠陀疗法',
                dailyTherapiesPoints: [
                    '每天4–5次治疗（根据医生建议）',
                    '根据您的体质和状况选择疗法',
                    '必要时可添加特殊按摩',
                    '医生每天监测进展，可能会调整治疗和草药支持以确保最佳效果',
                    '如果合适，可能会推荐温和的清洁/净化过程'
                ],
                herbalMedicineTitle: '草药支持',
                herbalMedicinePoints: [
                    '医生处方的草药每天两次服用：',
                    '早餐时',
                    '晚餐时',
                    '支持内部疗愈、排毒和持久平衡'
                ],
                yogaMeditationTitle: '瑜伽与冥想促进身心和谐',
                yogaMeditationPoints: [
                    '每周4次瑜伽课程（约1小时）',
                    '每周2次冥想课程：',
                    '在岛屿寺庙的独特精神体验，乘船前往',
                    '由僧侣引导的冥想（约1小时）'
                ],
                wellnessTitle: '包含的健康体验',
                wellnessPoints: [
                    '每周健康烹饪示范',
                    '免费短途旅行（文化/自然体验）'
                ],
                closingTitle: '闭幕仪式与离开',
                closingPoints: [
                    '美丽的花浴（最后一天）——传统的更新仪式',
                    '最终医生咨询，审查进展并提供：',
                    '持续的健康指导',
                    '居家处方和建议',
                    '送回机场'
                ]
            },
        },
        food: {
            heroTitle: '阿育吠陀美食与沿海美食',
            heroSubtitle: '正宗斯里兰卡风味和新鲜沿海美食',
            heroAlt: 'Mahi Beach 海滩度假村的烹饪体验',
            wellnessEyebrow: '通过食物实现健康',
            wellnessTitle: '重要性',
            ayurvedicFood: '阿育吠陀食品',
            wellnessIntro1: '在阿育吠陀中，食物被认为是最伟大的药物。你吃的东西直接影响你的多沙（Vata、Pitta、Kapha）、消化（agni）以及身体、心灵和灵魂的整体平衡。',
            wellnessIntro2: '阿育吠陀营养强调用心准备和正念进食的新鲜、季节性全食。它在每餐中促进六种味道（甜、酸、咸、辛辣、苦、涩），以滋养所有感官并保持和谐。',
            wellnessIntro3: '适当的阿育吠陀食物支持强大的消化，有助于清除毒素（ama），增强免疫力，改善能量，减少压力并预防许多慢性疾病。在 Mahi Beach，每道菜都经过精心准备，以符合您独特的体质，为深层治愈和活力。',
            foodImage1Alt: '六种风味的传统阿育吠陀餐',
            foodImage2Alt: '用于均衡营养的阿育吠陀草药和香料',
            culinaryPhilosophyEyebrow: '我们的烹饪哲学',
            culinaryPhilosophyTitle: '阿育吠陀',
            nutritionHighlight: '营养',
            culinaryPhilosophyResort: 'Mahi Beach Ayurveda Resort',
            nutritionTopImageAlt: 'Mahi Beach Ayurveda Resort 的阿育吠陀美食',
            freshNourishingLabel: '新鲜和营养',
            healingIngredientsAlt: '健康的阿育吠陀成分和香料',
            healingIngredientsLabel: '治愈性成分',
            philosophyText1: '食物包括六种主要味道（甜、酸、咸、苦、辛辣和涩）以及许多微妙变化，已在经典阿育吠陀文献中描述——其中一些可以追溯到 5000 多年前——以及每种食物的基本特性：Guna（固有质量）、Virya（效力/加热或冷却）、Vipaka（消化后影响）和 Prabhava（独特的特殊作用）。',
            philosophyText2: '因此，阿育吠陀营养在 Mahi Beach Ayurveda Resort 中扮演核心角色。这并不意味着严格、单调的制度，由医生单独规定的平淡、无味或过度苦涩的素食。相反，我们的阿育吠陀厨房是我们最大的优势之一：由我们的技术高超的厨师准备的菜肴会在您逗留的每一天让您惊喜和高兴！',
            philosophyText3: '在早餐时，享用一份丰盛的自助餐，里面装满新鲜热带水果、新鲜果汁、营养草药汤、自家烤面包和轻饼干，以及多种正宗斯里兰卡早餐选项。在午餐时，享用色彩缤纷、美味的自助餐，配有温和的鱼咖喱、蔬菜准备和草药菜肴。晚上，我们提供固定的素食菜单，可选新鲜鱼。周六，我们庆祝"斯里兰卡之夜"，自助餐扩大——我们的厨师在您面前准备传统当地特色菜，创造充满活力和真实的体验。',
            philosophyText4: '在阿育吠陀中，食物和饮料以多种方式分类——根据味道和特性、身体的消化能力（agni）、对特定健康状况的适用性、季节适宜性等等。在 Mahi Beach，我们同时仔细考虑所有这些因素，有意识地努力将所有六种风味纳入根据每位客人的个人体质量身定制的均衡组合中。',
            philosophyText5: '我们的饭菜采用新鲜蔬菜、热带水果和负责任采购的鱼。我们不提供红肉或酒精。',
            philosophyText6: '用餐时，阿育吠陀医生或合格营养师随时可用来指导您。他们会就您当前治疗阶段最合适的蔬菜、草药和香料提供建议，并帮助您相应地选择或避免菜肴。您的个性化草药灵药和健康中心团队的任何具体说明将放在您的个人桌子上。',
            philosophyText7: '这种水平的个人关怀和对饮食的关注是 Mahi Beach Ayurveda Resort 体验的标志。',
            philosophyText8: '食物被视为 Prana——每个人的生命维持能量。这就是为什么我们鼓励您以充分的意识对待每一顿饭：品尝香气、体验味道、感受温柔的温暖，并有意识地享受迷人的感觉。',
            diningExperienceEyebrow: '用餐体验',
            restaurantTitlePrefix: '我们的',
            ayurvedicHighlight: '阿育吠陀',
            restaurantTitleSuffix: '餐厅',
            restaurantDetail1: 'Mahi Beach 海滩度假村的我们的阿育吠陀餐厅提供独特的用餐体验，融合了传统阿育吠陀原则与正宗斯里兰卡沿海美食。我们优先选择新鲜、本地采购的食材来创作不仅美味可口而且促进整体幸福的餐点。',
            restaurantDetail2: '菜单经过精心设计，以平衡每道菜中的六种味道（甜、酸、咸、苦、辛辣和涩），确保营养和令人满意的体验。每餐都是精心准备的，融入了以其治愈特性而闻名的阿育吠陀草药和香料。',
            restaurantDetail3: '客人可以享用根据其个人多沙（身体体质）量身定制的各种菜肴，并提供素食、纯素和鱼素饮食选项。我们的厨师与阿育吠陀从业者密切合作，确保每顿餐都支持客人的健康和健康目标。',
            restaurantDetail4: '餐厅的氛围反映了宁静的沿海环境，为正念饮食提供了宁静的环境。无论您是享用丰盛的早餐自助餐还是品尝美食晚餐，我们阿育吠陀餐厅的每一餐都是滋养身体和灵魂的机会。',
            restaurantDetail5: '加入我们在 Mahi Beach 海滩度假村的阿育吠陀餐厅的烹饪之旅，庆祝斯里兰卡的丰富风味，同时拥抱阿育吠陀的永恒智慧。',
            restaurantImageAlt: 'Mahi Beach Ayurveda Resort 的晚餐',
            premiumDiningLabel: '高级美食',
            premiumDiningDescription: '在宁静的河边环境中享受正宗的阿育吠陀美食'
        },
        yoga: {
            heroTitle: '度假村瑜伽',
            heroSubtitle: '在贝鲁瓦拉找到平衡、力量与内心平静',
            heroAlt: 'Mahi Beach 海滩度假村的瑜伽',
            importanceEyebrow: '健康与平衡',
            importanceTitle: '瑜伽与冥想的重要性',
            importanceImageAlt: '瑜伽与冥想的重要性',
            importanceText1: '瑜伽与冥想是古老的修习，带来多方面的身心益处。它们提升柔韧性、力量与平衡，同时减轻压力与焦虑。',
            importanceText2: '规律练习可以提升专注力、改善睡眠质量并增强整体幸福感。瑜伽也鼓励正念，帮助人们连接内在自我，在日常的喧嚣中找到平静。',
            importanceText3: '在 Mahi Beach 海滩度假村，我们提供宁静的环境，非常适合练习瑜伽与冥想，让宾客焕新身心灵。',
            practiceEyebrow: '我们的练习',
            practiceTitle: '瑜伽练习与体验',
            practiceImageAlt: '度假村瑜伽练习',
            practiceText1: '在 Mahi Beach Ayurveda Resort，瑜伽主要以传统哈他瑜伽为主，并结合调息法（Pranayama）。这种整体方法旨在唤醒内在觉知并温和地激活昆达里尼（常称为第三眼）。特别强调脊柱的对齐与柔韧性，因为柔软的脊柱被认为有助于减缓衰老——“你的年龄取决于你的脊柱。”',
            practiceText2: '瑜伽课程每周进行四次，适合初学者和有经验的练习者。我们也会不定期引入阿斯汤伽瑜伽等特别课程，让宾客体验多样的体式与练习。我们的阿育吠陀医生鼓励定期参与，以支持并提升整体疗程效果。',
            practiceText3: '所有瑜伽课程都在专属 Yoga Shala 中进行，这是一处安静而宁和的空间，帮助专注、平衡与正念运动。每次课程通常以太阳致敬开始，随后是调息练习与精选体式序列，旨在改善柔韧性、循环与整体健康。',
            practiceText4: '我们的资深瑜伽老师会根据宾客的个人需求、能力与健康状况调整每一节课，确保安全、支持性强且深具益处的瑜伽体验。',
            spiritualEyebrow: '心灵之旅',
            spiritualTitle: '冥想与精神活动',
            spiritualSubtitle: '通过我们的神圣仪式和引导冥想深化你的灵修',
            meditationImageAlt: '度假村的冥想与灵修',
            meditationTitle: '冥想课程',
            meditationDesc: '宾客可参加每周三次的引导冥想课程，灵感源自佛教传统。这些课程旨在安抚心灵、深化觉知并支持情绪与精神疗愈。冥想在宁静的岛上寺庙进行，宾客需乘船前往——这段宁静而意义深远的旅程进一步提升整体冥想体验。'
        },
        home: {
            heroTitle: 'Mahi Beach 阿育吠陀海滩度假村',
            heroSubtitle1: '海洋中的阿育吠陀',
            heroSubtitle2: '在贝鲁瓦拉找到平衡、轻松呼吸并更新您的能量。',
            exploreResort: '探索度假村',
            bookNow: '立即预订',
            welcomeLabel: '欢迎',
            welcomeTitle: 'Mahi Beach 阿育吠陀海滩度假村',
            welcomeDesc1: '坐落在贝鲁瓦拉的原始海岸线上，Mahi Beach 阿育吠陀海滩度假村融合了古老的治愈传统和现代海岸奢华。我们的圣地邀请您开始一段变革式的健康之旅，在这里印度洋的节奏声与阿育吠陀的永恒智慧相遇。',
            welcomeDesc2: '体验个性化的阿育吠陀治疗、享受为平衡您体质而精心制作的营养美食，并在优雅的客房中放松，欣赏壮观的海景。无论您寻求恢复活力、放松还是精神重生，我们敬业的阿育吠陀医生和健康专家团队都会在每一步指导您。',
            learnMore: '了解更多',
            contactUs: '联系我们',
            welcomeImageAlt: 'Mahi Beach 阿育吠陀海滩度假村',
            welcomeImageCaption: '阿育吠陀健康与海滩静修',
            welcomeImageLocation: '斯里兰卡贝鲁瓦拉',
            highlightTitle: '海边的阿育吠陀圣地',
            highlightDesc: '发现斯里兰卡西南海岸的整体治愈。从定制治疗到宁静的阳台和正念美食，每个细节都旨在恢复您的节奏。',
            service1Title: '整体阿育吠陀疗法',
            service1Desc: '个性化咨询、正宗草本油和由经验丰富的阿育吠陀医生指导的日常治疗。',
            service2Title: '海滨客房和套房',
            service2Desc: '在海风中醒来，拥有私人阳台和沉静的内部装饰，为深度休息而设计。',
            service3Title: '养生美食',
            service3Desc: '新鲜的斯里兰卡产品、植物性菜单和个性化的膳食计划，补充您的体质。',
            service4Title: '瑜伽与正念',
            service4Desc: '日出瑜伽、日落冥想和呼吸练习，伴随着波浪的节奏。',
            service5Title: '河流和海岸之旅',
            service5Desc: '本托塔河巡游、海龟孵化场参观、香料园漫步和村庄自行车之旅。',
            roomsTitle: '我们的客房',
            roomsDesc: '选择符合您节奏的圣地，从宽敞的套房到舒适的豪华隐居处，每间都配有柔软的床单、温暖的木材和日出就绪的阳台。',
            roomBadge: '海滨逃亡',
            bookableNow: '现可预订',
            seaBreezeReady: '海风准备就绪',
            viewRoom: '查看客房',
            room1Title: '套房客房',
            room1Desc: '宽敞的套房，配有客厅区、慷慨的阳台和平静的调色板，适合悠闲的早晨。',
            room2Title: '豪华客房',
            room2Desc: '舒适的休闲场所，配备豪华床铺、花园景色和温暖的木制口音，日常简便。',
            room3Title: '豪华海景房',
            room3Desc: '随着海洋地平线醒来，柔软的床单和私人阳台，适合金色日落。',
            achievement1Title: '快乐的客人',
            achievement1Count: '1,000+',
            achievement2Title: '阿育吠陀治疗',
            achievement2Count: '20+',
            achievement3Title: '多年的护理',
            achievement3Count: '15+',
            achievement4Title: '旅行者的赞誉',
            achievement4Count: '1,000+',
            experiencesTitle: '探索 Mahi Beach 阿育吠陀海滩度假村',
            experiencesDesc: '从阿育吠陀之旅到精心策划的游览，选择让您的住宿难忘的体验。',
            planYourStay: '规划您的住宿',
            experience1Title: '客房和套房',
            experience1Desc: '通风的空间，配有阳台、海洋或花园景色，以及周到的舒适，为不匆忙的停留。',
            experience2Title: '阿育吠陀水疗',
            experience2Desc: '道地的疗法、蒸汽浴和恢复性的按摩，采用久经考验的仪式进行。',
            experience3Title: '美食体验',
            experience3Desc: '在我们的餐厅提供营养丰富的斯里兰卡和国际美食，精心准备以滋养身体和心灵。',
            experience4Title: '体验与旅游',
            experience4Desc: '河流狩猎之旅、寺庙参观、水上运动和本托塔周围精心策划的文化游览。',
            galleryTitle: 'Mahi Beach 阿育吠陀海滩度假村的时刻',
            galleryDesc: '一瞥我们的海岸圣地——日出、宁静的治疗、营养美食和为您打造的安静角落。',
            gallery1Alt: '穆图姆尼被棕榈树围绕的阳光沙滩',
            gallery2Alt: '进行中的阿育吠陀油疗',
            gallery3Alt: '配有躺椅的度假村游泳池',
            gallery4Alt: '为水疗准备的草药',
            gallery5Alt: '情侣在海边享受日落',
            gallery6Alt: '面向大海的瑜伽甲板',
            gallery7Alt: '热带花园小径',
            gallery8Alt: '健康早餐',
            gallery9Alt: '宁静的河景',
            gallery10Alt: '日落时的度假村外观光线柔和',
            gallery11Alt: '阿育吠陀草药和油展示',
            gallery12Alt: '花园里舒适的座位',
            resort1Alt: '带有绿色的露天休息室',
            resort2Alt: '舒适的房间内部',
            resort3Alt: '水疗处理空间',
            resort4Alt: '带自然光的餐饮区',
            resort5Alt: '放松的游泳池景色',
            sunsetLabel: '大自然的日常杰作',
            sunsetTitle: '晚间日落',
            sunsetDesc1: '看着白天优雅地进入黄昏，天空变成琥珀、深红和金色的画布。温柔的印度洋反映了这个天体景象，创造出光和水的迷人交响曲。',
            sunsetDesc2: '每个晚上穆图姆尼都为大自然最壮观的表演之一提供了前排座位。找到您完美的有利位置——无论是从您的私人阳台、海滨酒廊还是我们的日落冥想平台——让宁静的美丽淹没您。',
            sunsetFeature1: '从每个角落看到不受阻碍的海洋景色',
            sunsetFeature2: '日落宁静冥想',
            sunsetFeature3: '每天提供免费草本茶',
            sunsetFeature4: '每个晚上的照相时刻',
            sunsetImageAlt: 'Mahi Beach 海滩度假村的晚间日落',
            bestTime: '最佳时间',
            sunsetTime: '下午 6:00 - 6:45',
            poolLabel: '水生宁静',
            poolTitle: '游泳池区域',
            poolDesc1: '沉浸在我们原始无边界泳池的宁静中，结晶水与郁郁葱葱的热带花园相遇。为放松和恢复活力而设计，我们的泳池区提供了在斯里兰卡阳光下放松的完美度假。',
            poolDesc2: '无论您喜欢清爽的晨泳、带着好书的下午放松还是宁静的晚间浸浴，我们的泳池区都提供了一个田园般的环境。周围是舒适的躺椅、遮荫小屋和贴心的泳池服务，每一刻都成为珍贵的回忆。',
            poolFeature1: '温度控制的无边界游泳池',
            poolFeature2: '被热带花园景观包围',
            poolFeature3: '泳池边的清爽饮品和健康小食',
            poolFeature4: '带遮阳伞的高级躺椅',
            poolImageAlt: 'Mahi Beach 度假村令人放松的泳池区域',

            // 客人离别仪式
            departureLabel: '告别传统',
            departureTitle: '客人离别仪式',
            departureDesc1: '在 Mahi Beach 阿育吠陀度假村，我们通过一个有意义的离别仪式来纪念您与我们的旅程，这一仪式扎根于斯里兰卡传统。当您准备离开时，我们的团队聚集在一起，为您的安全旅行和持续健康提供祝福。',
            departureDesc2: '这一真诚的仪式包括传统祝福、一份特别的告别菜单，提供正宗的斯里兰卡美食，以及一份小礼物，让您带走我们的温暖。这是我们确保您对 Mahi Beach 的记忆在您离开后长久珍藏的方式。',
            departureFeature1: '传统佛教祝福，祝您旅途平安',
            departureFeature2: '个性化的告别礼物和纪念品',
            departureFeature3: '特别离别菜单，配有斯里兰卡美食',
            departureFeature4: '带有神圣仪式的祝福仪式',
            departureImageAlt: 'Mahi Beach 度假村的客人离别仪式',

            // TripAdvisor
            tripadvisorLabel: 'TripAdvisor',
            tripadvisorTitle: '客人评论',

            testimonialsTitle: '客人在他们的住宿期间',
            testimonialsLabel: '客人故事',

            // Video Section
            videoLabel: '沉浸式体验',
            videoTitle: '发现 Mahi Beach',
            videoDescription: '通过我们的沉浸式视频之旅，体验 Mahi Beach 阿伊吉顾度假村的美丽与宁静。探索世界级设施、原始海滩和恢复活力的健康体验。',

            // Featured Room
            featuredRoomLabel: '特色住宿',
            featuredRoomTitle: '豪华海景双人房',

            // Booking Bar
            bookingResort: '度假村',
            bookingResortName: 'Mahi Beach Ayurveda Resort',
            bookingCheckIn: '入住',
            bookingCheckOut: '退房',
            bookingGuests: '客人',
            booking1Guest: '1 位客人',
            booking2Guests: '2 位客人',
            booking3Guests: '3 位客人',
            bookingCheckAvailability: '查看空房',

            // Hero Buttons
            heroExploreButton: '探索 Mahi Beach',
            heroBookButton: '预订豪华房'
        },
    },
    ja: {
        about: {
            heroTitle: '私たちについて',
            heroSubtitle: 'Mahi Beach アーユルヴェーダ',
            heroBeachResort: 'Beach Resort',
            heroTagline1: '古来の知恵が現代ウェルネスと出会うムトゥムニアーユルヴェーダビーチリゾート',
            heroTagline2: 'パーソナライズされたアーユルヴェーダトリートメント、海の眺め、本物のスリランカのおもてなし',
            heroDescription: '私たちの特徴的なデラックスルームで本格的なアーユルヴェーダウェルネスを体験してください。海の安らぎと永遠の癒しが出会う場所です。',
            bookDeluxeRoom: 'デラックスルームを予約',
            bookDeluxeRoomShort: 'デラックスルーム予約',
            slide1: 'デラックスセレニティ',
            slide2: 'アーユルヴェーダハーモニー',
            slide3: 'ビーチフロントラグジュアリー',
            slide4: '自然のエレガンス',
            slide5: '癒しの逃避',
            historyLabel: '私たちの歩み',
            historyTitle: 'Mahi Beachアーユルヴェーダリゾートの歴史',
            historyDesc1: '2025年に設立されたMahi Beachアーユルヴェーダリゾートは、古代アーユルヴェーダの知恵がスリランカ南部海岸の静かな美しさと出会う聖地を作るという構想から生まれました。私たちはベルワラで全体的な癒しと若返りのための最も愛される目的地の一つを作りました。',
            historyDesc2: '伝統的なアーユルヴェーダ実践者の数世代に触発された私たちの創設者は、現代的な快適さと本物のスリランカのおもてなしを提供しながら、これらの時間がたった治療法を保存することを目指していました。私たちの開業以来、本物のウェルネス体験へのコミットメントを堅守し、私たちの遺産を定義するパーソナライズされたケアを提供しています。',
            historyDesc3: 'Mahi Beachアーユルヴェーダリゾートでは、世界中からゲストを迎えています。各訪問者は私たちの物語の一部となり、私たちのビーチサイドの避難所でバランス、癒し、変容を見出します。',
            statYear: '2025',
            statYearLabel: '設立',
            statGuest: '世界クラス',
            statGuestLabel: '幸せなゲスト数',
            experienceLegacy: '私たちのビジョンを体験',
            established: '設立',
            since2010: '2025年以来',
            chairmanLabel: '会長のビジョン',
            chairmanTitle: '伝統に根ざし、ウェルネスに触発されて',
            chairmanDesc1: 'Mahi Beachアーユルヴェーダリゾートへようこそ。2025年以来の私たちのビジョンは、古代アーユルヴェーダの知恵が現代的な快適さと出会う聖域を作ることです。すべてがスリランカの心からのおもてなしの温かさに包まれています。',
            chairmanDesc2: '私たちのリゾートのあらゆる側面——パーソナライズされたトリートメントと滋養のある料理から、私たちの空間の穏やかな雰囲気まで——は、ウェルネス、バランス、内なる平和への道をサポートするために丁寧に作られています。この変容の旅にあなたをお連れすることは私たちの特権です。',
            chairmanDesc3: '私は個人的に、Mahi Beachの基盤である調和、真正性、静けさを発見していただくことを歓迎いたします。',
            chairmanSignature: '— Mr. Mahinda',
            chairmanBadge: '会長',
            chairmanName: 'Mr. Mahinda',
            chairmanImageAlt: '会長 Mr. Mahinda',
            staffLabel: '私たちのチーム',
            staffTitle: '献身的なスタッフに会う',
            staffDesc1: 'ムトゥムニアーユルヴェーダビーチリゾートでは、私たちのチームは機能するすべての中心です。スタッフメンバーは、アーユルヴェーダウェルネスと本物のおもてなしに対する深い情熱を共有する、慧眼に選ばれ、訓練を受けた専門家です。',
            staffDesc2: '経験豊かなアーユルヴェーダ医師と熟練したマッサージセラピスト、献身的なおもてなしチームまで、各メンバーはすべてのゲストとのインタラクションに多年の専門知識と本当のケアをもたらします。真のウェルネスはトリートメントだけからは来るのではなく、あなたの旅について本当に気にかけている人々の温かさと注意から生まれると信じています。',
            staffDesc3: 'スタッフはアーユルヴェーダの最新実践における継続的なトレーニングを受け、専門性と文化的感受性の最高水準を保ちます。ゲストと意味のある関係を作ることに誇りを持ち、すべての訪問が思い出に残る変容的な経験となるようにしています。',
            statStaff: '15+',
            statStaffLabel: '熟練した専門家',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'ゲスト満足度',
            staffImageAlt: 'ムトゥムニアーユルヴェーダビーチリゾートの献身的なスタッフチーム',
            commitmentBadge: '私たちのコミットメント',
            excellenceCare: '卓越とケア',
            ctaLabel: 'お問い合わせ',
            ctaHeading: 'ウェルネスジャーニーを始める準備はできていますか？',
            ctaDesc: 'パーソナライズされたアーユルヴェーダリトリートを予約するために、私たちのチームにお問い合わせください。治療、宿泊施設、または特別なウェルネスパッケージについてご質問がある場合、私たちはあなたの完璧な逃げを作成するお手伝いをする準備ができています。',
            ctaButtonContact: '今すぐお問い合わせ',
            ctaButtonRooms: 'ルームを探索',
            contactUs: 'お問い合わせ',
            quickInfoCall: 'お電話ください',
            quickInfoEmail: 'メールをお送りください',
            quickInfoLocation: '場所',
            locationCity: 'ベルワラ、スリランカ'
        },
        rooms: {
            heroTitle: 'あなたの休魂地があなたを待っています',
            heroSubtitle: '癒し、回復、深い平和のために細心に設計された客室。',
            heroAlt: 'ムトゥムニアーユルヴェーダビーチリゾートの客室',
            exploreRooms: '私たちの客室を探索',
            filterAll: 'すべて',
            filterLuxurySuite: 'ラグジュアリースイート',
            filterDeluxeRooms: 'デラックスルーム',
            filterDeluxeSeaView: 'デラックスシービュールーム',
            noRoomsFound: 'このカテゴリで客室が見つかりません。',
            allRoomsInclude: 'すべての客室に含まれます',
            essentialComforts: 'あなたのウェルネスジャーニーのための本質的な快適さ',
            roomSize: '客室サイズ',
            guests: 'ゲスト',
            amenities: '設備',
            roomAmenities: 'ルームアメニティ',
            specialFeatures: '特殊機能',
            bookNow: '今すぐ予約',
            viewDetails: '詳細を表示',
            viewFullDetails: '全ての詳細を表示',
            highSpeedWifi: '高速WiFi',
            herbalTea: 'ハーブティーセレクション',
            climateControl: '気候制御',
            rainShower: 'レインシャワー',
            organicToiletries: 'オーガニック化粧品',
            dailyHousekeeping: '毎日のハウスキーピング',
            concierge: '24/7 コンシェルジュ',
            yogaMat: 'ヨガマットと小道具',
            beginHealing: 'あなたの癒しの旅を始めましょう',
            beginHealingDesc: '体を栄養、心を落ち着かせ、精神を回復させるために設計された環境で本物のアーユルヴェーダウェルネスを体験してください。',
            reserveRoom: '客室を予約',
            speakAdvisor: 'ウェルネスアドバイザーと相談',
            exploreOurRooms: '私たちの客室を探索',
            viewRoom: '客室を表示',
            luxurySuiteName: 'ラグジュアリースイート',
            luxurySuiteCategory: 'ラグジュアリースイート',
            luxurySuiteDesc: '伝統的なアーユルヴェーダの原則に従って設計された広々としたラグジュアリースイートで究極の静寂を体験してください。',
            deluxeRoomName: 'デラックスルーム',
            deluxeRoomCategory: 'デラックスルーム',
            deluxeRoomDesc: '調和のとれた設計の客室で、天然木の要素と落ち着いた水の特徴が完璧な静寂をもたらします。',
            seaViewDeluxeName: 'シービュー付きデラックス',
            seaViewDeluxeCategory: 'デラックスシービューム',
            seaViewDeluxeDesc: 'この優雅に設計されたデラックスルームで、落ち着いた海風と海の全景で目覚めてください。',
            kingSizeBed: 'キングサイズベッド',
            herbalTeaCoffee: 'ハーブティー＆コーヒー',
            individuallyControlledAC: '個別制御エアコン',
            premiumOrganicToiletries: 'プレミアムオーガニックアメニティ',
            dailyFreshFlowers: '毎日の新鮮な花',
            beachView: 'ビーチビュー',
            signatureAccommodation: 'シグネチャー宿泊施設',
            inRoomComfort: '客室内の快適さ',
            deluxeRoomAmenities: 'デラックスルームアメニティ',
            momentsInDeluxeRoom: 'デラックスルームでの時間',
            experienceAyurvedicLiving: '当館のシグネチャーデラックスルームで本格的なアーユルヴェーダライフを体験',
            reserveYourStay: 'ご宿泊の予約',
            deluxeRoom: {
                resortName: 'Mahi Beach Ayurveda Resort',
                heroTitle: 'デラックスルーム バルコニーとオーシャンビュー付き',
                heroSubtitle: 'ベントタの金色のビーチに動かされた落ち着いた海岸の隠れ家でくつろぎ、現代的な設備と穏やかな海風を組み合わせます。',
                bookThisRoom: 'この部屋を予約',
                callReservations: '予約に電話',
                navAll: 'すべて',
                navDeluxe: 'デラックス',
                navDeluxeSeaView: 'デラックスシービュー',
                navSuite: 'スイート',
                sectionTitle: '穏やかな海岸の隠れ家',
                sectionDesc: 'デラックスルームは、スローな朝と急がない夕日のために作られています。柔らかい中性のトーン、寛大なガラス張り、思慮深い照明が海の景色を招き入れ、バルコニーは海岸線の上にあなた自身の止まり木を提供します。',
                highlight1Title: 'パノラマビーチビュー',
                highlight1Desc: 'プライベートバルコニーから、碧い海と金色の日の出で目覚めてください。',
                highlight2Title: 'エレガントな海岸のインテリア',
                highlight2Desc: '柔らかいニュートラルパレット、温かい木質のアクセント、豊富な自然光。',
                highlight3Title: '静謐な睡眠体験',
                highlight3Desc: '回復的な休息のために厳選されたプレミアムリネン付きのプラッシュキングベッド。',
                atAGlance: '一目で',
                statSize: 'サイズ',
                statSizeValue: '41 平方メートル',
                statView: '景観',
                statViewValue: 'インド洋',
                statGuests: '客人',
                statGuestsValue: '2 人の大人',
                statBed: 'ベッド',
                statBedValue: 'キングまたはツイン',
                reserve: '予約',
                galleryAlt: 'デラックスルームギャラリー',
                inclusionsTitle: '滋在中に含まれるもの',
                inclusionsSubtitle: '思いやりのあるタッチ、一日中の快適さ',
                enhancedCleanliness: '強化された清潔さと安全基準',
                inclusion1: 'Breeze レストランでの無料朝食、昨食、夕食',
                inclusion2: '高速 Wi-Fi と室内ワークスペース',
                inclusion3: '24 時間ルームサービスとコンシェルジュ',
                inclusion4: '毎日のハウスキーピングと夕方のターンダウン',
                inclusion5: 'インフィニティプールとアーユルヴェーダスパ施設へのアクセス',
                inclusion6: '無料駐車場と近くのアトラクションへのシャトルサービス',
                amenityGroup1Title: '客室機能',
                amenityGroup1Item1: '41 平方メートルのスペース',
                amenityGroup1Item2: '座席付きプライベートバルコニー',
                amenityGroup1Item3: '気候制御付きエアコン',
                amenityGroup1Item4: '室内セーフ',
                amenityGroup2Title: 'バス体験',
                amenityGroup2Item1: '冷温水付きレインシャワー',
                amenityGroup2Item2: 'プレミアムバスアメニティ',
                amenityGroup2Item3: 'ヘアドライヤー',
                amenityGroup2Item4: '柔らかいバスローブとスリッパ',
                amenityGroup3Title: '室内快適',
                amenityGroup3Item1: '55インチスマート TV とケーブル',
                amenityGroup3Item2: 'コーヒーと紅茶ステーション',
                amenityGroup3Item3: 'ダイレクトダイヤル電話',
                amenityGroup4Title: '接続性',
                amenityGroup4Item1: '無料 Wi-Fi',
                amenityGroup4Item2: 'ワークデスク',
                amenityGroup4Item3: '24/7 フロントデスクサポート',
                essentialsTitle: '室内必需品',
                essentialsHeading: '家にいるように感じるために必要なすべて',
                essentialsDesc: 'シームレスな接続から注意深く選ばれた飲み物まで、デラックスルームはレジャーと実用性を融合させ、大切な瞬間に集中できるようにします。',
                essential1: '無料 Wi-Fi',
                essential2: 'コーヒーと紅茶ステーション',
                essential3: '24/7 ルームサービス',
                essential4: 'レインシャワー',
                oceanTitle: '海のそば',
                oceanSubtitle: 'ペースを落とし、海の空気を呼吸',
                oceanAlt: 'デラックスルーム座席エリア',
                ctaTitle: '滋在準備はいいですか？',
                ctaHeading: '今日デラックスルームを予約',
                ctaDesc: '最高の利用可能料金と特別オファーについては、予約チームにお問い合わせください。',
                checkAvailability: '空室状況を確認'
            }
        },

        navbar: {
            home: 'ホーム',
            aboutUs: '私たちについて',
            rooms: '客室',
            ayurveda: 'アーユルヴェーダ',
            yoga: 'ヨガ',
            food: 'お食事',
            events: 'イベント',
            blogs: 'ブログ',
            tours: 'ツアー',
            contactUs: 'お問い合わせ',
            bookOnline: 'オンライン予約',
            locationMaggona: 'Maggona Sri Lanka',
            selectResort: 'リゾートを選択',
            language: '言語',
            mainTitle: 'Mahi Beach Ayurveda Resort',
            resortBeach: 'Mahi Beach Ayurveda Resort',
            resortRiver: 'Mahi Beach Ayurveda Resort'
        },
        footer: {
            description: 'Mahi Beach Ayurveda Resort は、卓越したおもてなしとウェルネス体験を提供し、すべてのゲストが大切にされリフレッシュできるよう努めています。',
            linksTitle: 'リンク',
            contactTitle: 'お問い合わせ',
            viewLocation: '場所を見る',
            navHome: 'ホーム',
            navAbout: '私たちについて',
            navContact: 'お問い合わせ',
            navRooms: '客室',
            navAyurveda: 'アーユルヴェーダ',
            copyright: '© Copyright {{year}} Mahi Beach Ayurveda Resort.',
            developedBy: '開発',
            developerName: 'Redev Solution +94 764 608 225'
        },
        tours: {
            heroTitle: 'ツアーと遠足',
            heroSubtitle: 'ベルワラからスリランカの美しさを発見',
            kandeAlt: 'カンデ・ヴィハーラ寺院 - ベルワラ',
            kandeTitle: 'カンデ・ヴィハーラ寺院訪問',
            kandeBuddhaAlt: 'カンデ・ヴィハーラ寺院の巨大仏像',
            bentotaTitle: 'ベントタ川ボートサファリ',
            bentotaAlt: 'ベントタ川ボートサファリ - マングローブと野生動物',
            galleTitle: 'ガーレ旧市街ツアー',
            galleAlt: 'ガーレ旧市街ツアー',
            sigiriyaTitle: 'シギリヤ岩石要塞ツアー',
            sigiriyaAlt: 'シギリヤ岩石要塞ツアー',
            kandyTitle: 'キャンディ文化ツアー',
            kandyAlt: 'キャンディ文化ツアー',
            bookTour: 'このツアーを予約',
            viewDetails: '詳細を表示',
            introPara1: 'スリランカは時間を超えた美しさの地であり、黄金のビーチ、生い茂る緑の風景、古代の寺院、そして活気に満ちた文化が完璧な調和で集まっています。',
            introPara2: '静かな南西海岸から歴史的な都市、神聖な遺跡、野生動物保護区、霧がかかる丘陵地帯まで、すべての旅はユニークで忘れられない経験を提供します。',
            introPara3: 'ベルワラのムツムニ・アーユルヴェーダ・ビーチリゾートから始まり、私たちの厳選されたツアーと遠足はあなたの滞在を豊かにするために設計されており、探索、リラックス、ウェルネスのバランスを完璧に保っています。',
            kandeDetail1: 'カンデ・ヴィハーラ寺院（Kande Viharaya）— ベルワラ近郊の最も象徴的な仏教寺院の一つです。',
            kandeDetail2: '1734年に創建されたこの穏やかな「山の寺院」は丘の上に位置し、海岸線の穏やかな眺めを提供しています。',
            kandeDetail3: 'ハイライトには、48メートル（160フィート）の大きな座像の仏像（スリランカ最高のもの）、複雑なカンディアン時代のフレスコ画、古代の遺物室、美しい月石の入口、そして300年以上前の神聖なボディの木が含まれます。',
            kandeDetail4: '完璧な半日の精神的で文化的な経験 – 暑さを避けるための朝の訪問に最適です。',
            bentotaDetail1: 'ベントタ川に沿った平和で風景の美しいボートサファリをお楽しみください。これはベルワラ近郊で最も人気のある自然遠足の一つです。',
            bentotaDetail2: '地元の野生動物を観察しながら、豊かなマングローブ、狭い運河、静かなバックウォーターを滑空します。',
            bentotaDetail3: '一般的な目撃対象には、オオトカゲ、ワニ、様々な鳥の種（カワセミ、サギ、ワシ）、猿、そして時々カワウソや水ヘビが含まれます。',
            bentotaDetail4: '経験豊かなボート操縦者/ガイドが、興味深い植物、伝統的な漁法、河辺の村の生活を指摘してくれます。',
            bentotaDetail5: '自然愛好家と写真家に最適 – 穏やか、リラックス、そしてあなたのアーユルヴェーダウェルネス滞在を補完します。',
            galleDetail1: 'ユネスコ世界遺産であり、スリランカで最も保存状態の良い植民地時代の砦の一つであるガーレ砦の歴史を探索します。',
            galleDetail2: '石畳の通りを歩きながら、オランダの植民地建築、ブティック、カフェ、アートギャラリーに囲まれています。',
            galleDetail3: 'ガーレ灯台、オランダ改革派教会、国立海事博物館、素晴らしい海の眺めを提供する城壁などの主要な名所を訪問します。',
            galleDetail4: 'あなたの知識豊かなガイドから、砦の豊かな歴史、建築、文化的重要性について学びます。',
            galleDetail5: '歴史愛好家、文化愛好家、そしてスリランカの植民地時代の過去を体験したい人に最適です。',
            sigiriyaDetail1: 'スリランカで最も象徴的なランドマークの一つであり、ユネスコ世界遺産でもあるシギリヤ古代岩石要塞を発見します。',
            sigiriyaDetail2: '印象的な岩を登ったり、カシャッパ王宮殿の遺跡を探索したり、フレスコ画、庭園、有名なミラーウォールで装飾されています。',
            sigiriyaDetail3: '山頂から周囲のジャングルと田舎のパノラマビューをお楽しみください。',
            sigiriyaDetail4: 'あなたの専門ガイドからシギリヤに関連する魅力的な歴史、建築、伝説について学びます。',
            sigiriyaDetail5: '歴史愛好家、冒険家、そしてスリランカの豊かな文化遺産に興味のある人に最適です。',
            kandyDetail1: 'スリランカの最後の王都であり、ユネスコ世界遺産でもあるキャンディの活気に満ちた文化を体験します。',
            kandyDetail2: '聖歯舎利寺院（スリダラダ・マリガワ）を訪問してください。これは世界で最も重要な仏教遺跡の一つです。',
            kandyDetail3: 'ペラデニヤの王立植物園を探索し、膨大な熱帯植物やランの収集があります。',
            kandyDetail4: 'スリランカの豊かな芸術遺産を披露する伝統的なカンディアンダンスパフォーマンスをお楽しみください。',
            kandyDetail5: '文化愛好家、歴史愛好家、そしてスリランカの伝統に没頭したい人に最適です。',
            ellaTitle: 'エラ高地冒険',
            ellaAlt: 'エラ高地ツアー - ナインアーチブリッジと茶園',
            ellaDetail1: '素晴らしい山の景色と涼しい気候で有名なスリランカで最も絵のように美しい高地の目的地の一つであるエラへの旅。',
            ellaDetail2: '象徴的なナインアーチブリッジを訪問します。これは植民地時代の鉄道の驚異で、豊かな緑の中に設置されており、写真撮影や列車の通過を見るのに最適です。',
            ellaDetail3: '緑豊かな茶園を探索し、セイロン茶の生産について学び、リトルアダムスピークまたはエラロックからのパノラマビューをお楽しみください。',
            ellaDetail4: 'ラヴァナ滝を含む滝を発見し、景色の良いトレイルをハイキングし、魅力的な村の雰囲気を体験してください。',
            ellaDetail5: '自然愛好家、冒険家、そしてスリランカの息をのむような高地に逃げたい人に最適です。'
        },
        blogs: {
            heroTitle: 'Mahi Beach Ayurveda Resort ブログ',
            heroSubtitle1: '海岸からの物語、アーユルヴェーダの儀式',
            heroSubtitle2: 'Mahi Beach Ayurveda Resort',
            heroSubtitle3: '。ヒント、歴史、舞台裏の記録をご覧ください。',
            heroAlt: '夕日のリゾートビーチフロント散歩道',
            sectionTitle: 'Mahi Beach Ayurveda Resort ブログ',
            sectionDescription: '私たちの海岸リトリートからのガイド、物語、記録 — アーユルヴェーダの儀式、宝石の伝承、ベントタ周辺の旅行のヒントまで。',
            ayurvedaTitle: '本格的なアーユルヴェーダの心',
            ayurvedaExcerpt: 'スリランカの古代の知恵に根ざした歴史ある治癒の伝統を体験してください。',
            ayurvedaDescription: 'Mahi Beach Ayurveda Resortでは、アーユルヴェーダは単なる治療以上のものです — それは生き方です。私たちの治療法は何世紀にもわたる知識に基づいており、あなたの体質に合わせて個別化され、経験豊富なアーユルヴェーダ医師によって深い持続的なバランスのために指導されています。',
            ayurvedaAlt: 'ハーブオイルと天然要素を使ったアーユルヴェーダトリートメントセットアップ',
            healingTitle: 'パーソナライズされた癒しの旅',
            healingExcerpt: 'なぜすべてのゲストのウェルネスプログラムがユニークに設計されているのか。',
            healingDescription: '初回の相談から毎日の治療まで、あなたの癒しの旅は慎重に調整されています。ハーブ療法、治療的マッサージ、ヨガ、瞑想が協力して、身体、心、精神の調和を回復します。',
            healingAlt: '穏やかな環境でゲストに相談するアーユルヴェーダ医師',
            natureTitle: '海での癒し',
            natureExcerpt: '海風と熱帯の環境がウェルネスを高める方法。',
            natureDescription: 'スリランカの静かな海岸線に位置するMahi Beachは、自然に癒される環境を提供します。波の音、新鮮な海の空気、豊かな緑がアーユルヴェーダの効果を増幅し、深いリラクゼーションと再生を生み出します。',
            natureAlt: 'ヤシの木と海のあるリゾートのビーチフロントビュー',
            foodTitle: '内なるバランスのためのアーユルヴェーダ料理',
            foodExcerpt: 'あなたの治療をサポートするために作られた栄養価の高い食事。',
            foodDescription: '私たちのアーユルヴェーダ料理は、季節の地元産の食材を使って新鮮に調理されています。各食事はあなたのドーシャに合わせて、消化、デトックス、全体的な活力をサポートしながら、風味豊かで満足感のあるものです。',
            foodAlt: '天然のボウルに提供された伝統的なアーユルヴェーダ料理',
            yogaTitle: 'ヨガ、瞑想と内なる静けさ',
            yogaExcerpt: '心を落ち着かせ、身体を強化する穏やかな実践。',
            yogaDescription: '毎日のヨガと瞑想セッションは治療を補完し、柔軟性、呼吸、精神の明晰さを向上させます。これらのマインドフルな実践は、自分自身と再びつながり、滞在を超えて平和の感覚を持ち続けるのに役立ちます。',
            yogaAlt: '日の出時に海に面してヨガを練習するゲスト',
            lifestyleTitle: 'アーユルヴェーダを家に持ち帰る',
            lifestyleExcerpt: 'ウェルネスの旅を続けるためのシンプルなライフスタイルの実践。',
            lifestyleDescription: '出発前に、私たちの専門家が、日常のルーチン、食事、セルフケアの儀式を通じてバランスを維持する方法をご案内します。思い出以上のものを持ち帰ってください — より健康的な生活への持続可能な道を持ち帰ってください。',
            lifestyleAlt: 'リゾートの穏やかな環境でハーブティーを飲みながらリラックスするゲスト',
            readMore: 'もっと読む'
        },
        events: {
            heroEyebrow: '体験とアクティビティ',
            heroTitle: 'イベント',
            heroSubtitle: 'スリランカの伝統と海辺のラグジュアリーが融合した厳選体験',
            heroAlt: 'Mahi Beachのイベント',
            availableDaily: '毎日開催',
            bookNow: '今すぐ予約',
            highlightsTitle: 'ハイライト',
            detailAlt: '{{title}}の詳細',
            ctaTitle: '思い出作りの準備はできましたか？',
            ctaDescription: 'Mahi Beach Ayurveda Resortで理想のイベント体験をカスタマイズするため、私たちのチームにご相談ください',
            ctaContact: 'お問い合わせ',
            ctaViewRooms: '客室を見る',
            buddhistMonkMeditationTitle: '仏教僧による瞑想',
            buddhistMonkMeditationSubtitle: '伝統的なマインドフルネスの実践',
            buddhistMonkMeditationDescription: '静かなリゾート環境で、経験豊富な僧侶による本格的な仏教瞑想を体験してください。これらの古代の実践は、伝統的な詠唱、呼吸法、静寂の瞑想を組み合わせたガイド付きセッションを通じて、内なる平和、マインドフルネス、精神的な健康を促進します。',
            buddhistMonkMeditationHighlight1: '伝統的な仏教瞑想セッション',
            buddhistMonkMeditationHighlight2: '経験豊富な僧侶による指導',
            buddhistMonkMeditationHighlight3: 'リゾート内の静かな環境',
            buddhistMonkMeditationHighlight4: 'マインドフルネスと呼吸法',
            buddhistMonkMeditationHighlight5: '精神的ウェルネスの実践',
            cookeryTitle: '料理プログラム',
            cookerySubtitle: 'スリランカの味',
            cookeryDescription: '活気あふれるスリランカ料理の風味に浸ってください。熟練のシェフが実践的な料理セッションを通じて、世代を超えて受け継がれてきた伝統的なレシピを教えます。香り高いカレー、ホッパー、ココナッツ・サンボルなどを新鮮な地元食材で作る方法を学びます。',
            cookeryHighlight1: '伝統的なスリランカのレシピ',
            cookeryHighlight2: '実践的な料理体験',
            cookeryHighlight3: '新鮮な地元食材',
            cookeryHighlight4: 'レシピを持ち帰り',
            cookeryHighlight5: 'スパイスガーデンツアー付き',
            meditationTitle: '瞑想プログラム',
            meditationSubtitle: '内なる平和とマインドフルネス',
            meditationDescription: 'インド洋の穏やかな景色を背景にしたガイド付き瞑想で静けさを見つけましょう。経験豊富なインストラクターが、心を落ち着かせ精神を蘇らせる古来のマインドフルネス技法、呼吸法、ヨガの実践へ導きます。',
            meditationHighlight1: '日の出・日の入りセッション',
            meditationHighlight2: '海辺の瞑想',
            meditationHighlight3: '専門家による指導',
            meditationHighlight4: '呼吸法',
            meditationHighlight5: 'ヨガ＆マインドフルネス実践',
            nightBeachPartiesTitle: 'グリルナイト',
            nightBeachPartiesSubtitle: 'ビーチサイド料理体験',
            nightBeachPartiesDescription: '星空の下で忘れられないビーチサイドグリルナイトをお楽しみください。新鮮に焼かれたシーフード、プレミアムミート、鮮やかな野菜を、心地よい波の音を聞きながら味わってください。熟練のシェフが一品一品完璧に調理し、魔法のような海岸環境で忘れられない食事体験を創り出します。',
            nightBeachPartiesHighlight1: '新鮮に焼かれたシーフードとミート',
            nightBeachPartiesHighlight2: 'シェフによるライブグリル実演',
            nightBeachPartiesHighlight3: 'オーシャンフロントのダイニング雰囲気',
            nightBeachPartiesHighlight4: 'プレミアムBBQビュッフェセレクション',
            nightBeachPartiesHighlight5: '焚き火のあるビーチサイド雰囲気',
            bbqTitle: 'BBQパーティー',
            bbqSubtitle: 'ビーチサイドの祝祭',
            bbqDescription: 'ビーチサイドのBBQパーティーで忘れられない夜を体験してください。波のささやきを聞きながら、新鮮なシーフードのグリル、上質な肉、ベジタリアン料理を味わえます。ライブ音楽、ファイヤーダンサー、星空が祝祭と交流の完璧な雰囲気を演出します。',
            bbqHighlight1: '新鮮なシーフードのグリル',
            bbqHighlight2: 'オーシャンフロントダイニング',
            bbqHighlight3: 'ライブエンターテインメント',
            bbqHighlight4: '焚き火体験',
            bbqHighlight5: 'カスタマイズ可能なメニュー',
            boatTitle: 'ボートライド',
            boatSubtitle: '川と海岸の冒険',
            boatDescription: 'ベントータ川と沿岸水域を巡る魅力的なボート旅へ。マングローブの森を滑るように進み、珍しい鳥や野生動物を観察したり、ロマンチックなサンセットクルーズを楽しめます。ボートライドはスリランカの自然美と多様な生態系を新しい視点で体験できます。',
            boatHighlight1: 'ベントータ川クルーズ',
            boatHighlight2: 'マングローブ探索',
            boatHighlight3: '野生動物観察',
            boatHighlight4: 'サンセットボートツアー',
            boatHighlight5: 'プライベートチャーターあり',
            ayurvedaLecturesTitle: 'アーユルヴェーダ医師の講演',
            ayurvedaLecturesSubtitle: '古代の知恵と現代のウェルネス',
            ayurvedaLecturesDescription: '認定アーユルヴェーダ医師や実践者による講演で、アーユルヴェーダの深い原理を学びましょう。ドーシャのバランス、ハーブ療法、ホリスティックな癒しの実践、そして古代の知恵が現代のウェルネスにどう活かされるかを学べます。インタラクティブなセッションで、アーユルヴェーダ哲学と日常への応用を分かりやすく解説します。',
            ayurvedaLecturesHighlight1: '認定アーユルヴェーダ医師',
            ayurvedaLecturesHighlight2: 'パーソナライズされたドーシャ分析',
            ayurvedaLecturesHighlight3: 'ハーブ療法の学び',
            ayurvedaLecturesHighlight4: 'Q&Aセッション付き',
            ayurvedaLecturesHighlight5: '持ち帰り用ウェルネスガイド',
            musicTherapyTitle: '音楽療法',
            musicTherapySubtitle: '音による癒し',
            musicTherapyDescription: '穏やかな海辺の環境で、音楽療法の変容力を体験してください。経験豊富なセラピストが伝統的および現代的な楽器を使用して、深いリラクゼーション、感情の解放、全体的な癒しを促進する治療的なサウンドエクスペリエンスを作り出します。',
            musicTherapyHighlight1: '専門家が指導するセラピーセッション',
            musicTherapyHighlight2: '伝統的および現代的な楽器',
            musicTherapyHighlight3: 'リラクゼーションと感情解放療法',
            musicTherapyHighlight4: 'サウンド瞑想ワークショップ',
            musicTherapyHighlight5: '心身精神の調和',
            taiChiTitle: '太極拳',
            taiChiSubtitle: '穏やかな動きとバランス',
            taiChiDescription: '穏やかな海辺の庭で古代の太極拳の芸術を練習してください。これらの優雅で流れるような動きは、バランス、柔軟性、内なる強さを向上させながら、心を落ち着かせます。すべてのフィットネスレベルと年齢に適しています。',
            taiChiHighlight1: '日の出時の毎日のクラス',
            taiChiHighlight2: '認定マスターによる指導',
            taiChiHighlight3: 'バランスと柔軟性の向上',
            taiChiHighlight4: 'すべての年齢に適しています',
            taiChiHighlight5: '武道と瞑想の実践',
            traditionalClothsTitle: '伝統衣装体験イベント',
            traditionalClothsSubtitle: '文化遺産体験',
            traditionalClothsDescription: '伝統衣装の着付けとその価値を学ぶことで、スリランカの文化遺産に浸りましょう。専門スタイリストが本格的なキャンディアン・サリーや伝統衣装の着こなしを案内し、それぞれの文化的意義を説明します。特別な機会、文化体験、思い出に残る写真撮影に最適です。',
            traditionalClothsHighlight1: '専門的なスタイリング指導',
            traditionalClothsHighlight2: '本格的な伝統サリー',
            traditionalClothsHighlight3: '文化的意義の解説',
            traditionalClothsHighlight4: 'プロの写真撮影付き',
            traditionalClothsHighlight5: 'ファッション・フュージョンワークショップ',
            shanthiKarmaTitle: '文化舞踊',
            shanthiKarmaSubtitle: 'スリランカ伝統芸能',
            shanthiKarmaDescription: 'スリランカ文化舞踊の鮮やかな世界に浸ってください。色とりどりの衣装、リズミカルな太鼓、動きを通じた古代の物語を特徴とする魅惑的な伝統的なパフォーマンスを体験してください。才能豊かなダンサーたちが、何世紀も前からの民俗舞踊、キャンディアンダンス、スリランカの遺産に命を吹き込む文化的儀式を披露します。',
            shanthiKarmaHighlight1: '本格的なスリランカ伝統舞踊',
            shanthiKarmaHighlight2: '色鮮やかな伝統衣装とメイクアップ',
            shanthiKarmaHighlight3: 'ライブドラム伴奏',
            shanthiKarmaHighlight4: '動きを通じた文化的物語',
            shanthiKarmaHighlight5: 'キャンディアンダンスと民俗舞踊のパフォーマンス',
        },
        contact: {
            heroTitle: 'お問い合わせ',
            heroSubtitle: 'Mahi Beach Ayurveda Resort',
            heroAlt: 'お問い合わせ',
            sectionTitle: 'お気軽にご連絡ください',
            sectionSubtitle: 'リラックスとリフレッシュをお手伝いします',
            sectionDescription: 'アーユルヴェーダ滞在、ウェルネスパッケージ、予約、またはベールワラ（モラガラ）でのご滞在に関するご質問は、Mahi Beach Ayurveda Resortまでお問い合わせください。',
            callUs: 'お電話',
            emailTitle: 'メール',
            ourLocation: '所在地',
            locationAddress: 'No.112 rendagewatta Galle Rd, Maggona',
            socialNetwork: 'ソーシャルネットワーク',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'お問い合わせ',
            getInTouchDescription: 'ぜひご連絡ください。チームがウェルネスの旅をサポートし、質問への回答やご滞在の計画をお手伝いします。',
            nameLabel: 'お名前',
            emailLabel: 'メール',
            contactNumberLabel: '連絡先番号',
            messageLabel: 'メッセージ',
            sending: '送信中...',
            sendMessage: '送信',
            successMessage: 'メッセージを送信しました。まもなくご連絡します。',
            errorMessage: '送信中にエラーが発生しました。もう一度お試しください。',
            findUsOnMap: '地図で見る',
            whatsappSubject: 'Mahi Beach Ayurveda Resort お問い合わせ',
            whatsappName: 'お名前',
            whatsappEmail: 'メール',
            whatsappContactNumber: '連絡先番号',
            whatsappMessage: 'メッセージ'
        },


        ayurveda: {
            accordionTitle1: 'パンチャカルマを理解する',
            accordionDesc1: 'アーユルヴェーダ（「生命の科学」）は、5,000年以上前に生まれた世界最古のホリスティックな治癒体系の一つです。パンチャカルマは心・体・魂・環境の調和に基づき、健康を高め病を予防することを目的とし、施術は個別に整えられます。',
            accordionTitle2: 'パンチャカルマと生命エネルギー',
            accordionDesc2: 'アーユルヴェーダは、宇宙のすべてがつながっていると説きます。心・体・魂が調和すると健やかさが保たれ、乱れると不調が生じます。遺伝、けが、季節、年齢、感情などが影響します。\n\n人は空間・空気・火・水・土の五元素から成り、三つのドーシャ（ヴァータ＝空間/空気、ピッタ＝火/水、カパ＝水/土）となって身体の働きを司ります。\n\nそれぞれの配合は個人で異なり、通常は一つが優勢です。バランスが健康傾向を左右します。',
            accordionTitle3: 'ヴァータ・ドーシャ',
            accordionDesc3: 'ヴァータは最も影響力が高く、運動、呼吸、循環、心拍、排泄などを司ります。不規則な食事、恐れ、悲しみ、夜更かしで乱れやすくなります。\n\nヴァータ優勢の人は知的で創造的、エネルギッシュな傾向があり、体型は細身で冷えやすいことが多いです。乱れると不安や落ち着かなさ、呼吸や関節の不調が出る場合があります。\n\n瞑想、マッサージ、規則正しい生活、温かくやさしい食事で整えます。',
            accordionTitle4: 'ピッタ・ドーシャ',
            accordionDesc4: 'ピッタは消化・代謝・食欲に関わるホルモンを司ります。辛味や酸味、強い日差し、食事抜きで高まりやすくなります。\n\nピッタ優勢の人は決断力があり自信に満ち、行動的です。乱れると苛立ちや炎症傾向が出やすくなります。\n\n冷却作用のある軽い食事と、穏やかなヨガなどでバランスを取ります。',
            accordionTitle5: 'カパ・ドーシャ',
            accordionDesc5: 'カパは安定性、体力、構造、免疫を支えます。甘いものや重い食事、過度の睡眠で重くなりやすいです。\n\nカパ優勢の人は落ち着きがあり忍耐強く、体格がしっかりしていることが多いです。乱れると疲労感、鈍さ、体重増加が起こりやすくなります。\n\n軽めの食事、果物と野菜、活発な運動で整えます。',
            close: '閉じる',
            next: '次へ',
            previous: '前へ',
            treatmentsTitle: '当リゾートのシグネチャー・パンチャカルマトリートメント',
            treatmentsSubtitle: '伝統のケアでバランスを整え、緊張をゆるめ、心身をリセット。',
            bookTreatment: 'このトリートメントを予約',
            benefitsTitle: 'パンチャカルマの主な利点',
            shirodhara: 'シローダーラ',
            shirodharaDesc: '温かいハーブオイルを額に流し、神経系を落ち着かせます。',
            shirodhara1: 'ストレスや不安を和らげる',
            shirodhara2: '深い睡眠を促す',
            shirodhara3: '心の明晰さを高める',
            steamBath: 'スチームバス',
            steamBathDesc: 'ハーブの蒸気で毛穴を開き、デトックスと筋肉の緩和を促します。',
            steamBath1: '穏やかな発汗で浄化',
            steamBath2: '血行を促進',
            steamBath3: '筋肉のこわばりを軽減',
            flowerBath: 'フラワーバス',
            flowerBathDesc: '香り豊かな花の入浴でリラックスと回復。',
            flowerBath1: '神経系を落ち着かせる',
            flowerBath2: '肌をしっとり整える',
            flowerBath3: '気分を明るくする',
            headMassage: 'ヘッドマッサージ',
            headMassageDesc: '頭皮をほぐして蓄積した緊張を解放。',
            headMassage1: '頭の重さを軽減',
            headMassage2: '頭皮と毛根を整える',
            headMassage3: '深いリラクゼーション',
            faceMassage: 'フェイシャルマッサージ',
            faceMassageDesc: 'やさしいフェイシャルで輝きを戻し、ストレスを軽減。',
            faceMassage1: '肌のトーンを整える',
            faceMassage2: '表情のこわばりをほぐす',
            faceMassage3: 'リンパの流れをサポート',
            neckMassage: 'ネックマッサージ',
            neckMassageDesc: '首のこわばりを和らげる集中ケア。',
            neckMassage1: '首の不快感を軽減',
            neckMassage2: '可動域を広げる',
            neckMassage3: 'ストレスを和らげる',
            shoulderMassage: 'ショルダーマッサージ',
            shoulderMassageDesc: '肩の緊張をほどくセラピー。',
            shoulderMassage1: '肩の痛みを軽減',
            shoulderMassage2: '姿勢を整える',
            shoulderMassage3: '筋肉の結びをほぐす',
            bodyMassage: '全身マッサージ',
            bodyMassageDesc: '全身をゆるめる回復のリチュアル。',
            bodyMassage1: '巡りを整える',
            bodyMassage2: '筋肉の疲れを和らげる',
            bodyMassage3: '深いリラックスへ導く',
            backMassage: 'バックマッサージ',
            backMassageDesc: '背中の緊張や痛みに働きかけるケア。',
            backMassage1: '背中の痛みを和らげる',
            backMassage2: '背骨の快適さを支える',
            backMassage3: 'ストレスを軽減',
            footMassage: 'フットマッサージ',
            footMassageDesc: '足元から全身を落ち着かせるフットケア。',
            footMassage1: '血行を促す',
            footMassage2: '足の疲れを軽減',
            footMassage3: '穏やかな落ち着きをもたらす',
            purgative: '下剤療法',
            purgativeDesc: '消化器から余分なピッタと毒素を排出する浄化療法。',
            purgative1: '腸をクレンズ',
            purgative2: 'ピッタのバランスを整える',
            purgative3: '消化機能をサポート',
            nasalClearing: '鼻腔クリアリング',
            nasalClearingDesc: 'ハーブによる鼻ケアで通りを整え、呼吸を楽に。',
            nasalClearing1: '鼻づまりを緩和',
            nasalClearing2: '呼吸を改善',
            nasalClearing3: '副鼻腔の圧迫感を軽減',
            powderMassage: 'パウダーマッサージ',
            powderMassageDesc: 'ハーブパウダーで角質を整え、肌をリフレッシュ。',
            powderMassage1: '古い角質を除去',
            powderMassage2: '肌のきめを整える',
            powderMassage3: '巡りを促進',
            intensiveMassageDesc: '慢性的な緊張や頑固なコリに深くアプローチ。',
            intensiveMassage1: '深い筋緊張をほぐす',
            intensiveMassage2: '血流を改善',
            intensiveMassage3: '残る痛みを軽減',
            thermoMassage: '温熱マッサージ',
            thermoMassageDesc: '温めたハーブオイルで組織をゆるめ、回復を促進。',
            thermoMassage1: '筋肉の痛みを和らげる',
            thermoMassage2: '深いリラクゼーション',
            thermoMassage3: 'エネルギーの流れを整える',
            synchronMassage: 'シンクロナイズドマッサージ',
            synchronMassageDesc: '2人のセラピストによる同期施術で全身調和。',
            synchronMassage1: '全身のバランス',
            synchronMassage2: '安定したエネルギー循環',
            synchronMassage3: '深いリラックス体験',
            specialMassage: 'スペシャルマッサージ',
            specialMassageDesc: '目的に合わせたオーダーメイドの施術。',
            specialMassage1: 'パーソナル設計',
            specialMassage2: '特定の悩みにフォーカス',
            specialMassage3: '的確な癒しのアプローチ',
            benefit1Title: 'デトックスサポート：',
            benefit1Desc: '体内に溜まった毒素を手放し、活力を取り戻します。',
            benefit2Title: '消化のスムーズさ：',
            benefit2Desc: '消化を整え、栄養吸収を高めます。',
            benefit3Title: 'ストレスリセット：',
            benefit3Desc: '心身を静め、緊張や不安を軽減します。',
            benefit4Title: '免疫のレジリエンス：',
            benefit4Desc: '定期的なケアで防御力を高めます。',
            benefit5Title: 'リニューアル：',
            benefit5Desc: '細胞の再生を支え、健やかな肌に。',
            benefit6Title: 'ドーシャの調和：',
            benefit6Desc: 'ヴァータ、ピッタ、カパの調和を取り戻し、持続的な健康へ。',
            akkupancharTitle: 'アックパンチャル療法',
            akkupancharDesc1: 'は、特定の体のポイントでハーブペーストとオイルを使用する古代のアーユルヴェーダ療法です。この治療はエネルギーチャネルを刺激し、治癒を促進します。',
            akkupancharBenefit: '主な利点：',
            akkupancharDesc2: 'この専門療法は慢性的な痛みを助け、関節の柔軟性を改善し、血液循環を促進し、自然なエネルギーの流れを回復します。',
            akkupancharApplication: '治療的応用：',
            akkupancharDesc3: 'アックパンチャルは、ドーシャのバランスをとるために慎重に選択されたハーブ調合物で特定のマルマポイントに作用します。',
            akkupancharTransform: '変革を体験：',
            akkupancharDesc4: 'ムトゥムニアーユルヴェーダビーチリゾートでは、経験豊富なセラピストがあなたの健康ニーズに合わせて各鍼療法セッションをカスタマイズします。',
            experienceAkkupanchar: '今日鍼療法を体験',
            doctorsEyebrow: '私たちのエキスパートチーム',
            doctorsSectionTitle: '医師紹介',
            drSandyaName: 'M. サンディヤ・メンディス医師',
            drSandyaProfession: 'アーユルヴェーダ医師',
            drSandyaSpecialization: '臨床アーユルヴェーダ、パーソナライズド治療計画、ホスピタリティアーユルヴェーダケア',
            drSandyaProfileTitle: '専門プロフィール',
            drSandyaProfile: '25年以上のパーソナライズドケアとウェルネスソリューションの経験を持つ、思いやりのある献身的なアーユルヴェーダ専門家。伝統的なアーユルヴェーダの原則と現代の治療実践を融合し、高級ウェルネスリゾートで総合的な癒しの体験を提供することに特化しています。',
            drSandyaWorkExpTitle: '職務経歴',
            drSandyaWorkExp1: 'チーフドクター兼プログラム開発リーダー - マヒビーチアーユルヴェーダリゾート（2023年〜現在）',
            drSandyaWorkExp2: 'シニアアーユルヴェーダ医師 - Sun Aqua Resort and Spa, マッゴーナ（2008年〜2023年）',
            drSandyaWorkExp3: 'アーユルヴェーダコンサルタント - Amba Ayurveda Specialty Clinic（2006年〜2008年）',
            drSandyaWorkExp4: 'アーユルヴェーダ医師&パンチャカルマ専門家 - Paradise Road The Villa Bentota（2002年〜2006年）',
            drSandyaWorkExp5: 'アーユルヴェーダメディカルオフィサー - Hotel Blue Water（1996年〜2002年）',
            drSandyaEducationTitle: '学歴・専門資格',
            drSandyaEdu1: 'アーユルヴェーダ ディプロマ - Government Ayurveda College, ボレラ（1989年〜1993年）',
            drSandyaEdu2: 'レイキ 2nd ディグリー - Reiki Dasa Centre ネゴンボ スリランカ（2015年〜2016年）',
            drPandukaName: 'パンドゥカ・ラナウィーラ医師',
            drPandukaProfession: 'アーユルヴェーダ医師',
            drPandukaQualification: 'B.A.M.S. (アーユルヴェーダ医学・外科学士)',
            drPandukaProfileTitle: '専門プロフィール',
            drPandukaProfile: 'パンドゥカ・ラナウィーラ医師は、コロンボ大学でアーユルヴェーダ医学・外科学士号（B.A.M.S.）を取得した、資格と経験を持つアーユルヴェーダ医師です。彼の学術訓練は古典的なアーユルヴェーダの原則と包括的な臨床教育にしっかりと基づいており、伝統医学に対する構造化された倫理的で証拠に基づいたアプローチを支えています。',
            drPandukaExpertiseTitle: '専門的専門知識',
            drPandukaExpertise: '臨床診療に加えて、ラナウィーラ医師はゲストやウェルネスプログラムのために専門的なアーユルヴェーダ講義を実施し、アーユルヴェーダ哲学、疾病予防、ライフスタイル管理、伝統療法の実践的応用について明確な洞察を提供しています。これらのセッションはゲストの理解と関与を高め、持続可能な健康成果に貢献します。',
            drPandukaSpecialtyTitle: '統合療法',
            drPandukaSpecialty: '彼の治療専門知識は鍼療法と音楽療法にも及び、痛みの管理、ストレス軽減、神経学的バランス、感情的幸福をサポートするために選択的に統合しています。アーユルヴェーダとこれらの補完的モダリティを組み合わせることで、ラナウィーラ医師は真に統合的な癒しの体験を提供します。',
            drPandukaRoleTitle: '卓越性へのコミットメント',
            drPandukaRole: 'ホテルでの役割において、ラナウィーラ医師は高い臨床基準を維持しながら、パーソナライズされた治療計画と総合的なウェルネスガイダンスを提供しています。彼の専門的で落ち着いた思いやりのあるアプローチは、各ゲストが長期的なバランス、活力、全体的な幸福を目指した、安全で本格的で結果志向のケアを受けることを保証します。',
            gallery1: 'シローダーラ療法',
            gallery2: 'スチームバス',
            gallery3: 'フラワーバス',
            gallery4: 'ヘッドマッサージ',
            gallery5: '全身マッサージ',
            gallery6: 'ネックマッサージ',
            gallery7: 'フェイシャルマッサージ',
            gallery8: 'ショルダーマッサージ',
            heroTitle: 'パンチャカルマ・アーユルヴェーダ',
            heroSubtitle: 'ベルワラで身心霊を若返らせる',
            heroTagline: '海辺で本格的なスリランカのアーユルヴェーダヒーリングを体験',
            sectionEyebrow: 'MAHI BEACH AYURVEDA RESORTのパンチャカルマ・アーユルヴェーダ',
            sectionDescription: 'マッゴナのMahi Beach Ayurveda Resortで古代のパンチャカルマを体験してください。経験豊富なチームが、浄化・回復・調和のための個別ケアを提供します。'
        },
        food: {
            heroTitle: 'アーユルヴェーダ食と沿岸料理',
            heroSubtitle: 'スリランカの本物の味と新鮮な沿岸料理',
            heroAlt: 'Mahi Beach ビーチリゾートでの料理体験',
            wellnessEyebrow: '食べ物を通じた健康',
            wellnessTitle: 'の重要性',
            ayurvedicFood: 'アーユルヴェーダ食',
            wellnessIntro1: 'アーユルヴェーダでは、食べ物は最大の医学と考えられています。あなたが食べるものは、あなたのドーシャ（ヴァータ、ピッタ、カファ）、消化（アグニ）、そして体、心、精神全体のバランスに直接影響します。',
            wellnessIntro2: 'アーユルヴェーダ栄養は、配慮を持って準備され、マインドフルに食べられた新鮮で季節的な全食を強調しています。すべての感覚を栄養し、調和を保つために、各食事に6つの味（甘い、酸っぱい、塩辛い、ピリッとした、苦い、渋い）を促進しています。',
            wellnessIntro3: '適切なアーユルヴェーダ食は、強力な消化をサポートし、毒素（アマ）を除去するのを助け、免疫力を高め、エネルギーを改善し、ストレスを軽減し、多くの慢性疾患を予防します。Mahi Beachでは、各料理はあなたのユニークな体質に深い癒しと活力をもたらすために慎重に作られています。',
            foodImage1Alt: '6つの味を持つ伝統的なアーユルヴェーダ食事',
            foodImage2Alt: 'バランスの取れた栄養のためのアーユルヴェーダハーブとスパイス',
            culinaryPhilosophyEyebrow: '私たちの料理哲学',
            culinaryPhilosophyTitle: 'アーユルヴェーダ',
            nutritionHighlight: '栄養',
            culinaryPhilosophyResort: 'Mahi Beach Ayurveda Resortにて',
            nutritionTopImageAlt: 'Mahi Beach Ayurveda Resortでのアーユルヴェーダ料理',
            freshNourishingLabel: '新鮮で栄養豊富',
            healingIngredientsAlt: 'ヘルシーなアーユルヴェーダ食材とスパイス',
            healingIngredientsLabel: '治癒成分',
            philosophyText1: '甘い、酸っぱい、塩辛い、苦い、ピリッとした、渋い6つの主な味を含む食べ物は、古典的なアーユルヴェーダのテキストで説明されており、5000年以上前に遡るものもあります。グナ（固有の品質）、ヴィルヤ（効力/加熱または冷却）、ヴィパカ（消化後の影響）、およびプラバヴァ（ユニークな特殊作用）を含む各食品の本質的なプロパティ。',
            philosophyText2: 'その結果、アーユルヴェーダ栄養はMahi Beach Ayurveda Resortで中心的な役割を果たしています。これは、医師によってのみ指示される味気ない、無味、または過度に苦い食事の厳格で単調な体制を意味しません。それどころか、私たちのアーユルヴェーダキッチンは最大の強みの1つです。私たちの熟練したシェフが準備した料理は、滞在中毎日あなたを驚かせ、楽しませてくれます！',
            philosophyText3: '朝食には、新鮮なトロピカルフルーツ、新鮮なジュース、栄養価の高いハーブスープ、自家製パン、軽いクッキー、およびさまざまな本物のスリランカの朝食オプションが満載の豪華なビュッフェをお楽しみください。昼食には、マイルドな魚カレー、野菜の準備、ハーブが注入された料理を備えた、カラフルでおいしいビュッフェをお楽しみください。夕方には、新鮮な魚のオプションが利用可能な設定された菜食メニューを提供します。土曜日には、「スリランカの夜」をビュッフェ拡張で祝う—私たちのシェフは、生き生きで本物の経験を作成して、あなたの前で伝統的なローカルの専門性を準備します。',
            philosophyText4: 'アーユルヴェーダでは、食べ物と飲料は多くの方法で分類されています。味と特性、体の消化能力（アグニ）、特定の健康状態への適用性、季節の適切さなど。Mahi Beachでは、これらすべての要因を同時に慎重に検討し、各ゲストの個々の体質に合わせた6つの味すべてのバランスの取れた組み合わせに含める意識的な努力をしています。',
            philosophyText5: '私たちの食事には、新鮮な野菜、トロピカルフルーツ、責任を持って調達された魚が含まれています。赤身の肉やアルコールは提供していません。',
            philosophyText6: 'お食事の際には、アーユルヴェーダの医師または認定栄養士がいつでもお客様のご案内をさせていただきます。彼らは、あなたの現在の治療段階に最も適切な野菜、ハーブ、スパイスについてアドバイスし、それに応じて料理を選択または避けるのを支援します。あなたの個人的なハーブエリキシルと健康センターチームからの具体的な指示は、あなたの個別テーブルに配置されます。',
            philosophyText7: 'このレベルの個人的なケアと食事への注意は、Mahi Beach Ayurveda Resort体験の特徴です。',
            philosophyText8: 'すべての人間にとって、食べ物はプラーナ（生命を支える重要なエネルギー）と見なされています。だからこそ、各食事に完全な意識を持って取り組むことをお勧めします。香りを味わい、味を経験し、優しい温かさを感じ、おいしい感覚を意識的に楽しんでください。',
            diningExperienceEyebrow: 'ダイニング体験',
            restaurantTitlePrefix: '私たちの',
            ayurvedicHighlight: 'アーユルヴェーダ',
            restaurantTitleSuffix: 'レストラン',
            restaurantDetail1: 'Mahi Beach Ayurveda Resortの当社のアーユルヴェーダレストランは、伝統的なアーユルヴェーダの原則とスリランカの本物の沿岸料理を調和させたユニークなダイニング体験を提供しています。新鮮で地元産の食材を優先して、味覚を喜ばすだけでなく、全体的な幸福を促進する食事を作ります。',
            restaurantDetail2: 'メニューは、各料理の6つの味（甘い、酸っぱい、塩辛い、苦い、ピリッとした、渋い）のバランスを慎重に設計されており、栄養価が高く満足のいく体験を保証しています。各食事は丁寧に準備され、その治癒特性で知られているアーユルヴェーダのハーブとスパイスが組み込まれています。',
            restaurantDetail3: 'ゲストは、個々のドーシャ（体の体質）に合わせてカスタマイズされたさまざまな料理を楽しむことができます。ベジタリアン、ビーガン、ペスカタリアンの食事のオプションがあります。私たちのシェフはアーユルヴェーダの医師と密接に協力して、各食事がゲストの健康とウェルネスの目標をサポートしていることを確認します。',
            restaurantDetail4: 'レストランの雰囲気は静かな沿岸環境を反映し、マインドフルな食事のための落ち着いた雰囲気を提供しています。豪華な朝食ビュッフェを楽しんでも、グルメディナーを味わっても、私たちのアーユルヴェーダレストランでのすべての食事は、体と魂を育む機会です。',
            restaurantDetail5: 'Mahi Beach Ayurveda Resortのアーユルヴェーダレストランで、スリランカの豊かな風味を祝いながら、アーユルヴェーダの時代を超えた知恵を受け入れる料理の旅に参加してください。',
            restaurantImageAlt: 'Mahi Beach Ayurveda Resortでのダイニング',
            premiumDiningLabel: 'プレミアムダイニング',
            premiumDiningDescription: '穏やかなリバーサイド環境で本物のアーユルヴェーダ料理をお楽しみください',
            treatmentProgramme: {
                title: 'アーユルヴェーダ治療プログラム',
                subtitle: 'バランス、解毒、深い更新へのあなたの旅',
                intro: '穏やかな海辺のリトリートで本格的なアーユルヴェーダケアを体験し、身体を整え、心を落ち着かせ、エネルギーを満たします。到着後は私たちが細部まで手配するので、健康に集中できます。',
                welcomeTitle: 'ようこそと優しい始まり',
                doctorTitle: '医師相談とパーソナルプラン',
                dailyTherapiesTitle: '毎日のアーユルヴェーダセラピー',
                herbalMedicineTitle: 'ハーブ医学サポート',
                yogaMeditationTitle: 'ヨガと瞑想による心身の調和',
                wellnessTitle: 'ウェルネス体験の含有',
                closingTitle: '閉会式と出発',
                welcomePoints: [
                    '空港送迎とホテル送達',
                    '温かいおもてなしとホテルオリエンテーション',
                    'あなたの週間ウェルネススケジュールへの紹介',
                    'リラックスマッサージ（1日目）アーユルヴェーダセンターで、旅の疲労を緩和し、体を治療に備える'
                ],
                doctorPoints: [
                    'アーユルヴェーダ医師相談（2日目–午前）',
                    'あなたのドーシャ/体のタイプと健康上の懸念の完全な評価',
                    '翻訳者はリクエストに応じて利用可能',
                    'あなたの医師があなたのニーズと目標に合わせたパーソナライズされた治療プランを作成します'
                ],
                dailyTherapiesPoints: [
                    '1日4～5回の治療（医師が推奨）',
                    'あなたの体構成と状態に基づいて選ばれた療法',
                    '必要に応じて特別マッサージを追加できます',
                    '医師は毎日進行状況を監視し、最良の結果を確保するために治療とハーブサポートを調整する場合があります',
                    '適切な場合、穏やかなクレンジング/下剤プロセスが推奨される場合があります'
                ],
                herbalMedicinePoints: [
                    '医師が処方したハーブ薬を1日2回:',
                    '朝食時',
                    '夕食時',
                    '内部治癒、解毒、長期的なバランスをサポート'
                ],
                yogaMeditationPoints: [
                    '週に4回のヨガセッション（約1時間）',
                    '週に2回の瞑想セッション:',
                    '島のお寺での独特な精神体験、ボートでアクセス可能',
                    '僧侶による瞑想ガイダンス（約1時間）'
                ],
                wellnessPoints: [
                    '毎週の健康的な料理デモンストレーション',
                    '無料遠足（文化/自然体験）'
                ],
                closingPoints: [
                    '美しいフラワーバス（最後の日）—更新の伝統儀式',
                    '進捗をレビューして提供するための最終医師相談:',
                    '継続的なウェルネスガイダンス',
                    'ホーム処方と推奨事項',
                    '空港への返却送達'
                ]
            },
        },
        yoga: {
            heroTitle: 'リゾートのヨガ',
            heroSubtitle: 'ベルワラでバランス、強さ、内なる平穏を見つける',
            heroAlt: 'Mahi Beach Ayurveda Resortのヨガ',
            importanceEyebrow: 'ウェルネスとバランス',
            importanceTitle: 'ヨガと瞑想の重要性',
            importanceImageAlt: 'ヨガと瞑想の重要性',
            importanceText1: 'ヨガと瞑想は、身体的・精神的・感情的に多くの恩恵をもたらす古代の実践です。柔軟性、筋力、バランスを高めながら、ストレスや不安を軽減します。',
            importanceText2: '継続的な実践は集中力を高め、睡眠の質を改善し、全体的なウェルビーイングを促進します。ヨガはマインドフルネスも育み、内なる自分とつながり、日常の喧騒の中でも平穏を見つける助けになります。',
            importanceText3: 'Mahi Beach Ayurveda Resortでは、ヨガや瞑想に最適な静かな環境を提供し、心・体・魂をリフレッシュできるようにしています。',
            practiceEyebrow: '私たちの実践',
            practiceTitle: 'ヨガの実践と体験',
            practiceImageAlt: 'リゾートでのヨガ練習',
            practiceText1: 'Mahi Beach Ayurveda Resortでは、主に伝統的なハタヨガにプラーナーヤーマ（呼吸法）を組み合わせて行います。このホリスティックなアプローチは内なる気づきを高め、クンダリーニ（第三の目とも呼ばれる）を穏やかに刺激することを目的としています。背骨のアライメントと柔軟性を特に重視し、柔らかな背骨は老化を遅らせると考えられています――「あなたの年齢は背骨次第です。」',
            practiceText2: 'ヨガセッションは週4回行われ、初心者から経験者まで参加できます。時折アシュタンガ・ヨガなどの特別セッションも実施され、さまざまなポーズやルーティンを体験できます。アーユルヴェーダ医師は、治療プログラムの支援と強化のために定期的な参加を推奨しています。',
            practiceText3: 'すべてのヨガセッションは専用のYoga Shalaで行われます。集中力、バランス、マインドフルな動きを支えるために設計された静かな空間です。各セッションは通常、太陽礼拝から始まり、その後プラーナーヤーマと、柔軟性・循環・全体的な健康を高めるために選ばれたアーサナのシークエンスが続きます。',
            practiceText4: '経験豊富なヨガ講師が、ゲストのニーズ、能力、健康状態に合わせて各セッションを調整し、安全で支えのある、深く有益なヨガ体験を提供します。',
            spiritualEyebrow: 'スピリチュアルな旅',
            spiritualTitle: '瞑想とスピリチュアル活動',
            spiritualSubtitle: '神聖な儀式とガイド付き瞑想でスピリチュアルな実践を深めましょう',
            meditationImageAlt: 'リゾートでの瞑想とスピリチュアルプラクティス',
            meditationTitle: '瞑想セッション',
            meditationDesc: 'ゲストは、週3回開催される仏教の伝統に着想を得たガイド付き瞑想に参加できます。これらのセッションは、心を落ち着かせ、気づきを深め、感情的・精神的な癒やしを支えるよう設計されています。瞑想は静かな島の寺院で行われ、ゲストはボートで訪れます――穏やかで意味深い旅が全体の瞑想体験を豊かにします。'
        },
        home: {
            heroTitle: 'Mahi Beach Ayurveda Resort',
            heroSubtitle1: '海のアーユルヴェーダ',
            heroSubtitle2: 'バランスを見つけ、楽に呼吸し、ベルワラであなたのエネルギーを更新してください。',
            exploreResort: 'リゾートを探索',
            bookNow: '今すぐ予約',
            welcomeLabel: 'ようこそ',
            welcomeTitle: 'Mahi Beach Ayurveda Resort',
            welcomeDesc1: 'ベルワラの手つかずの海岸に位置するMahi Beach Ayurveda Resortは、古い治癒の伝統とモダンな海岸の贅沢の調和した融合を提供しています。私たちの聖域は、インド洋のリズミカルな音とアーユルヴェーダの時代を超えた叡智が出会う、変革的なウェルネスの旅へあなたを招待します。',
            welcomeDesc2: 'パーソナライズされたアーユルヴェーダトリートメント、あなたのドーシャのバランスを保つために精心込めて作られた栄養食、そして息をのむような海の景色の優雅な客室でくつろいでください。若返り、リラクゼーション、または精神的な再生を求めているかどうかにかかわらず、私たちの専任のアーユルヴェーダプラクティショナーとウェルネスの専門家チームはあらゆる段階であなたをガイドします。',
            learnMore: '詳細を学ぶ',
            contactUs: 'お問い合わせ',
            welcomeImageAlt: 'Mahi Beach Ayurveda Resort',
            welcomeImageCaption: 'アーユルヴェーダ ウェルネス & ビーチ レトリート',
            welcomeImageLocation: 'スリランカ、ベルワラ',
            highlightTitle: '海辺のアーユルヴェーダ聖地',
            highlightDesc: 'スリランカの南西海岸で全体的な治癒を見つけます。カスタマイズされた治療から静かなバルコニーとマインドフルな食事まで、すべての細部があなたのリズムを復元するために設計されています。',
            service1Title: '総合的なアーユルヴェーダセラピー',
            service1Desc: 'パーソナライズされたコンサルテーション、正真正銘のハーバルオイル、経験豊富なアーユルヴェーダ医師に導かれた毎日のトリートメント。',
            service2Title: 'ビーチフロント客室とスイート',
            service2Desc: '海風に目覚め、プライベートバルコニー、深いリラックスのために設計されたなだめるような内部。',
            service3Title: 'ウェルネス料理',
            service3Desc: 'スリランカの新鮮な農産物、プラントフォワードメニュー、あなたのドーシャを補完するカスタマイズされた食事計画。',
            service4Title: 'ヨガとマインドフルネス',
            service4Desc: '朝日ヨガ、夕焼け瞑想、波のリズムに合わせた呼吸運動。',
            service5Title: '川と沿岸の遠足',
            service5Desc: 'ベントタ川でのボートツアー、ウミガメの孵化場訪問、スパイスガーデンウォーク、村でのサイクリングツアー。',
            roomsTitle: '私たちの客室',
            roomsDesc: 'あなたのペースに合わせた聖地を選択してください。広々としたスイートから快適なデラックスの隠れ家まで、柔らかいリネン、温かい木、日の出の準備ができたバルコニー備え付き。',
            roomBadge: 'ビーチフロント エスケープ',
            bookableNow: '今すぐ予約可能',
            seaBreezeReady: '海風の準備ができた',
            viewRoom: 'ルームを表示',
            room1Title: 'スイート客室',
            room1Desc: 'ラウンジエリア付きの広々としたスイート、広々とした バルコニー、ゆっくりした朝のための穏やかなパレット。',
            room2Title: 'デラックス客室',
            room2Desc: 'ぜいたくなベッド、庭園の景色、日常の快適さのための温かい木製のアクセント付きの居心地の良い隠れ家。',
            room3Title: 'デラックス シービュー',
            room3Desc: '海の地平線で目覚め、柔らかいリネン、黄金色の夕日のためのプライベートバルコニー。',
            achievement1Title: '幸せなゲスト',
            achievement1Count: '1,000+',
            achievement2Title: 'アーユルヴェーダトリートメント',
            achievement2Count: '20+',
            achievement3Title: 'ケアの年',
            achievement3Count: '15+',
            achievement4Title: 'トラベラー アクラレム',
            achievement4Count: '1,000+',
            experiencesTitle: 'Mahi Beach Ayurveda Resortを探索',
            experiencesDesc: 'アーユルヴェーダの旅から厳選された遠足まで、あなたの滞在を忘れられさせる経験を選択してください。',
            planYourStay: 'あなたのステイをプラン',
            experience1Title: '客室とスイート',
            experience1Desc: 'バルコニー、海または庭園の景色を望む風通しの良いスペース、急いでいない滞在のための思慮深いコンフォート。',
            experience2Title: 'アーユルヴェーダスパ',
            experience2Desc: '本格的なセラピー、スチームバス、時代の試練に耐えた儀式で行われた再生マッサージ。',
            experience3Title: '食事体験',
            experience3Desc: '当レストランで提供されるスリランカ料理と国際料理、心身を養うために慎重に準備。',
            experience4Title: '体験とツアー',
            experience4Desc: 'リバーサファリ、寺院訪問、ウォータースポーツ、ベントタ周辺のキュレーションされた文化遠足。',
            galleryTitle: 'Mahi Beach Ayurveda Resortでの瞬間',
            galleryDesc: '私たちの沿岸の聖地を垣間見ましょう――日の出、穏やかなトリートメント、栄養のある料理、あなたのための静かな角。',
            gallery1Alt: 'ムトゥムニヤシで囲まれた日当たりの良いビーチ',
            gallery2Alt: '進行中のアーユルヴェーダオイルトリートメント',
            gallery3Alt: 'ラウンジャー付きリゾートプール',
            gallery4Alt: 'スパ用に準備されたハーブ',
            gallery5Alt: 'カップルが海での日没を楽しむ',
            gallery6Alt: 'オーシャンフェーシングヨガデッキ',
            gallery7Alt: '熱帯庭園の小道',
            gallery8Alt: 'ヘルシーな朝食',
            gallery9Alt: '穏やかな河の景色',
            gallery10Alt: '夕焼け時のリゾート外観が温かく照らされた',
            gallery11Alt: 'アーユルヴェーダハーブとオイルディスプレイ',
            gallery12Alt: '庭園での快適な座席',
            resort1Alt: 'グリーンのオープンエアラウンジ',
            resort2Alt: '快適なルームインテリア',
            resort3Alt: 'スパトリートメントスペース',
            resort4Alt: '自然光付きダイニングエリア',
            resort5Alt: 'リラックスプームの眺め',
            sunsetLabel: '自然の毎日の傑作',
            sunsetTitle: '夕方の夕焼け',
            sunsetDesc1: '日が優雅に薄暮に降伏し、空が琥珀、深紅、金色のキャンバスに変わるのを見てください。温和なインド洋はこの天体の光景を反映し、光と水の魅惑的なシンフォニーを作成します。',
            sunsetDesc2: 'Mahi Beachでの毎晩は、自然の最も息をのむようなパフォーマンスの1つへのフロントロウシートを提供します。あなたの完璧な有利な点を見つけてください――プライベートバルコニー、ビーチサイドラウンジ、または日没瞑想デッキから――穏やかな美しさが洗い流でください。',
            sunsetFeature1: '各隅からの遮られていない海の景色',
            sunsetFeature2: '日没穏やかな瞑想',
            sunsetFeature3: '毎日提供されるコンプリメントしてハーバルティー',
            sunsetFeature4: '毎晩のフォトジェニックな瞬間',
            sunsetImageAlt: 'Mahi Beach Ayurveda Resortでの夜間日没',
            bestTime: 'ベストタイム',
            sunsetTime: '午後6時～6時45分',
            poolLabel: '水生の静寂',
            poolTitle: 'プールエリア',
            poolDesc1: '結晶のような水が豪華な熱帯庭園と出会う、当社の素晴らしい無限プールの静寂に没入してください。リラクゼーションと若返りのために設計された、私たちのプールエリアはスリランカの太陽の下でくつろぐための完璧な逃げ場を提供します。',
            poolDesc2: '爽快な朝泳ぎ、良い本を持った午後のラウンジセッション、穏やかな夕方の浸浴を好むかどうかにかかわらず、当社のプールエリアは牧歌的な設定を提供しています。快適なラウンジャー、陰のあるカバナ、気配りのあるプールサイドサービスに囲まれて、すべての瞬間が大切な思い出になります。',
            poolFeature1: '温度制御された無限プール',
            poolFeature2: '熱帯庭園の風景に囲まれた',
            poolFeature3: 'プールサイドのリフレッシュメント＆ヘルシースナック',
            poolFeature4: '傘付きプレミアムラウンジャー',
            poolImageAlt: 'Mahi Beach Resortでリラックスなプールエリア',

            // ゲスト出発セレモニー
            departureLabel: '別れの伝統',
            departureTitle: 'ゲスト出発セレモニー',
            departureDesc1: 'Mahi Beach アーユルヴェーダリゾートでは、スリランカの伝統に根ざした意味のある出発セレモニーを通じて、私たちとのあなたの旅を名誉します。出発の準備をする際、私たちのチームは集まって、安全な旅行と継続的な健康のための祝福を提供します。',
            departureDesc2: 'この心からの儀式には、伝統的な祝福、本格的なスリランカの珍味をフィーチャーした特別な別れメニュー、そして私たちの温もりを持ち帰るための小さな贈り物が含まれています。これは、あなたが出発した後もMahi Beachの思い出が長く大切にされることを保証する私たちの方法です。',
            departureFeature1: '安全な旅行のための伝統的な仏教の祝福',
            departureFeature2: 'パーソナライズされた別れの贈り物と記念品',
            departureFeature3: 'スリランカの珍味を含む特別な出発メニュー',
            departureFeature4: '神聖な儀式を伴う祝福セレモニー',
            departureImageAlt: 'Mahi Beach Resortでのゲスト出発セレモニー',

            // TripAdvisor
            tripadvisorLabel: 'TripAdvisor',
            tripadvisorTitle: 'ゲストレビュー',

            testimonialsTitle: '彼らの滞在中のゲスト',
            testimonialsLabel: 'ゲストストーリー',

            // Video Section
            videoLabel: '沈浸体験',
            videoTitle: 'Mahi Beach を発見',
            videoDescription: '沈浸型ビデオジャーニーを通じて、Mahi Beach アーユルヴェーダリゾートの美しさと静けさを体験してください。世界クラスの設備、美しいビーチ、若返りのウェルネス体験を探索してください。',

            // Featured Room
            featuredRoomLabel: 'シグネチャー宿泊',
            featuredRoomTitle: 'デラックスダブルルーム（海景）',

            // Booking Bar
            bookingResort: 'リゾート',
            bookingResortName: 'Mahi Beach Ayurveda Resort',
            bookingCheckIn: 'チェックイン',
            bookingCheckOut: 'チェックアウト',
            bookingGuests: 'ゲスト',
            booking1Guest: '1名',
            booking2Guests: '2名',
            booking3Guests: '3名',
            bookingCheckAvailability: '空室状況を確認',

            // Hero Buttons
            heroExploreButton: 'Mahi Beach を探索',
            heroBookButton: 'デラックスルームを予約'
        },
    },
    cs: {
        about: {
            heroTitle: 'O nás',
            heroSubtitle: 'Mahi Beach Ayurveda Resort',
            heroBeachResort: 'Beach Resort',
            heroTagline1: 'Staré hlášky se setkávají s moderním v Mahi Beach Ayurveda Resort',
            heroTagline2: 'Personalizované ayurvédské léčby, výhled na oceán a autentické hotelnictví Sri Lanky',
            heroDescription: 'Zažijte autentický ayurvédský wellness v našem vyznačeném Deluxe pokoji, kde se oceánský klid setkává s nečasovým uzdravením.',
            bookDeluxeRoom: 'Rezervujte svůj Deluxe pokoj',
            bookDeluxeRoomShort: 'Rezervovat Deluxe pokoj',
            slide1: 'Deluxe klid',
            slide2: 'Ayurvédská harmonie',
            slide3: 'Pobřežní luxus',
            slide4: 'Přirozená elegance',
            slide5: 'Únik pro uzdravení',
            historyLabel: 'Naše cesta',
            historyTitle: 'Historie resortu Mahi Beach Ayurveda Resort',
            historyDesc1: 'Mahi Beach Ayurveda Resort byl založen v roce 2025 na základě vize vytvořit svatyni, kde se staré ayurvédské moudrosti setkává s klidnou krásou jižnícího pobřeží Sri Lanky. Vytvořili jsme jednu z nejoblíbenějších destinací Maggonay pro holistické uzdravení a omlazení.',
            historyDesc2: 'Naši zakladatelé, inspirovaní generacemi tradičních ayurvédských praktiků, se snažili zachovat tato prověřená léčebná umění a přitom poskytovat moderní pohodlí a autentické hotelnictví Sri Lanky. Od našeho otevření jsme zůstali věrni našemu závazku autentických zážitků a poskytování osobní péče definující naše dědictví.',
            historyDesc3: 'V Mahi Beach Ayurveda Resort vítáme hosty z celého světa. Každý návštěvník se stává součástí naší příběhu a nachází rovnováhu, uzdravení a transformaci v našem pobřežním útulném.',
            statYear: '2025',
            statYearLabel: 'Založeno',
            statGuest: 'Světová třída',
            statGuestLabel: 'Spokojení hosté obsluhováni',
            experienceLegacy: 'Zažijte naši vizi',
            established: 'Založeno',
            since2010: 'Od roku 2025',
            chairmanLabel: 'Vize předsedy',
            chairmanTitle: 'Zakořeněn v tradici, inspirován wellness',
            chairmanDesc1: 'Vítejte v Mahi Beach Ayurveda Resort. Naše vize od roku 2025 je vytvořit svatyni, kde se setkává starodávná ayurvédská moudrost s moderním komfortem, vše zahalené v opravdové vřelosti hotelnictví Sri Lanky.',
            chairmanDesc2: 'Každý aspekt našeho resortu — od personalizovaných léčeb a výživné kuchyně po klidnou atmosféru našich prostorů — je pečlivě vytvořen na podporu vaší cesty k wellness, rovnováze a vnitřnímu klidu. Je naším privilegiem doprovázet vás na této transformační cestě.',
            chairmanDesc3: 'Osobně vás vítám, abyste objevili harmonii, autentičnost a klid, které jsou základem Mahi Beach.',
            chairmanSignature: '— Mr. Mahinda',
            chairmanBadge: 'Předseda',
            chairmanName: 'Mr. Mahinda',
            chairmanImageAlt: 'Předseda Mr. Mahinda',
            staffLabel: 'Náš tým',
            staffTitle: 'Poznáte náš oddaný personál',
            staffDesc1: 'V Mahi Beach Ayurveda Resort je náš tým jádrem všeho, co děláme. Členové našeho personálu jsou pečlivě vybraní a vyškolení odborníci, kteří sdílejí hlubokou vášeň pro ayurvédský a autentické hotelnictví.',
            staffDesc2: 'Ot našich zkušených ayurvédských praktiků a kvalifikovaných masérů až po náš oddaný tým v hotelnictví, každý člen přináší roky odbornosti a autentické péče do každé interakce s hosty. Věříme, že skutečný nepochází jen z léčeb, ale z vřelosti a pozornosti lidí, kteří se opravdu starají o vaši cestu.',
            staffDesc3: 'Náš personál prochází nepřetržitým školením v nejnovějších ayurvédských praktikách a udržuje nejvyšší standardy profesionality a kulturní citlivosti. Jsme na tvorbě smysluplných připojení s našimi hosty hrdí a zajišťujeme, aby každá návštěva zažívala paměť a transformační zkušenost.',
            statStaff: '15+',
            statStaffLabel: 'Kvalifikovaní odborníci',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Spokojenost hostů',
            staffImageAlt: 'Náš oddaný tým personálu v Mahi Beach Ayurveda Resort',
            commitmentBadge: 'Náš závazek',
            excellenceCare: 'Dokonalost a péče',
            ctaLabel: 'Kontaktní',
            ctaHeading: 'Jste připraveni zahájit svou cestu?',
            ctaDesc: 'Kontaktujte náš tým a rezervujte si svůj personalizovaný ayurvédský útulný. Pokud máte otázky ohledně našich léčby, ubytování nebo speciálního balíčky, jsme tu proto, abychom vám pomohli vytvořit vaší dokonalou únik.',
            ctaButtonContact: 'Kontaktujte nás nyní',
            ctaButtonRooms: 'Prozkoumejte pokoje',
            contactUs: 'Kontaktujte nás',
            quickInfoCall: 'Zavolejte nám',
            quickInfoEmail: 'Pošli nam email',
            quickInfoLocation: 'Poloha',
            locationCity: 'Maggona Sri Lanka'
        },
        rooms: {
            heroTitle: 'Vaše svatyně na vás čeká',
            heroSubtitle: 'Pokoje pečlivě navržené pro uzdravení, obnovu a hluboký klid.',
            heroAlt: 'Pokoje Mahi Beach Ayurveda Resort',
            exploreRooms: 'Prozkoumejte naše pokoje',
            filterAll: 'Vše',
            filterLuxurySuite: 'Luxusní apartmá',
            filterDeluxeRooms: 'Pokoje Deluxe',
            filterDeluxeSeaView: 'Pokoj Deluxe s výhledem na moře',
            noRoomsFound: 'V této kategorii nebyly nalezeny žádné pokoje.',
            allRoomsInclude: 'Všechny pokoje zahrnují',
            essentialComforts: 'Základní pohodlí pro vaši cestu',
            roomSize: 'Velikost pokoje',
            guests: 'Hosté',
            amenities: 'Vybavení',
            roomAmenities: 'Vybavení pokoje',
            specialFeatures: 'Speciální funkce',
            bookNow: 'Rezervovat nyní',
            viewDetails: 'Zobrazit podrobnosti',
            viewFullDetails: 'Zobrazit všechny podrobnosti',
            highSpeedWifi: 'Vysokorychlostní WiFi',
            herbalTea: 'Výběr bylinných čajů',
            climateControl: 'Kontrola klimatu',
            rainShower: 'Sprcha jako déšť',
            organicToiletries: 'Bio. toaletní potřeby',
            dailyHousekeeping: 'Denní úklid pokoje',
            concierge: 'Concierge 24/7',
            yogaMat: 'Yogamate a příslušenství',
            beginHealing: 'Začněte svou cestu k uzdravení',
            beginHealingDesc: 'Zažijte autentické ájurvédické v prostředí navrženém tak, aby živilo vaše tělo, uklidnilo vaši mysl a obnovilo vaši duši.',
            reserveRoom: 'Rezervujte si pokoj',
            speakAdvisor: 'Mluvit s poradcem wellness',
            exploreOurRooms: 'Prozkoumejte naše pokoje',
            viewRoom: 'Zobrazit pokoj',
            luxurySuiteName: 'Luxusní apartmá',
            luxurySuiteCategory: 'Luxusní apartmá',
            luxurySuiteDesc: 'Zažijte maximální klid v našem prostorném luxusním apartmá navrženém podle tradičních ájurvédských principů s okamžitou mořskou scenérií.',
            deluxeRoomName: 'Pokoj Deluxe',
            deluxeRoomCategory: 'Pokoj Deluxe',
            deluxeRoomDesc: 'Harmonicky navržený pokoj s přírodními prvky z dřeva a zklidňujícími vodními prvky pro dokonalý klid.',
            seaViewDeluxeName: 'Deluxe s výhledem na moře',
            seaViewDeluxeCategory: 'Pokoj Deluxe s výhledem na moře',
            seaViewDeluxeDesc: 'Probuďte se s uklidňujícím mořským vánkem a panoramatickým výhledem na moře v tomto elegantně navrženém pokoji Deluxe.',
            kingSizeBed: 'Postel King-Size',
            herbalTeaCoffee: 'Bylinný čaj a káva',
            individuallyControlledAC: 'Individuálně řízená klimatizace',
            premiumOrganicToiletries: 'Prémiové organické toaletní potřeby',
            dailyFreshFlowers: 'Denní čerstvé květiny',
            beachView: 'Výhled na pláž',
            signatureAccommodation: 'Charakteristické ubytování',
            inRoomComfort: 'Pohodlí v pokoji',
            deluxeRoomAmenities: 'Vybavení pokoje Deluxe',
            momentsInDeluxeRoom: 'Okamžiky v pokoji Deluxe',
            experienceAyurvedicLiving: 'Zažijte autentický ájurvédský život v našem charakteristickém pokoji Deluxe',
            reserveYourStay: 'Rezervujte si pobyt',
            deluxeRoom: {
                resortName: 'Mahi Beach Ayurveda Resort',
                heroTitle: 'Pokoj Deluxe s balkonem a výhledem na moře',
                heroSubtitle: 'Kde se luxus snoubí s přírodou',
                bookThisRoom: 'Rezervovat tento pokoj',
                callReservations: 'Zavolejte na rezervace',
                signatureFeatures: 'Významné vlastnosti',
                deluxeRoomName: 'Pokoj Deluxe',
                discoverTheSpace: 'Objevte prostor',
                whatsIncluded: 'Co je zahrnuto',
                deluxeComfortCare: 'Pohodlí a péče Deluxe',
                inclusions: 'Zahrnuté služby',
                coreAmenities: 'Základní vybavení',
                amenityHighSpeedWifi: 'Vysokorychlostní Wi-Fi',
                amenityHerbalTeaCoffee: 'Bylinný čaj a káva',
                amenityIndividuallyControlledAC: 'Individuálně řízená klimatizace',
                amenityRainShower: 'Dešťová sprcha',
                amenityOrganicToiletries: 'Organické toaletní potřeby',
                amenityDailyFreshFlowers: 'Denní čerstvé květiny',
                beginYourHealingStay: 'Začněte svůj léčebný pobyt',
                experienceAyurvedicSerenity: 'Zažijte autentický ájurvdický pokoj v našem charakteristickém pokoji Deluxe',
                checkAvailabilityBook: 'Zkontrolovat dostupnost a rezervovat',
                speakWithReservations: 'Mluvit s rezervacemi',
                reserveThisRoom: 'Rezervovat tento pokoj',
                navAll: 'Všechny pokoje',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe s výhledem na moře',
                navSuite: 'Suite',
                sectionTitle: 'Únik do luxusu a klidu',
                sectionDesc: 'Užijte si perfektní harmonii elegance a pohodlí v našem pokoji Deluxe. Každý detail je navržen tak, aby vytvořil nezapomenutelný zážitek, přičemž mísí moderní vybavení s vřelostí přírody.',
                highlight1Title: 'Klidný azyl',
                highlight1Desc: 'Probuďte se s něžným brušením vln a působivým východem slunce nad oceánem.',
                highlight2Title: 'Elegantní interiéry',
                highlight2Desc: 'Harmonicky navržené prostory s přírodními prvky z dřeva a kamene.',
                highlight3Title: 'Moderní vybavení',
                highlight3Desc: 'Pokročilé vybavení a služby pro snadný pobyt.',
                atAGlance: 'Na první pohled',
                statSize: 'Rozloha',
                statSizeValue: '350 čtverečních stop',
                statView: 'Výhled',
                statViewValue: 'Zahrada',
                statGuests: 'Kapacita',
                statGuestsValue: '2 dospělí',
                statBed: 'Lůžko',
                statBedValue: 'Manželská postel King',
                reserve: 'Rezervovat',
                galleryAlt: 'Pokoj Deluxe',
                inclusionsTitle: 'Co je zahrnuto',
                inclusionsSubtitle: 'Vybavení a služby',
                enhancedCleanliness: 'Vylepšené protokoly čištění',
                inclusion1: 'Bezplatné Wi-Fi v celém pokoji',
                inclusion2: 'Minibar zdarma (nealkoholické nápoje)',
                inclusion3: 'Kávovar a čajové soupravy Nespresso',
                inclusion4: '24hodinová pokojová služba',
                inclusion5: 'Prémiové toaletní potřeby',
                inclusion6: 'Denní služba úklidu',
                amenityGroup1Title: 'Technologie',
                amenityGroup1Item1: '55" Smart TV',
                amenityGroup1Item2: 'Bezplatné Wi-Fi',
                amenityGroup1Item3: 'Bluetooth reproduktor',
                amenityGroup1Item4: 'USB dobíjecí porty',
                amenityGroup2Title: 'Koupelna',
                amenityGroup2Item1: 'Dešťová sprcha',
                amenityGroup2Item2: 'Prémiové toaletní potřeby',
                amenityGroup2Item3: 'Župan a pantofle',
                amenityGroup2Item4: 'Fén',
                amenityGroup3Title: 'Pohodlí',
                amenityGroup3Item1: 'Klimatizace',
                amenityGroup3Item2: 'Stropní ventilátor',
                amenityGroup3Item3: 'Minibar',
                amenityGroup4Title: 'Závěrečné doteky',
                amenityGroup4Item1: 'Kávovar a čajové soupravy',
                amenityGroup4Item2: 'Trezor',
                amenityGroup4Item3: 'Železo a žehlicí prkno',
                essentialsTitle: 'Esenciální možnosti',
                essentialsHeading: 'Vyberte svůj zážitek',
                essentialsDesc: 'Přizpůsobte si svůj pobyt s našimi kurátorovanými doplňky a službami.',
                essential1: 'Spa & wellness',
                essential2: 'Zážitky s jízdou',
                essential3: 'Výlety',
                essential4: 'Vodní sporty',
                oceanTitle: 'Pokoj spojující vás s přírodou',
                oceanSubtitle: 'Kde se krajiny moře, nebe a země harmonicky spojují',
                oceanAlt: 'Oceánský výhled',
                ctaTitle: 'Začněte svou cestu',
                ctaHeading: 'Připraveni si užít klid?',
                ctaDesc: 'Rezervujte si svůj únik do luxusu a objevte dokonalou harmonii mezi elegancí a pohodlím.',
                checkAvailability: 'Zkontrolovat dostupnost'
            }
        },

        navbar: {
            home: 'Domů',
            aboutUs: 'O nás',
            rooms: 'Pokoje',
            ayurveda: 'Ájurvéda',
            yoga: 'Jóga',
            food: 'Stravování',
            events: 'Akce',
            blogs: 'Blogy',
            tours: 'Výlety',
            contactUs: 'Kontakt',
            bookOnline: 'Rezervovat online',
            locationMaggona: 'Maggona Sri Lanka',
            selectResort: 'Vyberte resort',
            language: 'Jazyk',
            mainTitle: 'Mahi Beach Ayurveda Resort',
            resortBeach: 'Mahi Beach Ayurveda Resort',
            resortRiver: 'Mahi Beach Ayurveda Resort'
        },
        footer: {
            description: 'Mahi Beach Ayurveda Resort se zavazuje poskytovat výjimečnou pohostinnost a zážitky, aby se každý host cítil oceněn a znovu nabitý.',
            linksTitle: 'Odkazy',
            contactTitle: 'Kontakt',
            viewLocation: 'Zobrazit polohu',
            navHome: 'Domů',
            navAbout: 'O nás',
            navContact: 'Kontakt',
            navRooms: 'Pokoje',
            navAyurveda: 'Ájurvéda',
            copyright: '© Copyright {{year}} Mahi Beach Ayurveda Resort.',
            developedBy: 'Vyvinuto',
            developerName: 'Redev Solution +94 764 608 225'
        },
        tours: {
            heroTitle: 'Zájezdy a exkurze',
            heroSubtitle: 'Objevte krásu Srí Lanky z Beruwaly',
            kandeAlt: 'Chrám Kande Vihara - Maggona',
            kandeTitle: 'Návštěva chrámu Kande Vihara',
            kandeBuddhaAlt: 'Obří socha Buddhy v chrámu Kande Vihara',
            bentotaTitle: 'Lodní safari po řece Bentota',
            bentotaAlt: 'Lodní safari po řece Bentota - Mangrovové lesy a fauna',
            galleTitle: 'Prohlídka Starého města Galle',
            galleAlt: 'Prohlídka Starého města Galle',
            sigiriyaTitle: 'Prohlídka skalní pevnosti Sigiriya',
            sigiriyaAlt: 'Prohlídka skalní pevnosti Sigiriya',
            kandyTitle: 'Kulturní prohlídka Kandy',
            kandyAlt: 'Kulturní prohlídka Kandy',
            bookTour: 'Rezervovat tento zájezd',
            viewDetails: 'Zobrazit podrobnosti',
            introPara1: 'Srí Lanka je země věčné krásy, kde se zlaté pláže, bujné zelené krajiny, starobylé chrámy a živá kultura setkávají v dokonalé harmonii.',
            introPara2: 'Od poklidného jihozápadního pobřeží přes historická města, posvátná místa, přírodní rezervace až po mlhavou horskou krajinu - každá cesta nabízí jedinečný a nezapomenutelný zážitek.',
            introPara3: 'Počínaje resortem Mahi Beach Ayurveda Resort v Beruwalě jsou naše pečlivě vybrané zájezdy a exkurze navrhnuty tak, aby obohatily váš pobyt a dokonale vyvážily průzkum, relaxaci a wellness.',
            kandeDetail1: 'Chrám Kande Vihara (Kande Viharaya) – jeden z nejvýznamnějších buddhistických chrámů poblíž Beruwaly.',
            kandeDetail2: 'Založený roku 1734, tento klid "Horský chrám" se nachází na vrcholu kopce s poklidnými výhledem na pobřeží.',
            kandeDetail3: 'Mezi zajímavosti patří obrovská 48metrová sedící socha Buddhy (jedna z nejvyšších na Srí Lance), složité fresky z období Kandy, starověká komora ostatků, krásná měsíční brána a posvátný strom Bodhi starý více než 300 let.',
            kandeDetail4: 'Dokonalý duchovní a kulturní zážitek na půl dne – ideální pro ranní návštěvy, aby se zabránilo horku.',
            bentotaDetail1: 'Užijte si klidné a malebné lodní safari podél řeky Bentota, jedné z nejpopulárnějších přírodních exkurzí poblíž Beruwaly.',
            bentotaDetail2: 'Klouzejte přes bujné mangrovové lesy, úzké kanály a klidné vody a pozorujte přitom místní faunu.',
            bentotaDetail3: 'Běžná pozorování zahrnují varance, krokodýly, různé druhy ptáků (ledňáčky, volavky, orly), opice a někdy i vydry nebo vodní hadi.',
            bentotaDetail4: 'Váš zkušený lodní průvodce/průvodce vás upozorní na zajímavou flóru, tradiční metody rybolovu a život v říčních vesnicích.',
            bentotaDetail5: 'Ideální pro milovníky přírody a fotografy – klidné, relaxační a doplňující váš aýurvédský pobyt.',
            galleDetail1: 'Prozkoumejte historickou pevnost Galle, světové dědictví UNESCO a jednu z nejlépe zachovaných koloniálních pevností na Srí Lance.',
            galleDetail2: 'Procházejte se po dlážděných ulicích obklopených holandskými koloniálními budovami, butiky, kavárny a galeriemi umění.',
            galleDetail3: 'Navštivte klíčové památky, jako je majáku Galle, holandský reformovaný kostel, Národní námořní muzeum a hradby s nádherným výhledem na oceán.',
            galleDetail4: 'Poznejte bohatou historii, architekturu a kulturní significance pevnosti od svého znalého průvodce.',
            galleDetail5: 'Ideální pro milovníky historie, příznivce kultury a ty, kteří si chtějí vychutnat kolinální minulost Srí Lanky.',
            sigiriyaDetail1: 'Objevte starobylou skalní pevnost Sigiriya, jeden z nejznamenitějších landmarků Srí Lanky a světové dědictví UNESCO.',
            sigiriyaDetail2: 'Vyjděte na impozantní skálu a prozkoumejte zbytky paláce krále Kašyapy, ozdobené fresky, vodními zahradami a slávistickou Zrcadlovou zdí.',
            sigiriyaDetail3: 'Těšte se na panoramatické pohledy na okolní džungli a krajinu z vrcholu.',
            sigiriyaDetail4: 'Poznejte fascinující historii, architekturu a legendy spojené se Sigiriou od svého odborného průvodce.',
            sigiriyaDetail5: 'Ideální pro milovníky historie, dobrodruhy a ty, kteří se zajímají o bohaté kulturní dědictví Srí Lanky.',
            kandyDetail1: 'Zažijte vibrantní kulturu Kandy, poslední královské hlavní město Srí Lanky a světové dědictví UNESCO.',
            kandyDetail2: 'Navštivte chrám Svatého zubu (Sri Dalada Maligawa), jeden z nejvýznamnějších buddistických míst na světě.',
            kandyDetail3: 'Prozkoumejte Královskou botanickou zahradu v Peradenii, domov obrovské sbírky tropických rostlin a orchidejí.',
            kandyDetail4: 'Užijte si tradiční Kandyánské taneční představení, které předvádí bohaté umělecké dědictví Srí Lanky.',
            kandyDetail5: 'Ideální pro milovníky kultury, historiky a ty, kteří se chtějí ponořit do tradic Srí Lanky.',
            ellaTitle: 'Dobrodružství v horské krajině Ella',
            ellaAlt: 'Tour po horské krajině Ella - Most devíti oblouků a čajové plantáže',
            ellaDetail1: 'Cesta do Elly, jedné z nejmalebějších horských destinací Srí Lanky, proslulé úchvatnými horskými výhledy a chladným podnebím.',
            ellaDetail2: 'Navštivte ikonický Most devíti oblouků, železniční zázrak z koloniální éry zasazený do bujné zeleně, ideální pro fotografování a sledování projíždějících vlaků.',
            ellaDetail3: 'Prozkoumejte zelené čajové plantáže, dozvíte se o výrobě cejlonského čaje a užijte si panoramatické výhledy z Little Adam\'s Peak nebo skály Ella.',
            ellaDetail4: 'Objevte kaskádové vodopády včetně vodopádů Ravana, procházejte se po malebných stezkách a zažijte okouzlující vesničskou atmosféru.',
            ellaDetail5: 'Ideální pro milovníky přírody, dobrodruhy a ty, kteří chtějí uniknout do úchvatných horských oblastí Srí Lanky.'
        },
        blogs: {
            heroTitle: 'Blogy Mahi Beach Ayurveda Resort',
            heroSubtitle1: 'Příběhy z pobřeží, ayurvédské rituály v',
            heroSubtitle2: 'Mahi Beach Ayurveda Resort',
            heroSubtitle3: '. Ponořte se do tipů, historie a zákulisních poznámek.',
            heroAlt: 'Pobřežní cesta resortu při západu slunce',
            sectionTitle: 'Blogy Mahi Beach Ayurveda Resort',
            sectionDescription: 'Průvodce, příběhy a poznámky z našeho pobřežního útočiště — od ayurvédských rituálů přes historii drahých kamenů až po cestovní tipy kolem Bentoty.',
            ayurvedaTitle: 'Srdce autentického Ayurvedy',
            ayurvedaExcerpt: 'Zažijte osvědčené léčivé tradice zakořeněné v dávné moudrosti Srí Lanky.',
            ayurvedaDescription: 'V Mahi Beach Ayurveda Resort je Ayurveda víc než léčba — je to způsob života. Naše terapie jsou založeny na staletých znalostech, přizpůsobené vašemu typu těla a vedené zkušenými ayurvédskými lékaři pro hlubokou a trvalou rovnováhu.',
            ayurvedaAlt: 'Ayurvédské léčení s bylinkovými oleji a přírodními prvky',
            healingTitle: 'Personalizované léčivé cesty',
            healingExcerpt: 'Proč je program každého hosta jedinečně navržený.',
            healingDescription: 'Od úvodních konzultací až po denní ošetření je vaše léčivá cesta pečlivě přizpůsobena. Bylinné terapie, terapeutické masáže, jóga a meditace spolupracují na obnově harmonie mezi tělem, myslí a duší.',
            healingAlt: 'Ayurvédský lékař konzultuje hosta v klidném prostředí',
            natureTitle: 'Léčení u oceánu',
            natureExcerpt: 'Jak mořský vánek a tropické okolí posilují vaši pohodu.',
            natureDescription: 'Mahi Beach leží podél klidného pobřeží Srí Lanky a nabízí přirozeně léčivé prostředí. Zvuk vln, čerstvý oceánský vzduch a bujná zeleň zesílují účinky Ayurvedy a vytvářejí hluboký odpočinek a obnovu.',
            natureAlt: 'Pohled na pláž resortu s palmami a oceánem',
            foodTitle: 'Ayurvédská kuchyně pro vnitřní rovnováhu',
            foodExcerpt: 'Výživná jídla vytvořená na podporu vaší léčby.',
            foodDescription: 'Naše ayurvédská kuchyně je čerstvě připravována ze sezonních, místně získaných surovin. Každé jídlo je sladěno s vaší došou, podporuje trávení, detoxikaci a celkovou vitalitu, přičemž zůstává chutné a uspokojivé.',
            foodAlt: 'Tradiční ayurvédské jídlo servírované v přírodních miskách',
            yogaTitle: 'Jóga, meditace a vnitřní klid',
            yogaExcerpt: 'Jemné praktiky, které uklidňují mysl a posilují tělo.',
            yogaDescription: 'Denní jógové a meditační lekce doplňují vaše ošetření, zlepšují flexibilitu, dýchání a duševní jasnost. Tyto vědomé praktiky vám pomáhají znovu se spojit se sebou a унest pocit klidu i po vašem pobytu.',
            yogaAlt: 'Hosté cvičící jógu tváří k oceánu za úsvitu',
            lifestyleTitle: 'Vzít si Ayurvedu domů',
            lifestyleExcerpt: 'Jednoduché životní praktiky pro pokračování vaší cesty.',
            lifestyleDescription: 'Před odjezdem vás naši experti poradí, jak udržet rovnováhu pomocí denních rutin, stravy a rituálů sebepéče. Vezměte si domů víc než vzpomínky — vezměte si udržitelnou cestu ke zdravějšímu životu.',
            lifestyleAlt: 'Host relaxující s bylinkovým čajem v klidném prostředí resortu',
            readMore: 'Číst více'
        },
        events: {
            heroEyebrow: 'Zážitky a aktivity',
            heroTitle: 'Naše akce',
            heroSubtitle: 'Pečlivě vybrané zážitky spojující srílanskou tradici s pobřežním luxusem',
            heroAlt: 'Akce v Mahi Beach',
            availableDaily: 'Denně k dispozici',
            bookNow: 'Rezervovat',
            highlightsTitle: 'Hlavní body',
            detailAlt: '{{title}} – detail',
            ctaTitle: 'Připraveni vytvářet vzpomínky?',
            ctaDescription: 'Kontaktujte náš tým a přizpůsobte si dokonalý zážitek z akce v Mahi Beach Ayurveda Resort',
            ctaContact: 'Kontaktujte nás',
            ctaViewRooms: 'Zobrazit pokoje',
            buddhistMonkMeditationTitle: 'Meditace s buddhistickými mnichy',
            buddhistMonkMeditationSubtitle: 'Tradiční praktiky všímavosti',
            buddhistMonkMeditationDescription: 'Zažijte autentickou buddhistickou meditaci vedenou zkušenými mnichy v našem klidném resortu. Tyto starobylé praktiky podporují vnitřní klid, všímavost a duchovní pohodu prostřednictvím vedených sezení kombinujících tradiční zpěv, dechové techniky a tichou meditaci.',
            buddhistMonkMeditationHighlight1: 'Tradiční buddhistické meditační sezení',
            buddhistMonkMeditationHighlight2: 'Vedení zkušenými mnichy',
            buddhistMonkMeditationHighlight3: 'Klidné vnitřní prostředí resortu',
            buddhistMonkMeditationHighlight4: 'Techniky všímavosti a dýchání',
            buddhistMonkMeditationHighlight5: 'Praktiky duchovní pohody',
            cookeryTitle: 'Kuchařské programy',
            cookerySubtitle: 'Chuť Srí Lanky',
            cookeryDescription: 'Ponořte se do živých chutí srílanské kuchyně. Naši zkušení šéfkuchaři vás provedou praktickými kulinářskými lekcemi a naučí tradiční recepty předávané po generace. Naučte se připravovat aromatická kari, hoppers, kokosový sambol a další jídla z čerstvých místních surovin.',
            cookeryHighlight1: 'Tradiční srílanské recepty',
            cookeryHighlight2: 'Praktická kuchařská zkušenost',
            cookeryHighlight3: 'Čerstvé místní suroviny',
            cookeryHighlight4: 'Recepty s sebou domů',
            cookeryHighlight5: 'Včetně prohlídky zahrady s kořením',
            meditationTitle: 'Meditační programy',
            meditationSubtitle: 'Vnitřní klid a všímavost',
            meditationDescription: 'Najděte klid v našich vedených meditacích na pozadí klidného Indického oceánu. Naši zkušení instruktoři vás provedou starodávnými technikami všímavosti, dechovými cvičeními a jógovými praktikami, které uklidňují mysl a obnovují ducha.',
            meditationHighlight1: 'Sezení při východu a západu slunce',
            meditationHighlight2: 'Meditace na pláži',
            meditationHighlight3: 'Vedené odborníky',
            meditationHighlight4: 'Dechové techniky',
            meditationHighlight5: 'Jóga a všímavost',
            nightBeachPartiesTitle: 'Grilový večer',
            nightBeachPartiesSubtitle: 'Kulinářský zážitek na pláži',
            nightBeachPartiesDescription: 'Dopřejte si nezapomenutelný grilový večer na pláži pod hvězdami. Vychutnejte si čerstvě grilované mořské plody, prémiové maso a čerstvou zeleninu, zatímco si užíváte uklidňujícího zvuku oceánských vln. Naši zkušení kuchaři připravují každé jídlo k dokonalosti a vytvářejí nezapomenutelný kulinářský zážitek v kouzelném pobřežním prostředí.',
            nightBeachPartiesHighlight1: 'Čerstvě grilované mořské plody a maso',
            nightBeachPartiesHighlight2: 'Živá ukázka grilování kuchaři',
            nightBeachPartiesHighlight3: 'Atmosféra stolování u oceánu',
            nightBeachPartiesHighlight4: 'Výběr prémiového BBQ bufetu',
            nightBeachPartiesHighlight5: 'Plážová atmosféra s táborákem',
            bbqTitle: 'BBQ večírky',
            bbqSubtitle: 'Oslavy u moře',
            bbqDescription: 'Zažijte nezapomenutelné večery s našimi BBQ večírky na pláži. Vychutnejte si čerstvě grilované mořské plody, prémiové maso a vegetariánské dobroty, zatímco vlny šumí poblíž. Živá hudba, ohňoví tanečníci a hvězdná obloha vytvářejí dokonalou atmosféru pro oslavu a propojení.',
            bbqHighlight1: 'Čerstvé grilované mořské plody',
            bbqHighlight2: 'Stravování u oceánu',
            bbqHighlight3: 'Živá zábava',
            bbqHighlight4: 'Zážitek s ohněm',
            bbqHighlight5: 'Přizpůsobitelné menu',
            boatTitle: 'Projížďky lodí',
            boatSubtitle: 'Říční a pobřežní dobrodružství',
            boatDescription: 'Vydejte se na okouzlující plavby po řece Bentota a pobřežních vodách. Proplouvejte mangrovovými lesy, pozorujte exotické ptáky a divokou přírodu nebo si užijte romantické plavby při západu slunce. Naše projížďky lodí nabízejí jedinečný pohled na přírodní krásu Srí Lanky a její rozmanité ekosystémy.',
            boatHighlight1: 'Plavby po řece Bentota',
            boatHighlight2: 'Průzkum mangrovů',
            boatHighlight3: 'Pozorování divoké přírody',
            boatHighlight4: 'Plavby při západu slunce',
            boatHighlight5: 'Soukromý charter k dispozici',
            ayurvedaLecturesTitle: 'Přednášky lékařů ajurvédy',
            ayurvedaLecturesSubtitle: 'Starověká moudrost a moderní wellness',
            ayurvedaLecturesDescription: 'Objevte hluboké principy ajurvédy prostřednictvím přednášek vedených certifikovanými ajurvédskými lékaři a praktiky. Dozvíte se o vyvažování dóš, bylinných prostředcích, holistických léčebných praktikách a o tom, jak se starověká moudrost uplatňuje v moderním wellness. Naše interaktivní sezení objasňují ajurvédskou filosofii a její použití v každodenním životě.',
            ayurvedaLecturesHighlight1: 'Certifikovaní ajurvédští lékaři',
            ayurvedaLecturesHighlight2: 'Personalizovaná analýza dóš',
            ayurvedaLecturesHighlight3: 'Vzdělávání o bylinných prostředcích',
            ayurvedaLecturesHighlight4: 'Včetně Q&A sezení',
            ayurvedaLecturesHighlight5: 'průvodce na cestu',
            musicTherapyTitle: 'Muzikoterapie',
            musicTherapySubtitle: 'Uzdravení zvukem',
            musicTherapyDescription: 'Zažijte transformativní sílu muzikoterapie v našem klidném oceánském prostředí. Zkušení terapeuti používají tradiční a moderní nástroje k vytváření terapeutických zvukových zážitků, které podporují hlubokou relaxaci, emocionální uvolnění a celkové uzdravení.',
            musicTherapyHighlight1: 'Profesionálně vedené terapeutické sezení',
            musicTherapyHighlight2: 'Tradiční a moderní nástroje',
            musicTherapyHighlight3: 'Relaxační a emoční uvolňovací terapie',
            musicTherapyHighlight4: 'Zvukové meditační workshopy',
            musicTherapyHighlight5: 'Harmonizace mysli-těla-ducha',
            taiChiTitle: 'Tai Chi',
            taiChiSubtitle: 'Jemný pohyb a rovnováha',
            taiChiDescription: 'Cvičte starověké umění Tai Chi v naší klidné zahradě u moře. Tyto elegantní, plynulé pohyby zlepšují rovnováhu, flexibilitu a vnitřní sílu a zároveň uklidňují mysl. Vhodné pro všechny úrovně kondice a věk.',
            taiChiHighlight1: 'Denní hodiny při východu slunce',
            taiChiHighlight2: 'Vedené certifikovanými mistry',
            taiChiHighlight3: 'Zlepšuje rovnováhu a flexibilitu',
            taiChiHighlight4: 'Vhodné pro všechny věkové kategorie',
            taiChiHighlight5: 'Bojové umění a meditační praktiky',
            traditionalClothsTitle: 'Akce s tradičním oděvem',
            traditionalClothsSubtitle: 'Zážitek kulturního dědictví',
            traditionalClothsDescription: 'Ponořte se do srílanského kulturního dědictví tím, že se naučíte nosit a oceňovat tradiční oděv. Naši odborní stylisté vás provedou oblékáním autentických kandyských sárí a tradičních oděvů a vysvětlí kulturní význam každého kusu. Ideální pro zvláštní příležitosti, kulturní ocenění nebo vytvoření nezapomenutelných fotografií.',
            traditionalClothsHighlight1: 'Odborné stylistické vedení',
            traditionalClothsHighlight2: 'Autentická tradiční sárí',
            traditionalClothsHighlight3: 'Vysvětlení kulturního významu',
            traditionalClothsHighlight4: 'Profesionální fotografování v ceně',
            traditionalClothsHighlight5: 'Workshopy módní fúze',
            shanthiKarmaTitle: 'Kulturní tanec',
            shanthiKarmaSubtitle: 'Tradiční srílanské představení',
            shanthiKarmaDescription: 'Ponořte se do živého světa srílanského kulturního tance. Zažijte fascinující tradiční představení s barevnými kostýmy, rytmickými bubny a starověkým vyprávěním prostřednictvím pohybu. Naši talentovaní tanečníci předvádějí staletí staré lidové tance, Kandyan tanec a kulturní rituály, které přivádějí srílanské dědictví k životu.',
            shanthiKarmaHighlight1: 'Autentické tradiční srílanské tance',
            shanthiKarmaHighlight2: 'Barevné tradiční kostýmy a makeup',
            shanthiKarmaHighlight3: 'Živý bubnový doprovod',
            shanthiKarmaHighlight4: 'Kulturní vyprávění prostřednictvím pohybu',
            shanthiKarmaHighlight5: 'Představení Kandyan a lidového tance',
        },
        contact: {
            heroTitle: 'Kontaktujte nás',
            heroSubtitle: 'Mahi Beach Ayurveda Resort',
            heroAlt: 'Kontaktujte nás',
            sectionTitle: 'Neváhejte nás kontaktovat',
            sectionSubtitle: 'Jsme tu, abychom vám pomohli relaxovat a načerpat síly',
            sectionDescription: 'Kontaktujte Mahi Beach Ayurveda Resort ohledně ayurvédského pobytu, balíčků, rezervací nebo jakýchkoli dotazů během pobytu v Beruwale, Moragalle.',
            callUs: 'Zavolejte nám',
            emailTitle: 'Email',
            ourLocation: 'Naše poloha',
            locationAddress: 'No.112 rendagewatta Galle Rd, Maggona',
            socialNetwork: 'Sociální sítě',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Spojte se s námi',
            getInTouchDescription: 'Rádi vás uslyšíme — náš tým je připraven pomoci s vaším pobytem, odpovědět na otázky a naplánovat regenerující pobyt.',
            nameLabel: 'Jméno',
            emailLabel: 'Email',
            contactNumberLabel: 'Kontaktní číslo',
            messageLabel: 'Zpráva',
            sending: 'Odesílání...',
            sendMessage: 'Odeslat zprávu',
            successMessage: 'Vaše zpráva byla úspěšně odeslána! Brzy se ozveme.',
            errorMessage: 'Při odesílání došlo k chybě. Zkuste to prosím znovu.',
            findUsOnMap: 'Najděte nás na mapě',
            whatsappSubject: 'Kontakt Mahi Beach Ayurveda Resort',
            whatsappName: 'Jméno',
            whatsappEmail: 'Email',
            whatsappContactNumber: 'Kontaktní číslo',
            whatsappMessage: 'Zpráva'
        },


        ayurveda: {
            accordionTitle1: 'Pochopte Pančakarmu',
            accordionDesc1: 'Ájurvéda („věda o životě") patří k nejstarším celostním léčebným systémům na světě, vznikla před více než 5 000 lety. Pančakarma stojí na harmonii mysli, těla, duše a prostředí. Cílem je posílit zdraví a předcházet potížím, přičemž terapie se přizpůsobují jednotlivci.',
            accordionTitle2: 'Pančakarma a životní energie',
            accordionDesc2: 'Ájurvéda učí, že vše ve vesmíru je propojené. Když jsou mysl, tělo a duše v souladu, přichází pohoda; při narušení rovnováhy se objevují potíže. Ovlivnit ji může dědičnost, zranění, roční období, věk i emoce.\n\nČlověk je tvořen pěti prvky: prostor, vzduch, oheň, voda a země. Ty vytvářejí tři dóšy: VÁTA (prostor/vzduch), PITTA (oheň/voda) a KAPHA (voda/země), které řídí funkce těla.\n\nKaždý má jedinečnou směs dóš, obvykle s jednou dominantní. Jejich rovnováha ovlivňuje zdraví a vnímavost.',
            accordionTitle3: 'Dóša Váta',
            accordionDesc3: 'Váta je považována za nejvlivnější; řídí pohyb, dýchání, oběh, srdeční rytmus i vylučování. Vyvádí ji z míry nepravidelné jídlo, strach, smutek a ponocování.\n\nPři dominantní Vátě býváte bystří, kreativní a energičtí, často štíhlejší a citliví na chlad. V nerovnováze se může objevit úzkost a neklid.\n\nVyvážení přináší uzemnění: meditace, masáže, pravidelný režim a teplá, jemná strava.',
            accordionTitle4: 'Dóša Pitta',
            accordionDesc4: 'Pitta řídí trávení, metabolismus a hormony chuti k jídlu. Zhoršují ji pálivá či kyselá jídla, nadměrné horko a vynechaná jídla.\n\nPitta‑dominantní lidé jsou cílevědomí, soutěživí a sebejistí, často s „teplejší" konstitucí. V nerovnováze se projevuje podrážděnost či záněty.\n\nRovnováhu podporují chladivé lehké pokrmy a uklidňující praktiky, například jemná jóga.',
            accordionTitle5: 'Dóša Kapha',
            accordionDesc5: 'Kapha přináší stabilitu, sílu, strukturu a imunitu. Zvyšuje ji příliš sladkého, těžká jídla a nadměrný spánek.\n\nKapha‑dominantní lidé jsou klidní, trpěliví a vyrovnaní, často s robustnější postavou. V nerovnováze se objevuje únava, zpomalení a přibírání.\n\nVyvážení pomáhá lehčí strava, více ovoce a zeleniny a pravidelný pohyb.',
            close: 'Zavřít',
            next: 'Další',
            previous: 'Předchozí',
            treatmentsTitle: 'Naše signaturní procedury Pančakarmy',
            treatmentsSubtitle: 'Tradiční rituály, které vracejí rovnováhu, uvolňují napětí a obnovují tělo i mysl.',
            bookTreatment: 'Rezervovat tuto proceduru',
            benefitsTitle: 'Přínosy procedur Pančakarma',
            shirodhara: 'Šíródára',
            shirodharaDesc: 'Teplý bylinný olej jemně stéká na čelo a zklidňuje nervový systém.',
            shirodhara1: 'Zklidňuje stres a úzkost',
            shirodhara2: 'Podporuje hlubší spánek',
            shirodhara3: 'Zvyšuje duševní jasnost',
            steamBath: 'Parní lázeň',
            steamBathDesc: 'Bylinná pára otevírá póry, podporuje očistu a uvolňuje svaly.',
            steamBath1: 'Podporuje jemnou detoxikaci',
            steamBath2: 'Zlepšuje krevní oběh',
            steamBath3: 'Uvolňuje svalové napětí',
            flowerBath: 'Květinová lázeň',
            flowerBathDesc: 'Voňavá květinová koupel pro relax a znovunabití.',
            flowerBath1: 'Zklidňuje nervový systém',
            flowerBath2: 'Hydratuje a zjemňuje pokožku',
            flowerBath3: 'Zlepšuje náladu',
            headMassage: 'Masáž hlavy',
            headMassageDesc: 'Masáž pokožky hlavy uvolní nahromaděné napětí.',
            headMassage1: 'Ulevuje od tlaku v hlavě',
            headMassage2: 'Vyživuje pokožku a kořínky vlasů',
            headMassage3: 'Podporuje hlubokou relaxaci',
            faceMassage: 'Masáž obličeje',
            faceMassageDesc: 'Jemná masáž obličeje obnovuje jas a snižuje stres.',
            faceMassage1: 'Rozjasňuje pleť',
            faceMassage2: 'Uvolňuje napětí v obličeji',
            faceMassage3: 'Podporuje lymfatický tok',
            neckMassage: 'Masáž krku',
            neckMassageDesc: 'Cílená péče pro uvolnění krku.',
            neckMassage1: 'Zmírňuje diskomfort v krku',
            neckMassage2: 'Zlepšuje pohyblivost',
            neckMassage3: 'Snižuje stres',
            shoulderMassage: 'Masáž ramen',
            shoulderMassageDesc: 'Terapeutická masáž pro ztuhlá ramena.',
            shoulderMassage1: 'Ulevuje od bolesti ramen',
            shoulderMassage2: 'Podporuje lepší držení těla',
            shoulderMassage3: 'Uvolňuje svalové uzly',
            bodyMassage: 'Celotělová masáž',
            bodyMassageDesc: 'Celotělový rituál pro uvolnění a obnovu.',
            bodyMassage1: 'Podporuje cirkulaci',
            bodyMassage2: 'Zmírňuje svalovou únavu',
            bodyMassage3: 'Navozuje hluboký klid',
            backMassage: 'Masáž zad',
            backMassageDesc: 'Péče o záda pro uvolnění napětí a bolesti.',
            backMassage1: 'Ulevuje od bolesti zad',
            backMassage2: 'Podporuje komfort páteře',
            backMassage3: 'Snižuje stres',
            footMassage: 'Masáž nohou',
            footMassageDesc: 'Uzemňující masáž chodidel pro celkový klid.',
            footMassage1: 'Podporuje krevní oběh',
            footMassage2: 'Ulevuje unaveným nohám',
            footMassage3: 'Navozuje zklidnění',
            purgative: 'Projímadlo',
            purgativeDesc: 'Očistná terapie k odstranění přebytečné Pitty a toxinů z trávení.',
            purgative1: 'Čistí střeva',
            purgative2: 'Vyvažuje Pittu',
            purgative3: 'Podporuje trávení',
            nasalClearing: 'Nosní čištění',
            nasalClearingDesc: 'Bylinné nosní ošetření pro volné dýchání.',
            nasalClearing1: 'Uvolňuje ucpaný nos',
            nasalClearing2: 'Zlepšuje dýchání',
            nasalClearing3: 'Zmírňuje tlak v dutinách',
            powderMassage: 'Prášková masáž',
            powderMassageDesc: 'Exfoliace bylinkovými prášky pro svěží pokožku.',
            powderMassage1: 'Odstraňuje zrohovatělou pokožku',
            powderMassage2: 'Zjemňuje texturu pleti',
            powderMassage3: 'Podporuje prokrvení',
            intensiveMassageDesc: 'Hloubková terapie na chronické napětí a zatuhlé uzly.',
            intensiveMassage1: 'Uvolňuje hluboké napětí',
            intensiveMassage2: 'Zlepšuje krevní tok',
            intensiveMassage3: 'Snižuje přetrvávající bolest',
            thermoMassage: 'Termomasáž',
            thermoMassageDesc: 'Teplé bylinné oleje uvolňují tkáně a podporují regeneraci.',
            thermoMassage1: 'Uklidňuje bolavé svaly',
            thermoMassage2: 'Podporuje hluboké uvolnění',
            thermoMassage3: 'Harmonizuje tok energie',
            synchronMassage: 'Synchronní masáž',
            synchronMassageDesc: 'Synchronní masáž dvěma terapeuty pro celkovou harmonii.',
            synchronMassage1: 'Harmonie celého těla',
            synchronMassage2: 'Vyrovnaný tok energie',
            synchronMassage3: 'Hluboký relaxační zážitek',
            specialMassage: 'Speciální masáž',
            specialMassageDesc: 'Masáž na míru podle vašich potřeb a wellness cílů.',
            specialMassage1: 'Individuální přístup',
            specialMassage2: 'Zaměřeno na konkrétní potíže',
            specialMassage3: 'Cílená léčebná péče',
            benefit1Title: 'Detox podpora:',
            benefit1Desc: 'Pančakarma pomáhá uvolnit nahromaděné toxiny a obnovit vitalitu.',
            benefit2Title: 'Snadnější trávení:',
            benefit2Desc: 'Terapie podporují plynulé trávení a lepší vstřebávání živin.',
            benefit3Title: 'Reset stresu:',
            benefit3Desc: 'Uklidňující procedury snižují napětí i úzkost.',
            benefit4Title: 'Imunitní odolnost:',
            benefit4Desc: 'Pravidelná péče posiluje obranyschopnost.',
            benefit5Title: 'Obnova:',
            benefit5Desc: 'Podporuje buněčnou regeneraci a zdravou, svěží pleť.',
            benefit6Title: 'Rovnováha dóš:',
            benefit6Desc: 'Navrací harmonii Vátě, Pittě a Kaphě pro dlouhodobou pohodu.',
            akkupancharTitle: 'Akupunktura terapie',
            akkupancharDesc1: 'je starodávná terapeutická praxe využívající tenké jehly na specifických bodech těla. Toto ošetření stimuluje energetické kanály a podporuje léčení.',
            akkupancharBenefit: 'Hlavní výhody:',
            akkupancharDesc2: 'Tato specializovaná terapie pomáhá při chronických bolestech, zlepšuje flexibilitu kloubů, podporuje krevní oběh a obnovuje přirozený tok energie.',
            akkupancharApplication: 'Terapeutická aplikace:',
            akkupancharDesc3: 'Akupunktura působí na specifické marma body s pečlivě vybranými technikami k vyvážení dóš.',
            akkupancharTransform: 'Zažijte transformaci:',
            akkupancharDesc4: 'V Mahi Beach Ayurveda Resort naši zkušení terapeuti přizpůsobují každé sezení akupunktury vašim zdravotním potřebám.',
            experienceAkkupanchar: 'Zažijte akupunkturu dnes',
            doctorsEyebrow: 'NÁŠ TÝM EXPERTŮ',
            doctorsSectionTitle: 'Naši lékaři',
            drSandyaName: 'Dr. M. Sandya Mendis',
            drSandyaProfession: 'Lékařka ájurvédské medicíny',
            drSandyaSpecialization: 'Klinická ájurvéda, Personalizované plánování léčby, Ájurvédská péče v hotelovém průmyslu',
            drSandyaProfileTitle: 'Profesní profil',
            drSandyaProfile: 'Soucitná a oddaná ájurvédská odbornice s více než 25 lety zkušeností v poskytování personalizované péče a wellness řešení. Specializuje se na spojení tradičních ájurvédských principů s moderními terapeutickými praktikami pro celostní léčebné zážitky v luxusních wellness resortech.',
            drSandyaWorkExpTitle: 'Pracovní zkušenosti',
            drSandyaWorkExp1: 'Hlavní lékařka a vedoucí vývoje programů - Mahi Beach Ayurveda Resort (2023 – Současnost)',
            drSandyaWorkExp2: 'Seniorní ájurvédská lékařka - Sun Aqua Resort and Spa, Maggona (2008 – 2023)',
            drSandyaWorkExp3: 'Ájurvédská konzultantka - Amba Ayurveda Specialty Clinic (2006 – 2008)',
            drSandyaWorkExp4: 'Ájurvédská lékařka a specialistka na Pančakarmu - Paradise Road The Villa Bentota (2002 – 2006)',
            drSandyaWorkExp5: 'Ájurvédská zdravotní pracovnice - Hotel Blue Water (1996 – 2002)',
            drSandyaEducationTitle: 'Vzdělání a profesní kvalifikace',
            drSandyaEdu1: 'Diplom z ájurvédy - Government Ayurveda College, Borella (1989 – 1993)',
            drSandyaEdu2: 'Reiki 2. stupeň - Reiki Dasa Centre Negombo Srí Lanka (2015 – 2016)',
            drPandukaName: 'Dr. Panduka Ranaweera',
            drPandukaProfession: 'Ájurvédský lékař',
            drPandukaQualification: 'B.A.M.S. (Bachelor of Ayurvedic Medicine and Surgery)',
            drPandukaProfileTitle: 'Profesní profil',
            drPandukaProfile: 'Dr. Panduka Ranaweera je kvalifikovaný a zkušený ájurvédský lékař s titulem Bachelor of Ayurvedic Medicine and Surgery (B.A.M.S.) z University of Colombo. Jeho akademická příprava je pevně založena na klasických ájurvédských principech a komplexním klinickém vzdělání, podporujícím strukturovaný, etický a na důkazech založený přístup k tradiční medicíně.',
            drPandukaExpertiseTitle: 'Odborná expertíza',
            drPandukaExpertise: 'Kromě klinické praxe vede Dr. Ranaweera profesionální přednášky o ájurvédě pro hosty a wellness programy, nabízející jasné vhledy do ájurvédské filosofie, prevence nemocí, správy životního stylu a praktické aplikace tradičních terapií. Tyto sezení zvyšují porozumění a zapojení hostů, přispívající k udržitelným zdravotním výsledkům.',
            drPandukaSpecialtyTitle: 'Integrativní terapie',
            drPandukaSpecialty: 'Jeho terapeutická expertíza se také rozšiřuje na akupunkturu a muzikoterapii, které selektivně integruje k podpoře zvládání bolesti, snižování stresu, neurologické rovnováhy a emocionální pohody. Kombinací ájurvédy s těmito komplementárními modalitami poskytuje Dr. Ranaweera skutečně integrativní léčebný zážitek.',
            drPandukaRoleTitle: 'Závazek k dokonalosti',
            drPandukaRole: 'Ve své roli v hotelu udržuje Dr. Ranaweera vysoké klinické standardy, zatímco poskytuje personalizované léčebné plány a holistické wellness vedení. Jeho profesionální, klidný a soucitný přístup zajišťuje, že každý host obdrží bezpečnou, autentickou a na výsledky zaměřenou péči zaměřenou na dlouhodobou rovnováhu, vitalitu a celkovou pohodu.',
            gallery1: 'Terapie Šíródára',
            gallery2: 'Parní lázeň',
            gallery3: 'Květinová lázeň',
            gallery4: 'Masáž hlavy',
            gallery5: 'Celotělová masáž',
            gallery6: 'Masáž krku',
            gallery7: 'Masáž obličeje',
            gallery8: 'Masáž ramen',
            heroTitle: 'Pančakarma Ájurvéda',
            heroSubtitle: 'Omlazení těla, mysli a duše v Beruwale',
            heroTagline: 'Zažijte autentické srílanské ájurvédské léčení u oceánu',
            sectionEyebrow: 'PANČAKARMA ÁJURVÉDA V MAHI BEACH AYURVEDA RESORT',
            sectionDescription: 'Objevte starověké umění Pančakarmy v Mahi Beach Ayurveda Resort v Beruwale. Náš ájurvédský tým připravuje personalizované terapie pro očistu, obnovu a harmonii těla, mysli i ducha.',
            treatmentProgramme: {
                title: 'Program Ájurvédské Léčby',
                subtitle: 'Vaše Cesta k Rovnováze, Detoxikaci a Hlubokému Obnovení',
                intro: 'Zažijte autentickou ájurvédskou péči v klidném pobřežním útočišti, které podporuje tělo, zklidňuje mysl a obnovuje energii. Od příjezdu zařizujeme vše, abyste se mohli soustředit na své zdraví.',
                welcomeTitle: 'Vítání a Jemný Začátek',
                welcomePoints: [
                    'Vyzvednutí na letišti a transfer do hotelu',
                    'Srdečné uvítání a orientace v hotelu',
                    'Představení vašeho týdenního programu',
                    'Relaxační Masáž (1. den) v Ájurvédském Centru k uvolnění únavy z cesty a přípravě těla na ošetření'
                ],
                doctorTitle: 'Konzultace s Lékařem a Osobní Plán',
                doctorPoints: [
                    'Konzultace s Ájurvédským Lékařem (2. den – dopoledne)',
                    'Komplexní posouzení vaší Dóši/typu těla a zdravotních problémů',
                    'Tlumočník dostupný na požádání',
                    'Váš lékař vytvoří personalizovaný léčebný plán přizpůsobený vašim potřebám a cílům'
                ],
                dailyTherapiesTitle: 'Denní Ájurvédské Terapie',
                dailyTherapiesPoints: [
                    '4–5 ošetření denně (podle doporučení lékaře)',
                    'Terapie vybrané na základě vaší tělesné konstituce a stavu',
                    'Speciální masáže mohou být přidány podle potřeby',
                    'Lékař každý den sleduje pokrok a může upravit ošetření a bylinnou podporu pro zajištění nejlepších výsledků',
                    'Pokud je to vhodné, může být doporučen jemný čisticí/projímavý proces'
                ],
                herbalMedicineTitle: 'Podpora Bylinných Léků',
                herbalMedicinePoints: [
                    'Lékařem předepsané bylinné léky podávané dvakrát denně:',
                    'Během snídaně',
                    'Během večeře',
                    'Podporují vnitřní uzdravení, detoxikaci a dlouhodobou rovnováhu'
                ],
                yogaMeditationTitle: 'Jóga a Meditace pro Harmonii Těla a Mysli',
                yogaMeditationPoints: [
                    'Lekce jógy 4krát týdně (cca 1 hodina)',
                    'Meditační sezení 2krát týdně:',
                    'Jedinečný duchovní zážitek v Ostrovním Chrámu, dostupný lodí',
                    'Vedená meditace vedená mnichy (cca 1 hodina)'
                ],
                wellnessTitle: 'Zahrnuté Zážitky',
                wellnessPoints: [
                    'Týdenní ukázky zdravého vaření',
                    'Bezplatný výlet (kulturní/přírodní zážitek)'
                ],
                closingTitle: 'Závěrečný Rituál a Odjezd',
                closingPoints: [
                    'Krásná Květinová Koupel (poslední den)—tradiční rituál obnovy',
                    'Závěrečná Konzultace s Lékařem k přezkoumání pokroku a poskytnutí:',
                    'Pokračující poradenství',
                    'Recepty a doporučení pro domov',
                    'Transfer zpět na letiště'
                ]
            },
        },
        food: {
            heroTitle: 'Ayurvédská kuchyně a pobřežní kuchyně',
            heroSubtitle: 'Autentické chutě ze Srí Lanky a čerstvá pobřežní kuchyně',
            heroAlt: 'Kulinární zážitek v Mahi Beach Ayurveda Resort',
            wellnessEyebrow: 'skrze jídlo',
            wellnessTitle: 'Důležitost',
            ayurvedicFood: 'ayurvédského jídla',
            wellnessIntro1: 'V ajurvédě je jídlo považováno za největší medicínu. To, co jíte, přímo ovlivňuje vaše doshy (Vata, Pitta, Kapha), trávení (agni) a celkovou rovnováhu těla, mysli a ducha.',
            wellnessIntro2: 'Ajurvédská výživa zdůrazňuje čerstvé, sezónní potraviny celé připravované s péčí a vědomým jídlem. V každém jídle podporuje šest chutí (sladké, kyselé, slané, pálivé, hořké, tannické) pro výživu všech smyslů a zachování harmonie.',
            wellnessIntro3: 'Správné ajurvédské jídlo podporuje silné trávení, pomáhá zbavit se toxinů (ama), posílí imunitu, zlepšuje energii, snižuje stres a zabraňuje mnoha chronickým onemocněním. V Mahi Beach je každé jídlo pečlivě připraveno tak, aby se vyrovnalo vaší jedinečné konstituci pro hlubokého uzdravení a vitalitu.',
            foodImage1Alt: 'Tradiční ajurvédské jídlo se šesti chutěmi',
            foodImage2Alt: 'Ajurvédské byliny a koření pro vyváženou výživu',
            culinaryPhilosophyEyebrow: 'Naše kulinární filozofie',
            culinaryPhilosophyTitle: 'Ajurvédská',
            nutritionHighlight: 'výživa',
            culinaryPhilosophyResort: 'v Mahi Beach Ayurveda Resort',
            nutritionTopImageAlt: 'Ajurvédská kuchyně v Mahi Beach Ayurveda Resort',
            freshNourishingLabel: 'Čerstvé a výživné',
            healingIngredientsAlt: 'Zdravé ajurvédské ingredience a koření',
            healingIngredientsLabel: 'Léčivé ingredience',
            philosophyText1: 'Jídlo, které obsahuje šest hlavních chutí (sladké, kyselé, slané, hořké, pálivé a tannické) spolu s mnoha jemnými variacemi, bylo popsáno v klasických ajurvédských textech — některé pocházejí z doby před více než 5000 let — spolu s podstatných vlastnostmi každé potravy: Guna (vlastní kvalita), Virya (účinnost/zahřívání nebo chlazení), Vipaka (post-digestivní dopad) a Prabhava (jedinečné zvláštní působení).',
            philosophyText2: 'V důsledku toho hraje ajurvédská výživa ústřední roli v Mahi Beach Ayurveda Resort. To neznamená rigidní, monotónní režim bez chuti, bez chuti nebo nadměrně hořkých vegetariánských jídel určených výhradně lékaři. Naopak, naše ajurvédská kuchyně je jednou z našich největších silných stránek: jídla připravená našimi zručnými kuchaři vás překvapí a potěší každý den vašeho pobytu!',
            philosophyText3: 'K snídani si užijte hojný bufet s čerstvým tropickým ovocem, čerstvě vymačkaným ovocem, živinnými bylinkovými polévkami, domácím chlebem a lehkými sušenkami a řadou autentických možností snídaně ze Srí Lanky. K obědu si vychutnáte barevný a chutný bufet s jemným rybím curry, přípravou zeleniny a bylinkami infuzní jídla. Večer podáváme stanoveného vegetariánské menu s dostupnou možností čerstvé ryby. V sobotu oslavujeme „noc Srí Lanky" s rozšířeným bufettem — naši kuchaři připravují tradiční místní speciality přímo před vámi, což vytváří živou a autentickou zkušenost.',
            philosophyText4: 'V ajurvédě jsou potraviny a nápoje klasifikovány mnoha způsoby — podle chuti a vlastností, trávící kapacity těla (agni), vhodnosti pro specifické zdravotní stavy, sezónní vhodnosti a další. V Mahi Beach my pečlivě zvažujeme všechny tyto faktory současně, vědomě se snažíme zahrnout všech šest chutí do vyváženého kombinace přizpůsobených jednotlivé konstituci každého hosta.',
            philosophyText5: 'Naše jídla obsahují čerstvou zeleninu, tropické ovoce a odpovědně pocházející ryby. Nepodáváme červené maso ani alkohol.',
            philosophyText6: 'Během jídel je ajurvédský lékař nebo kvalifikovaný dietolog vždy k dispozici, aby vás vedl. Poradí vám na nejvhodnější zeleninu, byliny a koření pro vaši aktuální fázi léčby a pomohou vám vhodně vybírat nebo se vyhnout jídlům. Váš personalizovaný bylinný elixír a všechny konkrétní pokyny od týmu zdravotního centra budou umístěny na vašem individuálním stole.',
            philosophyText7: 'Tato úroveň osobní péče a pozornosti k dietě je charakteristikou zkušenosti v Mahi Beach Ayurveda Resort.',
            philosophyText8: 'Jídlo se považuje za Pranu — životní energii, která udržuje život — pro každého člověka. Právě proto vás podporujeme, abyste k jednotlivým jídlům přistupovali s plným povědomím: vychutnávajícím si arom, prožívajícím chutě, cítícím jemné teplo a vědomě užívajícím chutné pocity.',
            diningExperienceEyebrow: 'Gastronomická zkušenost',
            restaurantTitlePrefix: 'Naše',
            ayurvedicHighlight: 'ajurvédské',
            restaurantTitleSuffix: 'restaurace',
            restaurantDetail1: 'Naše ajurvédská restaurace v Mahi Beach Ayurveda Resort nabízí jedinečný stravovací zážitek, který harmonizuje tradiční ajurvédské principy s autentickou kuchyní pobřeží Srí Lanky. Upřednostňujeme čerstvé, místně pocházející ingredience, abychom vytvořili jídla, která nejen potěší chutě, ale také podporují holistickou pohodu.',
            restaurantDetail2: 'Jídelní lístek je pečlivě navrhnout tak, aby vyvážit šest chutí (sladké, kyselé, slané, hořké, pálivé, tannické) v každém jídle, což zajistí výživný a uspokojivý zážitek. Každé jídlo je připraveno s péčí a začleňuje ajurvédské byliny a koření známé svými léčivými vlastnostmi.',
            restaurantDetail3: 'Hosté se mohou těšit na různé jídla přizpůsobená jejich individuálním doshah (tělesným konstituci), s možnostmi pro vegetariánské, veganské a pescetariánské strany. Naši kuchařové úzce spolupracují s ajurvédskými praktiky, aby zajistili, že každé jídlo podporuje cíle zdraví a hostů.',
            restaurantDetail4: 'Atmosféra restaurace odráží klidné pobřežní prostředí a poskytuje klidné prostředí pro vědomé jídlo. Ať už si užíváte vydatný snídaňový bufet nebo vychutnávete jemné večeře, každé jídlo v naší ajurvédské restauraci je příležitostí na výživu těla a duše.',
            restaurantDetail5: 'Připojte se k nám v ajurvédské restauraci Mahi Beach Ayurveda Resort na kulinární cestě, která slaví bohaté chutě Srí Lanky a zároveň přijímá nadčasovou moudrost Ajurvédy.',
            restaurantImageAlt: 'Stravování v Mahi Beach Ayurveda Resort',
            premiumDiningLabel: 'Prémiové stravování',
            premiumDiningDescription: 'Zažijte autentickou ajurvédskou kuchyni v klidném pobřežním prostředí'
        },
        yoga: {
            heroTitle: 'Jóga v resortu',
            heroSubtitle: 'Najděte rovnováhu, sílu a vnitřní klid v Beruwale',
            heroAlt: 'Jóga v Mahi Beach Ayurveda Resort',
            importanceEyebrow: 'a rovnováha',
            importanceTitle: 'Význam jógy a meditace',
            importanceImageAlt: 'Význam jógy a meditace',
            importanceText1: 'Jóga a meditace jsou starobylé praktiky, které nabízejí řadu fyzických, duševních a emocionálních přínosů. Podporují flexibilitu, sílu a rovnováhu a zároveň snižují stres a úzkost.',
            importanceText2: 'Pravidelná praxe může zlepšit koncentraci, kvalitu spánku a celkovou pohodu. Jóga také podporuje všímavost, pomáhá lidem propojit se se svým vnitřním já a najít klid uprostřed každodenního shonu.',
            importanceText3: 'V Mahi Beach Ayurveda Resort nabízíme klidné prostředí ideální pro cvičení jógy a meditace, které hostům umožňuje obnovit mysl, tělo i ducha.',
            practiceEyebrow: 'Naše praxe',
            practiceTitle: 'Jógová praxe a zkušenost',
            practiceImageAlt: 'Jógová praxe v resortu',
            practiceText1: 'V Mahi Beach Ayurveda Resort se jóga praktikuje především jako tradiční Hatha Yoga v kombinaci s Pránájámou (dechové techniky). Tento holistický přístup je navržen k probuzení vnitřního uvědomění a jemné stimulaci Kundaliní (často označované jako třetí oko). Zvláštní důraz se klade na zarovnání páteře a flexibilitu, protože pružná páteř je považována za klíč ke zpomalení stárnutí — „Jste tak staří, jak stará je vaše páteř.“',
            practiceText2: 'Lekce jógy probíhají čtyřikrát týdně a jsou vhodné pro začátečníky i zkušené praktiky. Občas jsou zařazeny speciální lekce, například Ashtanga Yoga, které umožňují hostům vyzkoušet různé pozice a sestavy. Naši ayurvédští lékaři podporují pravidelnou účast, aby podpořili a posílili celkový léčebný program.',
            practiceText3: 'Všechny lekce jógy se konají v naší vyhrazené Yoga Shala, klidném prostoru navrženém pro soustředění, rovnováhu a vědomý pohyb. Každá lekce obvykle začíná Pozdravem slunci, následuje Pránájáma a sekvence pečlivě vybraných ásan zaměřených na zlepšení flexibility, cirkulace a celkové pohody.',
            practiceText4: 'Naši zkušení učitelé jógy přizpůsobují každou lekci individuálním potřebám, schopnostem a zdravotnímu stavu hostů, čímž zajišťují bezpečný, podpůrný a hluboce prospěšný zážitek pro každého.',
            spiritualEyebrow: 'Duchovní cesta',
            spiritualTitle: 'Meditace a duchovní aktivity',
            spiritualSubtitle: 'Prohlubte svou duchovní praxi s našimi posvátnými obřady a vedenými meditacemi',
            meditationImageAlt: 'Meditace a duchovní praxe v resortu',
            meditationTitle: 'Meditativní sezení',
            meditationDesc: 'Hosté jsou zváni k účasti na vedených meditacích konaných třikrát týdně, inspirovaných buddhistickými tradicemi. Tyto sezení jsou navrženy k uklidnění mysli, prohloubení uvědomění a podpoře emocionálního i duchovního uzdravení. Meditace probíhá v klidném chrámu na ostrově, kam se hosté dostanou lodí — klidná a smysluplná cesta, která obohacuje celkový meditační zážitek.'
        },
        home: {
            heroTitle: 'Mahi Beach Ayurveda Resort',
            heroSubtitle1: 'Ayurveda u oceánu',
            heroSubtitle2: 'Najděte rovnováhu, dýchejte lehčeji a obnovte svou energii v Beruwale.',
            exploreResort: 'Prozkoumejte resort',
            bookNow: 'Rezervovat nyní',
            welcomeLabel: 'Vítejte',
            welcomeTitle: 'Mahi Beach Ayurveda Resort',
            welcomeDesc1: 'Resort Mahi Beach Ayurveda Resort Beach se nachází na panskyxch březích Beruwal a kombinuje staré léčebné tradice s moderním přímemo-mořským luxusem. Naše svatyně vás zve na transformující cestu wellness, kde rytmické zvuky Indického oceánu potívají věčnou moudrost Ayurvedy.',
            welcomeDesc2: 'Zažijte personalizované ayurvédské léčby, vychutnávejte živiny připravená jídla vytvořená k vyvážení vaší doši a uvolněte se v elegantně vybavených pokojích s úchvatným výhledem na oceán. Ať už hledáte omlazenní, relaxaci nebo duchovní znovuzrození, náš oddaný tým ayurvédských praktik a odborníků na vás provede každým krokem.',
            learnMore: 'Zjistěte více',
            contactUs: 'Kontaktujte nás',
            welcomeImageAlt: 'Mahi Beach Ayurveda Resort',
            welcomeImageCaption: 'Ayurveda & Beach Retreat',
            welcomeImageLocation: 'Maggona Sri Lanka',
            highlightTitle: 'Ayurvédické svatyně u moře',
            highlightDesc: 'Objevte holistické léčení na jiho-západním pobřeží Sri Lanky. Od přizpůsobených léčeb k klidným balkonům a vědomé kuchyni, každý detail je navržen tak, aby obnovil váš ritmus.',
            service1Title: 'Holistické ayurvédské terapie',
            service1Desc: 'Personalizované konzultace, autentické bylinné oleje a denní léčby vedené zkušenými ayurvédskými lékaři.',
            service2Title: 'Pokoje a apartmány u pláže',
            service2Desc: 'Projděte se mořským vánkem, soukromými balkóny a uklidňujícím interiérem navrženým pro hluboký odpočinek.',
            service3Title: 'kuchyně',
            service3Desc: 'Čerstvé srílanské produkty, rostlinné jídelní lístky a přizpůsobené jídelní plány, které doplňují vaši dosu.',
            service4Title: 'Jóga a vědomí',
            service4Desc: 'Jóga na východ slunce, meditace na západ slunce a dechové cvičení v rytmu vln.',
            service5Title: 'Řívní a pobřežní exkurze',
            service5Desc: 'Plavby po řekou Bentota, návštěvy líhní mořských želv, procházky zahradami koření a cyklistické zájezdy po vesnicích.',
            roomsTitle: 'Naše pokoje',
            roomsDesc: 'Vyberte si svatyni, která odpovídá vašemu tempu, od prostorných apartmánů po útulné deluxe úkryty, všechny s měkkým prádlem, teplým dřevem a balkóny připravenými na východ slunce.',
            roomBadge: 'Útěk u pláže',
            bookableNow: 'Nyní rezervovaterné',
            seaBreezeReady: 'Připraven na mořský vánek',
            viewRoom: 'Zobrazit pokoj',
            room1Title: 'Apartmánové pokoje',
            room1Desc: 'Prostorné apartmány s obývacím pokojem, velkoryse velkými balkóny a uklidňující paletou pro pomalá ráno.',
            room2Title: 'Deluxe pokoje',
            room2Desc: 'Útulné úkryty s luxusními postelemi, výhledem na zahradu a teplými dřevěnými akcenty pro denní jednoduchost.',
            room3Title: 'Deluxe s výhledem na moře',
            room3Desc: 'Projděte se s horizontem oceánu, měkkým prádlem a soukromým balkonem určeným pro zlaté západy slunce.',
            achievement1Title: 'Šťastní hosté',
            achievement1Count: '1 000+',
            achievement2Title: 'Ayurvédské léčby',
            achievement2Count: '20+',
            achievement3Title: 'Leta péče',
            achievement3Count: '15+',
            achievement4Title: 'Cestovatelé Aklamace',
            achievement4Count: '1 000+',
            experiencesTitle: 'Prozkoumejte Mahi Beach Ayurveda Resort',
            experiencesDesc: 'Od ayurvédských jízd k kurátorským veletům, vyberte si zážitky, které vám zpřícemní pobyt nepamíti.',
            planYourStay: 'Plánujte svůj pobyt',
            experience1Title: 'Pokoje a apartmány',
            experience1Desc: 'Větrné prostory s balkóny, výhledem na oceán nebo zahradu a promyšleným komfortem pro nespěchající spočívající pobytů.',
            experience2Title: 'Ayurveda Spa',
            experience2Desc: 'Autentické terapie, parní lázně a regenerační masáže poskytované s osvědčenými rituály.',
            experience3Title: 'Kulinářský zážitek',
            experience3Desc: 'Výživná srílanská a mezinárodní kuchyně podávaná v naší restauraci, pečlivě připravená k výživě těla a mysli.',
            experience4Title: 'Zážitky a prohlídky',
            experience4Desc: 'Řiční safari, návštěvy chrámů, vodní sporty a kurované kulturní exkurze kolem Bentuty.',
            galleryTitle: 'Chvíle v Mahi Beach Ayurveda Resort',
            galleryDesc: 'Vhled do naší pobřežní svatyně — východy slunce, klidné léčby, výživná jídla a klidné kouty pro vás.',
            gallery1Alt: 'Slunečná pláž obklopená palmami v Mahi Beach',
            gallery2Alt: 'Probíhající ayurvédská olejová léčba',
            gallery3Alt: 'Resort bazén s lehátkys',
            gallery4Alt: 'Byliny připravené pro spa',
            gallery5Alt: 'Pár si užívá západ slunce u moře',
            gallery6Alt: 'Yoga paluba obličející oceán',
            gallery7Alt: 'Cesta tropickou zahradu',
            gallery8Alt: 'Zdravá snídaně',
            gallery9Alt: 'Klidný výhled na řeku',
            gallery10Alt: 'Resort exetrior hebce osvětleny při západu slunce',
            gallery11Alt: 'Displej ayurvédských bylin a olejů',
            gallery12Alt: 'Pohodlné sezení v zahradě',
            resort1Alt: 'Venkovní lounge se zelení',
            resort2Alt: 'Pohodlné vnitřní vybavení pokoje',
            resort3Alt: 'Prostor pro osm léčby',
            resort4Alt: 'Jídelní prostor s přirozeným světlem',
            resort5Alt: 'Relaxační výhled na bazén',
            sunsetLabel: 'Každodenní mistrovské dílo přírody',
            sunsetTitle: 'Večerní západ slunce',
            sunsetDesc1: 'Sledujte, jak se den elegantně vzdává soumraku, zatímco se obloha mění na plátno jantaru, purpury a zlata. Jemný Indický oceán odráží tuto nebeskou podívanou, což vytváří podmanivou symfonii světel a vody.',
            sunsetDesc2: 'Každý večer v Mahi Beach nabízí místa v první řadě jednoho z nejúchvatných přírodnatých p',
            sunsetFeature1: 'Nerušené mořské vidiny z každé rohu',
            sunsetFeature2: 'Meditace klidu při západu slunce',
            sunsetFeature3: 'Bezplatný bylinný čaj podávaný denně',
            sunsetFeature4: 'Fotogenické momenty každý večer',
            sunsetImageAlt: 'Večerní západ slunce u Mahi Beach Ayurveda Resort',
            bestTime: 'Nejlepší čas',
            sunsetTime: '18:00 - 18:45',
            poolLabel: 'Vodní klid',
            poolTitle: 'Bazénová oblast',
            poolDesc1: 'Ponořte se do klidu na naší nedotčené infinity bazénu, kde se křišťálově čistá voda setkávání s bujnou tropickou zahradou. Navržena pro relaxaci a mládí, naše bazénová oblast nabízí dokonalý únič k relaxování pod srílanským sluncem.',
            poolDesc2: 'Ať už preferujete osvěžující ranní plavání, posezení v odpoledni s dobrou knihou nebo pokojné večerní ponory, naše bazénová oblast poskytuje nádherné prostředí. Obklopeny pohodlnými lehátkami, stinnými kajutami a pozornými službami u bazénu, každý moment se stává vzácně vzpomínkou.',
            poolFeature1: 'Infinity bazén s kontrolou teploty',
            poolFeature2: 'Obklopen tropickými zahradní krajinavami',
            poolFeature3: 'Osvěžení a zdravé občerstvení u bazénu',
            poolFeature4: 'Premium lehátky s deštníky',
            poolImageAlt: 'Relaxační bazénová oblast v Mahi Beach Resort',

            // Ceremonie odjezdu hostů
            departureLabel: 'Tradice rozloučení',
            departureTitle: 'Ceremonie odjezdu hostů',
            departureDesc1: 'V Mahi Beach Ayurveda Resort ctíme vaši cestu s námi prostřednictvím smysluplné ceremonie odjezdu zakořeněné v srílanské tradici. Když se připravujete k odjezdu, náš tým se shromažďuje, aby poskytl požehnání pro bezpečné cesty a pokračující blahobyt.',
            departureDesc2: 'Tento upřímný rituál zahrnuje tradiční požehnání, speciální rozlučkové menu s autentickými srílanskými lahůdkami a malý dárek, abyste s sebou vzali naše teplo. Je to náš způsob, jak zajistit, aby vaše vzpomínky na Mahi Beach zůstaly cenné dlouho po vašem odjezdu.',
            departureFeature1: 'Tradiční buddhistická požehnání pro bezpečné cesty',
            departureFeature2: 'Personalizované rozlučkové dárky a upomínkové předměty',
            departureFeature3: 'Speciální menu odjezdu se srílanskými lahůdkami',
            departureFeature4: 'Ceremonie požehnání se svatými rituály',
            departureImageAlt: 'Ceremonie odjezdu hostů v Mahi Beach Resort',

            // TripAdvisor
            tripadvisorLabel: 'TripAdvisor',
            tripadvisorTitle: 'Recenze hostů',

            testimonialsTitle: 'Hosté během jejich pobytu',
            testimonialsLabel: 'Příběhy hostů',

            // Video Section
            videoLabel: 'Pohlcující zážitek',
            videoTitle: 'Objevte Mahi Beach',
            videoDescription: 'Zažijte krásu a klid Mahi Beach Ayurveda Resort prostřednictvím naší pohlcující videocesty. Prozkoumejte světové vybavení, nedotknuté pláže a omladné wellness zážitky.',

            // Featured Room
            featuredRoomLabel: 'Významné ubytování',
            featuredRoomTitle: 'Deluxe dvoulůžkový pokoj s výhledem na moře',

            // Booking Bar
            bookingResort: 'Resort',
            bookingResortName: 'Mahi Beach Ayurveda Resort',
            bookingCheckIn: 'Příjezd',
            bookingCheckOut: 'Odjezd',
            bookingGuests: 'Hosté',
            booking1Guest: '1 host',
            booking2Guests: '2 hosté',
            booking3Guests: '3 hosté',
            bookingCheckAvailability: 'Zkontrolovat dostupnost',

            // Hero Buttons
            heroExploreButton: 'Prozkoumejte Mahi Beach',
            heroBookButton: 'Rezervovat Deluxe pokoj'
        },
    },

    pl: {
        about: {
            heroTitle: 'O nas',
            heroSubtitle: 'Mahi Beach Ayurveda Resort',
            heroBeachResort: 'Beach Resort',
            heroTagline1: 'Starożytna mądrość spotyka się nowoczesnym w Mahi Beach Ayurveda Resort',
            heroTagline2: 'Spersonalizowane zabiegi ajurwedyjskie, widoki na ocean i autentyczna gościnność Sri Lanki',
            heroDescription: 'Doświadcz autentycznego dobrego samopoczucia ajurwedyjskiego w naszym charakterystycznym pokoju Deluxe, gdzie spokoj oceanu spotyka się z ponadczasowym uzdrawianiem.',
            bookDeluxeRoom: 'Zarezerwuj swój pokój Deluxe',
            bookDeluxeRoomShort: 'Zarezerwuj pokój Deluxe',
            slide1: 'Deluxe Spokój',
            slide2: 'Ajurwedyjska Harmonia',
            slide3: 'Luksus nad Plażą',
            slide4: 'Naturalna Elegancja',
            slide5: 'Uzdrawiająca Ucieczka',
            historyLabel: 'Nasza podróż',
            historyTitle: 'Historia Mahi Beach Ayurveda Resort',
            historyDesc1: 'Mahi Beach Ayurveda Resort został założony w 2025 roku z wizją stworzenia świętego miejsca, gdzie starożytna mądrość ajurwedyjska spotyka się z spokojnym pięknem południowego wybrzezia Sri Lanki. Stworzyliśmy jedno z najbardziej cenionych miejsc Berawali dla całościowego uzdrowienia i odmłodzenia.',
            historyDesc2: 'Nasi założyciele, zainspirowani pokoleniami tradycyjnych praktyków ajurwedy, dążyli do zachowania tych wypróbowanych sztuk uzdrawiania, jednocześnie zapewniając nowoczesny komfort i autentyczną gościnność Sri Lanki. Od naszego otwarcia pozostaliśmy wierny naszemu zobowiązaniu wobec autentycznych doświadczeń wellness, zapewniając spersonalizowaną opiekę definiującą nasze dziedzictwo.',
            historyDesc3: 'W Mahi Beach Ayurveda Resort gościnnie przyjmujemy gości z całego świata. Każdy odwiedzający staje się częścią naszej historii, znajdując równowagę, uzdrowienie i transformację w naszym przybrzeżnym schronieniu.',
            statYear: '2025',
            statYearLabel: 'Założono',
            statGuest: 'Klasy światowej',
            statGuestLabel: 'Szczęśliwych obsługiwanych gości',
            experienceLegacy: 'Doświadcz naszej wizji',
            established: 'Założono',
            since2010: 'Od 2025 roku',
            chairmanLabel: 'Wizja przewodniczącego',
            chairmanTitle: 'Zakorzeniony w tradycji, zainspirowany wellness',
            chairmanDesc1: 'Witamy w Mahi Beach Ayurveda Resort. Nasza wizja od 2025 roku polega na stworzeniu sanktuarium, gdzie starożytna mądrość ajurwedyjska spotyka się z nowoczesnym komfortem, wszystko otulone autentycznym ciepłem gościnności Sri Lanki.',
            chairmanDesc2: 'Każdy aspekt naszego kurortu — od spersonalizowanych zabiegów i odżywczej kuchni po spokojną atmosferę naszych przestrzeni — jest starannie stworzony, aby wspierać twoją ścieżkę do wellness, równowagi i wewnętrznego spokoju. To nasz przywilej towarzyszyć ci w tej transformacyjnej podróży.',
            chairmanDesc3: 'Osobiście witam cię, aby odkryć harmonię, autentyczność i spokój, które są fundamentem Mahi Beach.',
            chairmanSignature: '— Mr. Mahinda',
            chairmanBadge: 'Przewodniczący',
            chairmanName: 'Mr. Mahinda',
            chairmanImageAlt: 'Przewodniczący Mr. Mahinda',
            staffLabel: 'Nasz zespół',
            staffTitle: 'Poznaj nasz oddany personel',
            staffDesc1: 'W Mahi Beach Ayurveda Resort nasz zespół jest sercem wszystkiego, co robimy. Członkowie naszego personelu to starannie wybranie i wytrenowani profesjonaliści, którzy dzielą głęboką passion do ajurwedyjskiego i autentycznej gościnności.',
            staffDesc2: 'Od naszych doświadczonych praktyków ajurwedy i zdolnych terapeutów masażu po nasz oddany zespół gościnności, każdy członek wnosi lata doświadczenia i autentyczną opiekę do każdej interakcji z gośćmi. Wierzymy, że autentyczny pochodzi nie tylko z zabiegów, ale z ciepła i uwagi ludzi, którzy naprawdę dbają o twoją podróż.',
            staffDesc3: 'Nasz personel przechodzi ciągłe szkolenia w najnowszych praktykach ajurwedy, jednocześnie utrzymując najwyższe standardy profesjonalizmu i wrażliwości kulturowej. Jesteśmy dumni z tworzenia znaczących połączeń z naszymi gośćmi, zapewniając, że każda wizyta staje się niezapomnianym i transformacyjnym doświadczeniem.',
            statStaff: '15+',
            statStaffLabel: 'Wykwalikowani profesjonaliści',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Zadowolenie gości',
            staffImageAlt: 'Nasz oddany zespół personelu w Mahi Beach Ayurveda Resort',
            commitmentBadge: 'Nasze zobowiązanie',
            excellenceCare: 'Doskonałość i opieka',
            ctaLabel: 'Skontaktuj się',
            ctaHeading: 'Gotowy/a začą́ c swoją podróż wellness?',
            ctaDesc: 'Skontaktuj się z naszym zespołem, aby zarezerwować swój spersonalizowany ajurwedyjski retreat. Niezależnie od tego, czy masz pytania dotyczące naszych zabiegów, zakwaterowania lub specjalnych pakietów wellness, jesteśmy tu, aby pomóc ci stworzyć swoją doskonałą ucieczkę.',
            ctaButtonContact: 'Skontaktuj się z nami teraz',
            ctaButtonRooms: 'Eksploruj pokoje',
            contactUs: 'Skontaktuj się z nami',
            quickInfoCall: 'Zadzwoń do nas',
            quickInfoEmail: 'Wyślij nam e-mail',
            quickInfoLocation: 'Lokalizacja',
            locationCity: 'Maggona Sri Lanka'
        },
        rooms: {
            heroTitle: 'Twoja Świątynia Cię czeka',
            heroSubtitle: 'Pokoje starannie zaprojektowane do uzdrawiania, przywrócenia i głębokich spokojności.',
            heroAlt: 'Pokoje Mahi Beach Ayurveda Resort',
            exploreRooms: 'Odkryj nasze pokoje',
            filterAll: 'Wszystko',
            filterLuxurySuite: 'Apartament Luksusowy',
            filterDeluxeRooms: 'Pokoje Deluxe',
            filterDeluxeSeaView: 'Pokoj Deluxe z widokiem na morze',
            noRoomsFound: 'Nie znaleziono pokojów w tej kategorii.',
            allRoomsInclude: 'Wszystkie pokoje obejmują',
            essentialComforts: 'Niezbędny komfort dla twojej podróży wellness',
            roomSize: 'Rozmiar pokoju',
            guests: 'Goście',
            amenities: 'Udogodnienia',
            roomAmenities: 'Amenities pokoju',
            specialFeatures: 'Cechy szczególne',
            bookNow: 'Zarezerwuj teraz',
            viewDetails: 'Wyświetl szczegóły',
            viewFullDetails: 'Wyświetl pełne szczegóły',
            highSpeedWifi: 'Szybki WiFi',
            herbalTea: 'Wybór herbat ziołowych',
            climateControl: 'Kontrola klimatu',
            rainShower: 'Prysznic deszczowy',
            organicToiletries: 'Artykuły toaletowe organiczne',
            dailyHousekeeping: 'Codzienna obsługa pokoju',
            concierge: 'Recepcja 24/7',
            yogaMat: 'Mata do jogi i akcesoria',
            beginHealing: 'Zacznij swoją podróż uzdrawiającą',
            beginHealingDesc: 'Doświadcz autentycznego zdrowia ajurwedy w środowisku zaprojektowanym do odżywienia ciała, uspokojenia umysłu i przywrócenia duszy.',
            reserveRoom: 'Zarezerwuj pokój',
            speakAdvisor: 'Porozmawiaj z doradcą wellness',
            exploreOurRooms: 'Odkryj nasze pokoje',
            viewRoom: 'Wyświetl pokój',
            luxurySuiteName: 'Apartament Luksusowy',
            luxurySuiteCategory: 'Apartament Luksusowy',
            luxurySuiteDesc: 'Doświadcz ostatecznego spokoju w naszym przestronnym apartamencie luksusowym, zaprojektowanym zgodnie z tradycyjnymi zasadami ajurwedy ze spektakularnym widokiem na morze.',
            deluxeRoomName: 'Pokoj Deluxe',
            deluxeRoomCategory: 'Pokoj Deluxe',
            deluxeRoomDesc: 'Harmonijnie zaprojektowany pokój z naturalnymi elementami drewna i uspokajającymi funkcjami wodnymi dla doskonałego spokoju.',
            seaViewDeluxeName: 'Deluxe z widokiem na morze',
            seaViewDeluxeCategory: 'Pokoj Deluxe z widokiem na morze',
            seaViewDeluxeDesc: 'Obudź się w miękkim morskim powietrzu i panoramicznych widokach na morze w tym elegancko zaprojektowanym pokoju Deluxe.',
            kingSizeBed: 'Łóżko King-Size',
            herbalTeaCoffee: 'Herbata ziołowa i kawa',
            individuallyControlledAC: 'Indywidualnie sterowana klimatyzacja',
            premiumOrganicToiletries: 'Organiczne kosmetyki premium',
            dailyFreshFlowers: 'Codzienne świeże kwiaty',
            beachView: 'Widok na plażę',
            signatureAccommodation: 'Zakwaterowanie charakterystyczne',
            inRoomComfort: 'Komfort w pokoju',
            deluxeRoomAmenities: 'Udogodnienia pokoju Deluxe',
            momentsInDeluxeRoom: 'Chwile w pokoju Deluxe',
            experienceAyurvedicLiving: 'Doświadcz autentycznego życia ajurwedyjskiego w naszym charakterystycznym pokoju Deluxe',
            reserveYourStay: 'Zarezerwuj swój pobyt',
            deluxeRoom: {
                resortName: 'Mahi Beach Ayurveda Resort',
                heroTitle: 'Pokój Deluxe z balkonem i widokiem na morze',
                heroSubtitle: 'Gdzie luksus spotyka naturę',
                bookThisRoom: 'Zarezerwuj ten pokój',
                callReservations: 'Wywołaj rezerwacje',
                signatureFeatures: 'Charakterystyczne cechy',
                deluxeRoomName: 'Pokój Deluxe',
                discoverTheSpace: 'Odkryj przestrzeń',
                whatsIncluded: 'Co jest wliczone',
                deluxeComfortCare: 'Komfort i opieka Deluxe',
                inclusions: 'Wliczone usługi',
                coreAmenities: 'Główne udogodnienia',
                amenityHighSpeedWifi: 'Szybkie Wi-Fi',
                amenityHerbalTeaCoffee: 'Herbata ziołowa i kawa',
                amenityIndividuallyControlledAC: 'Indywidualnie sterowana klimatyzacja',
                amenityRainShower: 'Prysznic deszczowy',
                amenityOrganicToiletries: 'Organiczne kosmetyki',
                amenityDailyFreshFlowers: 'Codzienne świeże kwiaty',
                beginYourHealingStay: 'Rozpocznij swój leczniczy pobyt',
                experienceAyurvedicSerenity: 'Doświadcz autentycznego ajurwedyjskiego spokoju w naszym charakterystycznym pokoju Deluxe',
                checkAvailabilityBook: 'Sprawdź dostępność i zarezerwuj',
                speakWithReservations: 'Porozmawiaj z rezerwacjami',
                reserveThisRoom: 'Zarezerwuj ten pokój',
                navAll: 'Wszystkie pokoje',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe z widokiem na morze',
                navSuite: 'Apartament',
                sectionTitle: 'Ucieczka do luksusu i spokoju',
                sectionDesc: 'Doświadcz idealnej harmonii między elegancją a wygodą w naszym pokoju Deluxe. Każdy szczegół został starannie opracowany, aby stworzyć niezapomniane doświadczenie, łączące nowoczesne udogodnienia z ciepłem natury.',
                highlight1Title: 'Spokojny azyl',
                highlight1Desc: 'Obudź się przy łagodnym szumie fal i oszałamiającym wschodzie słońca nad oceanem.',
                highlight2Title: 'Eleganckie wnętrza',
                highlight2Desc: 'Harmonijnie zaprojektowane przestrzenie z naturalnymi elementami z drewna i kamienia.',
                highlight3Title: 'Nowoczesne udogodnienia',
                highlight3Desc: 'Najnowsze udogodnienia i usługi dla bezproblemowego pobytu.',
                atAGlance: 'W skrócie',
                statSize: 'Rozmiar',
                statSizeValue: '350 stóp kwadratowych',
                statView: 'Widok',
                statViewValue: 'Ogród',
                statGuests: 'Pojemność',
                statGuestsValue: '2 osoby dorosłe',
                statBed: 'Łóżko',
                statBedValue: 'King Size',
                reserve: 'Rezerwuj',
                galleryAlt: 'Pokoj Deluxe',
                inclusionsTitle: 'Co jest wliczone',
                inclusionsSubtitle: 'Udogodnienia i usługi',
                enhancedCleanliness: 'Ulepszone protokoły czystości',
                inclusion1: 'Bezpłatne Wi-Fi w całym pokoju',
                inclusion2: 'Bezpłatny minibar (napoje bezalkoholowe)',
                inclusion3: 'Ekspres do kawy Nespresso i zestaw herbaciany',
                inclusion4: 'Obsługa pokoju 24 godziny',
                inclusion5: 'Produkty toaletowe premium',
                inclusion6: 'Codzienna obsługa pokoju',
                amenityGroup1Title: 'Technologia',
                amenityGroup1Item1: '55" Smart TV',
                amenityGroup1Item2: 'Bezpłatne Wi-Fi',
                amenityGroup1Item3: 'Głośnik Bluetooth',
                amenityGroup1Item4: 'Porty ładujące USB',
                amenityGroup2Title: 'Łazienka',
                amenityGroup2Item1: 'Prysznic deszczowy',
                amenityGroup2Item2: 'Produkty toaletowe premium',
                amenityGroup2Item3: 'Szlafrok i kapcie',
                amenityGroup2Item4: 'Suszarka do włosów',
                amenityGroup3Title: 'Komfort',
                amenityGroup3Item1: 'Klimatyzacja',
                amenityGroup3Item2: 'Wentylator sufitowy',
                amenityGroup3Item3: 'Minibar',
                amenityGroup4Title: 'Ostatnie dotknięcia',
                amenityGroup4Item1: 'Ekspres do kawy i zestaw herbaciany',
                amenityGroup4Item2: 'Sejf',
                amenityGroup4Item3: 'Żelazko i deska do prasowania',
                essentialsTitle: 'Niezbędne możliwości',
                essentialsHeading: 'Wybierz swoje doświadczenie',
                essentialsDesc: 'Dostosuj swój pobyt za pomocą naszych kurowanych dodatków i usług.',
                essential1: 'Spa i wellness',
                essential2: 'Doświadczenia kulinarne',
                essential3: 'Wycieczki',
                essential4: 'Sporty wodne',
                oceanTitle: 'Pokój łączący Cię z naturą',
                oceanSubtitle: 'Gdzie krajobrazy morza, nieba i ziemi harmonijnie się łączą',
                oceanAlt: 'Widok oceanu',
                ctaTitle: 'Zacznij swoją podróż',
                ctaHeading: 'Gotowy do doświadczenia spokoju?',
                ctaDesc: 'Zarezerwuj swój ucieczka do luksusu i odkryj idealną harmonię między elegancją a wygodą.',
                checkAvailability: 'Sprawdź dostępność'
            }
        },
        home: {
            heroTitle: 'Kurort Mahi Beach Ayurveda Resort Beach',
            heroSubtitle1: 'Ayurveda przy oceanie',
            heroSubtitle2: 'Znajdź równowagę, łatwo oddychaj i odnów swoją energię w Beruwale.',
            exploreResort: 'Zbadaj kurort',
            bookNow: 'Zarezerwuj teraz',
            welcomeLabel: 'Witaj',
            welcomeTitle: 'Kurort Mahi Beach Ayurveda Resort Beach',
            welcomeDesc1: 'Położony na dziewiczych brzegach Beruwal, kurort Mahi Beach Ayurveda Resort Beach oferuje harmonijne połączenie starożytnych tradycji uzdrawiania i nowoczesnego luksusu przybrzeżnego. Nasze sanktuarium zaprasza cię w transformującą podróż wellness, gdzie rytmiczne dźwięki Oceanu Indyjskiego spotykają się z ponadczasową mądrością Ayurvedy.',
            welcomeDesc2: 'Doświadcz spersonalizowanych zabiegów ajurwedyjskich, delektuj się pożywną kuchnią opracowaną w celu równoważenia Twojego dosha i zrelaksuj się w elegancko wyposażonych pokojach z zachwycającymi widokami na ocean. Niezależnie od tego, czy szukasz odmłodzenia, relaksu czy duchowego odrodzenia, nasz oddany zespół praktyków Ayurvedy i ekspertów od będzie cię prowadził na każdym kroku.',
            learnMore: 'Dowiedz się więcej',
            contactUs: 'Skontaktuj się z nami',
            welcomeImageAlt: 'Kurort Mahi Beach Ayurveda Resort Beach',
            welcomeImageCaption: 'Ayurveda & Beach Retreat',
            welcomeImageLocation: 'Maggona Sri Lanka',
            highlightTitle: 'Sanktuarium Ayurvedy nad morzem',
            highlightDesc: 'Odkryj holistyczne uzdrawianie na południowo-zachodnim wybrzeżu Sri Lanki. Od dostosowanych zabiegów po spokojne balkony i świadome gotowanie, każdy szczegół został zaprojektowany, aby przywrócić twój rytm.',
            service1Title: 'Holistyczne terapie Ayurvedy',
            service1Desc: 'Spersonalizowane konsultacje, autentyczne oleje roślinne i codzienne zabiegi prowadzone przez doświadczonych lekarzy Ayurvedy.',
            service2Title: 'Pokoje i apartamenty na plaży',
            service2Desc: 'Obudź się z morskim powiewem, prywatnymi balkonami i uspokajającym wnętrzem zaprojektowanym do głębokie odpoczynku.',
            service3Title: 'Kuchnia wellness',
            service3Desc: 'Świeże produkty Sri Lanki, menu oparte na roślinach i spersonalizowane plany posiłków, które uzupełniają twojego dosh.',
            service4Title: 'Joga i uważność',
            service4Desc: 'Joga o wschodzie słońca, medytacja o zachodzie słońca i ćwiczenia oddechowe w rytmie fal.',
            service5Title: 'Wycieczki po rzekach i wybrzeżu',
            service5Desc: 'Rejsy po rzece Bentota, wizyty w inkubatoriach żółwi morskich, spacery po ogrodach przypraw i wycieczki rowerowe po wsiach.',
            roomsTitle: 'Nasze pokoje',
            roomsDesc: 'Wybierz sanktuarium, które odpowiada Twojemu tempu, od przestronnych apartamentów po przytulne deluxe schroniska, każdy z miękkimi prześcieradłami, ciepłym drewnem i balkonami gotowymi na wschód słońca.',
            roomBadge: 'Ucieczka na plaży',
            bookableNow: 'Teraz zarezerwować',
            seaBreezeReady: 'Gotowy do morskiego powiewu',
            viewRoom: 'Wyświetl pokój',
            room1Title: 'Pokoje apartamentowe',
            room1Desc: 'Przestronne apartamenty z salonem, hojnymi balkonami i uspokajającą paletą dla powolnych poranków.',
            room2Title: 'Pokoje Deluxe',
            room2Desc: 'Przytulne schroniska z luksusowymi łóżkami, widokiem na ogród i ciepłymi akcentami drewnianymi dla łatwości na codzień.',
            room3Title: 'Deluxe z widokiem na morze',
            room3Desc: 'Obudź się z horyzontem oceanu, miękkimi prześcieradłami i prywatnym balkonem stworzonym dla złotych zachodów słońca.',
            achievement1Title: 'Szczęśliwych gości',
            achievement1Count: '1 000+',
            achievement2Title: 'Zabiegi Ayurvedy',
            achievement2Count: '20+',
            achievement3Title: 'Lata opieki',
            achievement3Count: '15+',
            achievement4Title: 'Pochway podróżników',
            achievement4Count: '1 000+',
            experiencesTitle: 'Odkryj Kurort Mahi Beach Ayurveda Resort Beach',
            experiencesDesc: 'Od podróży Ayurvedy do kuratorskich wycieczek, wybierz doświadczenia, które sprawią, że twój pobyt będzie niezapomniany.',
            planYourStay: 'Zaplanuj swój pobyt',
            experience1Title: 'Pokoje i apartamenty',
            experience1Desc: 'Przestrzenne pomieszczenia z balkonami, widokami na ocean lub ogród i przemyślanym komfortem dla niespiesznych pobytów.',
            experience2Title: 'Spa Ayurvedy',
            experience2Desc: 'Autentyczne terapie, kąpiele parowe i regeneracyjne masaże realizowane dzięki sprawdzonym rytuałom.',
            experience3Title: 'Doświadczenie kulinarne',
            experience3Desc: 'Odżywcza kuchnia Sri Lanki i międzynarodowa serwowana w naszej restauracji, starannie przygotowana do odżywiania ciała i umysłu.',
            experience4Title: 'Doświadczenia i wycieczki',
            experience4Desc: 'Safari po rzece, wizyty w świątyniach, sporty wodne i wyselekcjonowane wycieczki kulturalne wokół Benutami.',
            galleryTitle: 'Chwile w Kurorcie Mahi Beach Ayurveda Resort Beach',
            galleryDesc: 'Wgląd w nasze przybrzeżne sanktuarium — wschody słońca, spokojne zabiegi, pożywny jedzenie i spokojne kąty dla ciebie ',
            gallery1Alt: 'Słoneczna plaża otoczona palmami w Mahi Beach',
            gallery2Alt: 'Trwająca terapia olejowa Ayurvedy',
            gallery3Alt: 'Basen kurortu z leżakami',
            gallery4Alt: 'Zioła przygotowane do spa',
            gallery5Alt: 'Para cieszy się zachodem słońca nad morzem',
            gallery6Alt: 'Taras jogi zwrócony ku oceanowi',
            gallery7Alt: 'Ścieżka tropikalnego ogrodu',
            gallery8Alt: 'Zdrowe śniadanie',
            gallery9Alt: 'Spokojny widok na rzekę',
            gallery10Alt: 'Eksterior kurortu ciepło oświetlony o zachodzie słońca',
            gallery11Alt: 'Wyświetl zioła Ayurvedy i oleje',
            gallery12Alt: 'Wygodne siedzenie w ogrodzie',
            resort1Alt: 'Otwarta loża z zielenią',
            resort2Alt: 'Wygodne wnętrze pokoju',
            resort3Alt: 'Przestrzeń spaowego leczenia',
            resort4Alt: 'Jadalnia ze światłem naturalnym',
            resort5Alt: 'Relaksujący widok basenu',
            sunsetLabel: 'Codzienny arcydzieło przyrody',
            sunsetTitle: 'Wieczorny zachód słońca',
            sunsetDesc1: 'Obserwuj, jak dzień gracefully oddaje zmrok, gdy niebo zmienia się w płótno bursztynu, karmazynu i złota. Łagodny Ocean Indyjski odzwierciedla to niebiańskie widowisko, tworząc hipnotyzującą symfonię światła i wody.',
            sunsetDesc2: 'Każdy wieczór w Mahi Beach oferuje miejsca w pierwszym rzędzie jednego z najbardziej spektakularnych występów przyrody. Znajdź swój idealny punkt widzenia — czy to z twojego prywatnego balkonu, loży na plaży czy naszego pokładu medytacji przy zachodzie słońca — i pozwól spokojnej piękności go oniemielać.',
            sunsetFeature1: 'Niezakłóconymi widokami za całego nieprzerwanego morza',
            sunsetFeature2: 'Spokojność medytacji o zachodzie słońca',
            sunsetFeature3: 'Bezpłatna herbata ziołowa serwowana codziennie',
            sunsetFeature4: 'Fotogeniczne momenty każdego wieczoru',
            sunsetImageAlt: 'Wieczorny zachód słońca na Kurorcie Mahi Beach Beach',
            bestTime: 'Najlepszy czas',
            sunsetTime: '18:00 - 18:45',
            poolLabel: 'Akwatyczna spokojność',
            poolTitle: 'Strefa basenu',
            poolDesc1: 'Zanurz się w spokój naszego nieskazitelnego basenu bez krawędzi, gdzie krystalowo czysta woda spotyka się z bujnymi tropikalnymi ogrodami. Zaelaprojektowana do relaksu i odmłodzenia, nasza strefa basenu oferuje doskonałą ucieczkę do relaksowania się pod słońcem Sri Lanki.',
            poolDesc2: 'Niezależnie od tego, czy wolisz oświeżające poranne pływanie, popołudniową sesję relaksu z dobrą książką czy spokojne wieczorne zanurzenia, nasza strefa basenu zapewnia idylliczne otoczenie. Otoczone wygodnymi leżakami, zacienionymi kabinami i troskliwą obsługą przy basenie, każdy moment staje się drogocennych wspomnieniem.',
            poolFeature1: 'Basen bez krawędzi z kontrolą temperatury',
            poolFeature2: 'Otoczony krajobrazami tropikalnych ogrodów',
            poolFeature3: 'Oświeżenia i zdrowe przekąski przy basenie',
            poolFeature4: 'Premium leżaki z parasolkami',
            poolImageAlt: 'Relaksująca strefa basenu w Kurorcie Mahi Beach',

            // Ceremonia Pożegnania Gości
            departureLabel: 'Tradycja Pożegnania',
            departureTitle: 'Ceremonia Pożegnania Gości',
            departureDesc1: 'W Mahi Beach Ayurveda Resort honorujemy Twoją podróż z nami poprzez znaczącą ceremonię pożegnania zakorzenioną w tradycji Sri Lanki. Gdy przygotowujesz się do wyjazdu, nasz zespół gromadzi się, aby zaoferować błogosławieństwa dla bezpiecznej podróży i ciągłego dobrego samopoczucia.',
            departureDesc2: 'Ten szczery rytuał obejmuje tradycyjne błogosławieństwa, specjalne menu pożegnalne z autentycznymi przysmakami Sri Lanki oraz mały prezent, aby zabrać ze sobą nasze ciepło. To nasz sposób na zapewnienie, że Twoje wspomnienia z Mahi Beach pozostaną cenne długo po Twoim wyjeździe.',
            departureFeature1: 'Tradycyjne buddyjskie błogosławieństwa dla bezpiecznej podróży',
            departureFeature2: 'Spersonalizowane prezenty pożegnalne i pamiątki',
            departureFeature3: 'Specjalne menu wyjazdu z przysmakami Sri Lanki',
            departureFeature4: 'Ceremonia błogosławieństwa ze świętymi rytuałami',
            departureImageAlt: 'Ceremonia pożegnania gości w Kurorcie Mahi Beach',

            // TripAdvisor
            tripadvisorLabel: 'TripAdvisor',
            tripadvisorTitle: 'Opinie Gości',

            testimonialsTitle: 'Goście podczas ich pobytu',
            testimonialsLabel: 'Historie Gości',

            // Video Section
            videoLabel: 'Wciągające Doświadczenie',
            videoTitle: 'Odkryj Mahi Beach',
            videoDescription: 'Doświadcz piękna i spokoju Mahi Beach Ayurveda Resort poprzez naszą wciągającą podróż wideo. Odkryj udogodnienia światowej klasy, dziewicze plaże i odmadzające doświadczenia wellness.',

            // Featured Room
            featuredRoomLabel: 'Wyróżniające Się Zakwaterowanie',
            featuredRoomTitle: 'Luksusowy Pokój Dwuosobowy z Widokiem na Morze',

            // Booking Bar
            bookingResort: 'Kurort',
            bookingResortName: 'Mahi Beach Ayurveda Resort',
            bookingCheckIn: 'Zameldowanie',
            bookingCheckOut: 'Wymeldowanie',
            bookingGuests: 'Goście',
            booking1Guest: '1 Gość',
            booking2Guests: '2 Gości',
            booking3Guests: '3 Gości',
            bookingCheckAvailability: 'Sprawdź Dostępność',

            // Hero Buttons
            heroExploreButton: 'Eksploruj Mahi Beach',
            heroBookButton: 'Zarezerwuj Luksusowy Pokój'
        },

        navbar: {
            home: 'Strona główna',
            aboutUs: 'O nas',
            rooms: 'Pokoje',
            ayurveda: 'Ajurweda',
            yoga: 'Joga',
            food: 'Wyżywienie',
            events: 'Wydarzenia',
            blogs: 'Blogi',
            tours: 'Wycieczki',
            contactUs: 'Kontakt',
            bookOnline: 'Rezerwuj online',
            locationMaggona: 'Maggona Sri Lanka',
            selectResort: 'Wybierz ośrodek',
            language: 'Język',
            mainTitle: 'Mahi Beach Ayurveda Resort',
            resortBeach: 'Mahi Beach Ayurveda Resort',
            resortRiver: 'Mahi Beach Ayurveda Resort'
        },
        footer: {
            description: 'Mahi Beach Ayurveda Resort dokłada starań, aby zapewnić wyjątkową gościnność i doświadczenia wellness, dzięki którym każdy gość czuje się doceniony i zregenerowany.',
            linksTitle: 'Linki',
            contactTitle: 'Kontakt',
            viewLocation: 'Zobacz lokalizację',
            navHome: 'Strona główna',
            navAbout: 'O nas',
            navContact: 'Kontakt',
            navRooms: 'Pokoje',
            navAyurveda: 'Ajurweda',
            copyright: '© Copyright {{year}} Mahi Beach Ayurveda Resort.',
            developedBy: 'Wykonanie',
            developerName: 'Redev Solution +94 764 608 225'
        },
        tours: {
            heroTitle: 'Wycieczki i wycieczki',
            heroSubtitle: 'Odkryj piękno Sri Lanki z Beruwali',
            kandeAlt: 'Świątynia Kande Vihara - Maggona',
            kandeTitle: 'Wizyta w świątyni Kande Vihara',
            kandeBuddhaAlt: 'Gigantyczna statua Buddy w świątyni Kande Vihara',
            bentotaTitle: 'Safari łodzią po rzece Bentota',
            bentotaAlt: 'Safari łodzią po rzece Bentota - Mangrowy i fauna',
            galleTitle: 'Wycieczka po Starym Mieście Galle',
            galleAlt: 'Wycieczka po Starym Mieście Galle',
            sigiriyaTitle: 'Wycieczka po twierdzy skalnej Sigiriya',
            sigiriyaAlt: 'Wycieczka po twierdzy skalnej Sigiriya',
            kandyTitle: 'Wycieczka kulturalna Kandy',
            kandyAlt: 'Wycieczka kulturalna Kandy',
            bookTour: 'Zarezerwuj tę wycieczkę',
            viewDetails: 'Wyświetl szczegóły',
            introPara1: 'Sri Lanka to kraj ponadczasowego piękna, gdzie złote plaże, bujne zielone krajobrazy, starożytne świątynie i tętniąca kulturą wspólnota łączą się w doskonałej harmonii.',
            introPara2: 'Od spokojnego południowo-zachodniego wybrzeża, poprzez zabytkowe miasta, święte miejsca, rezerwaty przyrody aż po mglisty region górski – każda podróż oferuje wyjątkowe i niezapomniane doświadczenie.',
            introPara3: 'Wycieczki i wycieczki zostały starannie wyselekcjonowane w celu wzbogacenia Twojego pobytu, doskonale łącząc badanie, relaks i wellness, rozpoczynając od kurortu Mahi Beach Ayurveda Resort w Beruwalę.',
            kandeDetail1: 'Świątynia Kande Vihara (Kande Viharaya) – jedna z najikoniczniejszych świątyń buddyjskich w pobliżu Beruwali.',
            kandeDetail2: 'Założona w 1734 roku, ta spokojna "Świątynia Górska" usytuowana na szczycie wzgórza oferuje spokojne widoki na linię brzegową.',
            kandeDetail3: 'Atrakcje obejmują ogromną statueę siedzącej Buddy o wysokości 48 metrów (jedną z najwyższych na Sri Lance), skomplikowane freski z epoki Kandyan, starożytną komorę relikwiarzą, piękną brame księżycową i święte drzewo Bodhi liczące ponad 300 lat.',
            kandeDetail4: 'Doskonałe doświadczenie duchowe i kulturalne na pół dnia – idealne na wizyty poranmne, aby uniknąć upału.',
            bentotaDetail1: 'Ciesz się spokojnym i malowniczym safari łodzią po rzece Bentota, jednej z najpopularniejszych ekskursji przyrodniczych w pobliżu Beruwali.',
            bentotaDetail2: 'Pływaj przez bujne mangrowy, wąskie kanały i spokojne wody, obserwując lokalną faunę.',
            bentotaDetail3: 'Typowe obserwacje obejmują jaszczurki wodne, krokodyle, różne gatunki ptaków (zimorodki, czaple, orły), małpy i czasami wydry lub węże wodne.',
            bentotaDetail4: 'Twój doświadczony przewodnik łodzią wskaże interesującą florę, tradycyjne metody połowów i życie we wsiach rzecznych.',
            bentotaDetail5: 'Doskonały dla miłośników przyrody i fotografów – spokojny, relaksujący i uzupełniający Twój pobyt ayrwedyjski wellness.',
            galleDetail1: 'Odkryj zabytkową twierdzę Galle, światowe dziedzictwo UNESCO i jedną z najlepiej zachowanych twierdz z czasów kolonialnych na Sri Lance.',
            galleDetail2: 'Spaceruj po brukowanych ulicach obsadzonych holenderskimi budynkami kolonialnymi, butików, kawiarni i galeriach sztuki.',
            galleDetail3: 'Odwiedź kluczowe atrakcje, takie jak latarnia Galle, holenderski kościół reformowany, Narodowe Muzeum Morskie i forty z wspaniałymi widokami na ocean.',
            galleDetail4: 'Poznaj bogatą historię, architekturę i znaczenie kulturowe twierdzy od swojego doświadczonego przewodnika.',
            galleDetail5: 'Idealny dla miłośników historii, entuzjastów kultury i tych, którzy chcą doświadczyć kolonialnej przeszłości Sri Lanki.',
            sigiriyaDetail1: 'Odkryj starożytną twierdze skalną Sigiriya, jeden z najbardziej znanych zabytków Sri Lanki i światowe dziedzictwo UNESCO.',
            sigiriyaDetail2: 'Wejdź na imponującą skałę i eksploruj ruiny pałacu króla Kaszjapy, zdobionego freskami, ogrodami wodnymi i słynną Ścianą Luster.',
            sigiriyaDetail3: 'Ciesz się panoramicznymi widokami na otaczającą dżunglę i okolicę ze szczytu.',
            sigiriyaDetail4: 'Poznaj fascynującą historię, architekturę i legendy związane z Sigiriją od swojego eksperta.',
            sigiriyaDetail5: 'Doskonały dla miłośników historii, poszukiwaczy przygód i tych zainteresowanych bogatym dziedzictwem kulturalnym Sri Lanki.',
            kandyDetail1: 'Doświadcz tętniącej życiem kultury Kandy, ostatniej królewskiej stolicy Sri Lanki i światowego dziedzictwa UNESCO.',
            kandyDetail2: 'Odwiedź Świątynię Świętego Zęba (Sri Dalada Maligawa), jedno z najważniejszych miejsc buddyjskich na świecie.',
            kandyDetail3: 'Eksploruj Królewskie Ogrody Botaniczne w Peradenii, siedzibę ogromnej kolekcji roślin tropikalnych i orchidei.',
            kandyDetail4: 'Ciesz się tradycyjnym przedstawieniem tańca Kandyjskiego, prezentującym bogate dziedzictwo artystyczne Sri Lanki.',
            kandyDetail5: 'Idealny dla entuzjastów kultury, pasjonatów historii i tych, którzy chcą zanurzyć się w tradycjach Sri Lanki.',
            ellaTitle: 'Przygoda w górskiej krainie Ella',
            ellaAlt: 'Wycieczka po górskiej krainie Ella - Most Dziewięciu Łuków i plantacje herbaty',
            ellaDetail1: 'Podróż do Elli, jednego z najbardziej malowniczych górskich miejsc Sri Lanki, słynącego wspaniałymi widokami górskimi i chłodnym klimatem.',
            ellaDetail2: 'Odwiedź ikoniczny Most Dziewięciu Łuków, kolejowy cud z czasów kolonialnych osadzony w bujnej zieleni, idealny do fotografowania i oglądania przejeżdżających pociągów.',
            ellaDetail3: 'Eksploruj zielone plantacje herbaty, dowiedz się o produkcji herbaty cejlońskiej i ciesz się panoramicznymi widokami z Little Adam\'s Peak lub skały Ella.',
            ellaDetail4: 'Odkryj kaskadowe wodospady, w tym wodospady Ravana, wędruj malowniczymi szlakami i doświadcz uroczej wiejskiej atmosfery.',
            ellaDetail5: 'Idealny dla miłośników przyrody, poszukiwaczy przygód i tych, którzy chcą uciec do zapierających dech w piersiach wyżyn Sri Lanki.'
        },
        blogs: {
            heroTitle: 'Blogi Mahi Beach Ayurveda Resort',
            heroSubtitle1: 'Historie z wybrzeża, rytuały ajurwedy w',
            heroSubtitle2: 'Mahi Beach Ayurveda Resort',
            heroSubtitle3: '. Zanurz się w wskazówkach, historii i notatkach z kulis.',
            heroAlt: 'Nadmorska ścieżka kurortu o zachodzie słońca',
            sectionTitle: 'Blogi Mahi Beach Ayurveda Resort',
            sectionDescription: 'Przewodniki, historie i notatki z naszego nadmorskiego odosobnienia — obejmujące rytuały ajurwedy, tradycje kamieni szlachetnych i porady podróżnicze wokół Bentoty.',
            ayurvedaTitle: 'Serce autentycznej ajurwedy',
            ayurvedaExcerpt: 'Doświadcz sprawdzonych tradycji leczniczych zakorzenionych w starożytnej mądrości Sri Lanki.',
            ayurvedaDescription: 'W Mahi Beach Ayurveda Resort ajurweda to coś więcej niż zabieg — to styl życia. Nasze terapie opierają się na wielowiekowej wiedzy, są dostosowane do twojego typu ciała i prowadzone przez doświadczonych lekarzy ajurwedyjskich dla głębokiej, trwałej równowagi.',
            ayurvedaAlt: 'Ustawienie zabiegu ajurwedyjskiego z olejkami ziołowymi i naturalnymi elementami',
            healingTitle: 'Spersonalizowane podróże lecznicze',
            healingExcerpt: 'Dlaczego program każdego gościa jest unikalnie zaprojektowany.',
            healingDescription: 'Od wstępnych konsultacji po codzienne zabiegi, twoja podróż lecznicza jest starannie dopasowana. Terapie ziołowe, masaże terapeutyczne, joga i medytacja współpracują, aby przywrócić harmonię między ciałem, umysłem i duchem.',
            healingAlt: 'Lekarz ajurwedyjski konsultujący gościa w spokojnym otoczeniu',
            natureTitle: 'Uzdrawianie nad oceanem',
            natureExcerpt: 'Jak morska bryza i tropikalne otoczenie wzmacniają twoje samopoczucie.',
            natureDescription: 'Położony wzdłuż spokojnego wybrzeża Sri Lanki, Mahi Beach oferuje naturalnie uzdrawiające środowisko. Dźwięk fal, świeże morskie powietrze i bujne zieleń wzmacniają efekty ajurwedy, tworząc głęboki relaks i odnowę.',
            natureAlt: 'Widok na plażę kurortu z palmami i oceanem',
            foodTitle: 'Kuchnia ajurwedyjska dla wewnętrznej równowagi',
            foodExcerpt: 'Odżywcze posiłki przygotowane na wsparcie twojego leczenia.',
            foodDescription: 'Nasza kuchnia ajurwedyjska jest świeżo przygotowywana z sezonowych, lokalnych składników. Każdy posiłek jest dopasowany do twojej doszy, wspierając trawienie, detoksykację i ogólną witalność, pozostając przy tym smacznym i satysfakcjonującym.',
            foodAlt: 'Tradycyjny posiłek ajurwedyjski podawany w naturalnych miseczkach',
            yogaTitle: 'Joga, medytacja i wewnętrzny spokój',
            yogaExcerpt: 'Łagodne praktyki uspokajające umysł i wzmacniające ciało.',
            yogaDescription: 'Codzienne sesje jogi i medytacji uzupełniają twoje zabiegi, poprawiając elastyczność, oddech i jasność umysłu. Te uważne praktyki pomagają ci ponownie się z sobą połączyć i przenieść poczucie spokoju poza twój pobyt.',
            yogaAlt: 'Goście praktykujący jogę z widokiem na ocean o wschodzie słońca',
            lifestyleTitle: 'Zabranie ajurwedy do domu',
            lifestyleExcerpt: 'Proste praktyki stylu życia, aby kontynuować twoją podróż wellness.',
            lifestyleDescription: 'Przed wyjazdem nasi eksperci doradzą ci, jak utrzymać równowagę poprzez codzienne rutyny, dietę i rytuały samoopieki. Zabierz do domu więcej niż wspomnienia — zabierz zrównoważoną ścieżkę do zdrowszego życia.',
            lifestyleAlt: 'Gość relaksujący się z ziołową herbatą w spokojnym otoczeniu kurortu',
            readMore: 'Czytaj więcej'
        },
        events: {
            heroEyebrow: 'Doświadczenia i aktywności',
            heroTitle: 'Nasze wydarzenia',
            heroSubtitle: 'Wyselekcjonowane doświadczenia łączące tradycję Sri Lanki z nadmorskim luksusem',
            heroAlt: 'Wydarzenia w Mahi Beach',
            availableDaily: 'Dostępne codziennie',
            bookNow: 'Zarezerwuj',
            highlightsTitle: 'Najważniejsze',
            detailAlt: '{{title}} – szczegóły',
            ctaTitle: 'Gotowy na tworzenie wspomnień?',
            ctaDescription: 'Skontaktuj się z naszym zespołem, aby spersonalizować idealne doświadczenie wydarzenia w Mahi Beach Ayurveda Resort',
            ctaContact: 'Skontaktuj się z nami',
            ctaViewRooms: 'Zobacz pokoje',
            buddhistMonkMeditationTitle: 'Medytacja z mnichami buddyjskimi',
            buddhistMonkMeditationSubtitle: 'Tradycyjne praktyki uważności',
            buddhistMonkMeditationDescription: 'Doświadcz autentycznej medytacji buddyjskiej prowadzonej przez doświadczonych mnichów w naszym spokojnym kurorcie. Te starożytne praktyki promują wewnętrzny spokój, uważność i duchowe samopoczucie poprzez sesje łączące tradycyjne śpiewy, techniki oddechowe i cichą medytację.',
            buddhistMonkMeditationHighlight1: 'Tradycyjne sesje medytacji buddyjskiej',
            buddhistMonkMeditationHighlight2: 'Prowadzenie przez doświadczonych mnichów',
            buddhistMonkMeditationHighlight3: 'Spokojne wnętrza kurortu',
            buddhistMonkMeditationHighlight4: 'Techniki uważności i oddychania',
            buddhistMonkMeditationHighlight5: 'Praktyki duchowego dobrostanu',
            cookeryTitle: 'Programy kulinarne',
            cookerySubtitle: 'Smak Sri Lanki',
            cookeryDescription: 'Zanurz się w żywych smakach kuchni Sri Lanki. Nasi doświadczeni szefowie kuchni prowadzą praktyczne zajęcia kulinarne, ucząc tradycyjnych przepisów przekazywanych z pokolenia na pokolenie. Naucz się przygotowywać aromatyczne curry, hoppers, kokosowy sambol i wiele więcej z użyciem świeżych lokalnych składników.',
            cookeryHighlight1: 'Tradycyjne przepisy Sri Lanki',
            cookeryHighlight2: 'Praktyczne doświadczenie kulinarne',
            cookeryHighlight3: 'Świeże lokalne składniki',
            cookeryHighlight4: 'Zabierz przepisy do domu',
            cookeryHighlight5: 'Wizyta w ogrodzie przypraw w cenie',
            meditationTitle: 'Programy medytacyjne',
            meditationSubtitle: 'Wewnętrzny spokój i uważność',
            meditationDescription: 'Znajdź spokój podczas naszych prowadzonych sesji medytacyjnych na tle spokojnego Oceanu Indyjskiego. Nasi doświadczeni instruktorzy prowadzą przez starożytne techniki uważności, ćwiczenia oddechowe i praktyki jogi zaprojektowane, aby uspokoić umysł i odnowić ducha.',
            meditationHighlight1: 'Sesje o wschodzie i zachodzie słońca',
            meditationHighlight2: 'Medytacja na plaży',
            meditationHighlight3: 'Prowadzone przez ekspertów',
            meditationHighlight4: 'Techniki oddechowe',
            meditationHighlight5: 'Praktyki jogi i uważności',
            nightBeachPartiesTitle: 'Wieczór grillowy',
            nightBeachPartiesSubtitle: 'Kulinarne doświadczenie na plaży',
            nightBeachPartiesDescription: 'Rozkoszuj się niezapomnianym wieczorem grillowym na plaży pod gwiazdami. Delektuj się świeżo grillowanymi owocami morza, mięsem premium i świeżymi warzywami, ciesząc się kojącym dźwiękiem fal oceanu. Nasi doświadczeni szefowie kuchni przygotowują każde danie do perfekcji, tworząc niezapomniane kulinarne doświadczenie w magicznym nadmorskim otoczeniu.',
            nightBeachPartiesHighlight1: 'Świeżo grillowane owoce morza i mięso',
            nightBeachPartiesHighlight2: 'Pokaz grillowania na żywo przez szefów kuchni',
            nightBeachPartiesHighlight3: 'Atmosfera kolacji przy oceanie',
            nightBeachPartiesHighlight4: 'Wybór bufetu BBQ premium',
            nightBeachPartiesHighlight5: 'Plażowa atmosfera z ogniskiem',
            bbqTitle: 'Imprezy BBQ',
            bbqSubtitle: 'Świętowanie na plaży',
            bbqDescription: 'Doświadcz niezapomnianych wieczorów podczas naszych imprez BBQ na plaży. Delektuj się świeżo grillowanymi owocami morza, mięsem premium i wegetariańskimi przysmakami, gdy obok szepczą fale. Muzyka na żywo, tancerze ognia i rozgwieżdżone niebo tworzą idealną atmosferę do świętowania i integracji.',
            bbqHighlight1: 'Świeżo grillowane owoce morza',
            bbqHighlight2: 'Posiłki nad oceanem',
            bbqHighlight3: 'Rozrywka na żywo',
            bbqHighlight4: 'Doświadczenie przy ognisku',
            bbqHighlight5: 'Konfigurowalne menu',
            musicTherapyTitle: 'Muzykoterapia',
            musicTherapySubtitle: 'Uzdrawianie dźwiękiem',
            musicTherapyDescription: 'Doświadcz transformacyjnej mocy muzykoterapii w naszym spokojnym oceanicznym otoczeniu. Doświadczeni terapeuci używają tradycyjnych i nowoczesnych instrumentów do tworzenia terapeutycznych doświadczeń dźwiękowych, które wspierają głęboki relaks, uwolnienie emocji i holistyczne uzdrawianie.',
            musicTherapyHighlight1: 'Profesjonalnie prowadzone sesje terapeutyczne',
            musicTherapyHighlight2: 'Tradycyjne i nowoczesne instrumenty',
            musicTherapyHighlight3: 'Terapia relaksacyjna i uwolnienia emocji',
            musicTherapyHighlight4: 'Warsztaty medytacji dźwiękowej',
            musicTherapyHighlight5: 'Harmonizacja umysł-ciało-duch',
            taiChiTitle: 'Tai Chi',
            taiChiSubtitle: 'Łagodny ruch i równowaga',
            taiChiDescription: 'Praktykuj starożytną sztukę Tai Chi w naszym spokojnym nadmorskim ogrodzie. Te eleganckie, płynne ruchy poprawiają równowagę, elastyczność i wewnętrzną siłę, jednocześnie uspokajając umysł. Odpowiednie dla wszystkich poziomów fitness i wieku.',
            taiChiHighlight1: 'Codzienne zajęcia o wschodzie słońca',
            taiChiHighlight2: 'Prowadzone przez certyfikowanych mistrzów',
            taiChiHighlight3: 'Poprawia równowagę i elastyczność',
            taiChiHighlight4: 'Odpowiednie dla wszystkich grup wiekowych',
            taiChiHighlight5: 'Sztuki walki i praktyki medytacyjne',
            boatTitle: 'Rejsy łodzią',
            boatSubtitle: 'Przygody rzeczne i przybrzeżne',
            boatDescription: 'Wyrusz w czarujące rejsy po rzece Bentota i wodach przybrzeżnych. Płyń przez lasy namorzynowe, obserwuj egzotyczne ptaki i dziką przyrodę lub ciesz się romantycznymi rejsami o zachodzie słońca. Nasze rejsy oferują unikalną perspektywę naturalnego piękna i różnorodnych ekosystemów Sri Lanki.',
            boatHighlight1: 'Rejsy po rzece Bentota',
            boatHighlight2: 'Eksploracja namorzynów',
            boatHighlight3: 'Obserwacja dzikiej przyrody',
            boatHighlight4: 'Rejsy o zachodzie słońca',
            boatHighlight5: 'Dostępny czarter prywatny',
            ayurvedaLecturesTitle: 'Wykłady lekarzy ajurwedyjskich',
            ayurvedaLecturesSubtitle: 'Starożytna mądrość i nowoczesny wellness',
            ayurvedaLecturesDescription: 'Poznaj głębokie zasady ajurwedy dzięki wykładom prowadzonym przez certyfikowanych lekarzy ajurwedyjskich i praktyków. Dowiedz się o równoważeniu dosz, ziołowych środkach, holistycznych praktykach leczenia oraz o tym, jak starożytna mądrość odnosi się do nowoczesnego wellness. Nasze interaktywne sesje wyjaśniają filozofię ajurwedy i jej zastosowanie w codziennym życiu.',
            ayurvedaLecturesHighlight1: 'Certyfikowani lekarze ajurwedyjscy',
            ayurvedaLecturesHighlight2: 'Spersonalizowana analiza doszy',
            ayurvedaLecturesHighlight3: 'Edukacja o ziołowych środkach',
            ayurvedaLecturesHighlight4: 'Sesje pytań i odpowiedzi',
            ayurvedaLecturesHighlight5: 'Przewodnik do zabrania',
            traditionalClothsTitle: 'Wydarzenia z tradycyjnym strojem',
            traditionalClothsSubtitle: 'Doświadczenie dziedzictwa kulturowego',
            traditionalClothsDescription: 'Zanurz się w dziedzictwie kulturowym Sri Lanki, ucząc się nosić i doceniać tradycyjny strój. Nasi styliści poprowadzą Cię przez zakładanie autentycznych kandiańskich sari i tradycyjnych ubiorów, wyjaśniając znaczenie kulturowe każdego elementu. Idealne na specjalne okazje, dla docenienia kultury lub stworzenia niezapomnianych zdjęć.',
            traditionalClothsHighlight1: 'Profesjonalne wskazówki stylizacyjne',
            traditionalClothsHighlight2: 'Autentyczne tradycyjne sari',
            traditionalClothsHighlight3: 'Wyjaśnienie znaczenia kulturowego',
            traditionalClothsHighlight4: 'Wliczona profesjonalna fotografia',
            traditionalClothsHighlight5: 'Warsztaty fuzji mody',
            shanthiKarmaTitle: 'Taniec kulturowy',
            shanthiKarmaSubtitle: 'Tradycyjne występy lankijskie',
            shanthiKarmaDescription: 'Zanurz się w żywym świecie lankijskiego tańca kulturowego. Doświadcz hipnotyzujących tradycyjnych występów z kolorowymi strojami, rytmicznymi bębnami i starożytnym opowiadaniem historii poprzez ruch. Nasi utalentowani tancerze prezentują wielowiekowe tańce ludowe, taniec Kandyan i rytuały kulturowe, które ożywiają lankijskie dziedzictwo.',
            shanthiKarmaHighlight1: 'Autentyczne tradycyjne tańce lankijskie',
            shanthiKarmaHighlight2: 'Kolorowe tradycyjne stroje i makijaż',
            shanthiKarmaHighlight3: 'Akompaniament bębnów na żywo',
            shanthiKarmaHighlight4: 'Opowiadanie kulturowe poprzez ruch',
            shanthiKarmaHighlight5: 'Występy tańca Kandyan i ludowego',
        },
        contact: {
            heroTitle: 'Skontaktuj się z nami',
            heroSubtitle: 'Mahi Beach Ayurveda Resort',
            heroAlt: 'Skontaktuj się z nami',
            sectionTitle: 'Zapraszamy do kontaktu',
            sectionSubtitle: 'Jesteśmy tutaj, aby pomóc Ci się zrelaksować i zregenerować',
            sectionDescription: 'Skontaktuj się z Mahi Beach Ayurveda Resort w sprawie pobytu ajurwedyjskiego, pakietów wellness, rezerwacji lub pytań podczas pobytu w Beruwali, Moragalla.',
            callUs: 'Zadzwoń do nas',
            emailTitle: 'Email',
            ourLocation: 'Nasza lokalizacja',
            locationAddress: 'No.112 rendagewatta Galle Rd, Maggona',
            socialNetwork: 'Media społecznościowe',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Napisz do nas',
            getInTouchDescription: 'Chętnie od Ciebie usłyszymy — nasz zespół jest gotowy pomóc w planowaniu pobytu, odpowiedzieć na pytania i wesprzeć Twoją podróż wellness.',
            nameLabel: 'Imię',
            emailLabel: 'Email',
            contactNumberLabel: 'Numer kontaktowy',
            messageLabel: 'Wiadomość',
            sending: 'Wysyłanie...',
            sendMessage: 'Wyślij wiadomość',
            successMessage: 'Twoja wiadomość została wysłana! Wkrótce się odezwiemy.',
            errorMessage: 'Wystąpił błąd podczas wysyłania. Spróbuj ponownie.',
            findUsOnMap: 'Znajdź nas na mapie',
            whatsappSubject: 'Kontakt Mahi Beach Ayurveda Resort',
            whatsappName: 'Imię',
            whatsappEmail: 'Email',
            whatsappContactNumber: 'Numer kontaktowy',
            whatsappMessage: 'Wiadomość'
        },



        ayurveda: {
            accordionTitle1: 'Poznaj Pańczakarmę',
            accordionDesc1: 'Ajurweda („nauka o życiu") to jeden z najstarszych systemów medycyny holistycznej, rozwijany od ponad 5 000 lat. Pańczakarma opiera się na harmonii umysłu, ciała, duszy i otoczenia. Jej celem jest wzmocnienie zdrowia i profilaktyka, a terapie są dobierane indywidualnie.',
            accordionTitle2: 'Pańczakarma i energia życia',
            accordionDesc2: 'Ajurweda zakłada, że wszystko we wszechświecie pozostaje ze sobą w relacji. Gdy umysł, ciało i dusza są w równowadze, pojawia się dobrostan; gdy równowaga zostaje zaburzona, pojawiają się dolegliwości. Wpływ mają m.in. dziedziczność, urazy, pory roku, wiek i emocje.\n\nCzłowieka tworzy pięć elementów: przestrzeń, powietrze, ogień, woda i ziemia. Z nich powstają trzy dosze: VATA (przestrzeń/powietrze), PITTA (ogień/woda) oraz KAPHA (woda/ziemia), które sterują funkcjami organizmu.\n\nKażdy ma unikalną mieszankę dosz, zwykle z jedną dominującą. Ich równowaga kształtuje zdrowie i podatność na choroby.',
            accordionTitle3: 'Dosza Vata',
            accordionDesc3: 'Vata uznawana jest za najważniejszą; odpowiada za ruch, oddech, krążenie, rytm serca i wydalanie. Zaburzają ją nieregularne posiłki, lęk, smutek i niedosypianie.\n\nPrzy dominacji Vaty jesteś bystry, kreatywny i pełen energii, często szczupły i wrażliwy na chłód. W nierównowadze pojawia się niepokój i lęk.\n\nRównowagę wspierają: uziemienie, medytacja, masaże, stały rytm dnia oraz ciepłe, łagodne posiłki.',
            accordionTitle4: 'Dosza Pitta',
            accordionDesc4: 'Pitta zarządza trawieniem, metabolizmem oraz hormonami głodu. Zaburzają ją ostre lub kwaśne potrawy, nadmiar gorąca i pomijanie posiłków.\n\nOsoby z dominującą Pittą są zdecydowane, ambitne i pewne siebie, często o „ciepłej" konstytucji. W nierównowadze pojawia się drażliwość i stany zapalne.\n\nRównowagę przynoszą lekkie, chłodzące potrawy i uspokajające praktyki, np. spokojna joga.',
            accordionTitle5: 'Dosza Kapha',
            accordionDesc5: 'Kapha zapewnia stabilność, siłę, strukturę i odporność. Wzrasta przy nadmiarze słodkiego, ciężkiej diecie i zbyt długim śnie.\n\nOsoby z dominującą Kaphą są spokojne, cierpliwe i zrównoważone, często o bardziej masywnej budowie. W nierównowadze pojawia się ospałość, spowolnienie i przybieranie na wadze.\n\nRównowagę wspiera lżejsza dieta, więcej owoców i warzyw oraz regularny ruch.',
            close: 'Zamknij',
            next: 'Następny',
            previous: 'Poprzedni',
            treatmentsTitle: 'Nasze sygnaturowe rytuały Pańczakarmy',
            treatmentsSubtitle: 'Tradycyjne terapie, które przywracają równowagę, rozluźniają napięcie i odnawiają ciało oraz umysł.',
            bookTreatment: 'Zarezerwuj ten zabieg',
            benefitsTitle: 'Dlaczego Pańczakarma działa',
            shirodhara: 'Śirodhara',
            shirodharaDesc: 'Ciepły olej ziołowy delikatnie spływa na czoło, uspokajając układ nerwowy.',
            shirodhara1: 'Łagodzi stres i niepokój',
            shirodhara2: 'Wspiera głębszy sen',
            shirodhara3: 'Poprawia klarowność umysłu',
            steamBath: 'Łaźnia parowa',
            steamBathDesc: 'Ziołowa para otwiera pory, wspiera detoks i rozluźnia mięśnie.',
            steamBath1: 'Wspomaga łagodne oczyszczanie',
            steamBath2: 'Poprawia krążenie',
            steamBath3: 'Rozluźnia napięte mięśnie',
            flowerBath: 'Kąpiel kwiatowa',
            flowerBathDesc: 'Aromatyczna kąpiel kwiatowa dla relaksu i odnowy.',
            flowerBath1: 'Uspokaja układ nerwowy',
            flowerBath2: 'Nawilża i zmiękcza skórę',
            flowerBath3: 'Podnosi nastrój',
            headMassage: 'Masaż głowy',
            headMassageDesc: 'Masaż skóry głowy uwalnia nagromadzone napięcie.',
            headMassage1: 'Zmniejsza uczucie ciężkości',
            headMassage2: 'Odżywia skórę głowy i cebulki',
            headMassage3: 'Wprowadza głęboki relaks',
            faceMassage: 'Masaż twarzy',
            faceMassageDesc: 'Delikatny masaż twarzy przywraca blask i redukuje stres.',
            faceMassage1: 'Rozświetla cerę',
            faceMassage2: 'Rozluźnia napięcie twarzy',
            faceMassage3: 'Wspiera drenaż limfatyczny',
            neckMassage: 'Masaż szyi',
            neckMassageDesc: 'Ukierunkowana praca nad sztywnością karku.',
            neckMassage1: 'Łagodzi dyskomfort szyi',
            neckMassage2: 'Zwiększa zakres ruchu',
            neckMassage3: 'Redukuje stres',
            shoulderMassage: 'Masaż ramion',
            shoulderMassageDesc: 'Terapeutyczny masaż rozluźniający barki.',
            shoulderMassage1: 'Zmniejsza ból barków',
            shoulderMassage2: 'Wspiera prawidłową postawę',
            shoulderMassage3: 'Rozbija napięte węzły mięśni',
            bodyMassage: 'Masaż całego ciała',
            bodyMassageDesc: 'Pełny rytuał dla odprężenia i regeneracji.',
            bodyMassage1: 'Poprawia krążenie',
            bodyMassage2: 'Łagodzi bóle mięśni',
            bodyMassage3: 'Pogłębia relaks',
            backMassage: 'Masaż pleców',
            backMassageDesc: 'Terapia pleców uwalniająca napięcie i ból.',
            backMassage1: 'Łagodzi ból pleców',
            backMassage2: 'Wspiera komfort kręgosłupa',
            backMassage3: 'Zmniejsza stres',
            footMassage: 'Masaż stóp',
            footMassageDesc: 'Uziemiający masaż stóp, który uspokaja całe ciało.',
            footMassage1: 'Stymuluje krążenie',
            footMassage2: 'Zmniejsza zmęczenie stóp',
            footMassage3: 'Przynosi ukojenie',
            purgative: 'Środek przeczyszczający',
            purgativeDesc: 'Oczyszczająca terapia usuwająca nadmiar Pitty i toksyny trawienne.',
            purgative1: 'Oczyszcza jelita',
            purgative2: 'Równoważy Pittę',
            purgative3: 'Wspiera trawienie',
            nasalClearing: 'Oczyszczanie nosa',
            nasalClearingDesc: 'Ziołowe oczyszczanie nosa dla swobodnego oddechu.',
            nasalClearing1: 'Łagodzi zatkanie',
            nasalClearing2: 'Poprawia oddychanie',
            nasalClearing3: 'Zmniejsza ucisk zatok',
            powderMassage: 'Masaż proszkiem',
            powderMassageDesc: 'Peeling ziołowymi proszkami dla odświeżonej skóry.',
            powderMassage1: 'Usuwa zrogowaciały naskórek',
            powderMassage2: 'Wygładza teksturę skóry',
            powderMassage3: 'Pobudza krążenie',
            intensiveMassageDesc: 'Głęboka terapia na przewlekłe napięcia i uporczywe węzły.',
            intensiveMassage1: 'Rozluźnia głębokie napięcie',
            intensiveMassage2: 'Poprawia przepływ krwi',
            intensiveMassage3: 'Zmniejsza przewlekłą bolesność',
            thermoMassage: 'Masaż Termiczny',
            thermoMassageDesc: 'Ciepłe oleje ziołowe rozluźniają tkanki i wspierają regenerację.',
            thermoMassage1: 'Łagodzi obolałe mięśnie',
            thermoMassage2: 'Wprowadza głęboki relaks',
            thermoMassage3: 'Wspiera przepływ energii',
            synchronMassage: 'Masaż Synchronizowany',
            synchronMassageDesc: 'Masaż synchroniczny wykonywany przez dwóch terapeutów dla pełnej harmonii.',
            synchronMassage1: 'Harmonia całego ciała',
            synchronMassage2: 'Zrównoważony przepływ energii',
            synchronMassage3: 'Głębokie doświadczenie relaksu',
            specialMassage: 'Masaż Specjalny',
            specialMassageDesc: 'Masaż szyty na miarę Twoich potrzeb zdrowotnych.',
            specialMassage1: 'Indywidualnie dopasowany',
            specialMassage2: 'Skoncentrowany na konkretnych problemach',
            specialMassage3: 'Celowane wsparcie terapeutyczne',
            benefit1Title: 'Wsparcie detoksu:',
            benefit1Desc: 'Pańczakarma pomaga usunąć nagromadzone toksyny i przywrócić witalność.',
            benefit2Title: 'Łatwiejsze trawienie:',
            benefit2Desc: 'Terapie wspierają płynne trawienie i lepsze wchłanianie składników.',
            benefit3Title: 'Reset stresu:',
            benefit3Desc: 'Uspokajające zabiegi obniżają napięcie i lęk.',
            benefit4Title: 'Odporność:',
            benefit4Desc: 'Regularna terapia wzmacnia naturalne mechanizmy obronne.',
            benefit5Title: 'Odnowa:',
            benefit5Desc: 'Wspiera regenerację komórkową i zdrowy blask skóry.',
            benefit6Title: 'Równowaga dosz:',
            benefit6Desc: 'Przywraca harmonię Vaty, Pitty i Kaphy dla trwałego dobrostanu.',
            akkupancharTitle: 'Terapia Akupunktury',
            akkupancharDesc1: 'jest starożytną praktyką terapeutyczną wykorzystującą cienkie igły na określonych punktach ciała. To leczenie stymuluje kanały energetyczne i promuje uzdrawianie.',
            akkupancharBenefit: 'Główne korzyści:',
            akkupancharDesc2: 'Ta specjalistyczna terapia pomaga w chronicznym bólu, poprawia elastyczność stawów, promuje krążenie krwi i przywraca naturalny przepływ energii.',
            akkupancharApplication: 'Zastosowanie terapeutyczne:',
            akkupancharDesc3: 'Akupunktura działa na określone punkty marma z ostrożnie dobranymi technikami do równoważenia dosz.',
            akkupancharTransform: 'Doświadcz transformacji:',
            akkupancharDesc4: 'W Mahi Beach Ayurveda Resort nasi doświadczeni terapeuci dostosowują każdą sesję akupunktury do Twoich potrzeb zdrowotnych.',
            experienceAkkupanchar: 'Doświadcz akupunktury dzisiaj',
            doctorsEyebrow: 'NASZ ZESPÓŁ EKSPERTÓW',
            doctorsSectionTitle: 'Nasi lekarze',
            drSandyaName: 'Dr M. Sandya Mendis',
            drSandyaProfession: 'Lekarz medycyny ajurwedyjskiej',
            drSandyaSpecialization: 'Ajurweda kliniczna, Planowanie personalizowanego leczenia, Opieka ajurwedyjska w hotelarstwie',
            drSandyaProfileTitle: 'Profil zawodowy',
            drSandyaProfile: 'Współczująca i oddana specjalistka ajurwedy z ponad 25-letnim doświadczeniem w zapewnianiu spersonalizowanej opieki i rozwiązań wellness. Specjalizuje się w łączeniu tradycyjnych zasad ajurwedy z nowoczesnymi praktykami terapeutycznymi, aby zapewnić holistyczne doświadczenia uzdrawiające w luksusowych ośrodkach wellness.',
            drSandyaWorkExpTitle: 'Doświadczenie zawodowe',
            drSandyaWorkExp1: 'Główna lekarka i lider rozwoju programów - Mahi Beach Ayurveda Resort (2023 – obecnie)',
            drSandyaWorkExp2: 'Starsza lekarka ajurwedy - Sun Aqua Resort and Spa, Maggona (2008 – 2023)',
            drSandyaWorkExp3: 'Konsultantka ajurwedy - Amba Ayurveda Specialty Clinic (2006 – 2008)',
            drSandyaWorkExp4: 'Lekarka ajurwedy i specjalistka Pańczakarmy - Paradise Road The Villa Bentota (2002 – 2006)',
            drSandyaWorkExp5: 'Lekarz ajurwedyjski - Hotel Blue Water (1996 – 2002)',
            drSandyaEducationTitle: 'Wykształcenie i kwalifikacje zawodowe',
            drSandyaEdu1: 'Dyplom z ajurwedy - Government Ayurveda College, Borella (1989 – 1993)',
            drSandyaEdu2: 'Reiki 2. stopnia - Reiki Dasa Centre Negombo Sri Lanka (2015 – 2016)',
            drPandukaName: 'Dr Panduka Ranaweera',
            drPandukaProfession: 'Lekarz ajurwedyjski',
            drPandukaQualification: 'B.A.M.S. (Bachelor of Ayurvedic Medicine and Surgery)',
            drPandukaProfileTitle: 'Profil zawodowy',
            drPandukaProfile: 'Dr Panduka Ranaweera jest wykwalifikowanym i doświadczonym lekarzem ajurwedyjskim, posiadającym tytuł Bachelor of Ayurvedic Medicine and Surgery (B.A.M.S.) z Uniwersytetu w Kolombo. Jego przygotowanie akademickie jest mocno oparte na klasycznych zasadach ajurwedy i kompleksowym kształceniu klinicznym, wspierającym ustrukturyzowane, etyczne i oparte na dowodach podejście do medycyny tradycyjnej.',
            drPandukaExpertiseTitle: 'Ekspertyza zawodowa',
            drPandukaExpertise: 'Oprócz praktyki klinicznej, Dr Ranaweera prowadzi profesjonalne wykłady z ajurwedy dla gości i programów wellness, oferując jasne spojrzenie na filozofię ajurwedyjską, zapobieganie chorobom, zarządzanie stylem życia i praktyczne zastosowanie terapii tradycyjnych. Te sesje zwiększają zrozumienie i zaangażowanie gości, przyczyniając się do trwałych wyników zdrowotnych.',
            drPandukaSpecialtyTitle: 'Terapie integracyjne',
            drPandukaSpecialty: 'Jego ekspertyza terapeutyczna rozciąga się również na akupunkturę i muzykoterapię, które selektywnie integruje w celu wsparcia zarządzania bólem, redukcji stresu, równowagi neurologicznej i dobrostanu emocjonalnego. Łącząc ajurwedę z tymi komplementarnymi modalnościami, Dr Ranaweera zapewnia prawdziwie integracyjne doświadczenie lecznicze.',
            drPandukaRoleTitle: 'Zaangażowanie w doskonałość',
            drPandukaRole: 'W swojej roli w hotelu, Dr Ranaweera utrzymuje wysokie standardy kliniczne, jednocześnie zapewniając spersonalizowane plany leczenia i holistyczne wskazówki wellness. Jego profesjonalne, spokojne i współczujące podejście zapewnia, że każdy gość otrzymuje bezpieczną, autentyczną i zorientowaną na wyniki opiekę mającą na celu długoterminową równowagę, witalność i ogólne samopoczucie.',
            gallery1: 'Terapia Śirodhara',
            gallery2: 'Łaźnia parowa',
            gallery3: 'Kąpiel kwiatowa',
            gallery4: 'Masaż głowy',
            gallery5: 'Masaż całego ciała',
            gallery6: 'Masaż szyi',
            gallery7: 'Masaż twarzy',
            gallery8: 'Masaż ramion',
            heroTitle: 'Pańczakarma Ajurweda',
            heroSubtitle: 'Odmłódź Ciało, Umysł i Duszę w Beruwali',
            heroTagline: 'Doświadcz autentycznego lankijskiego uzdrawiania ajurwedy nad oceanem',
            sectionEyebrow: 'PAŃCZAKARMA AJURWEDA W MAHI BEACH AYURVEDA RESORT',
            sectionDescription: 'Poznaj starożytną sztukę Pańczakarmy w Mahi Beach Ayurveda Resort w Beruwali. Nasz zespół ajurwedyjski przygotowuje spersonalizowane terapie oczyszczające, odnawiające i harmonizujące ciało, umysł i ducha.',
            treatmentProgramme: {
                title: 'Program Leczenia Ajurwedyjskiego',
                subtitle: 'Twoja Podróż ku Równowadze, Detoksykacji i Głębokiej Odnowie',
                intro: 'Doświadcz autentycznej opieki ajurwedyjskiej w spokojnym nadmorskim ośrodku, który wspiera ciało, uspokaja umysł i przywraca energię. Od chwili przyjazdu dbamy o każdy detal, byś mógł skupić się na dobrostanie.',
                welcomeTitle: 'Powitanie i Łagodny Początek',
                welcomePoints: [
                    'Odbiór z lotniska i transfer do hotelu',
                    'Ciepłe powitanie i orientacja w hotelu',
                    'Wprowadzenie do cotygodniowego programu wellness',
                    'Masaż Relaksacyjny (Dzień 1) w Centrum Ajurwedy, aby uwolnić zmęczenie podróżą i przygotować ciało do zabiegów'
                ],
                doctorTitle: 'Konsultacja Lekarska i Plan Osobisty',
                doctorPoints: [
                    'Konsultacja z Lekarzem Ajurwedy (Dzień 2 – rano)',
                    'Pełna ocena Twojej Doshy/typu ciała i problemów zdrowotnych',
                    'Tłumacz dostępny na życzenie',
                    'Twój lekarz tworzy spersonalizowany plan leczenia dostosowany do Twoich potrzeb i celów'
                ],
                dailyTherapiesTitle: 'Codzienne Terapie Ajurwedyjskie',
                dailyTherapiesPoints: [
                    '4–5 zabiegów dziennie (zgodnie z zaleceniami lekarza)',
                    'Terapie wybrane na podstawie Twojej konstytucji ciała i stanu',
                    'Specjalne masaże mogą być dodane w razie potrzeby',
                    'Lekarz monitoruje postępy codziennie i może dostosować zabiegi i wsparcie ziołowe, aby zapewnić najlepsze wyniki',
                    'W razie potrzeby może zostać zalecony łagodny proces oczyszczania/przeczyszczania'
                ],
                herbalMedicineTitle: 'Wsparcie Medycyną Ziołową',
                herbalMedicinePoints: [
                    'Przepisane przez lekarza leki ziołowe podawane dwa razy dziennie:',
                    'Podczas śniadania',
                    'Podczas kolacji',
                    'Wspierające wewnętrzne uzdrawianie, detoksykację i trwałą równowagę'
                ],
                yogaMeditationTitle: 'Joga i Medytacja dla Harmonii Ciała i Umysłu',
                yogaMeditationPoints: [
                    'Sesje jogi 4 razy w tygodniu (około 1 godzina)',
                    'Sesje medytacji 2 razy w tygodniu:',
                    'Unikalne doświadczenie duchowe w Świątyni na Wyspie, dostępnej łodzią',
                    'Medytacja prowadzona przez mnichów (około 1 godzina)'
                ],
                wellnessTitle: 'Wliczone Doświadczenia Wellness',
                wellnessPoints: [
                    'Cotygodniowe pokazy zdrowego gotowania',
                    'Darmowa wycieczka (doświadczenie kulturowe/przyrodnicze)'
                ],
                closingTitle: 'Rytuał Zamknięcia i Wyjazd',
                closingPoints: [
                    'Piękna Kąpiel Kwiatowa (ostatni dzień)—tradycyjny rytuał odnowy',
                    'Końcowa Konsultacja Lekarska w celu przeglądu postępów i zapewnienia:',
                    'Ciągłych wskazówek wellness',
                    'Recept i zaleceń dla domu',
                    'Transfer z powrotem na lotnisko'
                ]
            },
        },
        food: {
            heroTitle: 'Kuchnia ajurwedyjska i kuchnia przybrzeżna',
            heroSubtitle: 'Autentyczne smaki Sri Lanki i świeża kuchnia przybrzeżna',
            heroAlt: 'Doświadczenie kulinarne w Mahi Beach Ayurveda Resort',
            wellnessEyebrow: 'przez jedzenie',
            wellnessTitle: 'Znaczenie',
            ayurvedicFood: 'jedzenia ajurwedyjskiego',
            wellnessIntro1: 'W ajurwedzie jedzenie uważa się za największą medycynę. To, co jesz, bezpośrednio wpływa na twoje dosze (Vata, Pitta, Kapha), trawienie (agni) i ogólną równowagę ciała, umysłu i ducha.',
            wellnessIntro2: 'Odżywianie ajurwedyjskie podkreśla świeże, sezonowe, całe pokarmy przygotowywane z troską i świadomym jedzeniem. Promuje sześć smaków (słodki, kwaśny, słony, pikantny, gorzki, terpenujący) w każdym posiłku, aby odżywiać wszystkie zmysły i utrzymać harmonię.',
            wellnessIntro3: 'Właściwe jedzenie ajurwedyjskie wspiera silne trawienie, pomaga usuwać toksyny (ama), wzmacnia odporność, poprawia energię, zmniejsza stres i zapobiega wielu schorzeniom przewlekłym. W Mahi Beach każde danie jest ostrożnie przygotowywane, aby dostosować się do Twojej unikalnej konstytucji w celu głębokich gojenia i witalności.',
            foodImage1Alt: 'Tradycyjny posiłek ajurwedyjski z sześcioma smakami',
            foodImage2Alt: 'Zioła ajurwedyjskie i przyprawy do zbilansowanej odżywiania',
            culinaryPhilosophyEyebrow: 'Nasza filozofia kulinarna',
            culinaryPhilosophyTitle: 'Odżywianie',
            nutritionHighlight: 'ajurwedyjskie',
            culinaryPhilosophyResort: 'w Mahi Beach Ayurveda Resort',
            nutritionTopImageAlt: 'Kuchnia ajurwedyjska w Mahi Beach Ayurveda Resort',
            freshNourishingLabel: 'Świeże i pożywne',
            healingIngredientsAlt: 'Zdrowe składniki ajurwedyjskie i przyprawy',
            healingIngredientsLabel: 'Uzdrawiające składniki',
            philosophyText1: 'Jedzenie, które obejmuje sześć głównych smaków (słodki, kwaśny, słony, gorzki, pikantny i terminujący) wraz z wieloma subtelnym wariacjami, zostało opisane w klasycznych tekstach ajurwedyjskich — niektóre pochodzą z ponad 5000 lat temu — wraz z istotnymi właściwościami każdego pokarmu: Guna (jakość wrodzona), Virya (potencja/grzewcza lub chłodząca), Vipaka (wpływ po trawieniu) i Prabhava (unikalna akcja szczególna).',
            philosophyText2: 'W rezultacie odżywianie ajurwedyjskie odgrywa główną rolę w Mahi Beach Ayurveda Resort. Nie oznacza to sztywnego, monotonnego schematu niegrackich, bezsmakowych lub nadmiernie gorzkich posiłków wegetariańskich nakazanego wyłącznie przez lekarzy. Wręcz przeciwnie, nasza kuchnia ajurwedyjska jest jedną z naszych największych mocnych stron: potrawy przygotowywane przez naszych doświadczonych szefów kuchni będą Cię zadziwiać i delektować się każdego dnia pobytu!',
            philosophyText3: 'Na śniadanie ciesz się bogatym buffetem z świeżymi owocami tropikalnymi, świeżo wyciskanym sokiem, pożywną zupą z ziół, domowym chlebem i lekkimi ciasteczkami, a także wieloma autentycznymi opcjami śniadania na Sri Lance. Na obiad kosztuj kolorowego i smacznego bufetu z łagodnym curry rybnym, przygotowaniem warzyw i potrawami infuzowanymi ziołami. Wieczorem podajemy ustalane menu wegetariańskie z dostępną opcją świeżej ryby. W soboty świętujemy „Noc Sri Lanki" z powiększonym buffetem — nasi szefowie kuchni przygotowywają tradycyjne specjalności lokalne bezpośrednio przed tobą, tworząc żywą i autentyczną doświadczenie.',
            philosophyText4: 'W ajurwedzie żywność i napoje są klasyfikowane na wiele sposobów — w zależności od smaku i właściwości, zdolności trawiennej organizmu (agni), przydatności do określonych stanów zdrowotnych, stosowności sezonowej i więcej. W Mahi Beach ostrożnie rozważamy wszystkie te czynniki jednocześnie, świadomie starając się uwzględnić wszystkie sześć smaków w zbilansowanych kombinacjach dostosowanych do indywidualnej konstytucji każdego gościa.',
            philosophyText5: 'Nasze posiłki zawierają świeże warzywa, owoce tropikalne i odpowiedzialnie pozyskane ryby. Nie serwujemy czerwonego mięsa ani alkoholu.',
            philosophyText6: 'Podczas posiłków lekarz ajurwedyjski lub wykwalifikowany dietetyk jest zawsze dostępny, aby Cię prowadzić. Doradzą Ci na temat najbardziej odpowiedniej warzyw, ziół i przypraw do Twojej obecnej fazy leczenia i pomogą Ci odpowiednio wybierać lub unikać potraw. Twój spersonalizowany eliksir z ziół i wszelkie określone instrukcje od zespołu centrum zdrowia będą umieszczone na Twoim indywidualnym stole.',
            philosophyText7: 'Ten poziom osobistej opieki i uwagi do diety jest wyróżniającą cechą doświadczenia Mahi Beach Ayurveda Resort.',
            philosophyText8: 'Żywność jest uważana za Pranę — główną energię wspierającą życie — dla każdego człowieka. Dlatego zachęcamy Cię do podejścia do każdego posiłku pełną świadomością: smakując zapachy, doświadczając smaków, odczuwając łagodne ciepło i ciesząc się urokami świadomością.',
            diningExperienceEyebrow: 'Doświadczenie kulinarne',
            restaurantTitlePrefix: 'Nasz',
            ayurvedicHighlight: 'ajurwedyjski',
            restaurantTitleSuffix: 'restauracja',
            restaurantDetail1: 'Nasza ajurwedyjska restauracja w Mahi Beach Ayurveda Resort oferuje unikalne doświadczenie kulinarne, które harmonizuje tradycyjne zasady ajurwedyjskie z autentyczną przybrzeżną kuchnią Sri Lanki. Priorytetyzujemy świeże, lokalnie pozyskane składniki, aby stworzyć posiłki, które nie tylko zachwycają podniebienie, ale także promują holistyczne dobrostanu.',
            restaurantDetail2: 'Menu jest ostrożnie opracowana, aby zbilansować sześć smaków (słodki, kwaśny, słony, gorzki, pikantny, terpenujący) w każdym daniu, zapewniając pożywne i satysfakcjonujące doświadczenie. Każdy posiłek jest przygotowywany z troską, zawierający zioła ajurwedyjskie i przyprawy znane z ich właściwości uzdrawiających.',
            restaurantDetail3: 'Goście mogą cieszyć się różnorodnością potraw dostosowanych do ich indywidualnych dosech (typów ciała), z opcjami dla diet wegetariańskiej, wegańskiej i pescetariańskiej. Nasi szefowie kuchni ściśle współpracują z praktykami ajurwedyjskimi, aby zapewnić, że każdy posiłek wspiera cele zdrowia i dobrostanu gości.',
            restaurantDetail4: 'Atmosfera restauracji odzwierciedla spokojne przybrzeżne otoczenie, zapewniając spokojne otoczenie do świadomego jedzenia. Niezależnie od tego, czy cieszysz się hojnym śniadaniowym buffetem, czy smakowaniem gourmetową kolacją, każdy posiłek w naszej ajurwedyjskiej restauracji jest okazją do odżywienia ciała i duszy.',
            restaurantDetail5: 'Dołącz do nas w ajurwedyjskiej restauracji Mahi Beach Ayurveda Resort w podróży kulinarnej, która świętuje bogate smaki Sri Lanki, jednocześnie przyjmując ponadczasową mądrość Ajurvedy.',
            restaurantImageAlt: 'Jedzenie w Mahi Beach Ayurveda Resort',
            premiumDiningLabel: 'Prywatne jedzenie',
            premiumDiningDescription: 'Doświadczenie autentycznej kuchni ajurwedyjskiej w spokojnym otoczeniu nadrzecznym'
        },

        yoga: {
            heroTitle: 'Joga w kurorcie',
            heroSubtitle: 'Znajdź równowagę, siłę i wewnętrzny spokój w Beruwali',
            heroAlt: 'Joga w Mahi Beach Ayurveda Resort',
            importanceEyebrow: 'i równowaga',
            importanceTitle: 'Znaczenie jogi i medytacji',
            importanceImageAlt: 'Znaczenie jogi i medytacji',
            importanceText1: 'Joga i medytacja to starożytne praktyki, które oferują liczne korzyści fizyczne, psychiczne i emocjonalne. Wspierają elastyczność, siłę i równowagę, jednocześnie redukując stres i lęk.',
            importanceText2: 'Regularna praktyka może poprawić koncentrację, jakość snu i ogólne samopoczucie. Joga zachęca również do uważności, pomagając połączyć się z własnym wnętrzem i odnaleźć spokój pośród codziennego zgiełku.',
            importanceText3: 'W Mahi Beach Ayurveda Resort zapewniamy spokojne otoczenie idealne do praktykowania jogi i medytacji, dzięki czemu goście mogą odnowić umysł, ciało i ducha.',
            practiceEyebrow: 'Nasza praktyka',
            practiceTitle: 'Praktyka i doświadczenie jogi',
            practiceImageAlt: 'Praktyka jogi w kurorcie',
            practiceText1: 'W Mahi Beach Ayurveda Resort joga praktykowana jest głównie jako tradycyjna hatha joga, połączona z pranajamą (technikami oddechowymi). To holistyczne podejście ma na celu przebudzenie wewnętrznej świadomości i łagodne pobudzenie kundalini (często nazywanej trzecim okiem). Szczególny nacisk kładzie się na wyrównanie kręgosłupa i elastyczność, ponieważ uważa się, że sprężysty kręgosłup spowalnia proces starzenia — „Masz tyle lat, ile ma twój kręgosłup.”',
            practiceText2: 'Sesje jogi odbywają się cztery razy w tygodniu i są odpowiednie zarówno dla początkujących, jak i zaawansowanych praktyków. Od czasu do czasu wprowadzane są specjalne sesje, takie jak Ashtanga Yoga, pozwalające doświadczyć różnych pozycji i sekwencji. Nasi lekarze ajurwedyjscy zachęcają do regularnego udziału, aby wspierać i wzmacniać cały program leczenia.',
            practiceText3: 'Wszystkie sesje jogi odbywają się w naszej dedykowanej Yoga Shala, spokojnej przestrzeni zaprojektowanej, aby wspierać koncentrację, równowagę i uważny ruch. Każda sesja zwykle zaczyna się od Powitań Słońca, po których następuje pranajama oraz sekwencja starannie dobranych asan mających na celu poprawę elastyczności, krążenia i ogólnego samopoczucia.',
            practiceText4: 'Nasi doświadczeni nauczyciele jogi dostosowują każdą sesję do indywidualnych potrzeb, możliwości i stanu zdrowia gości, zapewniając bezpieczne, wspierające i głęboko korzystne doświadczenie dla każdego.',
            spiritualEyebrow: 'Duchowa podróż',
            spiritualTitle: 'Medytacja i aktywności duchowe',
            spiritualSubtitle: 'Pogłęb swoją praktykę duchową dzięki naszym świętym ceremoniiom i sesjom medytacji prowadzonej',
            meditationImageAlt: 'Medytacja i praktyka duchowa w kurorcie',
            meditationTitle: 'Sesje medytacji',
            meditationDesc: 'Goście są zaproszeni do udziału w prowadzonych sesjach medytacyjnych odbywających się trzy razy w tygodniu, inspirowanych tradycjami buddyjskimi. Sesje te mają na celu wyciszenie umysłu, pogłębienie świadomości oraz wspieranie uzdrowienia emocjonalnego i duchowego. Medytacja odbywa się w spokojnej świątyni na wyspie, do której goście docierają łodzią — spokojna i znacząca podróż wzbogaca całe doświadczenie medytacyjne.'
        },
    }
};


i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en',          // Default language
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;

